import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  Renderer2,
} from '@angular/core';
import { Constants } from '@base/src/app/models/constants';
import { QRButton } from '@base/src/app/models/qr-button.model';
import { QRDatePicker } from '@base/src/app/models/qr-date-picker.model';
import { QRDropdown } from '@base/src/app/models/qr-dropdown.model';
import { QRInputAutocomplete } from '@base/src/app/models/qr-input-autocomplete.model';
import { QRInput } from '@base/src/app/models/qr-input.model';
import { QRToggle } from '@base/src/app/models/qr-toggle.model';
import { OtherRemaxService } from '@base/src/app/services/renditions/other-remax.service';
import { PropertiesListService } from '@base/src/app/services/renditions/properties-list.service';
import * as moment from 'moment';
import { Options } from '@angular-slider/ngx-slider/options';
import { TableHeader } from '@base/src/app/models/tableheader.model';
import { QRDialog } from '@base/src/app/models/qr-dialog.model';
import { ReservationModel } from '@base/src/app/models/renditions/reservation.model';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { RenditionsService } from '@base/src/app/services/renditions/renditions.service';
import { OfficesListService } from '@base/src/app/services/renditions/offices-list.service';
import {
  ReferredRendition,
  RenditionModel,
} from '@base/src/app/models/renditions/rendition.model';
import { LogedUser } from '@base/src/app/core/models/logged-user.model';
import { ClientsOriginService } from '@base/src/app/services/renditions/clients-origin.service';
import {
  CommissionSummary,
  STATISTICS_COMPUTATION_LABELS,
} from '@base/src/app/models/renditions/commission-summary.model';
import { buildStatisticsSummary } from '@base/src/app/models/renditions/rendition-statistics.calculation';
import {
  InvoiceRendition,
  InvoiceRenditionAgentBilling,
  InvoiceRenditionAgentPayment,
  InvoiceRenditionBilling,
} from '@base/src/app/models/renditions/invoices.model';
import { SnackbarService } from '@base/src/app/services/snackbar.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AgentBilling,
  AgentPayment,
  AgentTypesArray,
  Billing,
  CobrokerCommission,
  CobrokerTeamLeader,
  Jurisdiction,
  OtherDeduction,
  ReferredCommission,
  ReferredDeduction,
  RenditionModelBE,
  TeamLeaderCommission,
  TeamLeaderDeduction,
} from '@base/src/app/models/renditions/RenditionModelBE.model';
import { OtherRealEstateService } from '@base/src/app/services/renditions/other-real-estate.service';
import { Overlay } from '@base/src/app/models/overlay.model';
import { environment } from '@base/environments/environment';
import { Banks } from '@base/src/app/models/renditions/banks.model';
import { QRSearchAutocompleteModel } from '@base/src/app/models/search-autocomplete.model';
import { UtilsService } from '@base/src/app/services/utils.service';
import {
  getNavigationOriginCode,
  NavigationOriginTypes,
} from '../../../pages/property-manager/models/navigation-origin-types.model';
import {
  AgentsCoBrokers,
  PropertyListingCaptured,
} from '@base/src/app/pages/listing-captured-form/models/property-listing-captured.model';
import { QrMonitorModel } from '@base/src/app/models/monitor/qr-monitor.model';
import { QrMonitorService } from '@base/src/app/services/monitor/qr-monitor.service';
import { FindRenditionByIdService } from '@base/src/app/services/renditions/find-rendition-by-id.service';
import {
  calculateAgentExpensesCap,
  filterAgentOfficeInvoicesForPool,
  getAgentOfficePoolCapContext,
  invoiceMatchesBuyerClient,
  invoiceMatchesSellerClient,
  invoicesWithinCap,
  isTeamLeaderBillable,
} from '@base/src/app/components/renditions/utils/invoice-cap.utils';

type InputTypes = string | number | undefined;
export class Agent {
  'teamJoinDate': Date | undefined | null;
  'agentLevelType': string | undefined;
  'agentName': string;
  'agentType': string;
  'id': number;
  'teamId': number | null;
  'teamLeaderId': number | null;
  'integratorSalesAssociatedId': string | null;
}
@Component({
  selector: 'app-rendition-full-form',
  templateUrl: './rendition-full-form.component.html',
  styleUrls: ['./rendition-full-form.component.scss'],
})
export class RenditionFullFormComponent implements OnInit {
  @Input() newRendition:
    | string
    | PropertyListingCaptured
    | {
        address: string;
        mlsid: string;
        qrid: string;
        entrepreneurshipId: string;
      }
    | undefined;
  @Input() reservation: ReservationModel | undefined;
  @Input() renditionFromBE: RenditionModelBE | undefined;
  @Input() user: LogedUser | undefined;
  @Input() needsToDeleteDraft?: number;
  @Input() jurisdictions: {
    id: number;
    iibb: number;
    name: string;
    previsionalCash: number;
    puroDeductionPercentage: number;
    teamDeductionPercentage: number;
    altoDeductionPercentage: number;
  }[] = [];
  @Input() banks: Banks[] = [];

  @Output() changeCommissionSummary: EventEmitter<CommissionSummary> =
    new EventEmitter<CommissionSummary>();

  @Output() stopLoading: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() formValidation: EventEmitter<{ draft: boolean; form: boolean }> =
    new EventEmitter<{ draft: boolean; form: boolean }>();

  rendition: RenditionModel | undefined;

  public readonly OFFICE_CLIENT = 'Oficina al cliente';
  public readonly AGENT_CLIENT = 'Agente al cliente';
  public readonly AGENT_OFFICE = 'Agente a la oficina';

  cobrokersAgentListOtherOffice: Agent[] = [];

  isDirectionEmpty = false;

  NODE = environment.node;
  NODE_GLOBAL = Constants.TENANT_ID_GLOBAL;
  NODE_AR = Constants.TENANT_ID_AR;
  NODE_DO = Constants.TENANT_ID_DO;
  isRegionAR: boolean = environment.node == Constants.TENANT_ID_AR;
  isRegionDO: boolean = environment.node == Constants.TENANT_ID_DO;
  // Variables para deifinir si es input comun o selector autocomplete para agentes
  inputAgentGlobalSeller = false;
  inputAgentGlobalBuyer = false;
  // Variables para deifinir si es input comun o selector autocomplete para referidos
  inputAgentGlobalSellerReferred = false;
  inputAgentGlobalBuyerReferred = false;

  commissionCheckout: CommissionSummary = new CommissionSummary();

  isRelationFiftyFifty = false;
  isBankDisabled = true;
  previousSellerRelation = 0;

  openOverlay = false;
  overlay: Overlay = {
    isButtonCloseVisible: false,
    isFullHeight: false,
    doesClickingOutsideContentClose: false,
  };

  /** 1 = Split Member/Leader, 0 = 100% Team Member */
  statisticsComputationToggle: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: [
      STATISTICS_COMPUTATION_LABELS[0],
      STATISTICS_COMPUTATION_LABELS[1],
    ],
    optionSelected: 1,
  };

  originToggle: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['Reserva', 'Nueva'],
    optionSelected: 0,
  };

  originReferredToggle: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['Vendedor', 'Comprador'],
    optionSelected: 0,
  };

  operationToggle: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['Venta', 'Alquiler', 'Alquiler temp.'],
    optionSelected: 0,
  };

  sharedWithToggle: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['Dos puntas', 'RE/MAX', 'Otra inmobiliaria'],
    optionSelected: 0,
  };

  sellerSharedWith: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['Mi oficina', 'RE/MAX', 'Otro'],
    optionSelected: 2,
  };

  sellerReferredSharedWith: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['Mi oficina', 'RE/MAX', 'Otro'],
    optionSelected: 0,
  };

  sellerCobrokerSharedWithModel: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['Mi oficina', 'RE/MAX', 'Otro'],
    optionSelected: 0,
  };

  sellerCobrokerSharedWith: {
    [key: string]: QRToggle;
  } = {};

  sellerCobrokerOfficeAutocompleteModel: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Oficina',
    isCleanButtonVisible: true,
    options: [],
  };

  sellerCobrokerOfficeAutocomplete: {
    [key: string]: QRInputAutocomplete;
  } = {};

  sellerCobrokerAgentAutocompleteModel: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Agente',
    isCleanButtonVisible: true,
    options: [],
  };

  pendingCommissionsToggle: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_1,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['Si', 'No'],
    optionSelected: 1,
  };

  sellerCobrokerAgentAutocomplete: {
    [key: string]: QRInputAutocomplete;
  } = {};

  inputSellerCobrokerLocalModel: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
  };

  inputSellerCobrokerLocal: {
    [key: string]: QRInput;
  } = {};

  cobrokerAgentsListMyOffice: Agent[] = [];

  isRegaliasChecked = false;

  inputSellerCobrokerOtherModel: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Nombre',
    debounceTime: 250,
  };

  inputSellerCobrokerOther: {
    [key: string]: QRInput;
  } = {};

  inputSellerCobrokerUSDModel: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
  };

  inputSellerCobrokerUSD: {
    [key: string]: QRInput;
  } = {};

  sellerTeamLeaderOrigin: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['T. Leader', 'T. Member'],
    optionSelected: 1,
  };

  buyerTeamLeaderOrigin: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['T. Leader', 'T. Member'],
    optionSelected: 1,
  };

  buyerSharedWith: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['Mi oficina', 'RE/MAX', 'Otro'],
    optionSelected: 2,
  };

  buyerReferredSharedWith: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['Mi oficina', 'RE/MAX', 'Otro'],
    optionSelected: 0,
  };

  inputDirectionMlsId: QRInputAutocomplete = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Buscar',
    isCleanButtonVisible: true,
    options: [],
  };

  inputDirectionNew: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese una dirección',
    debounceTime: 250,
  };

  buttonCleanDirection: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.CLOSE,
    iconOnly: true,
  };

  buttonCleanSellerReferred: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.CLOSE,
    iconOnly: true,
    type: QRButton.TYPE_BUTTON,
  };

  buttonCleanBuyerReferred: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.CLOSE,
    iconOnly: true,
  };

  inputMlsidGlobal: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
    hint: 'Solo se permiten letras, números, guiones (-), guiones bajos (_) y puntos (.) sin espacios en el medio',
    errorMsg:
      'Solo se permiten letras, números, guiones (-), guiones bajos (_) y puntos (.) sin espacios en el medio',
  };

  inputMlsidFirst: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
  };

  inputMlsidLast: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
  };

  dropdownBanks: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar',
    options: [],
  };

  dropdownPropertiesType: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar',
    options: [],
  };

  dropdownSellerClient: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar',
    options: [],
  };

  sellerClientDOAutocomplete: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Seleccionar',
    isCleanButtonVisible: true,
    options: [],
  };

  dropdownBuyerClient: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar',
    options: [],
  };

  buyerClientDOAutocomplete: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Seleccionar',
    isCleanButtonVisible: true,
    options: [],
  };

  datePicker: QRDatePicker = {
    date: moment().format('YYYY-MM-DD'),
    calendarWidth: 230,
    isDisplayedUp: false,
    errorMsg: 'La fecha no puede ser posterior al día actual.',
  };

  dropdownJurisdiction: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar',
    options: [],
  };

  officeAutocomplete: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Oficina',
    isCleanButtonVisible: true,
    options: [],
  };

  inputAgentOtherRealEstate: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Nombre',
    debounceTime: 250,
  };

  inputTC: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
  };

  inputClosePriceUSD: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
  };

  inputClosePriceLocal: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
  };

  inputPeriodo: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
  };

  periodoToggle: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_3,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['Días', 'Meses'],
    optionSelected: 1,
  };

  anotherRealEstateConfig: QRSearchAutocompleteModel = {
    buttonText: 'Seleccionar otra inmobiliaria',
    options: [],
    canCreateNewOption: true,
  };

  inputAnotherRealEstate: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
  };

  sellerOfficeAutocomplete: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Oficina',
    isCleanButtonVisible: true,
    options: [],
  };

  sellerOtherRemaxAutocomplete: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Otra inmobiliaria',
    isCleanButtonVisible: true,
    options: [],
  };

  buyerOtherRemaxAutocomplete: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Otra inmobiliaria',
    isCleanButtonVisible: true,
    options: [],
  };

  sellerReferredOfficeAutocomplete: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Oficina',
    isCleanButtonVisible: true,
    options: [],
  };

  buyerOfficeAutocomplete: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Oficina',
    isCleanButtonVisible: true,
    options: [],
  };

  buyerReferredOfficeAutocomplete: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Oficina',
    isCleanButtonVisible: true,
    options: [],
  };

  sellerAgentAutocomplete: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Agente',
    isCleanButtonVisible: true,
    options: [],
  };

  sellerReferredAgentAutocomplete: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Agente',
    isCleanButtonVisible: true,
    options: [],
  };

  inputSellerReferredOther: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Nombre',
    debounceTime: 250,
  };

  inputBuyerReferredOther: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Nombre',
    debounceTime: 250,
  };

  buyerAgentAutocomplete: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Agente',
    isCleanButtonVisible: true,
    options: [],
  };

  buyerReferredAgentAutocomplete: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Agente',
    isCleanButtonVisible: true,
    options: [],
  };

  buttonSellerAddReferred: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Agregar referido',
  };

  buttonBuyerAddReferred: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Agregar referido',
  };

  buttonSellerAddTeamLeader: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Agregar team leader',
  };

  buttonSellerAddCoBroker: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Agregar co-broker',
  };

  buttonBuyerAddTeamLeader: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Agregar team leader',
  };

  inputSellerReferredPercetage: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
  };

  inputSellerReferredUSD: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
  };

  inputBuyerReferredUSD: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
  };

  inputBuyerReferredPercetage: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
  };

  inputSellerReferredLocal: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
  };

  inputBuyerReferredLocal: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
  };

  inputJurisdictionPercentage: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
    hint: '%',
  };

  inputJurisdictionDollar: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
    hint: 'U$S',
  };

  inputJurisdictionLocal: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
    hint: '$',
  };

  inputJurisdictionManualName: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
    hint: 'Nombre de la deducción',
  };

  inputJurisdictionManualDollar: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
    hint: 'U$S',
  };

  inputJurisdictionManualLocal: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 250,
    hint: '$',
  };

  buttonDelete: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.DELETE_2,
    iconOnly: true,
  };

  creditEnable = false;
  inmobiliariaDropdownSelected: string = '';

  propertiesList: { id: number; name: string }[] = [];
  otherRemaxList: { id: number; name: string }[] = [];

  sliderOptions: Options = {
    floor: 0, // Rango mínimo
    ceil: 100, // Rango máximo,
    hidePointerLabels: true,
    hideLimitLabels: true,
    step: 0.0001,
  };

  buttonAddInvoices: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Agregar o quitar facturas',
    icon: Constants.ICONS.ADD_QUOTA,
  };

  buttonAddManualDeductionSeller: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Agregar deducción manual',
    icon: Constants.ICONS.PLUS,
  };

  buttonAddManualDeductionBuyer: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Agregar deducción manual',
    icon: Constants.ICONS.PLUS,
  };

  dialogAddInvoice: QRDialog = {
    isVisible: false,
    title: 'Agregar o quitar facturas',
    componentToLoad: QRDialog.DIALOG_ADD_INVOICE_RENDITIONS,
    textButtonAction: 'Volver',
  };

  isDraft = false;

  tableHeaderInvoices: TableHeader[] = [
    {
      id: '',
      text: '',
      percentageWidth: 5.08,
    },
    {
      id: 'type',
      text: 'Tipo',
      percentageWidth: 8.86,
    },
    {
      id: 'number',
      text: 'Núm',
      percentageWidth: 16.45,
    },
    {
      id: 'agent',
      text: 'Agente',
      percentageWidth: 20.57,
    },
    {
      id: 'name',
      text: 'Razón Social',
      percentageWidth: 17.4,
    },
    {
      id: 'total',
      text: 'Monto',
      percentageWidth: 17.4,
    },
    {
      id: 'iva',
      text: 'IVA',
      percentageWidth: 14.24,
    },
  ];

  errorInOfficeCaps = false;

  puntasValue = 50;
  addSellerReferred = false;
  addSellerTeamLeader = false;

  addBuyerReferred = false;
  addBuyerTeamLeader = false;

  showSellerManualDeduction = false;
  showBuyerManualDeduction = false;

  sellerRawCommissionUSD = 0;
  sellerRawCommissionLocal = 0;
  buyerRawCommissionUSD = 0;
  buyerRawCommissionLocal = 0;

  invoices: InvoiceRendition[] = [];

  renditionForm: FormGroup;

  exchangeRateMax = 0;
  exchangeRateMin = 0;

  sellerComitionUSD = 0;
  buyerComitionUSD = 0;

  sellerAgentFirstSubtotalUSD = 0;
  sellerAgentFirstSubtotalLocal = 0;
  sellerAgentSecondSubtotalUSD = 0;
  sellerAgentSecondSubtotalLocal = 0;

  buyerAgentFirstSubtotalUSD = 0;
  buyerAgentFirstSubtotalLocal = 0;
  buyerAgentSecondSubtotalUSD = 0;
  buyerAgentSecondSubtotalLocal = 0;

  dataForForm: { [key: string]: number } = {};

  today = moment().format('YYYY-MM-DD');

  myOfficeIsSeller = false;
  sellerRelation = 0;
  buyerRelation = 0;

  agentsListMyOffice: string[] = [];
  agentsListAnotherRemax: Agent[] = [];

  fullAgentList: Agent[] = [];

  sellerReferredAgentList: Agent[] = [];
  buyerReferredAgentList: Agent[] = [];

  clientOirgin: { id: number; label: string }[] = [];

  officesList: { id: number; name: string }[] = [];
  otherRealEstateList: { id: number; name: string; visible: boolean }[] = [];
  performingChange = false;

  isCuota = false;
  isIngresoRelacionado = false;
  isReferidoACobrar = false;
  isRendition = false;
  isEdit = false;

  userTriedToSubmitForm = false;

  msgLoading = '';
  waitingService = false;
  isSubmitting = false;

  invoicesCapsAreValid = true;
  netCommissionsAreValid = true;
  voucherTypeValid = true;
  actualExchangeRate = 0;

  cajaPrev: InvoiceRenditionBilling[] = [];

  dialogClearForm: QRDialog = {
    isVisible: false,
    width: '744px',
    height: '352px',
    title: '¿Limpiar datos cargados?',
    textButtonAction: 'Sí, limpiar',
    textButtonCancel: 'Cancelar',
    componentToLoad: QRDialog.DIALOG_RENDITION_CLEAR_FORM,
    value: '',
  };

  dialogDraftCreated: QRDialog = {
    isVisible: false,
    width: '744px',
    height: '360px',
    title: 'Borrador creado',
    componentToLoad: QRDialog.DIALOG_RENDITION_DRAFT_CREATED,
    value: '',
    isNotCloseable: true,
  };

  dialogWarningForInvalidCapsInvoices: QRDialog = {
    isVisible: false,
    width: '744px',
    height: '360px',
    title: 'Problemas en los montos de la facturación',
    componentToLoad: QRDialog.DIALOG_RENDITION_WARNING_INVALID_CAPS_INVOICES,
    value: '',
    textButtonAction: 'Aceptar',
  };

  dialogWarningInvoices: QRDialog = {
    isVisible: false,
    width: '744px',
    height: '360px',
    title: 'Aviso sobre facturación',
    componentToLoad: QRDialog.DIALOG_WARNING_INVOICES,
    value: '',
  };

  isUserFromCeroOffice = false;
  isBlockEditOpen = false;

  isCaptchmentLite = false; //se eligió una captacion en vez de reserva (Gestion LITE)
  qrid = '';
  entrepreneurshipId = '';

  isFromGestor = false; //Si puso "generar cierre" desde el gestor. Solo creaciones, no ediciones.
  NavigationOrigin: NavigationOriginTypes | undefined;

  isProd = environment.production;

  isPendingReport: boolean = false;
  isPendingReportIngresoRelacionado: boolean = false;

  private unloadListener: any;

  coBrokers: any[] = [];

  @ViewChild('sellerManualDeductionName') sellerManualDeductionName:
    | ElementRef
    | undefined;
  @ViewChild('buyerManualDeductionName') buyerManualDeductionName:
    | ElementRef
    | undefined;

  constructor(
    private readonly propertiesListService: PropertiesListService,
    private readonly otherRemaxService: OtherRemaxService,
    private readonly renditionsService: RenditionsService,
    private readonly officeListService: OfficesListService,
    private readonly clientsOriginService: ClientsOriginService,
    private readonly snackbarService: SnackbarService,
    private readonly router: Router,
    private readonly otherRealEstateService: OtherRealEstateService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly renderer: Renderer2,
    private readonly utilService: UtilsService,
    private readonly fb: FormBuilder,
    private readonly qrMonitorService: QrMonitorService,
    private readonly renditionFindByIdService: FindRenditionByIdService,
  ) {
    this.renditionForm = this.fb.group({});
  }

  async ngOnInit(): Promise<void> {
    this.addUnloadListener();
    this.checkUserFromCeroOffice();
    // if (this.user && !this.isProd && this.NODE === this.NODE_DO) this.user.agency_id = 2;

    this.isPendingReport =
      this.activatedRoute.snapshot.queryParamMap.get('report') === '1';

    this.isPendingReportIngresoRelacionado =
      this.activatedRoute.snapshot.queryParamMap.get('report') === '2';

    const PAYMENT_NUMBER =
      this.activatedRoute.snapshot.queryParamMap.get('paymentNumber') ?? null;
    switch (true) {
      case PAYMENT_NUMBER !== null &&
        PAYMENT_NUMBER !== '' &&
        Number(PAYMENT_NUMBER) > 0:
        this.setFormFieldsForForm('cuota');
        this.isCuota = true;
        break;

      case this.router.url.includes('cuota'):
        this.setFormFieldsForForm('cuota');
        this.isCuota = true;
        break;
      case this.router.url.includes('ingreso-relacionado'):
      case this.isPendingReportIngresoRelacionado:
        this.setFormFieldsForForm('ingreso-relacionado');
        this.isIngresoRelacionado = true;
        this.originToggle.optionSelected = 1;
        break;
      case this.router.url.includes('referido-a-cobrar'):
        this.setFormFieldsForForm('referido-a-cobrar');
        this.isReferidoACobrar = true;
        break;
      case this.router.url.includes('edit'):
        this.setFormFieldsForForm('rendition');
        this.isEdit = true;
        break;
      default:
        this.setFormFieldsForForm('rendition');
        this.isRendition = true;
        break;
    }

    this.isEdit = this.router.url.includes('edit');

    this.dataForForm['Venta'] = 2;
    this.dataForForm['Alquiler'] = 1;
    this.dataForForm['Alquiler temp.'] = 3;

    this.dataForForm['Dos puntas'] = 2;
    this.dataForForm['RE/MAX'] = 1;
    this.dataForForm['Otra inmobiliaria'] = 3;
    this.getOtherRealEstates();
    this.getPropertiesList();
    this.getOtherRemaxService();
    this.getClientsOriginService();

    if (this.jurisdictions) this.getJurisdictions();

    // Si es rendicion por ID
    if (this.renditionFromBE) {
      if (this.banks) this.getBanks(this.renditionFromBE.operationType);
      this.actualExchangeRate = this.renditionFromBE.exchangeRate;
      this.generateExchangeRateLimits(
        Number(this.renditionFromBE.exchangeRate),
      );
      this.datePicker.date = moment().format('YYYY-MM-DD');

      this.qrid = this.renditionFromBE.qrId ?? '';
      this.entrepreneurshipId = this.renditionFromBE.entrepreneurshipId ?? '';
      // Validamos que no pueda editar una rendicion si es del modulo viejo
      await this.getInitialAgentList(true, true, true, true);
      if (
        this.renditionFromBE.sharedBy == 2 &&
        this.renditionFromBE.sharedAgencyName != this.user?.agency_name
      ) {
        this.myOfficeIsSeller =
          this.renditionFromBE.organizationCommission.purchaseOrganizationId !=
          0;
        this.generateOtherRemaxAgentListInitialState(
          this.renditionFromBE.sharedAgencyId,
        );
      }

      this.renditionForm
        .get('bank')
        ?.setValue(this.renditionFromBE.bankText ?? '');
      this.isBankDisabled =
        !this.renditionFromBE.bank && !this.renditionFromBE.bankText;

      await this.getInitialOfficeList();

      this.specialCasesForm();
      this.checkForTeamLeader();

      this.formatForCheckout();

      if (
        this.NODE === this.NODE_DO &&
        (this.renditionFromBE.royaltyAmount ?? 0) > 0 &&
        (this.renditionFromBE.royaltyPercentage ?? 0) > 0
      ) {
        this.formatRoyalties();
      }

      if (this.NODE === this.NODE_DO) {
        this.pendingCommissionsToggle.optionSelected = this.renditionFromBE
          .pendingCommissions
          ? 0
          : 1;
        this.renditionForm
          .get('pendingCommissions')
          ?.setValue(this.renditionFromBE.pendingCommissions);
      }

      // Es reserva
    } else if (this.reservation && !this.isReferidoACobrar) {
      if (this.banks) this.getBanks(this.reservation.operationType);
      this.formatSharedWith(this.reservation);

      this.qrid = this.reservation.qrId ?? '';
      this.entrepreneurshipId = this.reservation.entrepreneurshipId ?? '';
      this.generateAgentsListAndOffices(this.reservation);
      this.formatOperationType(this.reservation.operationType);
      this.datePicker.date = moment().format('YYYY-MM-DD');
      this.setReservationValuesInForm(this.reservation);
      this.getExchangeRate();
      if (!this.reservation.credit) {
        this.renditionForm.get('bank')?.setValue('Pago al contado');
      }

      // Es rendicion nueva
    } else if (
      this.newRendition ||
      this.isReferidoACobrar ||
      this.isIngresoRelacionado
    ) {
      if (this.banks) this.getBanks(2);
      this.getExchangeRate();
      this.datePicker.date = moment().format('YYYY-MM-DD');
      this.setInitialValues();
      await this.getInitialAgentList(true, true, true, true);
      await this.getInitialOfficeList();
      this.renditionForm.get('bank')?.setValue('Pago al contado');

      await this.handleNewFormOtherOrNew();
    }
    this.NavigationOrigin = this.activatedRoute.snapshot.queryParams['origin'];
    this.isFromGestor = this.NavigationOrigin === NavigationOriginTypes.GESTOR;
  }

  formatRoyalties() {
    const ROYALTY_AMOUNT = this.renditionFromBE?.royaltyAmount ?? 0;
    const INPUT =
      (this.renditionFromBE?.organizationCommission?.purchaseAmountARS ?? 0) >
        0 ||
      (this.renditionFromBE?.organizationCommission?.saleAmountARS ?? 0) > 0
        ? 'regaliasLocal'
        : 'regaliasUSD';

    this.isRegaliasChecked = ROYALTY_AMOUNT > 0;

    if (
      this.NODE === this.NODE_DO &&
      this.isRegaliasChecked &&
      !this.renditionForm.contains('regaliasLocal') &&
      !this.renditionForm.contains('regaliasUSD')
    ) {
      this.renditionForm.addControl(
        'regaliasLocal',
        new FormControl(0, Validators.required),
      );
      this.renditionForm.addControl(
        'regaliasUSD',
        new FormControl(0, Validators.required),
      );
    }

    this.renditionForm.get(INPUT)?.setValue(ROYALTY_AMOUNT);
  }

  get statisticsComputationHint(): string {
    return this.statisticsComputationToggle.optionSelected === 0
      ? 'El 100% se le asigna al Member, sin importar el split ni cuánto cobra el Leader.'
      : 'La estadística respeta el split entre Member y Leader.';
  }

  get statisticsCheckTeamLeader(): 0 | 1 {
    return this.statisticsComputationToggle.optionSelected === 0 ? 0 : 1;
  }

  checkForTeamLeader() {
    this.hydrateStatisticsComputationMode(
      this.renditionFromBE?.teamLeaderDeductions,
      this.renditionFromBE?.cobrokerTeamLeaders,
    );
    if (
      this.renditionFromBE?.teamLeaderDeductions &&
      this.renditionFromBE.teamLeaderDeductions.length > 0
    ) {
      this.renditionFromBE?.teamLeaderDeductions?.forEach(
        (e: TeamLeaderDeduction) => {
          if (e.deductionType === 1) {
            this.renditionForm
              .get('sellerTeamLeader')
              ?.setValue(e.organizationName);

            if (e.checkTeamLeader === 1)
              this.renditionForm
                .get('sellerTeamLeaderOrigin')
                ?.setValue(
                  e.checkTeamLeader === 1
                    ? this.sellerTeamLeaderOrigin.viewValues[0]
                    : this.sellerTeamLeaderOrigin.viewValues[1],
                );

            this.sellerTeamLeaderOrigin.optionSelected =
              e.checkTeamLeader === 1 ? 0 : 1;

            this.renditionForm
              .get('sellerTeamLeaderUSD')
              ?.setValue(e.deductionAmountUsd);

            this.renditionForm
              .get('sellerTeamLeaderLocal')
              ?.setValue(e.deductionAmountArs);

            this.addSellerTeamLeader = true;
          } else {
            this.renditionForm
              .get('buyerTeamLeader')
              ?.setValue(e.organizationName);

            this.renditionForm
              .get('buyerTeamLeaderOrigin')
              ?.setValue(
                e.checkTeamLeader === 1
                  ? this.buyerTeamLeaderOrigin.viewValues[0]
                  : this.buyerTeamLeaderOrigin.viewValues[1],
              );

            this.buyerTeamLeaderOrigin.optionSelected =
              e.checkTeamLeader === 1 ? 0 : 1;

            this.renditionForm
              .get('buyerTeamLeaderUSD')
              ?.setValue(e.deductionAmountUsd);

            this.renditionForm
              .get('buyerTeamLeaderLocal')
              ?.setValue(e.deductionAmountArs);
            this.addBuyerTeamLeader = true;
          }
        },
      );
    }
  }

  checkUserFromCeroOffice() {
    this.isUserFromCeroOffice =
      (this.user &&
        this.user.agency_name === 'Cero' &&
        this.user.agency_id === 2 &&
        environment.production) ??
      false;
  }

  async handleNewFormOtherOrNew() {
    this.isCaptchmentLite =
      typeof this.newRendition != 'string' && !!this.newRendition;
    //Dirección cargada en origen: otro/nueva
    if (typeof this.newRendition == 'string') {
      this.renditionForm.get('address')?.setValue(this.newRendition);
    } else {
      //Captación elegida en buscador (autompletar address y mlsid)
      this.renditionForm.get('address')?.setValue(this.newRendition?.address);
      if (this.newRendition?.mlsid && this.NODE !== this.NODE_DO) {
        if (this.NODE === Constants.TENANT_ID_GLOBAL) {
          this.renditionForm
            .get('mlsidGlobal')
            ?.setValue(this.newRendition.mlsid);
        } else {
          const [MLSID_FIRST, MLSID_LAST] = this.newRendition.mlsid.split('-');
          this.renditionForm.get('mlsidFirst')?.setValue(MLSID_FIRST);
          this.renditionForm.get('mlsidLast')?.setValue(MLSID_LAST);
        }
      } else if (this.NODE === this.NODE_DO && this.newRendition) {
        await this.generateRenditionFromMaxCore(
          this.newRendition as PropertyListingCaptured,
        );
      }
      this.originToggle = {
        ...this.originToggle,
        viewValues: ['RE/MAX', 'Otro'],
      };
      this.originToggle = { ...this.originToggle, optionSelected: 0 };
      this.qrid = this.newRendition?.qrid ?? '';
      this.entrepreneurshipId = this.newRendition?.entrepreneurshipId ?? '';
    }
  }

  async generateRenditionFromMaxCore(data: PropertyListingCaptured) {
    if (this.isCuota) {
      const QUERY = this.activatedRoute.snapshot.queryParamMap;
      const RENDITION_ID = QUERY.get('renditionId') ?? '';

      const RESPONSE = await this.renditionFindByIdService.get(RENDITION_ID);
      this.renditionFromBE = RESPONSE?.data?.rendition;
    }

    const SET_FORM_VALUE = (controlName: string, value: any) =>
      this.renditionForm.get(controlName)?.setValue(value);

    const USER_AGENCY_NAME = this.user?.agency_name ?? '';
    // Datos básicos
    SET_FORM_VALUE('address', data.address ?? '');
    SET_FORM_VALUE('propertyType', data.propertyType ?? '');
    SET_FORM_VALUE('mlsidGlobal', data.mlsid ?? '');
    SET_FORM_VALUE('exclusiveId', this.resolveExclusivityType(data.contract));
    SET_FORM_VALUE('credit', data.aptCredit);
    if (data.closedDate) {
      SET_FORM_VALUE('date', data.closedDate);
      this.datePicker.date = moment(data.closedDate).format('YYYY-MM-DD');
      this.datePicker = { ...this.datePicker };
    }

    this.isDirectionEmpty =
      data.address === '' ||
      data.address === null ||
      data.address === undefined;

    this.entrepreneurshipId = data.entrepreneurshipId ?? '';

    if (data.closedPrice) {
      data.closedPrice.localCurrency === 'USD'
        ? SET_FORM_VALUE('closePriceUSD', data.closedPrice.usdValue)
        : SET_FORM_VALUE('closePriceLocal', data.closedPrice.localValue);
      SET_FORM_VALUE('exchangeRate', data.closedPrice.tc);
    } else {
      if (data.price.tc) {
        SET_FORM_VALUE('exchangeRate', data.price.tc);
      }

      const IS_USD = data.price.currency === 'USD';

      SET_FORM_VALUE(
        IS_USD ? 'closePriceUSD' : 'closePriceLocal',
        data.price.price,
      );
    }

    // Tipo de operación
    this.operationToggle.optionSelected = data.type === 'sale' ? 0 : 1;

    SET_FORM_VALUE(
      'operationType',
      this.operationToggle.viewValues[this.operationToggle.optionSelected],
    );

    // Agentes
    const AGENTS = data.agents ?? [];

    const SELLER_AGENTS = AGENTS.filter(
      (e: AgentsCoBrokers) =>
        this.utilService.textNormalize(e.type) === 'captacion',
    );

    const BUYER_AGENTS = AGENTS.filter(
      (e: AgentsCoBrokers) =>
        this.utilService.textNormalize(e.type) === 'venta',
    );

    const BUYER_REFERRED_AGENTS = AGENTS.filter(
      (e: AgentsCoBrokers) =>
        this.utilService.textNormalize(e.type) === 'referido',
    );

    const SELLER_AMOUNT = SELLER_AGENTS.reduce(
      (acc, curr) => acc + curr.comission,
      0,
    );

    const BUYER_AMOUNT = BUYER_AGENTS.reduce(
      (acc, curr) => acc + curr.comission,
      0,
    );

    const SELLER_MAXCORE_DATA = SELLER_AGENTS.find(
      (e) => e.agent === data.agent,
    );

    const BUYER_MAXCORE_DATA = BUYER_AGENTS.find(
      (e) => e.agent === data.soldby,
    );

    if (SELLER_MAXCORE_DATA) {
      const SELLER_CURRENCY =
        SELLER_MAXCORE_DATA.comissionCurrency === 'RD' ||
        SELLER_MAXCORE_DATA.comissionCurrency === 'DOP'
          ? 'sellerLocal'
          : 'sellerUSD';
      SET_FORM_VALUE(SELLER_CURRENCY, SELLER_AMOUNT);
    }

    if (BUYER_MAXCORE_DATA) {
      const BUYER_CURRENCY =
        BUYER_MAXCORE_DATA.comissionCurrency === 'RD' ||
        BUYER_MAXCORE_DATA.comissionCurrency === 'DOP'
          ? 'buyerLocal'
          : 'buyerUSD';
      SET_FORM_VALUE(BUYER_CURRENCY, BUYER_AMOUNT);
    }

    const SELLER_AGENT = this.fullAgentList.find(
      (e: Agent) => e.integratorSalesAssociatedId === data.agent,
    );

    const BUYER_AGENT = this.fullAgentList.find(
      (e: Agent) => e.integratorSalesAssociatedId === data.soldby,
    );

    // ==========================
    //   CASO DOS PUNTAS
    // ==========================

    if (
      SELLER_AGENT?.integratorSalesAssociatedId ===
      BUYER_AGENT?.integratorSalesAssociatedId
    ) {
      await this.onChangeSharedWith(0);
      this.buyerAgentAutocompleteChange(BUYER_AGENT?.agentName);
      this.sellerAgentAutocompleteChange(SELLER_AGENT?.agentName);
    }

    if (
      SELLER_AGENT &&
      BUYER_AGENT &&
      SELLER_AGENT?.integratorSalesAssociatedId !==
        BUYER_AGENT?.integratorSalesAssociatedId
    ) {
      await this.onChangeSharedWith(1);
      this.dropdownOfficeChange(this.user?.agency_name);
      this.onChangeSellerReferredSharedWith(0);
      this.onChangeSellerReferredSharedWith(0);

      this.buyerAgentAutocompleteChange(BUYER_AGENT.agentName);
      this.sellerAgentAutocompleteChange(SELLER_AGENT.agentName);
    }

    // ==========================
    //  SOLO COMPRADOR
    // ==========================
    if (!SELLER_AGENT && BUYER_AGENT) {
      const SELLER_OTHER_REAL_ESTATE = SELLER_AGENTS.find(
        (e) =>
          e.agent === 'Agente Externo' && e.officeName === 'Otra Inmobiliaria',
      );

      const SELLER_OTHER_OFFICE = SELLER_AGENTS.find(
        (e) => e.officeName !== USER_AGENCY_NAME && data.agent === e.agent,
      );

      if (SELLER_OTHER_REAL_ESTATE) {
        await this.onChangeSharedWith(2);
        this.sellerSharedWith.optionSelected = 2;

        SET_FORM_VALUE(
          'sellerSharedWith',
          this.sellerSharedWith.viewValues[
            this.sellerSharedWith.optionSelected
          ],
        );
        SET_FORM_VALUE(
          'sharedWithAnotherRealEstate',
          SELLER_OTHER_REAL_ESTATE.officeName,
        );
        SET_FORM_VALUE('sellerAgent', SELLER_OTHER_REAL_ESTATE.agent);
      } else if (SELLER_OTHER_OFFICE) {
        await this.onChangeSharedWith(1);
        this.sellerSharedWith.optionSelected = 1;

        SET_FORM_VALUE(
          'sellerSharedWith',
          this.sellerSharedWith.viewValues[
            this.sellerSharedWith.optionSelected
          ],
        );

        await this.dropdownOfficeChange(SELLER_OTHER_OFFICE.officeName.trim());

        const SELLER_AGENT_OTHER_REMAX = this.fullAgentList.find(
          (e: Agent) =>
            e.integratorSalesAssociatedId === SELLER_OTHER_OFFICE.agent,
        );

        if (SELLER_AGENT_OTHER_REMAX) {
          this.sellerAgentAutocompleteChange(
            SELLER_AGENT_OTHER_REMAX.agentName,
          );
        }
      }

      this.buyerSharedWith.optionSelected = 0;
      SET_FORM_VALUE(
        'buyerSharedWith',
        this.buyerSharedWith.viewValues[this.buyerSharedWith.optionSelected],
      );
      SET_FORM_VALUE('buyerOffice', USER_AGENCY_NAME);

      this.buyerAgentAutocompleteChange(BUYER_AGENT.agentName);
    }

    // ==========================
    //   SOLO CAPTADOR
    // ==========================
    if (!BUYER_AGENT && SELLER_AGENT) {
      const BUYER_OTHER_REAL_ESTATE = BUYER_AGENTS.find(
        (e) =>
          e.agent === 'Agente Externo' && e.officeName === 'Otra Inmobiliaria',
      );

      const BUYER_OTHER_OFFICE = BUYER_AGENTS.find(
        (e) => e.officeName !== USER_AGENCY_NAME && data.soldby === e.agent,
      );

      if (BUYER_OTHER_REAL_ESTATE) {
        await this.onChangeSharedWith(2);
        this.buyerSharedWith.optionSelected = 2;

        SET_FORM_VALUE(
          'buyerSharedWith',
          this.buyerSharedWith.viewValues[this.buyerSharedWith.optionSelected],
        );
        SET_FORM_VALUE(
          'sharedWithAnotherRealEstate',
          BUYER_OTHER_REAL_ESTATE.officeName,
        );
        SET_FORM_VALUE('buyerAgent', BUYER_OTHER_REAL_ESTATE.agent);
      } else if (BUYER_OTHER_OFFICE) {
        await this.onChangeSharedWith(1);
        this.buyerSharedWith.optionSelected = 1;

        SET_FORM_VALUE(
          'buyerSharedWith',
          this.buyerSharedWith.viewValues[this.buyerSharedWith.optionSelected],
        );
        await this.dropdownOfficeChange(BUYER_OTHER_OFFICE.officeName.trim());

        const BUYER_AGENT_OTHER_REMAX = this.fullAgentList.find(
          (e: Agent) =>
            e.integratorSalesAssociatedId === BUYER_OTHER_OFFICE.agent,
        );

        if (BUYER_AGENT_OTHER_REMAX) {
          this.buyerAgentAutocompleteChange(BUYER_AGENT_OTHER_REMAX.agentName);
        }
      }

      this.sellerSharedWith.optionSelected = 0;
      SET_FORM_VALUE(
        'sellerSharedWith',
        this.sellerSharedWith.viewValues[this.sellerSharedWith.optionSelected],
      );
      SET_FORM_VALUE('sellerOffice', USER_AGENCY_NAME);

      this.sellerAgentAutocompleteChange(SELLER_AGENT.agentName);
    }

    this.performCalculation('value');

    // ==========================
    //   CASO COBROKERS
    // ==========================

    const SELLER_TEAM_LEADER = this.fullAgentList.find(
      (e: Agent) => e.id === SELLER_AGENT?.teamLeaderId,
    );

    const SELLER_TEAM_LEADER_INTERNATIONAL_ID =
      SELLER_TEAM_LEADER?.integratorSalesAssociatedId;

    const FIND_TEAM_LEADER = SELLER_AGENTS.find(
      (e) => e.agent === SELLER_TEAM_LEADER_INTERNATIONAL_ID,
    );

    const SELLER_2_AGENTS_BUT_NOT_COBROKER =
      SELLER_AGENTS.length === 2 &&
      SELLER_AGENT?.teamId &&
      SELLER_AGENT?.teamLeaderId !== SELLER_AGENT?.id &&
      FIND_TEAM_LEADER;

    const IS_SELLER_COBROKER =
      SELLER_AGENTS.length > 1 && !SELLER_2_AGENTS_BUT_NOT_COBROKER;

    if (IS_SELLER_COBROKER) {
      const COBROKERS = SELLER_AGENTS.filter(
        (e) =>
          e.agent !== data.agent &&
          e.agent !== SELLER_TEAM_LEADER_INTERNATIONAL_ID &&
          e.agent !== SELLER_AGENT?.integratorSalesAssociatedId,
      );

      // beto
      for (const coBroker of COBROKERS) {
        if (coBroker.comission > 0) {
          const index = this.coBrokers.length;

          const NEW_ID_COBROKER = this.getNextCoBrokerId();
          this.sellerCobrokers.insert(index, this.createSellerCobrokerForm());
          this.coBrokers.push({
            id: NEW_ID_COBROKER,
          });
          this.generateNewCoBrokerInputs(NEW_ID_COBROKER);

          // Caso cobroker propia oficina
          const COBROKER = this.fullAgentList.find(
            (e) => e.integratorSalesAssociatedId === coBroker.agent,
          );
          if (
            COBROKER &&
            coBroker.officeName.trim() === this.user?.agency_name
          ) {
            await this.onChangeSellerCobrokerSharedWith(
              0,
              { id: NEW_ID_COBROKER },
              index,
            );
            this.sellerCobrokerAgentAutocompleteChange(
              COBROKER.agentName,
              index,
            );
          } else {
            // Caso cobroker otra oficina
            const COBROKER_OFFICE = this.officesList.find(
              (e) => e.name === coBroker.officeName.trim(),
            );
            if (COBROKER_OFFICE) {
              await this.onChangeSellerCobrokerSharedWith(
                1,
                { id: NEW_ID_COBROKER },
                index,
              );
              await this.sellerCobrokerOfficeAutocompleteChange(
                COBROKER_OFFICE.name.trim(),
                { id: NEW_ID_COBROKER },
                index,
              );

              const COBROKER_AGENT = this.cobrokersAgentListOtherOffice.find(
                (e) =>
                  e.integratorSalesAssociatedId === coBroker?.agent?.trim(),
              );

              this.sellerCobrokerAgentAutocompleteChange(
                COBROKER_AGENT?.agentName,
                index,
              );
            } else {
              await this.onChangeSellerCobrokerSharedWith(
                2,
                { id: NEW_ID_COBROKER },
                index,
              );
              this.changeSellerCobrokerOther(coBroker.officeName.trim(), index);
            }
          }

          const IS_USD =
            coBroker.comissionCurrency !== 'RD' &&
            coBroker.comissionCurrency !== 'DOP';

          IS_USD
            ? this.changeInputSellerCobrokerUSD(coBroker.comission, index)
            : this.changeInputSellerCobrokerLocal(coBroker.comission, index);
        }
      }
    }

    // ==========================
    //   SOLO REFERIDO
    // ==========================
    if (BUYER_REFERRED_AGENTS.length > 0) {
      this.addBuyerReferred = true;
      if (
        BUYER_REFERRED_AGENTS[0].agent === 'Agente Externo' &&
        BUYER_REFERRED_AGENTS[0].officeName === 'Otra Inmobiliaria'
      ) {
        await this.onChangeBuyerReferredSharedWith(2);
        this.changeBuyerReferredOther(BUYER_REFERRED_AGENTS[0].agent);
      }

      const BUYER_REFERRED_AMOUNT = BUYER_REFERRED_AGENTS[0].comission;
      const IS_USD =
        BUYER_REFERRED_AGENTS[0].comissionCurrency !== 'RD' &&
        BUYER_REFERRED_AGENTS[0].comissionCurrency !== 'DOP';

      IS_USD
        ? this.changeInputBuyerReferredUSD(BUYER_REFERRED_AMOUNT)
        : this.changeInputBuyerReferredLocal(BUYER_REFERRED_AMOUNT);
    }
  }

  specialCasesForm() {
    if (this.renditionFromBE) {
      if (this.isCuota) {
        this.renditionForm
          .get('closePriceUSD')
          ?.setValue(this.renditionFromBE.totalAmountOperationUSD);
        this.renditionForm
          .get('closePriceLocal')
          ?.setValue(this.renditionFromBE.totalAmountOperationARS);
      }

      if (this.isReferidoACobrar) {
        this.setReferiadoACobrarInitialValues();
      }
    }
  }

  checkTypeOfForm() {
    switch (true) {
      case this.router.url.includes('cuota'):
        this.setFormFieldsForForm('cuota');
        this.isCuota = true;
        break;
      case this.router.url.includes('ingreso-relacionado'):
        this.setFormFieldsForForm('ingreso-relacionado');
        this.isIngresoRelacionado = true;
        this.originToggle.optionSelected = 1;
        this.renditionForm.get('originToggle')?.setValue('Nueva');
        break;
      case this.router.url.includes('referido-a-cobrar'):
        this.setFormFieldsForForm('referido-a-cobrar');
        this.isReferidoACobrar = true;
        break;
      case this.router.url.includes('edit'):
        this.setFormFieldsForForm('rendition');
        this.isEdit = true;
        break;
      default:
        this.setFormFieldsForForm('rendition');
        this.isRendition = true;
        break;
    }
  }

  generateExchangeRateLimits(rate: number) {
    this.exchangeRateMax =
      this.NODE === Constants.TENANT_ID_GLOBAL ? 99999999 : rate * 1.4;
    this.exchangeRateMin =
      this.NODE === Constants.TENANT_ID_GLOBAL ? 1 : rate * 0.4;
    this.renditionForm
      .get('exchangeRate')
      ?.setValidators([
        Validators.required,
        this.exchangeRateValidator(this.exchangeRateMin, this.exchangeRateMax),
      ]);
  }

  generateOtherRemaxAgentListInitialState(id: number) {
    const URL = id + '/agents';
    this.renditionsService.get(URL).then((response: any) => {
      if (response?.data?.agents) {
        if (this.myOfficeIsSeller) {
          this.buyerAgentAutocomplete.options = [];
          response.data.agents.forEach((e: Agent) => {
            this.buyerAgentAutocomplete.options.push(e.agentName);
          });
        } else {
          this.sellerAgentAutocomplete.options = [];
          response.data.agents.forEach((e: Agent) => {
            this.sellerAgentAutocomplete.options.push(e.agentName);
          });
        }
      }
    });
  }

  addUnloadListener() {
    this.unloadListener = this.renderer.listen(
      'window',
      'beforeunload',
      this.unloadNotification.bind(this),
    );
  }

  unloadNotification(event: any) {
    event.returnValue = true;
  }

  removeUnloadListener() {
    if (this.unloadListener) {
      this.unloadListener();
      this.unloadListener = null;
    }
  }

  getOtherRealEstates() {
    const URL = this.user?.agency_id.toString() ?? '';
    this.otherRealEstateService.get(URL).then((response) => {
      if (response?.othersRealEstates) {
        this.otherRealEstateList = [...response.othersRealEstates];
        response.othersRealEstates.forEach(
          (e: { id: number; name: string; visible: boolean }) => {
            if (e.visible) this.anotherRealEstateConfig.options.push(e.name);
          },
        );
      }
    });
  }

  setCuotaInitialValues() {
    this.invoices = [];
    this.renditionForm.get('closePriceUSD')?.setValue(0);
    this.renditionForm.get('closePriceLocal')?.setValue(0);

    this.renditionForm.get('sellerPercentage')?.setValue(0);
    this.renditionForm.get('buyerPercentage')?.setValue(0);
  }

  setInitialValues() {
    // Origen
    this.originToggle.optionSelected = 1;

    // Compartida con
    this.sharedWithToggle.optionSelected = 0;

    // Puntas
    this.sellerSharedWith.optionSelected = 0;
    this.buyerSharedWith.optionSelected = 0;

    // Oficina
    this.renditionForm.get('sellerOffice')?.setValue(this.user?.agency_name);
    this.renditionForm.get('buyerOffice')?.setValue(this.user?.agency_name);
  }

  setReferiadoACobrarInitialValues() {
    // Nombre agente
    const NAME =
      this.renditionFromBE?.organizationCommission.purchaseOrganizationName ??
      this.renditionFromBE?.organizationCommission.saleOrganizationName;

    this.renditionForm.get('referredName')?.setValue(NAME);

    // Origen referido
    const IS_SELLER =
      this.renditionFromBE?.organizationCommission.purchaseOrganizationName;
    this.originReferredToggle.optionSelected = IS_SELLER ? 0 : 1;

    // Compartida con
    this.sharedWithToggle.optionSelected =
      this.renditionFromBE?.sharedBy == 2 ? 0 : 1;
    if (this.renditionFromBE?.sharedBy == 2) {
      this.renditionForm
        .get('sharedWithOffice')
        ?.setValue(this.renditionFromBE.sharedAgencyName);
    }

    this.updateSharedWithOfficeValidator();

    if (this.renditionFromBE?.sharedBy == 3) {
      this.renditionForm
        .get('sharedWith')
        ?.setValue(
          this.sharedWithToggle.viewValues[
            this.sharedWithToggle.optionSelected
          ],
        );
      this.renditionFromBE.otherRealEstate?.name
        ? this.renditionForm
            .get('sharedWithAnotherRealEstate')
            ?.setValue(this.renditionFromBE.otherRealEstate.name)
        : this.renditionForm
            .get('sharedWithAnotherRealEstate')
            ?.setValue(this.renditionFromBE.sharedAgencyName);
    }

    // Deducciones

    this.renditionForm
      .get('sellerAgentDeductionPercentage')
      ?.setValue(
        this.renditionFromBE?.purchaseDeduction.deductionPercentage ?? 0,
      );

    this.renditionForm
      .get('sellerAgentDeductionUSD')
      ?.setValue(
        this.renditionFromBE?.purchaseDeduction.deductionAmountUSD ?? 0,
      );

    this.renditionForm
      .get('sellerAgentDeductionLocal')
      ?.setValue(
        this.renditionFromBE?.purchaseDeduction.deductionAmountARS ?? 0,
      );

    this.renditionForm
      .get('buyerAgentDeductionPercentage')
      ?.setValue(this.renditionFromBE?.saleDeduction.deductionPercentage ?? 0);

    this.renditionForm
      .get('buyerAgentDeductionUSD')
      ?.setValue(this.renditionFromBE?.saleDeduction.deductionAmountUSD ?? 0);

    this.renditionForm
      .get('buyerAgentDeductionLocal')
      ?.setValue(this.renditionFromBE?.saleDeduction.deductionAmountARS ?? 0);

    if (
      this.renditionFromBE?.otherDeductions &&
      this.renditionFromBE?.otherDeductions.length > 0
    ) {
      this.showSellerManualDeduction =
        this.renditionFromBE?.otherDeductions[0].type == 1;
      this.showBuyerManualDeduction =
        this.renditionFromBE?.otherDeductions[0].type != 1;

      this.renditionFromBE?.otherDeductions[0].type == 1
        ? this.renditionForm
            .get('sellerManualDeductionName')
            ?.setValue(this.renditionFromBE?.otherDeductions[0].description)
        : this.renditionForm
            .get('buyerManualDeductionName')
            ?.setValue(this.renditionFromBE?.otherDeductions[0].description);
      this.renditionFromBE?.otherDeductions[0].type == 1
        ? this.renditionForm
            .get('sellerManualDeductionUSD')
            ?.setValue(this.renditionFromBE?.otherDeductions[0].amountUSD)
        : this.renditionForm
            .get('buyerManualDeductionUSD')
            ?.setValue(this.renditionFromBE?.otherDeductions[0].amountUSD);
      this.renditionFromBE?.otherDeductions[0].type == 1
        ? this.renditionForm
            .get('sellerManualDeductionLocal')
            ?.setValue(this.renditionFromBE?.otherDeductions[0].amountARS)
        : this.renditionForm
            .get('buyerManualDeductionLocal')
            ?.setValue(this.renditionFromBE?.otherDeductions[0].amountARS);
    }
  }

  async getInitialOfficeList() {
    const OFFICE_ITEM = {
      id: 2,
      name: 'Cero',
    };

    const REGION_ID =
      (this.NODE === this.NODE_GLOBAL
        ? this.user?.agency_region.toString()
        : '') ?? '';

    const response: any = await this.officeListService.get(REGION_ID);
    if (response?.data?.agencies) {
      this.officesList = [...response.data.agencies];
      if (this.isUserFromCeroOffice) {
        this.officesList.push(OFFICE_ITEM);
      }

      if (this.renditionFromBE)
        this.formatRenditionFromBeToForm(this.renditionFromBE);
    }
  }

  referredNameChange($event: string | undefined) {
    this.originReferredToggle.optionSelected == 0
      ? this.renditionForm.get('sellerAgent')?.setValue($event)
      : this.renditionForm.get('buyerAgent')?.setValue($event);
    this.originReferredToggle.optionSelected == 0
      ? this.renditionForm.get('buyerAgent')?.setValue('')
      : this.renditionForm.get('sellerAgent')?.setValue('');

    this.renditionForm.get('referredName')?.setValue($event ?? '');
    this.calculationsJurisdiction();
  }

  async getInitialAgentList(
    seller: boolean,
    buyer: boolean,
    sellerReferred: boolean,
    buyerReferred: boolean,
  ) {
    const URL = this.user?.agency_id + '/agents';
    if (seller) this.sellerAgentAutocomplete.options = [];
    if (sellerReferred) this.sellerReferredAgentAutocomplete.options = [];
    if (buyer) this.buyerAgentAutocomplete.options = [];
    if (buyerReferred) this.buyerReferredAgentAutocomplete.options = [];
    const response = await this.renditionsService.get(URL);
    if (response?.data?.agents) {
      this.fullAgentList = [...this.fullAgentList, ...response.data.agents];

      response.data.agents.forEach((e: Agent) => {
        if (
          !(
            this.NODE === this.NODE_DO &&
            (!e.teamId || !e.teamLeaderId) &&
            e.agentType === 'JUNIOR'
          )
        ) {
          if (seller) {
            this.sellerAgentAutocomplete.options.push(e.agentName);
          }
          if (sellerReferred)
            this.sellerReferredAgentAutocomplete.options.push(e.agentName);
          if (buyer) {
            this.buyerAgentAutocomplete.options.push(e.agentName);
          }
          if (buyerReferred)
            this.buyerReferredAgentAutocomplete.options.push(e.agentName);
        }
      });

      this.sellerAgentAutocomplete.options.sort((a: string, b: string) =>
        a.toLowerCase() > b.toLowerCase() ? 1 : -1,
      );

      this.sellerReferredAgentAutocomplete.options.sort(
        (a: string, b: string) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1),
      );

      this.buyerAgentAutocomplete.options.sort((a: string, b: string) =>
        a.toLowerCase() > b.toLowerCase() ? 1 : -1,
      );

      this.buyerReferredAgentAutocomplete.options.sort(
        (a: string, b: string) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1),
      );
    }

    this.formatForCheckout();
  }

  async getInitialAgentsCobroker(officeId: number) {
    const URL = officeId + '/agents';
    return this.renditionsService.get(URL);
  }

  getExchangeRate() {
    const URL = this.user?.agency_id.toString() + '/tc';
    this.renditionsService.get(URL).then((response: any) => {
      if (response?.data?.tc) this.actualExchangeRate = response.data.tc;

      this.exchangeRateMax =
        this.NODE === Constants.TENANT_ID_GLOBAL
          ? 99999999
          : response.data.tc * 1.4;
      this.exchangeRateMin =
        this.NODE === Constants.TENANT_ID_GLOBAL ? 1 : response.data.tc * 0.4;

      this.renditionForm
        .get('exchangeRate')
        ?.setValidators([
          Validators.required,
          this.exchangeRateValidator(
            this.exchangeRateMin,
            this.exchangeRateMax,
          ),
        ]);

      this.renditionForm.get('exchangeRate')?.updateValueAndValidity();

      if (this.renditionForm.value.exchangeRate) return;
      this.reservation
        ? this.renditionForm
            .get('exchangeRate')
            ?.setValue(this.reservation.exchangeRate)
        : this.renditionForm.get('exchangeRate')?.setValue(response.data.tc);
    });
  }

  getClientsOriginService() {
    this.clientsOriginService.get('').then((response: any) => {
      if (response?.data?.customersOrigin) {
        this.clientOirgin = [...response.data.customersOrigin];
        response?.data?.customersOrigin.forEach(
          (e: { id: number; label: string }) => {
            this.dropdownSellerClient.options.push(e.label);
            this.sellerClientDOAutocomplete.options.push(e.label);
            this.dropdownBuyerClient.options.push(e.label);
            this.buyerClientDOAutocomplete.options.push(e.label);
          },
        );
      }
    });
  }

  generateAgentsListAndOffices(data: ReservationModel) {
    const AGENCY_ID =
      !data || data.agencyId == 0
        ? this.user?.agency_id.toString()
        : data.agencyId.toString();

    const URL = AGENCY_ID + '/agents';
    this.renditionsService.get(URL).then((response: any) => {
      if (response?.data?.agents) {
        this.fullAgentList = [...this.fullAgentList, ...response.data.agents];
        const ITEM_SELLER: Agent = response.data.agents.find(
          (e: Agent) => e.id == data.organizationIdSeller,
        );
        // Checkeo si el vendedor pertenece a mi oficina
        if (ITEM_SELLER) {
          this.myOfficeIsSeller = true;
          this.sellerSharedWith.optionSelected = 0;
          this.renditionForm
            .get('sellerAgent')
            ?.setValue(ITEM_SELLER.agentName);
          this.renditionForm
            .get('sellerSharedWith')
            ?.setValue(
              this.sellerSharedWith.viewValues[
                this.sellerSharedWith.optionSelected
              ],
            );

          this.updateSellerTeamLeader(ITEM_SELLER.agentName);

          response.data.agents.forEach((e: Agent) => {
            this.sellerAgentAutocomplete.options.push(e.agentName);
            this.sellerReferredAgentAutocomplete.options.push(e.agentName);
            this.buyerReferredAgentAutocomplete.options.push(e.agentName);

            this.agentsListMyOffice.push(e.agentName);
          });

          // Checkeo si el comprador pertenece a mi oficina
        }
        const ITEM_BUYER = response.data.agents.find(
          (e: Agent) => e.id == data.organizationIdPurchaser,
        );
        if (ITEM_BUYER) {
          this.myOfficeIsSeller = false;
          this.buyerSharedWith.optionSelected = 0;
          this.renditionForm.get('buyerAgent')?.setValue(ITEM_BUYER.agentName);

          this.renditionForm
            .get('buyerSharedWith')
            ?.setValue(
              this.buyerSharedWith.viewValues[
                this.buyerSharedWith.optionSelected
              ],
            );

          this.updateBuyerTeamLeader(ITEM_BUYER.agentName);

          response.data.agents.forEach((e: Agent) => {
            this.buyerAgentAutocomplete.options.push(e.agentName);
            this.agentsListMyOffice.push(e.agentName);
            this.sellerReferredAgentAutocomplete.options.push(e.agentName);
            this.buyerReferredAgentAutocomplete.options.push(e.agentName);
          });
        }
      }

      this.getOfficesList(data);

      if (this.NODE === this.NODE_GLOBAL) {
        this.resolveSharedWithPuntasForGlobal(data);
      }

      if (
        this.NODE != this.NODE_GLOBAL &&
        data.sharedAgencyId &&
        data.sharedBy == 2 &&
        (!data.organizationIdSeller ||
          data.organizationIdSeller <= 0 ||
          !data.organizationIdPurchaser ||
          data.organizationIdPurchaser <= 0)
      ) {
        this.getOtherRemaxAgentsList(data);
      }

      if (this.NODE === this.NODE_GLOBAL) {
        if (data.organizationNameOtherRemaxComprador) {
          this.renditionForm
            .get('buyerAgent')
            ?.setValue(data.organizationNameOtherRemaxComprador);
        }
        if (data.organizationNameOtherRemaxVendedor) {
          this.renditionForm
            .get('sellerAgent')
            ?.setValue(data.organizationNameOtherRemaxVendedor);
        }
      }

      if (data.sharedBy == 3) {
        this.formatReservationOtherRealEstate(data);
      }
      this.formatForCheckout();
    });
  }

  resolveSharedWithPuntasForGlobal(data: ReservationModel) {
    //Punta vendedora
    switch (true) {
      case data.organizationIdSeller > 0:
        this.sellerSharedWith.optionSelected = 0;

        this.inputAgentGlobalSeller = false;
        break;
      case data.organizationIdSeller === -2:
        this.sellerSharedWith.optionSelected = 1;
        this.inputAgentGlobalSeller = true;
        break;

      default:
        this.sellerSharedWith.optionSelected = 3;
        this.inputAgentGlobalSeller = true;
        break;
    }
    // Punta compradora
    switch (true) {
      case data.organizationIdPurchaser > 0:
        this.buyerSharedWith.optionSelected = 0;
        this.inputAgentGlobalBuyer = false;
        break;
      case data.organizationIdPurchaser === -2:
        this.buyerSharedWith.optionSelected = 1;
        this.inputAgentGlobalBuyer = true;
        break;

      default:
        this.buyerSharedWith.optionSelected = 3;
        this.inputAgentGlobalBuyer = true;
        break;
    }

    this.renditionForm
      .get('sellerSharedWith')
      ?.setValue(
        this.sellerSharedWith.viewValues[this.sellerSharedWith.optionSelected],
      );

    this.renditionForm
      .get('buyerSharedWith')
      ?.setValue(
        this.buyerSharedWith.viewValues[this.buyerSharedWith.optionSelected],
      );
  }

  formatReservationOtherRealEstate(data: ReservationModel) {
    const OTHER_ESTATE = data.otherRealEstate
      ? data.otherRealEstate?.name
      : data.sharedAgencyName;

    this.renditionForm
      .get('sharedWithAnotherRealEstate')
      ?.setValue(OTHER_ESTATE);

    if (!this.anotherRealEstateConfig.options.includes(OTHER_ESTATE)) {
      this.anotherRealEstateConfig.options.push(OTHER_ESTATE);
    }

    if (!data.otherRealEstate && data.sharedAgencyName) {
      this.renditionForm
        .get('anotherRealEstateInput')
        ?.setValue(data.sharedAgencyName);
    }

    this.renditionForm
      .get('sellerAgent')
      ?.setValue(data.organizationNameSeller);
    this.renditionForm
      .get('buyerAgent')
      ?.setValue(data.organizationNamePurchaser);

    if (this.myOfficeIsSeller) {
      this.renditionForm.get('sellerOffice')?.setValue(this.user?.agency_name);
      this.renditionForm.get('buyerSharedWith')?.setValue('Otro');
      this.buyerSharedWith.optionSelected = 2;
      this.renditionForm.removeControl('buyerOffice');
    } else {
      this.renditionForm.get('buyerOffice')?.setValue(this.user?.agency_name);
      this.renditionForm.get('sellerSharedWith')?.setValue('Otro');
      this.sellerSharedWith.optionSelected = 2;
      this.renditionForm.removeControl('sellerOffice');
    }
  }

  getOfficesList(data: ReservationModel) {
    const CERO_OFFICE = {
      id: 2,
      name: 'Cero',
    };

    const REGION_ID =
      (this.NODE === this.NODE_GLOBAL
        ? this.user?.agency_region.toString()
        : '') ?? '';

    this.officeListService.get(REGION_ID).then((response: any) => {
      if (response?.data?.agencies) {
        this.officesList = [...response.data.agencies];
        if (this.isUserFromCeroOffice) {
          this.officesList.push(CERO_OFFICE);
        }
        const MY_OFFICE = this.officesList.find(
          (e: { id: number; name: string }) => e.id == data.agencyId,
        );
        if (MY_OFFICE) {
          let anotherOffice = undefined;
          if (data.sharedAgencyId && data.sharedBy == 2) {
            anotherOffice = this.officesList.find(
              (e: { id: number; name: string }) => e.id == data.sharedAgencyId,
            );
          }
          const ARRAY: string[] = [];
          response?.data?.agencies.forEach(
            (e: { id: number; name: string }) => {
              if (e.name != this.user?.agency_name) ARRAY.push(e.name);
            },
          );

          if (this.isUserFromCeroOffice) {
            ARRAY.push(CERO_OFFICE.name);
          }

          this.buyerOfficeAutocomplete.options = [...ARRAY];
          this.sellerOfficeAutocomplete.options = [...ARRAY];
          this.buyerReferredOfficeAutocomplete.options = [...ARRAY];
          this.sellerReferredOfficeAutocomplete.options = [...ARRAY];
          this.sellerReferredOfficeAutocomplete.options =
            this.sellerReferredOfficeAutocomplete.options.filter(
              (e: string) => e != this.user?.agency_name,
            );
          this.buyerReferredOfficeAutocomplete.options =
            this.buyerReferredOfficeAutocomplete.options.filter(
              (e: string) => e != this.user?.agency_name,
            );
          this.setOfficesValues(MY_OFFICE, anotherOffice, data);
        }
      }
    });
  }

  setOfficesValues(
    myOffice: { id: number; name: string },
    anotherOffice: { id: number; name: string } | undefined,
    data: ReservationModel,
  ) {
    if (!this.renditionForm.get('sellerOffice')) {
      this.renditionForm.addControl(
        'sellerOffice',
        new FormControl('', Validators.required),
      );
    }
    if (!this.renditionForm.get('buyerOffice')) {
      this.renditionForm.addControl(
        'buyerOffice',
        new FormControl('', Validators.required),
      );
    }

    if (this.sharedWithToggle.optionSelected === 0) {
      this.renditionForm.get('sellerOffice')?.setValue(myOffice.name);
      this.renditionForm.get('buyerOffice')?.setValue(myOffice.name);
    } else {
      const SELLER =
        data.organizationIdSeller && data.organizationIdSeller > 0
          ? myOffice
          : anotherOffice;

      const BUYER =
        data.organizationIdPurchaser && data.organizationIdPurchaser > 0
          ? myOffice
          : anotherOffice;

      SELLER
        ? this.renditionForm.get('sellerOffice')?.setValue(SELLER?.name)
        : this.renditionForm.removeControl('sellerOffice');
      BUYER
        ? this.renditionForm.get('buyerOffice')?.setValue(BUYER?.name)
        : this.renditionForm.removeControl('buyerOffice');
    }
  }

  getOtherRemaxAgentsList(data: ReservationModel) {
    const URL = data.sharedAgencyId + '/agents';
    this.renditionsService.get(URL).then((response: any) => {
      if (response?.data?.agents) {
        this.fullAgentList = [...this.fullAgentList, ...response.data.agents];
        if (this.myOfficeIsSeller) {
          this.buyerSharedWith.optionSelected = 1;
          this.renditionForm
            .get('buyerSharedWith')
            ?.setValue(
              this.buyerSharedWith.viewValues[
                this.buyerSharedWith.optionSelected
              ],
            );
          response.data.agents.forEach((e: Agent) => {
            this.buyerAgentAutocomplete.options.push(e.agentName);
          });
          if (data.organizationNameOtherRemaxComprador) {
            this.renditionForm
              .get('buyerAgent')
              ?.setValue(data.organizationNameOtherRemaxComprador);
          }
        } else {
          this.sellerSharedWith.optionSelected = 1;
          this.renditionForm
            .get('sellerSharedWith')
            ?.setValue(
              this.sellerSharedWith.viewValues[
                this.sellerSharedWith.optionSelected
              ],
            );
          response.data.agents.forEach((e: Agent) => {
            this.sellerAgentAutocomplete.options.push(e.agentName);
          });
          if (data.organizationNameOtherRemaxVendedor) {
            this.renditionForm
              .get('sellerAgent')
              ?.setValue(data.organizationNameOtherRemaxVendedor);
          }
        }
      }
      this.formatForCheckout();
    });
  }

  getJurisdictions() {
    this.jurisdictions.forEach(
      (e: {
        id: number;
        iibb: number;
        name: string;
        previsionalCash: number;
        puroDeductionPercentage: number;
        teamDeductionPercentage: number;
        altoDeductionPercentage: number;
      }) => {
        this.dropdownJurisdiction.options.push(e.name);
      },
    );
    if (this.dropdownJurisdiction.options.length == 1) {
      this.renditionForm
        .get('jurisdiction')
        ?.setValue(this.dropdownJurisdiction.options[0]);
    }
    this.dropdownJurisdiction = { ...this.dropdownJurisdiction };
  }

  setReservationValuesInForm(data: ReservationModel) {
    this.setValuesSectionProperty(data);
    this.setValuesSectionOperation(data);
    this.setValuesSectionPuntas(data);
    this.setValuesSectionPuntasRange(data);
    this.setValuesSectionSellerAgent(data);
    this.setValuesSectionBuyerAgent(data);
    this.setNotes(data);

    this.performCalculation();
  }

  setNotes(data: ReservationModel) {
    this.renditionForm.get('reservationNotes')?.setValue(data.notes);
  }

  setValuesSectionProperty(data: ReservationModel) {
    this.renditionForm.get('address')?.setValue(data.address);
    this.renditionForm.get('propertyType')?.setValue(data.propertyTypeName);
    if (
      this.NODE === Constants.TENANT_ID_GLOBAL ||
      this.NODE === Constants.TENANT_ID_DO
    ) {
      this.renditionForm.get('mlsidGlobal')?.setValue(data.mlsid);
    } else {
      this.formatMlsId(data.mlsid);
    }
  }

  setValuesSectionOperation(data: ReservationModel) {
    this.renditionForm.get('date')?.setValue(data.statisticsDate);
    this.renditionForm.get('credit')?.setValue(data.credit);
    this.renditionForm.get('exchangeRate')?.setValue(data.exchangeRate);
    data.currency == 'USD'
      ? this.renditionForm.get('closePriceUSD')?.setValue(data.price)
      : this.renditionForm.get('closePriceLocal')?.setValue(data.price);
  }

  setValuesSectionPuntas(data: ReservationModel) {
    if (data.percentageComitionSeller) {
      this.renditionForm
        .get('sellerPercentage')
        ?.setValue(data.percentageComitionSeller);
      data.currency == 'USD'
        ? this.renditionForm
            .get('sellerUSD')
            ?.setValue(data.amountComitionSeller)
        : this.renditionForm
            .get('sellerLocal')
            ?.setValue(data.amountComitionSeller);
    }

    if (data.percentageComitionPurchaser) {
      this.renditionForm
        .get('buyerPercentage')
        ?.setValue(data.percentageComitionPurchaser);
      data.currency == 'USD'
        ? this.renditionForm
            .get('buyerUSD')
            ?.setValue(data.amountComitionPurchaser)
        : this.renditionForm
            .get('buyerLocal')
            ?.setValue(data.amountComitionPurchaser);
    }
  }

  setValuesSectionPuntasRange(data: ReservationModel) {
    if (data.currency == 'USD') {
      this.renditionForm
        .get('sellerRelation')
        ?.setValue(
          (this.renditionForm.value.sellerUSD /
            (this.renditionForm.value.sellerUSD +
              this.renditionForm.value.buyerUSD)) *
            100,
        );
      this.renditionForm
        .get('buyerRelation')
        ?.setValue(100 - this.renditionForm.value.sellerRelation);
    } else {
      this.renditionForm
        .get('sellerRelation')
        ?.setValue(
          (this.renditionForm.value.sellerLocal /
            (this.renditionForm.value.sellerLocal +
              this.renditionForm.value.buyerLocal)) *
            100,
        );
      this.renditionForm
        .get('buyerRelation')
        ?.setValue(100 - this.renditionForm.value.sellerRelation);
    }
    this.sellerRelation = 100 - this.renditionForm.value.buyerRelation;

    if (data.shared) this.onRelationFiftyFifty();
  }

  setValuesSectionSellerAgent(data: ReservationModel) {
    if (data.organizationIdSeller && data.organizationIdSeller > 0) {
      this.renditionForm.get('sellerOffice')?.setValue(this.user?.agency_name);
    } else {
      this.renditionForm.get('sellerOffice')?.setValue(data.sharedAgencyName);
    }
    if (data.organizationIdSeller != -2) {
      this.renditionForm
        .get('sellerAgent')
        ?.setValue(data.organizationNameSeller);
    }

    this.renditionForm.get('exclusiveId')?.setValue(data.captationType);

    this.renditionForm.get('sellerClient')?.setValue(data.customerOriginSale);
    this.renditionForm
      .get('sellerSharedWith')
      ?.setValue(
        this.sellerSharedWith.viewValues[this.sellerSharedWith.optionSelected],
      );
  }

  setValuesSectionBuyerAgent(data: ReservationModel) {
    if (data.organizationIdPurchaser && data.organizationIdPurchaser > 0) {
      this.renditionForm.get('buyerOffice')?.setValue(this.user?.agency_name);
    } else {
      this.renditionForm.get('buyerOffice')?.setValue(data.sharedAgencyName);
    }

    if (data.organizationIdPurchaser != -2) {
      this.renditionForm
        .get('buyerAgent')
        ?.setValue(data.organizationNamePurchaser);
    }
    this.renditionForm
      .get('buyerClient')
      ?.setValue(data.customerOriginPurchase);
    this.renditionForm
      .get('buyerSharedWith')
      ?.setValue(
        this.buyerSharedWith.viewValues[this.buyerSharedWith.optionSelected],
      );
  }

  rangeFromRelation($event: number) {
    if ($event != this.renditionForm.value.sellerRelation) {
      if (this.isRelationFiftyFifty) {
        this.sellerRelation = 50;
        this.buyerRelation = 50;
        this.renditionForm.get('sellerRelation')?.setValue(50);
        this.renditionForm.get('buyerRelation')?.setValue(50);
      } else {
        const RESULT = $event ?? 0;
        if (Number(RESULT) !== this.renditionForm.value.sellerRelation) {
          this.renditionForm.get('sellerRelation')?.setValue(100 - RESULT);
          this.renditionForm.get('buyerRelation')?.setValue(RESULT);

          const EXCHANGE = this.renditionForm.value.exchangeRate;
          const TOTAL_SELER =
            this.renditionForm.value.sellerUSD +
            this.renditionForm.value.sellerLocal / EXCHANGE;

          const TOTAL_BUYER =
            this.renditionForm.value.buyerUSD +
            this.renditionForm.value.buyerLocal / EXCHANGE;

          const RELATION_1 =
            Math.round(
              (TOTAL_SELER / (TOTAL_BUYER + TOTAL_SELER)) * 100 * 100,
            ) / 100;
          const RELATION_2 = Math.round((100 - RESULT) * 100) / 100;
          if (RELATION_1 == RELATION_2) {
            this.sellerRelation =
              (TOTAL_SELER / (TOTAL_BUYER + TOTAL_SELER)) * 100;
          }

          this.calculationsJurisdiction();
          this.formatForCheckout();
        }
      }
    }
  }

  changeInputSellerRelation($event: InputTypes) {
    const RESULT = this.cleanInput($event);
    const PAST_RELATION = Math.round(this.sellerRelation * 100) / 100;
    if (PAST_RELATION != RESULT) {
      this.sellerRelation = RESULT;
      this.buyerRelation = 100 - RESULT;
    }

    if (RESULT == 50) {
      this.isRelationFiftyFifty = true;
    }

    if (Number(RESULT) !== Number(this.renditionForm.value.sellerRelation)) {
      this.renditionForm.get('sellerRelation')?.setValue(RESULT);
      this.renditionForm.get('buyerRelation')?.setValue(100 - RESULT);
    }
    this.performCalculation();
  }

  changeInputBuyerRelation($event: InputTypes) {
    const RESULT = this.cleanInput($event);
    const PAST_RELATION = 100 - Math.round(this.sellerRelation * 100) / 100;
    if (PAST_RELATION != RESULT) {
      this.sellerRelation = 100 - RESULT;
      this.buyerRelation = RESULT;
    }

    if (RESULT == 50) {
      this.isRelationFiftyFifty = true;
    }

    if (Number(RESULT) !== Number(this.renditionForm.value.buyerRelation)) {
      this.renditionForm.get('buyerRelation')?.setValue(RESULT);
      this.renditionForm.get('sellerRelation')?.setValue(100 - RESULT);
    }
  }

  getOtherRemaxService() {
    const REGION_ID =
      (this.NODE === this.NODE_GLOBAL
        ? this.user?.agency_region.toString()
        : '') ?? '';

    this.otherRemaxService.get(REGION_ID).then((response: any) => {
      if (response?.data?.agencies) {
        response.data.agencies.forEach((e: { id: number; name: string }) => {
          this.officeAutocomplete.options.push(e.name);
        });
        this.officeAutocomplete.options.sort((a: string, b: string) =>
          a.toLowerCase() > b.toLowerCase() ? 1 : -1,
        );

        this.otherRemaxList = [...response.data.agencies];
        this.officeAutocomplete = { ...this.officeAutocomplete };
      }
    });
  }

  getPropertiesList() {
    this.propertiesListService.get('').then((response: any) => {
      if (response?.data?.properties) {
        response.data.properties.forEach((e: { id: number; name: string }) => {
          this.dropdownPropertiesType.options.push(e.name);
        });
        this.propertiesList = [...response.data.properties];
        this.dropdownPropertiesType = { ...this.dropdownPropertiesType };
      }
    });
  }

  formatSharedWith(data: ReservationModel) {
    switch (data.sharedBy) {
      case 1:
      case 2: {
        this.sharedWithToggle.optionSelected =
          data.organizationIdPurchaser == data.organizationIdSeller ? 0 : 1;
        const AGENCY = data.sharedAgencyName
          ? data.sharedAgencyName
          : this.user?.agency_name;
        this.renditionForm.get('sharedWithOffice')?.setValue(AGENCY);
        break;
      }

      case 3:
        this.sharedWithToggle.optionSelected = 2;
        if (data.otherRealEstate) {
          this.renditionForm
            .get('sharedWithAnotherRealEstate')
            ?.setValue(data.otherRealEstate.name);
        } else {
          this.renditionForm
            .get('sharedWithAnotherRealEstate')
            ?.setValue(data.sharedAgencyName);
        }
        break;
    }
    this.renditionForm
      .get('sharedWith')
      ?.setValue(
        this.sharedWithToggle.viewValues[this.sharedWithToggle.optionSelected],
      );

    this.updateSharedWithOfficeValidator();
  }

  formatMlsId(mlsid: string) {
    if (mlsid) {
      this.renditionForm.get('mlsidFirst')?.setValue(mlsid);
      const SPLIT = mlsid.split('-');
      if (SPLIT?.length > 1) {
        const ONLY_NUMBERS_1 = SPLIT[0].replace(/\D/g, '');
        const ONLY_NUMBERS_2 = SPLIT[1].replace(/\D/g, '');
        this.renditionForm.get('mlsidFirst')?.setValue(ONLY_NUMBERS_1);
        this.renditionForm.get('mlsidLast')?.setValue(ONLY_NUMBERS_2);
      }
    }
  }

  formatOperationType(id: number) {
    // IDS => 1 Alquiler, 2 Venta, 3 Alquiler temporal
    switch (id) {
      case 1:
        this.operationToggle.optionSelected = 1;
        break;
      case 2:
        this.operationToggle.optionSelected = 0;
        break;
      case 3:
        this.operationToggle.optionSelected = 2;
        break;
      default:
        this.operationToggle.optionSelected = 0;
        break;
    }
    this.renditionForm
      .get('operationType')
      ?.setValue(
        this.operationToggle.viewValues[this.operationToggle.optionSelected],
      );
  }

  onChangeOrigin($event: number) {
    if (this.isReferidoACobrar) {
      this.originReferredToggle.optionSelected = $event;

      this.originReferredToggle.optionSelected == 0
        ? this.renditionForm
            .get('sellerAgent')
            ?.setValue(this.renditionForm.value.referredName)
        : this.renditionForm
            .get('buyerAgent')
            ?.setValue(this.renditionForm.value.referredName);
      this.originReferredToggle.optionSelected == 0
        ? this.renditionForm.get('buyerAgent')?.setValue('')
        : this.renditionForm.get('sellerAgent')?.setValue('');

      $event == 1
        ? this.renditionForm.get('originReferredTogle')?.setValue('Comprador')
        : this.renditionForm.get('originReferredTogle')?.setValue('Vendedor');

      this.calculationsJurisdiction();
    } else {
      this.snackbarService.openSnackBar(
        'El origen no puede se cambiado. Debe crear una nueva rendición',
        '',
      );
    }
  }

  directionMlsIdChange($event: string | undefined) {
    console.log($event);
  }

  changeInputDirectionNew($event: InputTypes) {
    this.renditionForm.get('address')?.setValue($event?.toString() ?? '');
  }

  changeInputMlsIdGlobal($event: InputTypes) {
    const INPUT = $event?.toString().trim() ?? '';
    const VALID_REGEX = /^[a-zA-Z0-9._-]+$/;
    VALID_REGEX.test(INPUT)
      ? this.renditionForm.get('mlsidGlobal')?.setValue(INPUT)
      : this.renditionForm.get('mlsidGlobal')?.setErrors({ invalid: true });

    this.checkValidityRenditionForm();
  }

  changeInputMlsIdFirst($event: InputTypes) {
    const INPUT = $event?.toString() ?? '';
    this.renditionForm.get('mlsidFirst')?.setValue(INPUT);
    this.checkValidityRenditionForm();
  }

  changeInputMlsIdLast($event: InputTypes) {
    const INPUT = $event?.toString() ?? '';
    this.renditionForm.get('mlsidLast')?.setValue(INPUT);
    this.checkValidityRenditionForm();
  }

  dropdownPropertiesTypeChange($event: string) {
    this.renditionForm.get('propertyType')?.setValue($event);
    this.checkValidityRenditionForm();
  }

  datepickerChange($event: string) {
    this.renditionForm.get('date')?.setValue($event);
    this.datePicker.date = $event;
    this.syncTeamLeadersWithRenditionDate();
    this.checkValidityRenditionForm();
  }

  onChangeOperation($event: number) {
    this.renditionForm
      .get('operationType')
      ?.setValue(this.operationToggle.viewValues[$event]);
    this.operationToggle.optionSelected = $event;
    this.dropdownBanks.options = [];
    this.renditionForm.get('bank')?.setValue('');
    const TYPE = $event === 0 ? 2 : 1;
    this.getBanks(TYPE);
  }

  onChangeExclusive($event: MatSlideToggleChange) {
    this.renditionForm.get('exclusiveId')?.setValue(2);
    if ($event.checked) this.renditionForm.get('exclusiveId')?.setValue(1);
  }

  creditChanged($event: MatSlideToggleChange) {
    this.renditionForm.get('credit')?.setValue($event.checked);
    let value = '';
    if (!$event.checked) {
      if (this.NODE === this.NODE_GLOBAL) {
        value =
          this.operationToggle.optionSelected == 0
            ? 'Pago al contado'
            : 'Contado';
      } else {
        value =
          this.operationToggle.optionSelected == 0
            ? 'Pago al contado'
            : 'Garantía Propietaria';
      }
      this.renditionForm.get('bank')?.setValue(value);
    }
  }

  dropdownBankChange($event: string) {
    this.renditionForm.get('credit')?.setValue(true);
    this.renditionForm.get('bank')?.setValue($event);
    if (
      $event == 'Pago al contado' ||
      $event == 'Garantía Propietaria' ||
      $event == 'Contado'
    ) {
      this.renditionForm.get('credit')?.setValue(false);
    }
  }

  dropdownJurisdictionChange($event: string) {
    this.renditionForm.get('jurisdiction')?.setValue($event);
    this.calculationsJurisdiction('dropdown');
  }

  calculationsJurisdiction(type?: string) {
    const JURISDICTION = this.jurisdictions.find(
      (e) => e.name == this.renditionForm.value.jurisdiction,
    );

    let sellerAgent = this.fullAgentList.find(
      (e) => e.agentName == this.renditionForm.value.sellerAgent,
    );

    let buyerAgent = this.fullAgentList.find(
      (e) => e.agentName == this.renditionForm.value.buyerAgent,
    );

    let sellerReferred = this.fullAgentList.find(
      (e) => e.agentName == this.renditionForm.value.sellerReferredName,
    );

    let buyerReferred = this.fullAgentList.find(
      (e) => e.agentName == this.renditionForm.value.buyerReferredName,
    );

    if (this.renditionFromBE) {
      if (!sellerAgent) {
        sellerAgent = new Agent();
        sellerAgent.agentName =
          this.renditionFromBE.organizationCommission.purchaseOrganizationName;
        sellerAgent.agentType =
          this.renditionFromBE.organizationCommission.purchaseOrganizationAgentType;
        sellerAgent.id =
          this.renditionFromBE.organizationCommission.purchaseOrganizationId;
        sellerAgent.teamId =
          this.renditionFromBE.organizationCommission.purchaseOrganizationTeamId;
        sellerAgent.teamLeaderId =
          this.renditionFromBE.organizationCommission.purchaseOrganizationTeamLeaderId;
        if (sellerAgent.teamId && this.NODE !== this.NODE_DO) {
          sellerAgent.agentType = 'TEAM_JUNIOR';
        }
      }

      if (!buyerAgent) {
        buyerAgent = new Agent();
        buyerAgent.agentName =
          this.renditionFromBE.organizationCommission.saleOrganizationName;
        buyerAgent.agentType =
          this.renditionFromBE.organizationCommission.saleOrganizationAgentType;
        buyerAgent.id =
          this.renditionFromBE.organizationCommission.saleOrganizationId;
        buyerAgent.teamId =
          this.renditionFromBE.organizationCommission.saleOrganizationTeamId;
        buyerAgent.teamLeaderId =
          this.renditionFromBE.organizationCommission.saleOrganizationTeamLeaderId;
        if (buyerAgent.teamId && this.NODE !== this.NODE_DO) {
          buyerAgent.agentType = 'TEAM_JUNIOR';
        }
      }

      const SELLER_REFERRED_COMMISSION =
        this.renditionFromBE.referredCommissions.find(
          (e: ReferredCommission) => e.type == 1,
        );

      if (SELLER_REFERRED_COMMISSION) {
        sellerReferred = new Agent();
        sellerReferred.agentName =
          SELLER_REFERRED_COMMISSION.organizationName ?? '';
        sellerReferred.agentType =
          SELLER_REFERRED_COMMISSION.organizationAgentType;
        sellerReferred.id = SELLER_REFERRED_COMMISSION.organizationId;
        sellerReferred.teamId = SELLER_REFERRED_COMMISSION.organizationTeamId;
        sellerReferred.teamLeaderId =
          SELLER_REFERRED_COMMISSION.organizationTeamLeaderId;
        if (this.NODE === this.NODE_DO) {
          sellerReferred.agentLevelType =
            SELLER_REFERRED_COMMISSION.organizationAgentLevelType;
        }

        if (sellerReferred.teamId && this.NODE !== this.NODE_DO) {
          sellerReferred.agentType = 'TEAM_JUNIOR';
        }
      }

      const BUYER_REFERRED_COMMISSION =
        this.renditionFromBE.referredCommissions.find(
          (e: ReferredCommission) => e.type == 2,
        );

      if (BUYER_REFERRED_COMMISSION) {
        buyerReferred = new Agent();
        buyerReferred.agentName =
          BUYER_REFERRED_COMMISSION.organizationName ?? '';
        buyerReferred.agentType =
          BUYER_REFERRED_COMMISSION.organizationAgentType;
        buyerReferred.id = BUYER_REFERRED_COMMISSION.organizationId;
        buyerReferred.teamId = BUYER_REFERRED_COMMISSION.organizationTeamId;
        buyerReferred.teamLeaderId =
          BUYER_REFERRED_COMMISSION.organizationTeamLeaderId;
        if (this.NODE === this.NODE_DO) {
          buyerReferred.agentLevelType =
            BUYER_REFERRED_COMMISSION.organizationAgentLevelType;
        }

        if (buyerReferred.teamId && this.NODE !== this.NODE_DO) {
          buyerReferred.agentType = 'TEAM_JUNIOR';
        }
      }
    }

    this.resolveChangeJurisdictionOrAgent(
      JURISDICTION,
      sellerAgent,
      buyerAgent,
      type,
    );

    this.resolveChangeJurisdictionOrReferred(
      JURISDICTION,
      sellerReferred,
      buyerReferred,
    );
  }

  resolveChangeJurisdictionOrAgent(
    jurisdiction: Jurisdiction | undefined,
    sellerAgent: Agent | undefined,
    buyerAgent: Agent | undefined,
    typeCalc?: string,
  ) {
    if (sellerAgent && jurisdiction) {
      let type = sellerAgent.agentType;
      if (sellerAgent.teamId && this.NODE !== this.NODE_DO) {
        type = 'TEAM_JUNIOR';
      }
      if (
        this.renditionForm.value.sellerAgentDeductionPercentage != 0 &&
        typeCalc != 'dropdown'
      ) {
        this.changeSellerAgentDeductionPercentage(
          this.renditionForm.value.sellerAgentDeductionPercentage.toLocaleString(),
        );
      } else {
        // Jurisdiccion agente
        switch (type) {
          case 'ALTO':
            this.changeSellerAgentDeductionPercentage(
              this.cleanInputJurisdiction(jurisdiction.altoDeductionPercentage),
              'calc',
            );
            break;
          case 'PURO':
            this.changeSellerAgentDeductionPercentage(
              this.cleanInputJurisdiction(jurisdiction.puroDeductionPercentage),
              'calc',
            );
            break;
          case 'TEAM_JUNIOR':
            this.changeSellerAgentDeductionPercentage(
              this.cleanInputJurisdiction(jurisdiction.teamDeductionPercentage),
              'calc',
            );
            break;
          default:
            this.changeSellerAgentDeductionPercentage(0, 'calc');
            break;
        }
      }
    } else {
      this.changeSellerAgentDeductionPercentage(0, 'calc');
    }
    if (buyerAgent && jurisdiction) {
      // Jurisdiccion agente
      let type = buyerAgent.agentType;
      if (buyerAgent.teamId && this.NODE !== this.NODE_DO) {
        type = 'TEAM_JUNIOR';
      }
      if (
        this.renditionForm.value.buyerAgentDeductionPercentage != 0 &&
        typeCalc != 'dropdown'
      ) {
        this.changeBuyerAgentDeductionPercentage(
          this.renditionForm.value.buyerAgentDeductionPercentage.toLocaleString(),
        );
      } else {
        switch (type) {
          case 'ALTO':
            this.changeBuyerAgentDeductionPercentage(
              this.cleanInputJurisdiction(jurisdiction.altoDeductionPercentage),
              'calc',
            );
            break;
          case 'PURO':
            this.changeBuyerAgentDeductionPercentage(
              this.cleanInputJurisdiction(jurisdiction.puroDeductionPercentage),
              'calc',
            );
            break;
          case 'TEAM_JUNIOR':
            this.changeBuyerAgentDeductionPercentage(
              this.cleanInputJurisdiction(jurisdiction.teamDeductionPercentage),
              'calc',
            );
            break;
          default:
            this.changeBuyerAgentDeductionPercentage(0, 'calc');
            break;
        }
      }
    } else {
      this.changeBuyerAgentDeductionPercentage(0, 'calc');
    }
  }

  resolveChangeJurisdictionOrReferred(
    jurisdiction: Jurisdiction | undefined,
    sellerReferred: Agent | undefined,
    buyerReferred: Agent | undefined,
  ) {
    if (sellerReferred && jurisdiction) {
      let type = sellerReferred.agentType;
      if (sellerReferred.teamId && this.NODE !== this.NODE_DO) {
        type = 'TEAM_JUNIOR';
      }

      // Jurisdiccion agente
      switch (type) {
        case 'ALTO':
          this.changeInputSellerReferredDeductionPercentage(
            jurisdiction.altoDeductionPercentage,
          );
          break;
        case 'PURO':
          this.changeInputSellerReferredDeductionPercentage(
            jurisdiction.puroDeductionPercentage,
          );
          break;
        case 'TEAM_JUNIOR':
          this.changeInputSellerReferredDeductionPercentage(
            jurisdiction.teamDeductionPercentage,
          );
          break;
        default:
          this.changeInputSellerReferredDeductionPercentage(0);
          break;
      }
    }

    if (buyerReferred && jurisdiction) {
      let type = buyerReferred.agentType;
      if (buyerReferred.teamId && this.NODE !== this.NODE_DO) {
        type = 'TEAM_JUNIOR';
      }

      // Jurisdiccion agente
      switch (type) {
        case 'ALTO':
          this.changeInputBuyerReferredDeductionPercentage(
            jurisdiction.altoDeductionPercentage,
          );
          break;
        case 'PURO':
          this.changeInputBuyerReferredDeductionPercentage(
            jurisdiction.puroDeductionPercentage,
          );
          break;
        case 'TEAM_JUNIOR':
          this.changeInputBuyerReferredDeductionPercentage(
            jurisdiction.teamDeductionPercentage,
          );
          break;
        default:
          this.changeInputBuyerReferredDeductionPercentage(0);
          break;
      }
    }
  }

  changeInputSellerReferredDeductionPercentage(
    percentage: number,
    type?: string,
  ) {
    const RESULT = this.cleanInput(percentage);

    if (
      Number(RESULT) !=
      Number(this.renditionForm.value.sellerReferredDeductionPercentage)
    ) {
      this.renditionForm
        .get('sellerReferredDeductionPercentage')
        ?.setValue(Number(RESULT ?? 0));

      if (type != 'user') {
        const USD = this.renditionForm.value.sellerReferredUSD * (RESULT / 100);
        const LOCAL =
          this.renditionForm.value.sellerReferredLocal * (RESULT / 100);

        this.renditionForm
          .get('sellerReferredDeductionUSD')
          ?.setValue(Number(USD ?? 0));

        this.renditionForm
          .get('sellerReferredDeductionLocal')
          ?.setValue(Number(LOCAL ?? 0));
      }
    }
    this.formatForCheckout();
  }

  changeInputBuyerReferredDeductionPercentage(percentage: number) {
    const RESULT = this.cleanInput(percentage);
    if (
      Number(RESULT) !=
      Number(this.renditionForm.value.buyerReferredDeductionPercentage)
    ) {
      this.renditionForm
        .get('buyerReferredDeductionPercentage')
        ?.setValue(Number(RESULT ?? 0));
      const USD = this.renditionForm.value.buyerReferredUSD * (RESULT / 100);
      const LOCAL =
        this.renditionForm.value.buyerReferredLocal * (RESULT / 100);

      this.renditionForm
        .get('buyerReferredDeductionUSD')
        ?.setValue(Number(USD ?? 0));

      this.renditionForm
        .get('buyerReferredDeductionLocal')
        ?.setValue(Number(LOCAL ?? 0));
    }
    this.formatForCheckout();
  }

  cleanSeller() {
    if (this.renditionForm.value.sellerAgent) {
      this.renditionForm.get('sellerAgent')?.setValue('');
      this.renditionForm.get('sellerReferredName')?.setValue('');
      this.renditionForm.get('sellerReferredPercentage')?.setValue(0);
      this.renditionForm.get('sellerReferredUSD')?.setValue(0);
      this.renditionForm.get('sellerReferredLocal')?.setValue(0);
      this.renditionForm.get('sellerManualDeductionUSD')?.setValue(0);
      this.renditionForm.get('sellerManualDeductionLocal')?.setValue(0);
      this.renditionForm.get('sellerManualDeductionName')?.setValue('');
    }
  }

  cleanBuyer() {
    if (this.renditionForm.value.buyerAgent) {
      this.renditionForm.get('buyerAgent')?.setValue('');
      this.renditionForm.get('buyerReferredName')?.setValue('');
      this.renditionForm.get('buyerReferredPercentage')?.setValue(0);
      this.renditionForm.get('buyerReferredUSD')?.setValue(0);
      this.renditionForm.get('buyerReferredLocal')?.setValue(0);
      this.renditionForm.get('buyerManualDeductionUSD')?.setValue(0);
      this.renditionForm.get('buyerManualDeductionLocal')?.setValue(0);
      this.renditionForm.get('buyerManualDeductionName')?.setValue('');
    }
  }

  async onChangeSharedWith($event: number) {
    this.sharedWithToggle.optionSelected = $event;
    this.sharedWithToggle = { ...this.sharedWithToggle };
    this.renditionForm
      .get('sharedWith')
      ?.setValue(this.sharedWithToggle.viewValues[$event]);

    if (!this.renditionForm.get('sellerOffice')) {
      this.renditionForm.addControl(
        'sellerOffice',
        new FormControl('', Validators.required),
      );
    }

    if (!this.renditionForm.get('buyerOffice')) {
      this.renditionForm.addControl(
        'buyerOffice',
        new FormControl('', Validators.required),
      );
    }
    switch (this.renditionForm.value.sharedWith) {
      // Dos puntas
      case 'Dos puntas':
        this.inputAgentGlobalBuyer = false;
        this.inputAgentGlobalSeller = false;

        this.sellerSharedWith.optionSelected = 0;
        this.buyerSharedWith.optionSelected = 0;
        this.renditionForm.get('sellerSharedWith')?.setValue('Mi oficina');
        this.renditionForm
          .get('sellerOffice')
          ?.setValue(this.user?.agency_name);
        this.renditionForm.get('buyerSharedWith')?.setValue('Mi oficina');
        this.renditionForm.get('buyerOffice')?.setValue(this.user?.agency_name);
        this.renditionForm.get('sharedWithOffice')?.setValue('');
        this.renditionForm.get('sharedWithAnotherRealEstate')?.setValue('');

        // Saco otras validaciones que no vendrian al caso
        this.renditionForm.get('sharedWithAnotherRealEstate')?.setErrors(null);
        await this.getInitialAgentList(true, true, true, true);
        this.cleanSeller();
        this.cleanBuyer();
        break;

      // Otro Remax
      case 'RE/MAX':
        this.renditionForm.get('sharedWithAnotherRealEstate')?.setValue('');
        this.renditionForm.get('sharedWithAnotherRealEstate')?.setErrors(null);

        this.cleanSeller();
        this.cleanBuyer();
        if (this.NODE === this.NODE_GLOBAL) {
          this.validateFieldsGlobal();
        }
        break;

      // Otra inmobiliaria
      case 'Otra inmobiliaria':
        this.renditionForm
          .get('sharedWithAnotherRealEstate')
          ?.addValidators(Validators.required);

        this.cleanSeller();
        this.cleanBuyer();
        break;
    }

    this.updateSharedWithOfficeValidator();
  }

  // Mirrors the *ngIf that shows the "Oficina" field in the template
  isSharedWithOfficeVisible(): boolean {
    return this.isReferidoACobrar
      ? this.sharedWithToggle.optionSelected === 0
      : this.sharedWithToggle.optionSelected === 1;
  }

  updateSharedWithOfficeValidator() {
    const CONTROL = this.renditionForm.get('sharedWithOffice');
    if (!CONTROL) return;

    this.isSharedWithOfficeVisible()
      ? CONTROL.setValidators(Validators.required)
      : CONTROL.clearValidators();

    CONTROL.updateValueAndValidity();
  }

  validateFieldsGlobal() {
    this.inputAgentGlobalSeller =
      this.renditionForm.value.sellerOffice &&
      this.renditionForm.value.sellerOffice != this.user?.agency_name;
    this.inputAgentGlobalBuyer =
      this.renditionForm.value.buyerOffice &&
      this.renditionForm.value.buyerOffice != this.user?.agency_name;
  }

  async dropdownOfficeChange($event: string | undefined) {
    this.renditionForm.get('sharedWithOffice')?.setValue($event ?? '');
    if (this.sellerSharedWith.optionSelected == 1) {
      await this.sellerOfficeAutocompleteChange($event);
    }
    if (this.buyerSharedWith.optionSelected == 1) {
      await this.buyerOfficeAutocompleteChange($event);
    }
  }

  changeInputClosePriceUSD($event: InputTypes) {
    const RESULT = this.cleanInput($event);
    if (RESULT >= 0) {
      if (Number(RESULT) != Number(this.renditionForm.value.closePriceUSD)) {
        this.renditionForm.get('closePriceUSD')?.setValue(Number(RESULT ?? 0));

        this.performCalculation('percentage');
      }
    } else {
      this.renditionForm.get('closePriceUSD')?.setValue(0);
      this.formatForCheckout();
    }
  }

  changeInputClosePriceLocal($event: InputTypes) {
    if ($event) {
      const RESULT = this.cleanInput($event);
      if (Number(RESULT) != Number(this.renditionForm.value.closePriceLocal)) {
        this.renditionForm.get('closePriceLocal')?.setValue(RESULT ?? 0);

        this.performCalculation('percentage');
      }
    } else {
      this.renditionForm.get('closePriceLocal')?.setValue(0);
      this.formatForCheckout();
    }
  }

  changeInputTC($event: InputTypes) {
    const RESULT = this.cleanInput($event);

    const IS_RESULT_IN_RANGE =
      RESULT >= this.exchangeRateMin && RESULT <= this.exchangeRateMax;
    const MINIMUM_VALUE_ACORDING_TO_NODE =
      this.NODE === this.NODE_GLOBAL ? RESULT >= 1 : RESULT > 1;

    const VALIDATION_FOR_GLOBAL =
      RESULT >= 1 && this.NODE === Constants.TENANT_ID_GLOBAL;

    if (
      (IS_RESULT_IN_RANGE && MINIMUM_VALUE_ACORDING_TO_NODE) ||
      VALIDATION_FOR_GLOBAL
    ) {
      this.renditionForm.get('exchangeRate')?.setValue(Number(RESULT));
      if (
        this.renditionForm.value.sellerPercentage > 0 ||
        this.renditionForm.value.buyerPercentage > 0
      ) {
        this.performCalculation('tc');
      }
    } else {
      this.renditionForm.get('exchangeRate')?.setErrors({ invalid: true });
    }
  }

  changeInputRentValue($event: InputTypes) {
    const RESULT = this.cleanInput($event);
    if (RESULT != this.renditionForm.value.rentInput) {
      this.renditionForm.get('rentInput')?.setValue(RESULT);
      if (RESULT === 0 || !$event) {
        this.renditionForm.get('rentInput')?.setErrors({ invalid: true });
      }
    }
  }

  onChangeRentPeriodo($event: number) {
    this.periodoToggle.optionSelected = $event;
    this.renditionForm
      .get('rentPeriod')
      ?.setValue(
        this.periodoToggle.viewValues[this.periodoToggle.optionSelected],
      );
  }

  dropdownInmobiliariaChange($event: string) {
    this.renditionForm.get('sharedWithAnotherRealEstate')?.setValue($event);
  }

  onSellerClientChange($event: string | undefined) {
    this.renditionForm.get('sellerClient')?.setValue($event);
    this.checkValidityRenditionForm();
  }

  dropdownReferredClientChange($event: string) {
    this.renditionForm.get('referredClient')?.setValue($event);
    this.checkValidityRenditionForm();
  }

  changeInputSellerPercentage($event: InputTypes, type?: string) {
    const RESULT = this.cleanInput($event);
    this.renditionForm.get('buyerPercentage')?.setErrors(null);

    if (RESULT >= 0) {
      if (
        Number(RESULT) !=
        Number(
          Math.round(this.renditionForm.value.sellerPercentage * 100) / 100,
        )
      ) {
        this.renditionForm
          .get('sellerPercentage')
          ?.setValue(Number(RESULT ?? 0));

        if (type != 'calc') {
          this.performCalculation('percentage');
        }
      }
    } else {
      this.renditionForm.get('sellerPercentage')?.setValue(0);
      this.performCalculation('value');
    }

    if (
      (this.renditionForm.value.sellerPercentage == 0 ||
        !this.renditionForm.value.sellerPercentage) &&
      (this.renditionForm.value.buyerPercentage == 0 ||
        !this.renditionForm.value.buyerPercentage)
    ) {
      this.renditionForm.get('sellerPercentage')?.setErrors({ invalid: true });
    }
  }

  changeInputSellerUSD($event: InputTypes) {
    const RESULT = this.cleanInput($event);
    if (RESULT >= 0) {
      const ROUND_RESULT = Math.round(Number(RESULT * 100)) / 100;
      const ROUND_PREVIOUS_RESULT =
        Math.round(Number(this.renditionForm.value.sellerUSD * 100)) / 100;

      if (ROUND_RESULT != ROUND_PREVIOUS_RESULT) {
        this.renditionForm.get('sellerUSD')?.setValue(Number(RESULT ?? 0));

        this.performCalculation('value');
      }
    }
    if (RESULT === 0) {
      this.renditionForm.get('sellerUSD')?.setValue(0);
      this.renditionForm.get('sellerManualDeductionUSD')?.setValue(0);
      this.performCalculation('value');
    }
  }

  changeInputSellerLocal($event: InputTypes) {
    const RESULT = this.cleanInput($event);

    if (RESULT >= 0) {
      const ROUND_RESULT = Math.round(Number(RESULT * 100)) / 100;
      const ROUND_PREVIOUS_RESULT =
        Math.round(Number(this.renditionForm.value.sellerLocal * 100)) / 100;

      if (ROUND_RESULT != ROUND_PREVIOUS_RESULT) {
        this.renditionForm.get('sellerLocal')?.setValue(Number(RESULT ?? 0));

        this.performCalculation('value');
      }
    }

    if (RESULT === 0) {
      this.renditionForm.get('sellerLocal')?.setValue(0);
      this.renditionForm.get('sellerManualDeductionLocal')?.setValue(0);
      this.performCalculation('value');
    }
  }

  changeInputBuyerPercentage($event: InputTypes, type?: string) {
    const RESULT = this.cleanInput($event);
    this.renditionForm.get('sellerPercentage')?.setErrors(null);

    if (RESULT >= 0) {
      if (
        Number(RESULT) !=
        Number(Math.round(this.renditionForm.value.buyerPercentage * 100) / 100)
      ) {
        this.renditionForm
          .get('buyerPercentage')
          ?.setValue(Number(RESULT ?? 0));

        if (type != 'calc') {
          this.performCalculation('percentage');
        }
      }
    } else {
      this.renditionForm.get('buyerPercentage')?.setValue(0);
      this.performCalculation('value');
    }

    if (
      (this.renditionForm.value.sellerPercentage == 0 ||
        !this.renditionForm.value.sellerPercentage) &&
      (this.renditionForm.value.buyerPercentage == 0 ||
        !this.renditionForm.value.buyerPercentage)
    ) {
      this.renditionForm.get('buyerPercentage')?.setErrors({ invalid: true });
    }
  }

  changeInputBuyerUSD($event: InputTypes) {
    const RESULT = this.cleanInput($event);
    if (RESULT >= 0) {
      const ROUND_RESULT = Math.round(Number(RESULT * 100)) / 100;
      const ROUND_PREVIOUS_RESULT =
        Math.round(Number(this.renditionForm.value.buyerUSD * 100)) / 100;

      if (ROUND_RESULT != ROUND_PREVIOUS_RESULT) {
        this.renditionForm.get('buyerUSD')?.setValue(Number(RESULT ?? 0));

        this.performCalculation('value');
      }
    }
    if (RESULT === 0) {
      this.renditionForm.get('buyerUSD')?.setValue(0);
      this.renditionForm.get('buyerManualDeductionUSD')?.setValue(0);
      this.performCalculation('value');
    }
  }

  changeInputBuyerLocal($event: InputTypes) {
    const RESULT = this.cleanInput($event);

    if (RESULT >= 0) {
      const ROUND_RESULT = Math.round(Number(RESULT * 100)) / 100;
      const ROUND_PREVIOUS_RESULT =
        Math.round(Number(this.renditionForm.value.buyerLocal * 100)) / 100;

      if (ROUND_RESULT != ROUND_PREVIOUS_RESULT) {
        this.renditionForm.get('buyerLocal')?.setValue(Number(RESULT ?? 0));

        this.performCalculation('value');
      }
    }

    if (RESULT === 0) {
      this.renditionForm.get('buyerLocal')?.setValue(0);
      this.renditionForm.get('buyerManualDeductionLocal')?.setValue(0);

      this.performCalculation('value');
    }
  }

  onBuyerClientChange($event: string | undefined) {
    this.renditionForm.get('buyerClient')?.setValue($event);
    this.checkValidityRenditionForm();
  }

  onCleanDirection($event: Event) {
    $event.preventDefault();
    this.openDialogClearForm();
  }

  async onChangeSellerSharedWith($event: number) {
    if (this.renditionForm.value.sharedWith == 'Dos puntas') {
      this.sellerSharedWith.optionSelected = 0;
      this.buyerSharedWith.optionSelected = 0;
      this.renditionForm.get('sellerSharedWith')?.setValue('Mi oficina');
      this.renditionForm.get('buyerSharedWith')?.setValue('Mi oficina');
      this.snackbarService.openSnackBar(
        'No puede cambiar agente o oficina cuando tiene ambas puntas',
        '',
      );
    } else if (
      this.renditionForm.value.sharedWith == 'RE/MAX' &&
      this.renditionForm.value.sharedWithOffice == this.user?.agency_name
    ) {
      if ($event != 0) {
        this.sellerSharedWith.optionSelected = 0;
        this.renditionForm.get('sellerSharedWith')?.setValue('Mi oficina');
        this.snackbarService.openSnackBar(
          'La operación es compartida con su oficina',
          '',
        );
      }
    } else if (this.buyerSharedWith.optionSelected !== 0 && $event !== 0) {
      this.sellerSharedWith.optionSelected = 0;
      this.snackbarService.openSnackBar(
        'Una de las puntas debe ser de su oficina',
        '',
      );
    } else {
      this.sellerSharedWith.optionSelected = $event;
      this.renditionForm
        .get('sellerSharedWith')
        ?.setValue(this.sellerSharedWith.viewValues[$event]);

      if (!this.renditionForm.get('sellerOffice')) {
        this.renditionForm.addControl(
          'sellerOffice',
          new FormControl('', Validators.required),
        );
      }

      this.renditionForm.get('sellerAgent')?.setValue('');
      this.renditionForm.get('sellerOffice')?.setValue('');
      switch ($event) {
        case 0:
          this.sellerOfficeAutocomplete.options = [];
          this.renditionForm
            .get('sellerOffice')
            ?.setValue(this.user?.agency_name);
          await this.getInitialAgentList(true, false, false, false);

          if (this.sharedWithToggle.optionSelected == 1) {
            this.buyerSharedWith.optionSelected = 1;
            this.renditionForm.get('buyerSharedWith')?.setValue('RE/MAX');

            if (this.renditionForm.value.sharedWithOffice) {
              await this.buyerOfficeAutocompleteChange(
                this.renditionForm.value.sharedWithOffice,
              );
            }
            this.inputAgentGlobalSeller =
              this.NODE === this.NODE_GLOBAL &&
              this.renditionForm.value.buyerSharedWith != 'Mi oficina' &&
              this.renditionForm.value.buyerOffice != this.user?.agency_name;
          }

          if (this.sharedWithToggle.optionSelected == 2) {
            this.buyerSharedWith.optionSelected = 2;
            this.renditionForm.get('buyerSharedWith')?.setValue('Otro');
            if (
              this.renditionForm.value.anotherRealEstateInput ||
              this.renditionForm.value.sharedWithAnotherRealEstate
            ) {
              this.renditionForm.get('buyerOffice')?.setValue('');
              this.renditionForm.get('buyerAgent')?.setValue('');
            }
          }

          break;
        case 1:
          this.sellerOfficeAutocomplete.options = [];
          this.sellerAgentAutocomplete.options = [];
          this.officesList.forEach((e: { id: number; name: string }) => {
            this.sellerOfficeAutocomplete.options.push(e.name);
          });
          if (this.renditionForm.value.sharedWithOffice) {
            this.sellerOfficeAutocompleteChange(
              this.renditionForm.value.sharedWithOffice,
            );
          }

          this.buyerSharedWith.optionSelected = 0;
          this.renditionForm.get('buyerSharedWith')?.setValue('Mi oficina');

          break;
        case 2:
          this.renditionForm.removeControl('sellerOffice');
          this.sellerAgentAutocomplete.options = [];
          this.sellerOtherRemaxAutocomplete.options = [];
          this.otherRemaxList.forEach((e: { id: number; name: string }) => {
            this.sellerOtherRemaxAutocomplete.options.push(e.name);
          });
          this.buyerSharedWith.optionSelected = 0;
          this.renditionForm.get('buyerSharedWith')?.setValue('Mi oficina');
          break;
      }
    }
    // Validacion para region global
    this.inputAgentGlobalSeller =
      this.NODE === this.NODE_GLOBAL &&
      this.renditionForm.value.sellerSharedWith != 'Mi oficina' &&
      this.renditionForm.value.sellerOffice != this.user?.agency_name;
  }

  async onChangeSellerReferredSharedWith($event: number) {
    this.inputAgentGlobalSellerReferred = false;
    this.sellerReferredSharedWith.optionSelected = $event;
    this.renditionForm
      .get('sellerReferredSharedWith')
      ?.setValue(this.sellerReferredSharedWith.viewValues[$event]);
    this.sellerReferredAgentAutocomplete.options =
      $event != 0 ? [] : [...this.agentsListMyOffice];
    this.renditionForm.get('sellerReferredAgent')?.setValue('');
    this.renditionForm.get('sellerReferredOffice')?.setValue('');
    this.renditionForm.get('sellerReferredName')?.setValue('');

    // Limpio inputs
    this.renditionForm.get('sellerReferredUSD')?.setValue(0);
    this.renditionForm.get('sellerReferredLocal')?.setValue(0);
    this.renditionForm.get('sellerReferredPercentage')?.setValue(0);

    switch ($event) {
      case 0:
        this.renditionForm
          .get('sellerReferredOffice')
          ?.setValue(this.user?.agency_name);
        await this.getInitialAgentList(false, false, true, false);

        break;
      case 1:
        this.sellerReferredOfficeAutocomplete.options = [];
        this.officesList.forEach((e: { id: number; name: string }) => {
          if (e.name != this.user?.agency_name) {
            this.sellerReferredOfficeAutocomplete.options.push(e.name);
          }
        });
        break;
    }
    this.formatForCheckout();
  }

  async onChangeBuyerReferredSharedWith($event: number) {
    this.buyerReferredSharedWith.optionSelected = $event;
    this.renditionForm
      .get('buyerReferredSharedWith')
      ?.setValue(this.buyerReferredSharedWith.viewValues[$event]);
    this.buyerReferredAgentAutocomplete.options =
      $event != 0 ? [] : [...this.agentsListMyOffice];
    this.renditionForm.get('buyerReferredAgent')?.setValue('');
    this.renditionForm.get('buyerReferredOffice')?.setValue('');
    this.renditionForm.get('buyerReferredName')?.setValue('');

    // Limpio inputs
    this.renditionForm.get('buyerReferredUSD')?.setValue(0);
    this.renditionForm.get('buyerReferredLocal')?.setValue(0);
    this.renditionForm.get('buyerReferredPercentage')?.setValue(0);

    switch ($event) {
      case 0:
        this.renditionForm
          .get('buyerReferredOffice')
          ?.setValue(this.user?.agency_name);
        await this.getInitialAgentList(false, false, false, true);
        break;
      case 1:
        this.buyerReferredOfficeAutocomplete.options = [];
        this.officesList.forEach((e: { id: number; name: string }) => {
          if (e.name != this.user?.agency_name) {
            this.buyerReferredOfficeAutocomplete.options.push(e.name);
          }
        });
        break;
    }
    this.formatForCheckout();
  }

  async sellerOfficeAutocompleteChange($event: string | undefined) {
    this.sellerAgentAutocomplete.options = [];
    this.renditionForm.get('sellerAgent')?.setValue('');
    if ($event) {
      const OFFICE = this.officesList.find(
        (e: { id: number; name: string }) => e.name == $event,
      );
      if (OFFICE) {
        this.renditionForm.get('sellerOffice')?.setValue(OFFICE.name);
        if (
          this.sellerSharedWith.optionSelected == 1 &&
          this.sharedWithToggle.optionSelected == 1
        ) {
          this.renditionForm.get('sharedWithOffice')?.setValue(OFFICE.name);
        }
        const URL = OFFICE.id + '/agents';
        const response: any = await this.renditionsService.get(URL);
        if (response?.data?.agents) {
          this.otherRemaxList = response.data.agents;
          response.data.agents.forEach((e: Agent) => {
            this.sellerAgentAutocomplete.options.push(e.agentName);
            this.fullAgentList.push(e);
          });
        }
      }
    }
    this.sellerAgentAutocomplete = { ...this.sellerAgentAutocomplete };
  }

  sellerAgentAutocompleteChange($event: string | undefined) {
    this.renditionForm
      .get('sellerAgent')
      ?.setErrors($event === undefined ? { invalid: true } : null);
    if (
      $event === this.renditionForm.value.buyerAgent &&
      this.sharedWithToggle.optionSelected != 0
    ) {
      this.renditionForm.get('sellerAgent')?.setErrors({ invalid: true });
    } else {
      this.renditionForm.get('sellerAgent')?.setValue($event);
      if (this.renditionForm.value.sharedWith === 'Dos puntas') {
        this.renditionForm.get('buyerAgent')?.setValue($event);
        this.renditionForm.get('sellerSharedWith')?.setValue('Mi oficina');
        this.renditionForm.get('buyerSharedWith')?.setValue('Mi oficina');
        this.sellerSharedWith.optionSelected = 0;
        this.buyerSharedWith.optionSelected = 0;
      }

      const SELLER_AGENT = this.fullAgentList.find(
        (e: Agent) => e.agentName === $event,
      );

      this.renditionForm.get('sellerTeamLeader')?.setValue(null);
      const IS_JUNIOR_AGENT_DO =
        SELLER_AGENT?.teamId &&
        SELLER_AGENT?.teamLeaderId !== SELLER_AGENT?.id &&
        this.NODE === this.NODE_DO &&
        this.renditionForm.value.sellerOffice === this.user?.agency_name;

      this.calculationsJurisdiction('dropdown');
      if (this.NODE === this.NODE_AR || this.NODE === this.NODE_GLOBAL) {
        this.updateSellerTeamLeader($event?.toString());
      } else if (IS_JUNIOR_AGENT_DO) {
        this.generateSellerTeamLeaderDO(SELLER_AGENT);
        if (this.renditionForm.value.sharedWith === 'Dos puntas') {
          this.generateBuyerTeamLeaderDO(SELLER_AGENT);
        }
      }
      this.formatForCheckout();
    }
  }

  generateSellerTeamLeaderDO(agent: Agent) {
    const TEAM_LEADER = this.fullAgentList.find(
      (e: Agent) => e.id === agent.teamLeaderId,
    );
    if (TEAM_LEADER) {
      this.renditionForm
        .get('sellerTeamLeader')
        ?.setValue(TEAM_LEADER.agentName);
    }
  }

  updateSellerTeamLeader(agentName: string | undefined) {
    this.renditionForm.get('sellerTeamLeaderUSD')?.setValue(0);
    this.renditionForm.get('sellerTeamLeaderLocal')?.setValue(0);
    this.addSellerTeamLeader = false;

    const FIND = this.fullAgentList.find((e) => e.agentName === agentName);
    if (FIND?.teamId) {
      const FIND_TEAM_LEADER = this.fullAgentList.find(
        (agent) => agent.id === FIND.teamLeaderId,
      );
      if (FIND_TEAM_LEADER) {
        this.renditionForm
          .get('sellerTeamLeader')
          ?.setValue(FIND_TEAM_LEADER.agentName);

        if (
          this.renditionForm.value.sellerAgent ===
          this.renditionForm.value.buyerAgent
        ) {
          this.renditionForm
            .get('buyerTeamLeader')
            ?.setValue(FIND_TEAM_LEADER.agentName);
        }
      }
    }
  }

  updateBuyerTeamLeader(agentName: string | undefined) {
    this.renditionForm.get('buyerTeamLeaderUSD')?.setValue(0);
    this.renditionForm.get('buyerTeamLeaderLocal')?.setValue(0);
    this.addBuyerTeamLeader = false;

    const FIND = this.fullAgentList.find((e) => e.agentName === agentName);
    if (FIND?.teamId) {
      const FIND_TEAM_LEADER = this.fullAgentList.find(
        (agent) => agent.id === FIND.teamLeaderId,
      );
      if (FIND_TEAM_LEADER) {
        this.renditionForm
          .get('buyerTeamLeader')
          ?.setValue(FIND_TEAM_LEADER.agentName);

        if (
          this.renditionForm.value.sellerAgent ===
          this.renditionForm.value.buyerAgent
        ) {
          this.renditionForm
            .get('sellerTeamLeader')
            ?.setValue(FIND_TEAM_LEADER.agentName);
        }
      }
    }
  }

  buyerAgentAutocompleteChange($event: string | undefined) {
    this.renditionForm
      .get('buyerAgent')
      ?.setErrors($event === undefined ? { invalid: true } : null);
    if (
      $event === this.renditionForm.value.sellerAgent &&
      this.sharedWithToggle.optionSelected != 0
    ) {
      this.renditionForm.get('buyerAgent')?.setErrors({ invalid: true });
    } else {
      this.renditionForm.get('buyerAgent')?.setValue($event);
      if (this.renditionForm.value.sharedWith === 'Dos puntas') {
        this.renditionForm.get('sellerAgent')?.setValue($event);
        this.renditionForm.get('sellerSharedWith')?.setValue('Mi oficina');
        this.renditionForm.get('buyerSharedWith')?.setValue('Mi oficina');
        this.sellerSharedWith.optionSelected = 0;
        this.buyerSharedWith.optionSelected = 0;
      }

      const BUYER_AGENT = this.fullAgentList.find(
        (e: Agent) => e.agentName === $event,
      );

      this.renditionForm.get('buyerTeamLeader')?.setValue(null);
      const IS_JUNIOR_AGENT_DO =
        BUYER_AGENT?.teamId &&
        BUYER_AGENT?.teamLeaderId !== BUYER_AGENT?.id &&
        this.NODE === this.NODE_DO &&
        this.renditionForm.value.buyerOffice === this.user?.agency_name;

      this.calculationsJurisdiction('dropdown');
      if (this.NODE === this.NODE_AR || this.NODE === this.NODE_GLOBAL) {
        this.updateBuyerTeamLeader($event?.toString());
      } else if (IS_JUNIOR_AGENT_DO) {
        this.generateBuyerTeamLeaderDO(BUYER_AGENT);
        if (this.renditionForm.value.sharedWith === 'Dos puntas') {
          this.generateSellerTeamLeaderDO(BUYER_AGENT);
        }
      }
      this.formatForCheckout();
    }
  }

  generateBuyerTeamLeaderDO(agent: Agent) {
    const TEAM_LEADER = this.fullAgentList.find(
      (e: Agent) => e.id === agent.teamLeaderId,
    );
    if (TEAM_LEADER) {
      this.renditionForm
        .get('buyerTeamLeader')
        ?.setValue(TEAM_LEADER.agentName);
    }
  }

  changeSellerAgentOther($event: InputTypes) {
    this.renditionForm.get('sellerAgent')?.setValue($event);
    this.formatForCheckout();
  }

  changeBuyerAgentOther($event: InputTypes) {
    this.renditionForm.get('buyerAgent')?.setValue($event);
    this.formatForCheckout();
  }

  sellerReferredOfficeAutocompleteChange($event: string | undefined) {
    if ($event) {
      this.inputAgentGlobalSellerReferred =
        this.NODE === this.NODE_GLOBAL && $event != this.user?.agency_name;
      if ($event !== this.user?.agency_name) {
        const OFFICE = this.officesList.find(
          (e: { id: number; name: string }) => e.name == $event,
        );
        if (OFFICE) {
          this.sellerReferredAgentAutocomplete.options = [];
          this.renditionForm.get('sellerReferredOffice')?.setValue(OFFICE.name);
          const URL = OFFICE.id + '/agents';
          this.renditionsService.get(URL).then((response: any) => {
            if (response?.data?.agents) {
              this.sellerReferredAgentList = [...response.data.agents];
              this.sellerReferredAgentList.forEach((e: Agent) => {
                this.sellerReferredAgentAutocomplete.options.push(e.agentName);
              });
            }
          });
        }
        this.sellerReferredAgentAutocomplete = {
          ...this.sellerReferredAgentAutocomplete,
        };
      } else {
        this.sellerReferredSharedWith.optionSelected = 0;
        this.onChangeSellerReferredSharedWith(0);
      }
    }
    this.formatForCheckout();
  }

  sellerReferredAgentAutocompleteChange($event: string | undefined) {
    if ($event) {
      if ($event == this.renditionForm.value.sellerAgent) {
        this.renditionForm.controls['sellerReferredName'].setErrors({
          invalid: true,
        });
      } else {
        this.renditionForm.get('sellerReferredName')?.setValue($event);

        this.changeInputSellerReferredPercentage(25);
        this.calculationsJurisdiction();

        this.formatForCheckout();
      }
    } else {
      this.renditionForm.get('sellerReferredName')?.setValue('');
      this.renditionForm.get('sellerReferredPercentage')?.setValue(0);
      this.renditionForm.get('sellerReferredUSD')?.setValue(0);
      this.renditionForm.get('sellerReferredLocal')?.setValue(0);

      this.performCalculation();
    }
  }

  changeSellerReferredOther($event: InputTypes) {
    this.renditionForm.get('sellerReferredName')?.setValue($event);
    this.formatForCheckout();
  }

  changeBuyerReferredOther($event: InputTypes) {
    this.renditionForm.get('buyerReferredName')?.setValue($event);
    this.formatForCheckout();
  }

  changeInputSellerReferredPercentage($event: InputTypes, type?: string) {
    const USD_SELLER = this.renditionForm.value.sellerUSD;
    const USD_BUYER = this.renditionForm.value.buyerUSD;
    const LOCAL_SELLER = this.renditionForm.value.sellerLocal;
    const LOCAL_BUYER = this.renditionForm.value.buyerLocal;

    const USD_TOTAL = (USD_SELLER + USD_BUYER) * (this.sellerRelation / 100);
    const LOCAL_TOTAL =
      (LOCAL_SELLER + LOCAL_BUYER) * (this.sellerRelation / 100);

    const RESULT = this.cleanInput($event);

    if (RESULT < 100) {
      if (
        Math.round(Number(RESULT) * 100) / 100 !=
        Math.round(
          Number(this.renditionForm.value.sellerReferredPercentage) * 100,
        ) /
          100
      ) {
        this.renditionForm
          .get('sellerReferredPercentage')
          ?.setValue(Number(RESULT ?? 0));

        if (type !== 'user') {
          const USD = USD_TOTAL * (RESULT / 100);
          const LOCAL = LOCAL_TOTAL * (RESULT / 100);

          if (
            Math.trunc(this.renditionForm.value.sellerReferredUSD * 100) /
              100 !=
            Math.trunc(USD * 100) / 100
          ) {
            this.changeInputSellerReferredUSD(USD.toLocaleString(), 'calc');
          }

          if (
            Math.trunc(this.renditionForm.value.sellerReferredLocal * 100) /
              100 !=
            Math.trunc(LOCAL * 100) / 100
          ) {
            this.changeInputSellerReferredLocal(LOCAL.toLocaleString(), 'calc');
          }
          this.performCalculation('referred');
        }
        this.formatForCheckout();
      }
    } else {
      this.renditionForm.controls['sellerReferredPercentage'].setErrors({
        invalid: true,
      });
    }
  }

  changeInputSellerReferredUSD($event: InputTypes, type?: string) {
    const USD_SELLER =
      this.renditionForm.value.closePriceUSD *
      (this.renditionForm.value.sellerPercentage / 100);
    const USD_BUYER =
      this.renditionForm.value.closePriceUSD *
      (this.renditionForm.value.buyerPercentage / 100);
    const LOCAL_SELLER =
      this.renditionForm.value.closePriceLocal *
      (this.renditionForm.value.sellerPercentage / 100);
    const LOCAL_BUYER =
      this.renditionForm.value.closePriceLocal *
      (this.renditionForm.value.buyerPercentage / 100);

    const USD_TOTAL = (USD_SELLER + USD_BUYER) * (this.sellerRelation / 100);
    const LOCAL_TOTAL =
      (LOCAL_SELLER + LOCAL_BUYER) * (this.sellerRelation / 100);

    const RESULT = this.cleanInput($event);
    if (
      RESULT <
      this.commissionCheckout.seller.usd -
        this.renditionForm.value.sellerManualDeductionUSD
    ) {
      if (
        Number(RESULT) != Number(this.renditionForm.value.sellerReferredUSD)
      ) {
        this.renditionForm
          .get('sellerReferredUSD')
          ?.setValue(Number(RESULT ?? 0));

        if (type != 'calc') {
          const REFERRED_TOTAL =
            RESULT +
            this.renditionForm.value.sellerReferredLocal /
              (this.renditionForm.value.exchangeRate ?? 0);

          const PERCETNTAGE =
            USD_TOTAL > 0
              ? Math.trunc((REFERRED_TOTAL / USD_TOTAL) * 100 * 100) / 100
              : Math.trunc((REFERRED_TOTAL / LOCAL_TOTAL) * 100 * 100) / 100;

          const DTO_PERCETNTAGE = PERCETNTAGE.toString().replaceAll('.', ',');

          this.changeInputSellerReferredPercentage(DTO_PERCETNTAGE, 'user');
        }
      }
    } else {
      this.renditionForm.controls['sellerReferredUSD'].setErrors({
        invalid: true,
      });
    }
  }

  changeInputSellerReferredLocal($event: InputTypes, type?: string) {
    const USD_SELLER =
      this.renditionForm.value.closePriceUSD *
      (this.renditionForm.value.sellerPercentage / 100);
    const USD_BUYER =
      this.renditionForm.value.closePriceUSD *
      (this.renditionForm.value.buyerPercentage / 100);
    const LOCAL_SELLER =
      this.renditionForm.value.closePriceLocal *
      (this.renditionForm.value.sellerPercentage / 100);
    const LOCAL_BUYER =
      this.renditionForm.value.closePriceLocal *
      (this.renditionForm.value.buyerPercentage / 100);

    const USD_TOTAL = (USD_SELLER + USD_BUYER) * (this.sellerRelation / 100);
    const LOCAL_TOTAL =
      (LOCAL_SELLER + LOCAL_BUYER) * (this.sellerRelation / 100);

    const RESULT = this.cleanInput($event);

    if (
      RESULT <
      this.commissionCheckout.seller.local -
        this.renditionForm.value.sellerManualDeductionLocal
    ) {
      if (
        Number(RESULT) != Number(this.renditionForm.value.sellerReferredLocal)
      ) {
        this.renditionForm
          .get('sellerReferredLocal')
          ?.setValue(Number(RESULT ?? 0));

        if (type != 'calc') {
          const REFERRED_TOTAL =
            RESULT +
            this.renditionForm.value.sellerReferredUSD *
              (this.renditionForm.value.exchangeRate ?? 0);

          const PERCENTAGE =
            USD_TOTAL > 0
              ? Math.trunc((REFERRED_TOTAL / USD_TOTAL) * 100 * 100) / 100
              : Math.trunc((REFERRED_TOTAL / LOCAL_TOTAL) * 100 * 100) / 100;

          const DTO_PERCENTAGE = PERCENTAGE.toString().replaceAll('.', ',');
          this.changeInputSellerReferredPercentage(DTO_PERCENTAGE, 'user');
        }
      }
    } else {
      this.renditionForm.controls['sellerReferredLocal'].setErrors({
        invalid: true,
      });
    }
  }

  onChangeSellerTeamLeaderOrigin($event: number) {
    this.renditionForm
      .get('sellerTeamLeaderOrigin')
      ?.setValue(this.sellerTeamLeaderOrigin.viewValues[$event]);

    const PERCENTAGE_SUGGESTED = $event === 0 ? 0.5625 : 0.4375;
    if (this.renditionForm.value.sellerTeamLeaderUSD > 0) {
      const TOTAL_USD =
        this.commissionCheckout.seller.agent.firstSubtotal.usd *
        PERCENTAGE_SUGGESTED;
      this.renditionForm.get('sellerTeamLeaderUSD')?.setValue(TOTAL_USD);
    }

    if (this.renditionForm.value.sellerTeamLeaderLocal > 0) {
      const TOTAL_LOCAL =
        this.commissionCheckout.seller.agent.firstSubtotal.local *
        PERCENTAGE_SUGGESTED;
      this.renditionForm.get('sellerTeamLeaderLocal')?.setValue(TOTAL_LOCAL);
    }
  }

  changeSellerTeamUSD($event: InputTypes) {
    const RESULT = this.cleanInput($event);
    if (
      !this.isReferidoACobrar &&
      RESULT <=
        this.commissionCheckout.seller.usd -
          this.commissionCheckout.seller.referred.rawCommission.usd -
          this.commissionCheckout.seller.agent.manualDeduction.usd &&
      RESULT >= 0
    ) {
      const CURRENT_VALUE = this.renditionForm.value.sellerTeamUSD;
      if (Number(RESULT) !== Number(CURRENT_VALUE)) {
        this.renditionForm.get('sellerTeamLeaderUSD')?.setValue(RESULT);
        this.formatForCheckout();
        this.calculationsJurisdiction();
      }
    } else {
      this.renditionForm.controls['sellerTeamLeaderUSD'].setErrors({
        invalid: true,
      });
    }
  }

  changeSellerTeamLocal($event: InputTypes) {
    const RESULT = this.cleanInput($event);

    if (
      !this.isReferidoACobrar &&
      RESULT <=
        this.commissionCheckout.seller.local -
          this.commissionCheckout.seller.referred.rawCommission.local -
          this.commissionCheckout.seller.agent.manualDeduction.local &&
      RESULT >= 0
    ) {
      const CURRENT_VALUE = this.renditionForm.value.sellerTeamLocal;
      if (Number(RESULT) !== Number(CURRENT_VALUE)) {
        this.renditionForm.get('sellerTeamLeaderLocal')?.setValue(RESULT);
        this.formatForCheckout();
        this.calculationsJurisdiction();
      }
    } else {
      this.renditionForm.controls['sellerTeamLeaderLocal'].setErrors({
        invalid: true,
      });
    }
  }

  generateSubTotalSellerUSD() {
    return (
      (this.renditionForm.value.sellerUSD + this.renditionForm.value.buyerUSD) *
        (this.sellerRelation / 100) -
      this.renditionForm.value.sellerManualDeductionUSD -
      (this.renditionForm.value.sellerReferredUSD || 0) -
      (this.renditionForm.value.sellerTeamLeaderUSD || 0)
    );
  }

  generateSubTotalReferidoACobrarUSD() {
    return (
      this.renditionForm.value.closePriceUSD -
      this.renditionForm.value.sellerManualDeductionUSD -
      (this.renditionForm.value.sellerReferredUSD || 0) -
      (this.renditionForm.value.sellerTeamLeaderUSD || 0)
    );
  }

  generateSubTotalReferidoACobrarLocal() {
    return (
      this.renditionForm.value.closePriceLocal -
      (this.originReferredToggle.optionSelected == 0
        ? this.renditionForm.value.sellerManualDeductionLocal
        : this.renditionForm.value.buyerManualDeductionLocal)
    );
  }

  generateSubTotalSellerLocal() {
    return (
      (this.renditionForm.value.sellerLocal +
        this.renditionForm.value.buyerLocal) *
        (this.sellerRelation / 100) -
      this.renditionForm.value.sellerManualDeductionLocal -
      (this.renditionForm.value.sellerReferredLocal || 0) -
      (this.renditionForm.value.sellerTeamLeaderLocal || 0)
    );
  }

  generateSubTotaReferidoACobrarUSD() {
    return (
      this.renditionForm.value.closePriceUSD -
      (this.originReferredToggle.optionSelected == 0
        ? this.renditionForm.value.sellerManualDeductionUSD
        : this.renditionForm.value.buyerManualDeductionUSD)
    );
  }

  generateSubTotaReferidoACobrarLocal() {
    return (
      this.renditionForm.value.closePriceLocal -
      (this.originReferredToggle.optionSelected == 0
        ? this.renditionForm.value.sellerManualDeductionLocal
        : this.renditionForm.value.buyerManualDeductionLocal)
    );
  }

  generateSubTotalBuyerUSD() {
    return (
      (this.renditionForm.value.sellerUSD + this.renditionForm.value.buyerUSD) *
        ((100 - this.sellerRelation) / 100) -
      this.renditionForm.value.buyerManualDeductionUSD -
      (this.renditionForm.value.buyerReferredUSD || 0) -
      (this.renditionForm.value.buyerTeamLeaderUSD || 0)
    );
  }

  generateSubTotalBuyerLocal() {
    return (
      (this.renditionForm.value.sellerLocal +
        this.renditionForm.value.buyerLocal) *
        ((100 - this.sellerRelation) / 100) -
      this.renditionForm.value.buyerManualDeductionLocal -
      (this.renditionForm.value.buyerReferredLocal || 0) -
      (this.renditionForm.value.buyerTeamLeaderLocal || 0)
    );
  }

  changeSellerAgentDeductionPercentage($event: InputTypes, type?: string) {
    const RESULT = isNaN(Number($event))
      ? this.cleanInput($event)
      : Number($event);

    this.sellerAgentSecondSubtotalUSD = this.isReferidoACobrar
      ? this.generateSubTotalReferidoACobrarUSD()
      : this.generateSubTotalSellerUSD();
    this.sellerAgentSecondSubtotalLocal = this.isReferidoACobrar
      ? this.generateSubTotalReferidoACobrarLocal()
      : this.generateSubTotalSellerLocal();

    if (RESULT < 100 || RESULT >= 0) {
      const CURRENT_VALUE =
        this.renditionForm.value.sellerAgentDeductionPercentage;
      const RESULT_ROUND = Math.round(RESULT * 100) / 100;

      const OLD_VALUE_USD = this.renditionForm.value.sellerAgentDeductionUSD;
      const NEW_VALUE_USD =
        this.sellerAgentSecondSubtotalUSD * (RESULT_ROUND / 100);

      const OLD_VALUE_LOCAL =
        this.renditionForm.value.sellerAgentDeductionLocal;
      const NEW_VALUE_LOCAL =
        this.sellerAgentSecondSubtotalLocal * (RESULT_ROUND / 100);

      const CURRENT_RESULT_ROUND = Math.round(CURRENT_VALUE * 100) / 100;
      const NEW_RESULT_ROUND = Math.round(RESULT_ROUND * 100) / 100;

      const DIFFERENCE_USD = Math.abs(NEW_VALUE_USD - OLD_VALUE_USD) >= 0.09;
      const DIFFERENCE_LOCAL =
        Math.abs(NEW_VALUE_LOCAL - OLD_VALUE_LOCAL) >= 0.09;

      if (
        CURRENT_RESULT_ROUND !== NEW_RESULT_ROUND ||
        DIFFERENCE_USD ||
        DIFFERENCE_LOCAL
      ) {
        if (
          Math.round(RESULT * 100) / 100 !==
            Math.round(CURRENT_VALUE * 100) / 100 ||
          type === 'calc' ||
          this.sellerAgentSecondSubtotalUSD * (RESULT / 100) !=
            this.renditionForm.value.sellerAgentDeductionUSD ||
          this.sellerAgentSecondSubtotalLocal * (RESULT / 100) !=
            this.renditionForm.value.sellerAgentDeductionLocal
        ) {
          this.renditionForm
            .get('sellerAgentDeductionPercentage')
            ?.setValue(Number(RESULT ?? 0));

          if (type !== 'user') {
            const USD = this.sellerAgentSecondSubtotalUSD * (RESULT / 100);
            const LOCAL = this.sellerAgentSecondSubtotalLocal * (RESULT / 100);

            const CURRENT_USD =
              this.renditionForm.value.sellerAgentDeductionUSD;
            if (
              Math.trunc(CURRENT_USD * 100) / 100 !==
              Math.trunc(USD * 100) / 100
            ) {
              this.changeSellerAgentDeductionUSD(USD, 'calc');
            }

            const CURRENT_LOCAL =
              this.renditionForm.value.sellerAgentDeductionLocal;
            if (
              Math.trunc(CURRENT_LOCAL * 100) / 100 !==
              Math.trunc(LOCAL * 100) / 100
            ) {
              this.changeSellerAgentDeductionLocal(LOCAL, 'calc');
            }
          }
        }
      }
      this.formatForCheckout();
    } else {
      this.renditionForm.controls['sellerAgentDeductionPercentage'].setErrors({
        invalid: true,
      });
    }
  }

  changeSellerAgentDeductionUSD($event: InputTypes, type?: string) {
    const result = type === 'calc' ? Number($event) : this.cleanInput($event);

    const usdSubtotal = this.isReferidoACobrar
      ? this.commissionCheckout.referred.firstSubtotal.usd
      : this.commissionCheckout.seller.agent.secondSubtotal.usd;
    if (result >= usdSubtotal && result > 0) {
      this.renditionForm.controls['sellerAgentDeductionUSD'].setErrors({
        invalid: true,
      });
    } else {
      const currentValue = this.renditionForm.value.sellerAgentDeductionUSD;

      if (Number(result) !== Number(currentValue)) {
        this.renditionForm
          .get('sellerAgentDeductionUSD')
          ?.setValue(Number(result ?? 0));

        if (type !== 'calc') {
          const total =
            this.sellerAgentSecondSubtotalUSD +
            this.sellerAgentSecondSubtotalLocal /
              this.renditionForm.value.exchangeRate;
          const deduction =
            result +
            this.renditionForm.value.sellerAgentDeductionLocal /
              this.renditionForm.value.exchangeRate;

          const percentage = Number((deduction / total) * 100);
          this.changeSellerAgentDeductionPercentage(percentage, 'user');
        }

        this.formatForCheckout();
      }
    }
  }

  changeSellerAgentDeductionLocal($event: InputTypes, type?: string) {
    const result = type === 'calc' ? Number($event) : this.cleanInput($event);

    const localSubtotal = this.isReferidoACobrar
      ? this.commissionCheckout.referred.firstSubtotal.local
      : this.commissionCheckout.seller.agent.secondSubtotal.local;

    if (result >= localSubtotal && result > 0) {
      this.renditionForm.controls['sellerAgentDeductionLocal'].setErrors({
        invalid: true,
      });
    } else {
      const currentValue = this.renditionForm.value.sellerAgentDeductionLocal;

      if (Number(result) !== Number(currentValue)) {
        this.renditionForm
          .get('sellerAgentDeductionLocal')
          ?.setValue(Number(result ?? 0));

        if (type !== 'calc') {
          const total =
            this.sellerAgentSecondSubtotalUSD +
            this.sellerAgentSecondSubtotalLocal /
              this.renditionForm.value.exchangeRate;
          const deduction =
            this.renditionForm.value.sellerAgentDeductionUSD +
            result / this.renditionForm.value.exchangeRate;
          const percentage = Number((deduction / total) * 100);

          this.changeSellerAgentDeductionPercentage(percentage, 'user');
        }

        this.formatForCheckout();
      }
    }
  }

  changeSellerManualDeductionName($event: InputTypes) {
    this.renditionForm.get('sellerManualDeductionName')?.setValue($event);
    this.formatForCheckout();
  }

  changeSellerManualDeductionUSD($event: InputTypes) {
    const result = this.cleanInput($event);

    if (
      (!this.isReferidoACobrar &&
        result <=
          this.commissionCheckout.seller.usd -
            this.renditionForm.value.sellerReferredUSD &&
        result > 0) ||
      (this.isReferidoACobrar &&
        result <= this.commissionCheckout.closedPrice.usd)
    ) {
      const currentValue = this.renditionForm.value.sellerManualDeductionUSD;
      if (Number(result) !== Number(currentValue)) {
        this.renditionForm.get('sellerManualDeductionUSD')?.setValue(result);
        this.formatForCheckout();
        this.calculationsJurisdiction();
      }
    } else {
      this.renditionForm.controls['sellerManualDeductionUSD'].setErrors({
        invalid: true,
      });
    }
  }

  changeSellerManualDeductionLocal($event: InputTypes) {
    const result = this.cleanInput($event);
    if (
      (!this.isReferidoACobrar &&
        result <=
          this.commissionCheckout.seller.local -
            this.renditionForm.value.sellerReferredLocal &&
        result > 0) ||
      (this.isReferidoACobrar &&
        result <= this.commissionCheckout.closedPrice.local)
    ) {
      const currentValue = this.renditionForm.value.sellerManualDeductionLocal;

      if (Number(result) !== Number(currentValue)) {
        this.renditionForm.get('sellerManualDeductionLocal')?.setValue(result);
        this.formatForCheckout();
        this.calculationsJurisdiction();
      }
    } else {
      this.renditionForm.controls['sellerManualDeductionLocal'].setErrors({
        invalid: true,
      });
    }
  }

  onSellerAddReferred($event: Event) {
    $event.preventDefault();
    const IS_OFFICE_SHARED: boolean =
      this.renditionForm.value.sellerSharedWith == 'Mi oficina';
    const AGENT: string = this.renditionForm.value.sellerAgent;
    this.addSellerReferred = IS_OFFICE_SHARED && !!AGENT;
    if (!AGENT) {
      this.snackbarService.openSnackBar(
        'Ingrese un agente en la punta ' +
          (this.NODE === this.NODE_DO ? 'captadora' : 'vendedora'),
        '',
      );
    }
    if (!IS_OFFICE_SHARED) {
      this.snackbarService.openSnackBar(
        'No puede agregar un referido si la punta no es de su oficina',
        '',
      );
    }
  }

  private readonly TEAM_LEADER_JOIN_DATE_ERROR =
    'La fecha de la rendición es anterior al ingreso del agente al team';

  private getRenditionDate(): string {
    return this.renditionForm.value.date ?? this.datePicker.date;
  }

  private getAgentByName(
    agentName: string | undefined | null,
  ): Agent | undefined {
    if (!agentName) {
      return undefined;
    }
    return this.fullAgentList.find((e) => e.agentName === agentName);
  }

  private isRenditionDateBeforeTeamJoin(agent: Agent | undefined): boolean {
    if (!agent?.teamJoinDate) {
      return false;
    }
    const RENDITION_DATE = this.getRenditionDate();
    if (!RENDITION_DATE) {
      return false;
    }
    const JOIN_DATE = moment(agent.teamJoinDate).startOf('day');
    const DATE = moment(RENDITION_DATE).startOf('day');
    if (!JOIN_DATE.isValid() || !DATE.isValid()) {
      return false;
    }
    return JOIN_DATE.isAfter(DATE);
  }

  isTeamLeaderBlockedByJoinDate(agentName: string | undefined | null): boolean {
    return this.isRenditionDateBeforeTeamJoin(this.getAgentByName(agentName));
  }

  private showTeamLeaderJoinDateSnackbar(): void {
    this.snackbarService.openSnackBar(this.TEAM_LEADER_JOIN_DATE_ERROR, '');
  }

  private clearSellerTeamLeaderSelection(): void {
    this.addSellerTeamLeader = false;
    this.renditionForm.get('sellerTeamLeaderUSD')?.setValue(0);
    this.renditionForm.get('sellerTeamLeaderLocal')?.setValue(0);
    this.renditionForm.get('sellerTeamLeader')?.setValue(null);
  }

  private clearBuyerTeamLeaderSelection(): void {
    this.addBuyerTeamLeader = false;
    this.renditionForm.get('buyerTeamLeaderUSD')?.setValue(0);
    this.renditionForm.get('buyerTeamLeaderLocal')?.setValue(0);
    this.renditionForm.get('buyerTeamLeader')?.setValue(null);
  }

  private hasInvalidTeamLeaderForRenditionDate(): boolean {
    const SELLER_INVALID =
      this.addSellerTeamLeader &&
      this.isRenditionDateBeforeTeamJoin(
        this.getAgentByName(this.renditionForm.value.sellerAgent),
      );
    const BUYER_INVALID =
      this.addBuyerTeamLeader &&
      this.isRenditionDateBeforeTeamJoin(
        this.getAgentByName(this.renditionForm.value.buyerAgent),
      );
    return !!(SELLER_INVALID || BUYER_INVALID);
  }

  private syncTeamLeadersWithRenditionDate(): void {
    const SELLER_BLOCKED =
      this.addSellerTeamLeader &&
      this.isRenditionDateBeforeTeamJoin(
        this.getAgentByName(this.renditionForm.value.sellerAgent),
      );
    const BUYER_BLOCKED =
      this.addBuyerTeamLeader &&
      this.isRenditionDateBeforeTeamJoin(
        this.getAgentByName(this.renditionForm.value.buyerAgent),
      );

    if (!SELLER_BLOCKED && !BUYER_BLOCKED) {
      return;
    }

    if (SELLER_BLOCKED) {
      this.clearSellerTeamLeaderSelection();
    }
    if (BUYER_BLOCKED) {
      this.clearBuyerTeamLeaderSelection();
    }

    this.showTeamLeaderJoinDateSnackbar();
    this.performCalculation();
  }

  onSellerRemoveTeamLeader($event: Event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.clearSellerTeamLeaderSelection();
  }

  onBuyerRemoveTeamLeader() {
    this.clearBuyerTeamLeaderSelection();
  }

  onSellerAddTeamLeader($event: Event) {
    $event.preventDefault();

    const FIND_AGENT = this.getAgentByName(
      this.renditionForm.value.sellerAgent,
    );

    if (this.isRenditionDateBeforeTeamJoin(FIND_AGENT)) {
      this.showTeamLeaderJoinDateSnackbar();
      return;
    }

    this.renditionForm.get('sellerTeamLeaderUSD')?.setValue(0);
    this.renditionForm.get('sellerTeamLeaderLocal')?.setValue(0);

    if (FIND_AGENT?.teamId) {
      if (FIND_AGENT.teamLeaderId === FIND_AGENT.id) {
        this.snackbarService.openSnackBar(
          'El agente seleccionado es el leader del team',
          '',
        );
      } else {
        this.addSellerTeamLeader = true;

        const FIND_TEAM_LEADER = this.fullAgentList.find(
          (e) => e.id === FIND_AGENT.teamLeaderId,
        );
        if (FIND_TEAM_LEADER) {
          this.renditionForm
            .get('sellerTeamLeader')
            ?.setValue(FIND_TEAM_LEADER.agentName);
        }

        const PERCENTAGE_SUGGESTED =
          this.sellerTeamLeaderOrigin.optionSelected === 0 ? 0.5625 : 0.4375;
        if (this.commissionCheckout.seller.agent.firstSubtotal.usd > 0) {
          const TOTAL_USD =
            this.commissionCheckout.seller.agent.firstSubtotal.usd *
            PERCENTAGE_SUGGESTED;
          this.renditionForm.get('sellerTeamLeaderUSD')?.setValue(TOTAL_USD);
        }

        if (this.commissionCheckout.seller.agent.firstSubtotal.local > 0) {
          const TOTAL_LOCAL =
            this.commissionCheckout.seller.agent.firstSubtotal.local *
            PERCENTAGE_SUGGESTED;
          this.renditionForm
            .get('sellerTeamLeaderLocal')
            ?.setValue(TOTAL_LOCAL);
        }

        this.performCalculation();
      }
    } else {
      this.snackbarService.openSnackBar(
        'El agente seleccionado no pertenece a un team',
        '',
      );
    }
  }

  private getNextCoBrokerId(): number {
    if (this.coBrokers.length === 0) {
      return 1;
    }
    const MAX_ID = Math.max(
      ...this.coBrokers.map((cobroker) => cobroker.id || 0),
    );
    return MAX_ID + 1;
  }

  private createSellerCobrokerForm(): FormGroup {
    return this.fb.group({
      sellerCobrokerSharedWith: [null],
      sellerCobrokerId: [null],
      sellerCobrokerOffice: [null],
      sellerCobrokerOfficeId: [null],
      sellerCobrokerName: [null],
      sellerCobrokerSplit: [null],
      sellerCobrokerType: [null],
      sellerCobrokerUSD: [0],
      sellerCobrokerLocal: [0],
    });
  }

  onRemoveCoBroker($event: Event, coBroker: { id: number }) {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    const index = this.coBrokers.findIndex((c) => c.id === coBroker.id);
    if (index === -1) return;

    // 1) eliminar de la lista usada por el *ngFor
    this.coBrokers.splice(index, 1);

    // 2) eliminar el subform asociado
    this.sellerCobrokers.removeAt(index);

    // 3) limpiar configs por id
    delete this.sellerCobrokerSharedWith[coBroker.id];
    delete this.sellerCobrokerOfficeAutocomplete[coBroker.id];
    delete this.sellerCobrokerAgentAutocomplete[coBroker.id];
    delete this.inputSellerCobrokerOther[coBroker.id];
    delete this.inputSellerCobrokerUSD[coBroker.id];
    delete this.inputSellerCobrokerLocal[coBroker.id];

    this.formatForCheckout();
  }

  regaliasChanged(value: boolean) {
    this.isRegaliasChecked = value;
    if (!value) {
      this.renditionForm.removeControl('regaliasLocal');
      this.renditionForm.removeControl('regaliasUSD');
    } else {
      this.renditionForm.addControl('regaliasLocal', new FormControl(0));
      this.renditionForm.addControl('regaliasUSD', new FormControl(0));
    }
  }

  changeRegaliasLocal($event: InputTypes) {
    const RESULT = this.cleanInput($event);
    const TOP = this.commissionCheckout.office.subtotal.local;
    const CONTROL = this.renditionForm.get('regaliasLocal');

    if (RESULT < 0 || RESULT > TOP) {
      CONTROL?.setErrors({ invalid: true });
      return;
    }

    CONTROL?.setValue(RESULT);
    CONTROL?.setErrors(null);
  }

  changeRegaliasUSD($event: InputTypes) {
    const RESULT = this.cleanInput($event);
    const TOP = this.commissionCheckout.office.subtotal.usd;
    const CONTROL = this.renditionForm.get('regaliasUSD');

    if (RESULT < 0 || RESULT > TOP) {
      CONTROL?.setErrors({ invalid: true });
      return;
    }

    CONTROL?.setValue(RESULT);
    CONTROL?.setErrors(null);
  }

  trackByCobroker(index: number, item: { id: number }): number {
    return item.id;
  }

  private applyCurrencyMode(group: FormGroup, key: string): void {
    if (group.contains(key)) group.removeControl(key);
  }

  get sellerCobrokers(): FormArray {
    return this.renditionForm.get('sellerCobrokers') as FormArray;
  }

  onSellerAddCoBroker() {
    const NEW_ID_COBROKER = this.getNextCoBrokerId();

    this.sellerCobrokers.insert(0, this.createSellerCobrokerForm());

    this.coBrokers.unshift({
      id: NEW_ID_COBROKER,
    });

    this.generateNewCoBrokerInputs(NEW_ID_COBROKER);
    this.onChangeSellerCobrokerSharedWith(0, { id: NEW_ID_COBROKER }, 0);
  }

  generateNewCoBrokerInputs(id: number) {
    this.sellerCobrokerSharedWith[id] = {
      ...this.sellerCobrokerSharedWithModel,
    };

    this.sellerCobrokerOfficeAutocomplete[id] = {
      ...this.sellerCobrokerOfficeAutocompleteModel,
    };

    this.sellerCobrokerAgentAutocomplete[id] = {
      ...this.sellerCobrokerAgentAutocompleteModel,
    };

    this.inputSellerCobrokerOther[id] = {
      ...this.inputSellerCobrokerOtherModel,
    };

    this.inputSellerCobrokerUSD[id] = {
      ...this.inputSellerCobrokerUSDModel,
    };

    this.inputSellerCobrokerLocal[id] = {
      ...this.inputSellerCobrokerLocalModel,
    };
  }

  async onChangeSellerCobrokerSharedWith(
    selectedIndex: number,
    coBroker: { id: number },
    index: number,
  ): Promise<void> {
    const CONFIG = this.sellerCobrokerSharedWith[coBroker.id];

    CONFIG.optionSelected = selectedIndex;

    const GROUP = this.sellerCobrokers.at(index) as FormGroup;

    const SHARED_WITH_LABEL =
      CONFIG.viewValues?.[selectedIndex] ?? CONFIG.viewValues?.[0] ?? null;
    GROUP.get('sellerCobrokerSharedWith')?.setValue(SHARED_WITH_LABEL);

    this.sellerCobrokerAgentAutocomplete[coBroker.id].options =
      selectedIndex !== 0 ? [] : [...this.agentsListMyOffice];

    GROUP.patchValue({
      sellerCobrokerName: '',
      sellerCobrokerOffice: '',
      sellerCobrokerUSD: 0,
      sellerCobrokerLocal: 0,
    });

    switch (selectedIndex) {
      case 0: {
        // Origen: mi oficina
        GROUP.get('sellerCobrokerOffice')?.setValue(
          this.user?.agency_name ?? '',
        );

        const MY_OFFICE = this.officesList.find(
          (e: { id: number; name: string }) =>
            e.name === this.user?.agency_name,
        );
        if (MY_OFFICE && this.cobrokerAgentsListMyOffice.length === 0) {
          const RESPONSE = await this.getInitialAgentsCobroker(MY_OFFICE.id);
          if (RESPONSE?.data?.agents) {
            const OPTIONS_AGENTS = RESPONSE?.data?.agents.map(
              (e: Agent) => e.agentName,
            );
            this.sellerCobrokerAgentAutocomplete[coBroker.id].options =
              OPTIONS_AGENTS;
            this.sellerCobrokerAgentAutocomplete[coBroker.id] = {
              ...this.sellerCobrokerAgentAutocomplete[coBroker.id],
            };
          }
        }

        break;
      }

      case 1: {
        // Origen: otra oficina
        const officeOptions: string[] = [];

        this.officesList.forEach((e: { id: number; name: string }) => {
          if (e.name !== this.user?.agency_name) {
            officeOptions.push(e.name);
          }
        });

        this.sellerCobrokerOfficeAutocomplete[coBroker.id].options =
          officeOptions;
        break;
      }
      case 0: {
        GROUP.get('sellerCobrokerOffice')?.setValue(this.user?.agency_name);
        GROUP.get('sellerCobrokerOfficeId')?.setValue(null);
        break;
      }
    }

    this.formatForCheckout();
  }

  async sellerCobrokerOfficeAutocompleteChange(
    selectedOfficeName: string | undefined,
    cobroker: { id: number },
    index: number,
  ): Promise<void> {
    if (selectedOfficeName) {
      const GROUP = this.sellerCobrokers.at(index) as FormGroup;
      GROUP.get('sellerCobrokerName')?.setValue(null);

      if (selectedOfficeName !== this.user?.agency_name) {
        const OFFICE = this.officesList.find(
          (e: { id: number; name: string }) => e.name === selectedOfficeName,
        );

        if (OFFICE) {
          GROUP.get('sellerCobrokerOffice')?.setValue(OFFICE.name);
          GROUP.get('sellerCobrokerOfficeId')?.setValue(OFFICE.id.toString());

          this.sellerCobrokerAgentAutocomplete[cobroker.id].options = [];

          const RESPONSE = await this.getInitialAgentsCobroker(OFFICE.id);
          this.cobrokersAgentListOtherOffice = [];

          if (RESPONSE?.data?.agents) {
            this.cobrokersAgentListOtherOffice = RESPONSE.data.agents;
            RESPONSE.data.agents.forEach((e: Agent) => {
              this.sellerCobrokerAgentAutocomplete[cobroker.id].options.push(
                e.agentName,
              );
            });
          }

          this.sellerCobrokerAgentAutocomplete[cobroker.id] = {
            ...this.sellerCobrokerAgentAutocomplete[cobroker.id],
          };
        }
      } else {
        this.sellerCobrokerSharedWith[cobroker.id].optionSelected = 0;
        GROUP.get('sellerCobrokerOfficeId')?.setValue(null);
        GROUP.get('sellerCobrokerOffice')?.setValue(this.user?.agency_name);

        await this.onChangeSellerCobrokerSharedWith(0, cobroker, index);
      }
    }

    this.formatForCheckout();
  }

  sellerCobrokerAgentAutocompleteChange(
    selectedAgentName: string | undefined,
    index: number,
  ): void {
    const GROUP = this.sellerCobrokers.at(index) as FormGroup;

    if (selectedAgentName) {
      if (selectedAgentName === this.renditionForm.value.sellerAgent) {
        GROUP.get('sellerCobrokerName')?.setErrors({ invalid: true });
      } else {
        let find = this.fullAgentList.find(
          (e: Agent) => e.agentName === selectedAgentName,
        );

        if (!find) {
          find = this.cobrokersAgentListOtherOffice.find(
            (e: Agent) => e.agentName === selectedAgentName,
          );
        }

        if (find) {
          GROUP.get('sellerCobrokerSplit')?.setValue(find.agentType);
          GROUP.get('sellerCobrokerType')?.setValue(find.agentLevelType);
          GROUP.get('sellerCobrokerId')?.setValue(find.id);
        }

        GROUP.get('sellerCobrokerName')?.setValue(selectedAgentName);
        GROUP.get('sellerCobrokerName')?.setErrors(null);
      }
    } else {
      GROUP.patchValue({
        sellerCobrokerName: null,
        sellerCobrokerUSD: 0,
        sellerCobrokerLocal: 0,
      });
    }
    this.formatForCheckout();
  }

  changeSellerCobrokerOther($event: InputTypes, index: number): void {
    const GROUP = this.sellerCobrokers.at(index) as FormGroup;

    GROUP.get('sellerCobrokerName')?.setValue($event);

    this.formatForCheckout();
  }

  changeInputSellerCobrokerUSD($event: InputTypes, index: number): void {
    const GROUP = this.sellerCobrokers.at(index) as FormGroup;

    const RESULT = this.cleanInput($event);
    // Revisar luego si hay que agregar la sumatoria de los cobrokers o que validamos
    const MAX_USD =
      this.renditionForm.value.sellerUSD -
      (this.renditionForm.value.sellerManualDeductionUSD || 0);

    if (RESULT >= 0 && RESULT < MAX_USD) {
      const current = GROUP.get('sellerCobrokerUSD')?.value ?? 0;

      if (Number(RESULT) !== Number(current)) {
        GROUP.get('sellerCobrokerUSD')?.setValue(Number(RESULT ?? 0));
        GROUP.get('sellerCobrokerUSD')?.setErrors(null);
      }
    } else {
      GROUP.get('sellerCobrokerUSD')?.setErrors({ invalid: true });
    }

    this.formatForCheckout();
  }

  changeInputSellerCobrokerLocal($event: InputTypes, index: number): void {
    const GROUP = this.sellerCobrokers.at(index) as FormGroup;

    const RESULT = this.cleanInput($event);
    // Revisar luego si hay que agregar la sumatoria de los cobrokers o que validamos
    const MAX_LOCAL =
      this.renditionForm.value.sellerLocal -
      (this.renditionForm.value.sellerManualDeductionLocal || 0);

    if (RESULT >= 0 && RESULT < MAX_LOCAL) {
      const current = GROUP.get('sellerCobrokerLocal')?.value ?? 0;

      if (Number(RESULT) !== Number(current)) {
        GROUP.get('sellerCobrokerLocal')?.setValue(Number(RESULT ?? 0));
        GROUP.get('sellerCobrokerLocal')?.setErrors(null);
      }
    } else {
      GROUP.get('sellerCobrokerLocal')?.setErrors({ invalid: true });
    }

    this.formatForCheckout();
  }

  async onChangeBuyerSharedWith($event: number) {
    if (this.renditionForm.value.sharedWith == 'Dos puntas') {
      this.sellerSharedWith.optionSelected = 0;
      this.buyerSharedWith.optionSelected = 0;
      this.renditionForm.get('sellerSharedWith')?.setValue('Mi oficina');
      this.renditionForm.get('buyerSharedWith')?.setValue('Mi oficina');
      this.snackbarService.openSnackBar(
        'No puede cambiar agente o oficina cuando tiene ambas puntas',
        '',
      );
    } else if (
      this.renditionForm.value.sharedWith == 'RE/MAX' &&
      this.renditionForm.value.sharedWithOffice == this.user?.agency_name
    ) {
      if ($event != 0) {
        this.buyerSharedWith.optionSelected = 0;
        this.renditionForm.get('buyerSharedWith')?.setValue('Mi oficina');
        this.snackbarService.openSnackBar(
          'La operación es compartida con su oficina',
          '',
        );
      }
    } else if (this.sellerSharedWith.optionSelected !== 0 && $event !== 0) {
      this.buyerSharedWith.optionSelected = 0;
      this.snackbarService.openSnackBar(
        'Una de las puntas debe ser de su oficina',
        '',
      );
    } else {
      this.buyerSharedWith.optionSelected = $event;
      this.renditionForm
        .get('buyerSharedWith')
        ?.setValue(this.buyerSharedWith.viewValues[$event]);

      if (!this.renditionForm.get('buyerOffice')) {
        this.renditionForm.addControl(
          'buyerOffice',
          new FormControl('', Validators.required),
        );
      }

      this.renditionForm.get('buyerAgent')?.setValue('');
      this.renditionForm.get('buyerOffice')?.setValue('');
      switch ($event) {
        case 0:
          this.renditionForm
            .get('buyerOffice')
            ?.setValue(this.user?.agency_name);
          this.buyerOfficeAutocomplete.options = [];

          await this.getInitialAgentList(false, true, false, false);

          if (this.sharedWithToggle.optionSelected == 1) {
            this.sellerSharedWith.optionSelected = 1;
            this.renditionForm.get('sellerSharedWith')?.setValue('RE/MAX');

            if (this.renditionForm.value.sharedWithOffice) {
              this.sellerOfficeAutocompleteChange(
                this.renditionForm.value.sharedWithOffice,
              );
              this.inputAgentGlobalSeller =
                this.NODE === this.NODE_GLOBAL &&
                this.renditionForm.value.sellerSharedWith != 'Mi oficina' &&
                this.renditionForm.value.sellerOffice != this.user?.agency_name;
            }
          }

          if (this.sharedWithToggle.optionSelected == 2) {
            this.sellerSharedWith.optionSelected = 2;
            this.renditionForm.get('sellerSharedWith')?.setValue('Otro');

            if (
              this.renditionForm.value.anotherRealEstateInput ||
              this.renditionForm.value.sharedWithAnotherRealEstate
            ) {
              this.renditionForm.get('sellerOffice')?.setValue('');
              this.renditionForm.get('sellerAgent')?.setValue('');
            }
          }

          break;
        case 1:
          this.buyerOfficeAutocomplete.options = [];
          this.buyerAgentAutocomplete.options = [];
          this.officesList.forEach((e: { id: number; name: string }) => {
            this.buyerOfficeAutocomplete.options.push(e.name);
          });
          if (this.renditionForm.value.sharedWithOffice) {
            await this.buyerOfficeAutocompleteChange(
              this.renditionForm.value.sharedWithOffice,
            );
          }

          this.sellerSharedWith.optionSelected = 0;
          this.renditionForm.get('sellerSharedWith')?.setValue('Mi oficina');

          break;
        case 2:
          this.renditionForm.removeControl('buyerOffice');
          this.buyerAgentAutocomplete.options = [];
          this.buyerOtherRemaxAutocomplete.options = [];
          this.otherRemaxList.forEach((e: { id: number; name: string }) => {
            this.buyerOtherRemaxAutocomplete.options.push(e.name);
          });
          this.sellerSharedWith.optionSelected = 0;
          this.renditionForm.get('sellerSharedWith')?.setValue('Mi oficina');
          break;
      }
    }

    this.inputAgentGlobalBuyer =
      this.NODE === this.NODE_GLOBAL &&
      this.renditionForm.value.buyerSharedWith != 'Mi oficina' &&
      this.renditionForm.value.buyerOffice != this.user?.agency_name;
  }

  async buyerOfficeAutocompleteChange($event: string | undefined) {
    this.buyerAgentAutocomplete.options = [];
    this.renditionForm.get('buyerAgent')?.setValue('');
    if ($event) {
      const office = this.officesList.find(
        (e: { id: number; name: string }) => e.name == $event,
      );
      if (office) {
        this.renditionForm.get('buyerOffice')?.setValue(office.name);
        if (
          this.buyerSharedWith.optionSelected == 1 &&
          this.sharedWithToggle.optionSelected == 1
        ) {
          this.renditionForm.get('sharedWithOffice')?.setValue(office.name);
        }
        const url = office.id + '/agents';
        const response: any = await this.renditionsService.get(url);
        if (response?.data?.agents) {
          this.otherRemaxList = response.data.agents;
          response.data.agents.forEach((e: Agent) => {
            this.buyerAgentAutocomplete.options.push(e.agentName);
            this.fullAgentList.push(e);
          });
        }
      }
    }
    this.buyerAgentAutocomplete = { ...this.buyerAgentAutocomplete };
  }

  buyerReferredOfficeAutocompleteChange($event: string | undefined) {
    if ($event) {
      this.inputAgentGlobalBuyerReferred =
        this.NODE === this.NODE_GLOBAL && $event != this.user?.agency_name;
      if (this.user?.agency_name != $event) {
        const office = this.officesList.find(
          (e: { id: number; name: string }) => e.name == $event,
        );
        if (office) {
          this.buyerReferredAgentAutocomplete.options = [];
          this.renditionForm.get('buyerReferredName')?.setValue('');
          this.renditionForm.get('buyerReferredOffice')?.setValue(office.name);
          const url = office.id + '/agents';
          this.renditionsService.get(url).then((response: any) => {
            if (response?.data?.agents) {
              this.buyerReferredAgentList = [...response.data.agents];
              this.buyerReferredAgentList.forEach((e: Agent) => {
                this.buyerReferredAgentAutocomplete.options.push(e.agentName);
              });
            }
          });
        }
      } else {
        this.buyerReferredSharedWith.optionSelected = 0;
        this.onChangeBuyerReferredSharedWith(0);
      }
    } else {
      this.renditionForm.get('buyerReferredName')?.setValue('');
      this.renditionForm.get('buyerReferredOffice')?.setValue('');
    }
    this.buyerReferredAgentAutocomplete = {
      ...this.buyerReferredAgentAutocomplete,
    };
  }

  buyerReferredAgentAutocompleteChange($event: string | undefined) {
    if ($event) {
      if ($event == this.renditionForm.value.buyerAgent) {
        this.renditionForm.controls['buyerReferredName'].setErrors({
          invalid: true,
        });
      } else {
        this.renditionForm.get('buyerReferredName')?.setValue($event);

        this.changeInputBuyerReferredPercentage(25);
        this.calculationsJurisdiction();

        this.formatForCheckout();
      }
    } else {
      this.renditionForm.get('buyerReferredName')?.setValue('');
      this.renditionForm.get('buyerReferredPercentage')?.setValue(0);
      this.renditionForm.get('buyerReferredUSD')?.setValue(0);
      this.renditionForm.get('buyerReferredLocal')?.setValue(0);

      this.performCalculation();
    }
  }

  changeInputBuyerReferredPercentage($event: InputTypes, type?: string) {
    const USD_SELLER = this.renditionForm.value.sellerUSD;
    const USD_BUYER = this.renditionForm.value.buyerUSD;
    const LOCAL_SELLER = this.renditionForm.value.sellerLocal;
    const LOCAL_BUYER = this.renditionForm.value.buyerLocal;

    const USD_TOTAL = (USD_SELLER + USD_BUYER) * (this.buyerRelation / 100);
    const LOCAL_TOTAL =
      (LOCAL_SELLER + LOCAL_BUYER) * (this.buyerRelation / 100);

    const result = this.cleanInput($event);

    if (result < 100) {
      if (
        Math.round(Number(result) * 100) / 100 !=
        Math.round(
          Number(this.renditionForm.value.buyerReferredPercentage) * 100,
        ) /
          100
      ) {
        this.renditionForm
          .get('buyerReferredPercentage')
          ?.setValue(Number(result ?? 0));

        if (type != 'user') {
          const usd = USD_TOTAL * (result / 100);
          const local = LOCAL_TOTAL * (result / 100);

          if (
            Math.trunc(this.renditionForm.value.buyerReferredUSD * 100) / 100 !=
            Math.trunc(usd * 100) / 100
          ) {
            this.changeInputBuyerReferredUSD(usd.toLocaleString(), 'calc');
          }

          if (
            Math.trunc(this.renditionForm.value.buyerReferredLocal * 100) /
              100 !=
            Math.trunc(local * 100) / 100
          ) {
            this.changeInputBuyerReferredLocal(local.toLocaleString(), 'calc');
          }

          this.performCalculation('referred');
        }
        this.formatForCheckout();
      }
    } else {
      this.renditionForm.controls['buyerReferredPercentage'].setErrors({
        invalid: true,
      });
    }
  }

  changeInputBuyerReferredUSD($event: InputTypes, type?: string) {
    const USD_SELLER =
      this.renditionForm.value.closePriceUSD *
      (this.renditionForm.value.sellerPercentage / 100);
    const USD_BUYER =
      this.renditionForm.value.closePriceUSD *
      (this.renditionForm.value.buyerPercentage / 100);
    const LOCAL_SELLER =
      this.renditionForm.value.closePriceLocal *
      (this.renditionForm.value.sellerPercentage / 100);
    const LOCAL_BUYER =
      this.renditionForm.value.closePriceLocal *
      (this.renditionForm.value.buyerPercentage / 100);

    const USD_TOTAL = (USD_SELLER + USD_BUYER) * (this.buyerRelation / 100);
    const LOCAL_TOTAL =
      (LOCAL_SELLER + LOCAL_BUYER) * (this.buyerRelation / 100);

    const result = this.cleanInput($event);
    // aca
    if (
      result <
      this.commissionCheckout.buyer.usd -
        this.renditionForm.value.buyerManualDeductionUSD
    ) {
      if (Number(result) != Number(this.renditionForm.value.buyerReferredUSD)) {
        this.renditionForm
          .get('buyerReferredUSD')
          ?.setValue(Number(result ?? 0));

        if (type != 'calc') {
          const referredTotal =
            result +
            this.renditionForm.value.buyerReferredLocal /
              (this.renditionForm.value.exchangeRate ?? 0);

          const percentage =
            USD_TOTAL > 0
              ? Math.trunc((referredTotal / USD_TOTAL) * 100 * 100) / 100
              : Math.trunc((referredTotal / LOCAL_TOTAL) * 100 * 100) / 100;

          const dto_percentage = percentage.toString().replaceAll('.', ',');

          this.changeInputBuyerReferredPercentage(dto_percentage, 'user');
        }
      }
    } else {
      this.renditionForm.controls['buyerReferredUSD'].setErrors({
        invalid: true,
      });
    }
  }

  changeInputBuyerReferredLocal($event: InputTypes, type?: string) {
    const USD_SELLER =
      this.renditionForm.value.closePriceUSD *
      (this.renditionForm.value.sellerPercentage / 100);
    const USD_BUYER =
      this.renditionForm.value.closePriceUSD *
      (this.renditionForm.value.buyerPercentage / 100);
    const LOCAL_SELLER =
      this.renditionForm.value.closePriceLocal *
      (this.renditionForm.value.sellerPercentage / 100);
    const LOCAL_BUYER =
      this.renditionForm.value.closePriceLocal *
      (this.renditionForm.value.buyerPercentage / 100);

    const USD_TOTAL = (USD_SELLER + USD_BUYER) * (this.buyerRelation / 100);
    const LOCAL_TOTAL =
      (LOCAL_SELLER + LOCAL_BUYER) * (this.buyerRelation / 100);

    const result = this.cleanInput($event);
    if (
      result <
      this.commissionCheckout.buyer.local -
        this.renditionForm.value.buyerManualDeductionLocal
    ) {
      if (
        Number(result) != Number(this.renditionForm.value.buyerReferredLocal)
      ) {
        this.renditionForm
          .get('buyerReferredLocal')
          ?.setValue(Number(result ?? 0));

        if (type != 'calc') {
          const referredTotal =
            result +
            this.renditionForm.value.buyerReferredUSD *
              (this.renditionForm.value.exchangeRate ?? 0);

          const percentage =
            USD_TOTAL > 0
              ? Math.trunc((referredTotal / USD_TOTAL) * 100 * 100) / 100
              : Math.trunc((referredTotal / LOCAL_TOTAL) * 100 * 100) / 100;

          const dto_percentage = percentage.toString().replaceAll('.', ',');

          this.changeInputBuyerReferredPercentage(dto_percentage, 'user');
        }
      }
    } else {
      this.renditionForm.controls['buyerReferredLocal'].setErrors({
        invalid: true,
      });
    }
  }

  onChangeBuyerTeamLeaderOrigin($event: number) {
    this.renditionForm
      .get('buyerTeamLeaderOrigin')
      ?.setValue(this.buyerTeamLeaderOrigin.viewValues[$event]);

    const PERCENTAGE_SUGGESTED = $event === 0 ? 0.5625 : 0.4375;
    if (this.renditionForm.value.buyerTeamLeaderUSD > 0) {
      const TOTAL_USD =
        this.commissionCheckout.buyer.agent.firstSubtotal.usd *
        PERCENTAGE_SUGGESTED;
      this.renditionForm.get('buyerTeamLeaderUSD')?.setValue(TOTAL_USD);
    }

    if (this.renditionForm.value.buyerTeamLeaderLocal > 0) {
      const TOTAL_LOCAL =
        this.commissionCheckout.buyer.agent.firstSubtotal.local *
        PERCENTAGE_SUGGESTED;
      this.renditionForm.get('buyerTeamLeaderLocal')?.setValue(TOTAL_LOCAL);
    }
  }

  changeBuyerTeamUSD($event: InputTypes) {
    const RESULT = this.cleanInput($event);

    if (
      !this.isReferidoACobrar &&
      RESULT <=
        this.commissionCheckout.buyer.usd -
          this.commissionCheckout.buyer.referred.rawCommission.usd -
          this.commissionCheckout.buyer.agent.manualDeduction.usd &&
      RESULT >= 0
    ) {
      const CURRENT_VALUE = this.renditionForm.value.buyerTeamUSD;
      if (Number(RESULT) !== Number(CURRENT_VALUE)) {
        this.renditionForm.get('buyerTeamLeaderUSD')?.setValue(RESULT);
        this.formatForCheckout();
        this.calculationsJurisdiction();
      }
    } else {
      this.renditionForm.controls['buyerTeamLeaderUSD'].setErrors({
        invalid: true,
      });
    }
  }

  changeBuyerTeamLocal($event: InputTypes) {
    const RESULT = this.cleanInput($event);

    if (
      !this.isReferidoACobrar &&
      RESULT <=
        this.commissionCheckout.buyer.local -
          this.commissionCheckout.buyer.referred.rawCommission.local -
          this.commissionCheckout.buyer.agent.manualDeduction.local &&
      RESULT >= 0
    ) {
      const CURRENT_VALUE = this.renditionForm.value.buyerTeamLocal;
      if (Number(RESULT) !== Number(CURRENT_VALUE)) {
        this.renditionForm.get('buyerTeamLeaderLocal')?.setValue(RESULT);
        this.formatForCheckout();
        this.calculationsJurisdiction();
      }
    } else {
      this.renditionForm.controls['buyerTeamLeaderLocal'].setErrors({
        invalid: true,
      });
    }
  }

  changeBuyerAgentDeductionPercentage($event: InputTypes, type?: string) {
    const result = isNaN(Number($event))
      ? this.cleanInput($event)
      : Number($event);

    this.buyerAgentSecondSubtotalUSD = this.isReferidoACobrar
      ? this.generateSubTotalReferidoACobrarUSD()
      : this.generateSubTotalBuyerUSD();
    this.buyerAgentSecondSubtotalLocal = this.isReferidoACobrar
      ? this.generateSubTotalReferidoACobrarLocal()
      : this.generateSubTotalBuyerLocal();

    if (result < 100 || result >= 0) {
      const currentValue =
        this.renditionForm.value.buyerAgentDeductionPercentage;
      const RESULT_ROUND = Math.round(result * 100) / 100;

      const OLD_VALUE_USD = this.renditionForm.value.buyerAgentDeductionUSD;
      const NEW_VALUE_USD =
        this.buyerAgentSecondSubtotalUSD * (RESULT_ROUND / 100);

      const OLD_VALUE_LOCAL = this.renditionForm.value.buyerAgentDeductionLocal;
      const NEW_VALUE_LOCAL =
        this.buyerAgentSecondSubtotalLocal * (RESULT_ROUND / 100);

      const CURRENT_RESULT_ROUND = Math.round(currentValue * 100) / 100;
      const NEW_RESULT_ROUND = Math.round(RESULT_ROUND * 100) / 100;

      const DIFFERENCE_USD = Math.abs(NEW_VALUE_USD - OLD_VALUE_USD) >= 0.09;
      const DIFFERENCE_LOCAL =
        Math.abs(NEW_VALUE_LOCAL - OLD_VALUE_LOCAL) >= 0.09;

      if (
        CURRENT_RESULT_ROUND !== NEW_RESULT_ROUND ||
        DIFFERENCE_USD ||
        DIFFERENCE_LOCAL
      ) {
        if (
          Math.round(result * 100) / 100 !==
            Math.round(currentValue * 100) / 100 ||
          type === 'calc' ||
          this.buyerAgentSecondSubtotalUSD * (result / 100) !=
            this.renditionForm.value.buyerAgentDeductionUSD ||
          this.buyerAgentSecondSubtotalLocal * (result / 100) !=
            this.renditionForm.value.buyerAgentDeductionLocal
        ) {
          this.renditionForm
            .get('buyerAgentDeductionPercentage')
            ?.setValue(Number(result ?? 0));

          if (type !== 'user') {
            const usd = this.buyerAgentSecondSubtotalUSD * (result / 100);
            const local = this.buyerAgentSecondSubtotalLocal * (result / 100);

            const currentUSD = this.renditionForm.value.buyerAgentDeductionUSD;
            if (
              Math.trunc(currentUSD * 100) / 100 !==
              Math.trunc(usd * 100) / 100
            ) {
              this.changeBuyerAgentDeductionUSD(usd, 'calc');
            }

            const currentLocal =
              this.renditionForm.value.buyerAgentDeductionLocal;
            if (
              Math.trunc(currentLocal * 100) / 100 !==
              Math.trunc(local * 100) / 100
            ) {
              this.changeBuyerAgentDeductionLocal(local, 'calc');
            }
          }
        }
      }
      this.formatForCheckout();
    } else {
      this.renditionForm.controls['buyerAgentDeductionPercentage'].setErrors({
        invalid: true,
      });
    }
  }

  changeBuyerAgentDeductionUSD($event: InputTypes, type?: string) {
    const result = type === 'calc' ? Number($event) : this.cleanInput($event);

    const usdSubtotal = this.isReferidoACobrar
      ? this.commissionCheckout.referred.firstSubtotal.usd
      : this.commissionCheckout.buyer.agent.secondSubtotal.usd;
    if (result >= usdSubtotal && result > 0) {
      this.renditionForm.controls['buyerAgentDeductionUSD'].setErrors({
        invalid: true,
      });
    } else {
      const currentValue = this.renditionForm.value.buyerAgentDeductionUSD;

      if (Number(result) !== Number(currentValue)) {
        this.renditionForm
          .get('buyerAgentDeductionUSD')
          ?.setValue(Number(result ?? 0));

        if (type !== 'calc') {
          const total =
            this.buyerAgentSecondSubtotalUSD +
            this.buyerAgentSecondSubtotalLocal /
              this.renditionForm.value.exchangeRate;
          const deduction =
            result +
            this.renditionForm.value.buyerAgentDeductionLocal /
              this.renditionForm.value.exchangeRate;

          const percentage = Number((deduction / total) * 100);
          this.changeBuyerAgentDeductionPercentage(percentage, 'user');
        }

        this.formatForCheckout();
      }
    }
  }

  changeBuyerAgentDeductionLocal($event: InputTypes, type?: string) {
    const result = type === 'calc' ? Number($event) : this.cleanInput($event);

    const localSubtotal = this.isReferidoACobrar
      ? this.commissionCheckout.referred.firstSubtotal.local
      : this.commissionCheckout.buyer.agent.secondSubtotal.local;

    if (result >= localSubtotal && result > 0) {
      this.renditionForm.controls['buyerAgentDeductionLocal'].setErrors({
        invalid: true,
      });
    } else {
      const currentValue = this.renditionForm.value.buyerAgentDeductionLocal;

      if (Number(result) !== Number(currentValue)) {
        this.renditionForm
          .get('buyerAgentDeductionLocal')
          ?.setValue(Number(result ?? 0));

        if (type !== 'calc') {
          const total =
            this.buyerAgentSecondSubtotalUSD +
            this.buyerAgentSecondSubtotalLocal /
              this.renditionForm.value.exchangeRate;
          const deduction =
            this.renditionForm.value.buyerAgentDeductionUSD +
            result / this.renditionForm.value.exchangeRate;
          const percentage = Number((deduction / total) * 100);

          this.changeBuyerAgentDeductionPercentage(percentage, 'user');
        }

        this.formatForCheckout();
      }
    }
  }

  changeBuyerManualDeductionName($event: InputTypes) {
    this.renditionForm.get('buyerManualDeductionName')?.setValue($event);
    this.formatForCheckout();
  }

  changeBuyerManualDeductionUSD($event: InputTypes) {
    const result = this.cleanInput($event);

    if (
      (!this.isReferidoACobrar &&
        result <=
          this.commissionCheckout.buyer.usd -
            this.renditionForm.value.buyerReferredUSD) ||
      (this.isReferidoACobrar &&
        result <= this.commissionCheckout.closedPrice.usd)
    ) {
      const currentValue = this.renditionForm.value.buyerManualDeductionUSD;
      if (Number(result) !== Number(currentValue)) {
        this.renditionForm.get('buyerManualDeductionUSD')?.setValue(result);
        this.formatForCheckout();
        this.calculationsJurisdiction();
      }
    } else {
      this.renditionForm.controls['buyerManualDeductionUSD'].setErrors({
        invalid: true,
      });
    }
  }

  changeBuyerManualDeductionLocal($event: InputTypes) {
    const result = this.cleanInput($event);

    if (
      (!this.isReferidoACobrar &&
        result <=
          this.commissionCheckout.buyer.local -
            this.renditionForm.value.buyerReferredLocal) ||
      (this.isReferidoACobrar &&
        result <= this.commissionCheckout.closedPrice.local)
    ) {
      const currentValue = this.renditionForm.value.buyerManualDeductionLocal;
      if (Number(result) !== Number(currentValue)) {
        this.renditionForm.get('buyerManualDeductionLocal')?.setValue(result);
        this.formatForCheckout();
        this.calculationsJurisdiction();
      }
    } else {
      this.renditionForm.controls['buyerManualDeductionLocal'].setErrors({
        invalid: true,
      });
    }
  }

  onCleanSellerReferred($event: Event) {
    $event.preventDefault();
    this.addSellerReferred = false;
    this.renditionForm.get('sellerReferredOffice')?.setValue('');
    this.renditionForm.get('sellerReferredName')?.setValue('');
    this.renditionForm.get('sellerReferredPercentage')?.setValue(0);
    this.renditionForm.get('sellerReferredUSD')?.setValue(0);
    this.renditionForm.get('sellerReferredLocal')?.setValue(0);

    this.performCalculation();
  }

  onCleanBuyerReferred($event: Event) {
    $event.preventDefault();
    this.addBuyerReferred = false;
    this.renditionForm.get('buyerReferredOffice')?.setValue('');
    this.renditionForm.get('buyerReferredName')?.setValue('');
    this.renditionForm.get('buyerReferredPercentage')?.setValue(0);
    this.renditionForm.get('buyerReferredUSD')?.setValue(0);
    this.renditionForm.get('buyerReferredLocal')?.setValue(0);

    this.performCalculation();
  }

  onBuyerAddReferred($event: Event) {
    $event.preventDefault();
    const IS_OFFICE_SHARED: boolean =
      this.renditionForm.value.buyerSharedWith == 'Mi oficina';
    const AGENT: string = this.renditionForm.value.buyerAgent;
    this.addBuyerReferred = IS_OFFICE_SHARED && !!AGENT;
    if (!AGENT) {
      this.snackbarService.openSnackBar(
        'Ingrese un agente en la punta vendedora',
        '',
      );
    }
    if (!IS_OFFICE_SHARED) {
      this.snackbarService.openSnackBar(
        'No puede agregar un referido si la punta no es de su oficina',
        '',
      );
    }
  }

  onBuyerAddTeamLeader($event: Event) {
    $event.preventDefault();
    const FIND_AGENT = this.getAgentByName(this.renditionForm.value.buyerAgent);

    if (this.isRenditionDateBeforeTeamJoin(FIND_AGENT)) {
      this.showTeamLeaderJoinDateSnackbar();
      return;
    }

    this.renditionForm.get('buyerTeamLeaderUSD')?.setValue(0);
    this.renditionForm.get('buyerTeamLeaderLocal')?.setValue(0);
    if (FIND_AGENT?.teamId) {
      if (FIND_AGENT.teamLeaderId === FIND_AGENT.id) {
        this.snackbarService.openSnackBar(
          'El agente seleccionado es el leader del team',
          '',
        );
      } else {
        this.addBuyerTeamLeader = true;

        const FIND_TEAM_LEADER = this.fullAgentList.find(
          (e) => e.id === FIND_AGENT.teamLeaderId,
        );
        if (FIND_TEAM_LEADER) {
          this.renditionForm
            .get('buyerTeamLeader')
            ?.setValue(FIND_TEAM_LEADER.agentName);
        }
        const PERCENTAGE_SUGGESTED =
          this.buyerTeamLeaderOrigin.optionSelected === 0 ? 0.5625 : 0.4375;
        if (this.commissionCheckout.buyer.agent.firstSubtotal.usd > 0) {
          const TOTAL_USD =
            this.commissionCheckout.buyer.agent.firstSubtotal.usd *
            PERCENTAGE_SUGGESTED;
          this.renditionForm.get('buyerTeamLeaderUSD')?.setValue(TOTAL_USD);
        }

        if (this.commissionCheckout.buyer.agent.firstSubtotal.local > 0) {
          const TOTAL_LOCAL =
            this.commissionCheckout.buyer.agent.firstSubtotal.local *
            PERCENTAGE_SUGGESTED;
          this.renditionForm.get('buyerTeamLeaderLocal')?.setValue(TOTAL_LOCAL);
        }

        this.performCalculation();
      }
    } else {
      this.snackbarService.openSnackBar(
        'El agente seleccionado no pertenece a un team',
        '',
      );
    }
  }

  openSellerManualDeduction($event: Event) {
    $event.preventDefault();
    this.showSellerManualDeduction = true;
  }

  deleteSellerManualDeduction($event: Event) {
    $event.preventDefault();
    this.showSellerManualDeduction = false;
    this.renditionForm.get('sellerManualDeductionPercentage')?.setValue(0);
    this.renditionForm.get('sellerManualDeductionUSD')?.setValue(0);
    this.renditionForm.get('sellerManualDeductionLocal')?.setValue(0);
    this.renditionForm.get('sellerManualDeductionName')?.setValue('');

    this.performCalculation();
  }

  openBuyerManualDeduction() {
    this.showBuyerManualDeduction = true;
  }

  deleteBuyerManualDeduction($event: Event) {
    $event.preventDefault();
    this.showBuyerManualDeduction = false;
    this.renditionForm.get('buyerManualDeductionPercentage')?.setValue(0);
    this.renditionForm.get('buyerManualDeductionUSD')?.setValue(0);
    this.renditionForm.get('buyerManualDeductionLocal')?.setValue(0);
    this.renditionForm.get('buyerManualDeductionName')?.setValue('');

    this.performCalculation();
  }

  changeRenditionNotes($event: any) {
    const input = $event.target.value.toString().trim();
    this.renditionForm.get('renditionNotes')?.setValue(input);
  }

  // Abrir dialogo agregar facturas
  openDialogAddInvoices($event: Event): void {
    $event.preventDefault();
    this.openInvoices();
  }

  openInvoices() {
    const jurisdiction = this.jurisdictions.find(
      (e) => e.name == this.renditionForm.value.jurisdiction,
    );

    if (
      jurisdiction &&
      (this.renditionForm.value.closePriceUSD > 0 ||
        this.renditionForm.value.closePriceLocal > 0) &&
      (this.renditionForm.value.sellerAgent ||
        this.renditionForm.value.buyerAgent)
    ) {
      this.dialogAddInvoice = {
        ...this.dialogAddInvoice,
        isVisible: true,
        value: {
          checkout: this.commissionCheckout,
          exchangeRate: this.renditionForm.value.exchangeRate,
          sharedWith: this.renditionForm.value.sharedWith,
          previsional: jurisdiction.previsionalCash,
          invoices: this.invoices,
        },
      };
    } else {
      this.snackbarService.openSnackBar(
        'Debe seleccionar una jurisdicción, precio de cierre y completar alguna de las puntas primero',
        '',
      );
    }
  }

  validationsForm(): boolean {
    let result = true;

    if (this.NODE === this.NODE_DO) {
      const ONLY_USD =
        (this.renditionForm.value.sellerUSD > 0 ||
          this.renditionForm.value.buyerUSD > 0) &&
        this.renditionForm.value.sellerLocal === 0 &&
        this.renditionForm.value.buyerLocal === 0;
      const KEY = ONLY_USD ? 'sellerCobrokerLocal' : 'sellerCobrokerUSD';

      const DOUBLE_CURRENCY =
        (this.renditionForm.value.sellerLocal > 0 ||
          this.renditionForm.value.buyerLocal > 0) &&
        (this.renditionForm.value.sellerUSD > 0 ||
          this.renditionForm.value.buyerUSD > 0);
      // Aplicar el modo de moneda
      if (!DOUBLE_CURRENCY) {
        this.sellerCobrokers.controls.forEach((ctrl) => {
          this.applyCurrencyMode(ctrl as FormGroup, KEY);
        });
      }
    }

    if (
      this.operationToggle.optionSelected != 0 &&
      (this.renditionForm.value.rentInput === 0 ||
        !this.renditionForm.value.rentInput)
    ) {
      this.renditionForm.get('rentInput')?.setErrors({ invalid: true });
      this.snackbarService.openSnackBar(
        'El período de alquiler no puede ser 0',
        '',
      );
      return false;
    } else {
      this.renditionForm.get('rentInput')?.clearValidators();
      this.renditionForm.get('rentInput')?.updateValueAndValidity();
    }

    // Validacion para bancos y garantias
    if (this.renditionForm.value.credit && !this.renditionForm.value.bank) {
      const MESSAGE =
        this.operationToggle.optionSelected == 0
          ? 'La selección de un banco es obligatoria para ventas con crédito.'
          : 'La selección de una garantía es obligatoria para alquileres con garantía.';
      this.snackbarService.openSnackBar(MESSAGE, '');
      this.renditionForm.get('bank')?.setErrors({ invalid: true });
      return false;
    }

    // Validacion para evitar que pasen a movimientos con precio de cierre 0 en ambas monedas
    if (
      (this.renditionForm.value.closePriceLocal == 0 ||
        !this.renditionForm.value.closePriceLocal) &&
      (this.renditionForm.value.closePriceUSD == 0 ||
        !this.renditionForm.value.closePriceUSD)
    ) {
      this.snackbarService.openSnackBar(
        'El PRECIO DE CIERRE no puede ser 0',
        '',
      );
      return false;
    }

    // Validacion MLSID cuando la punta vendedora es de otra inmobiliaria
    if (
      this.isPendingReportIngresoRelacionado ||
      this.isPendingReport ||
      this.renditionForm.value.sellerSharedWith == 'Otro' ||
      (this.renditionForm.value.sellerSharedWith == 'RE/MAX' &&
        this.renditionForm.value.sellerOffice != this.user?.agency_name &&
        ((this.NODE !== Constants.TENANT_ID_GLOBAL &&
          !this.renditionForm.value.mlsidFirst &&
          !this.renditionForm.value.mlsidLast) ||
          (!this.renditionForm.value.mlsidGlobal &&
            this.NODE === Constants.TENANT_ID_GLOBAL)))
    ) {
      this.renditionForm.get('mlsidFirst')?.clearValidators();
      this.renditionForm.get('mlsidLast')?.clearValidators();
      this.renditionForm.get('mlsidGlobal')?.clearValidators();
      this.renditionForm.get('mlsidGlobal')?.updateValueAndValidity();
      this.renditionForm.get('mlsidFirst')?.updateValueAndValidity();
      this.renditionForm.get('mlsidLast')?.updateValueAndValidity();
    }

    // Validacion para sacar el error del dropdown de "Otra inmobiliaria"
    if (this.sharedWithToggle.optionSelected != 2) {
      this.renditionForm.get('sharedWithAnotherRealEstate')?.clearValidators();
    }

    // Validacion OTRA INMOBILIARIA
    if (
      this.sharedWithToggle.optionSelected == 2 &&
      !this.renditionForm.value.sharedWithAnotherRealEstate
    ) {
      this.renditionForm
        .get('sharedWithAnotherRealEstate')
        ?.setErrors({ invalid: true });
    }

    // Validacion OFICINA
    if (
      this.isSharedWithOfficeVisible() &&
      !this.renditionForm.value.sharedWithOffice?.trim()
    ) {
      const OFFICE_CONTROL = this.renditionForm.get('sharedWithOffice');
      OFFICE_CONTROL?.setErrors({ invalid: true });
      OFFICE_CONTROL?.markAsTouched();
    }

    // Validacion MONTOS NEGATIVOS
    if (!this.netCommissionsAreValid) {
      this.snackbarService.openSnackBar(
        'No puede avanzar con MONTOS NEGATIVOS',
        '',
      );
      return false;
      // Validacion TOPES EXCEDIDOS
    } else if (!this.invoicesCapsAreValid) {
      this.snackbarService.openSnackBar(
        'No puede avanzar con TOPES EXCEDIDOS EN FACTURAS',
        '',
      );
      return false;
    }

    if (
      this.isReferidoACobrar &&
      this.renditionForm.value.sharedWith == 'RE/MAX' &&
      !this.renditionForm.value.sharedWithOffice?.trim()
    ) {
      this.snackbarService.openSnackBar('Debes seleccionar una oficina', '');
      return false;
    }
    if (
      this.isReferidoACobrar &&
      this.renditionForm.value.sharedWith == 'Otra inmobiliaria' &&
      !this.renditionForm.value.sharedWithAnotherRealEstate
    ) {
      this.renditionForm
        .get('sharedWithAnotherRealEstate')
        ?.setErrors({ invalid: true });
    }

    if (
      this.renditionForm.value.sharedWith == 'Otra inmobiliaria' &&
      this.renditionForm.value.sharedWithAnotherRealEstate == 'Nueva' &&
      !this.renditionForm.value.anotherRealEstateInput &&
      this.isReferidoACobrar
    ) {
      this.renditionForm
        .get('anotherRealEstateInput')
        ?.setErrors({ invalid: true });
    }

    // Cuando es otra inmobiliaria, remover el validador de la oficina que no es mi punta ( el campo sellerOffice o buyerOffice, ya que no aplican)
    if (this.renditionForm.value.sharedWith == 'Otra inmobiliaria') {
      this.renditionForm.value.sellerSharedWith == 'Mi oficina'
        ? this.renditionForm.removeControl('buyerOffice')
        : this.renditionForm.removeControl('sellerOffice');
    }

    // Cuando es otra inmobiliaria, remover el validador de la oficina que no es mi punta ( el campo sellerOffice o buyerOffice, ya que no aplican)
    if (this.renditionForm.value.sharedWith == 'Otra inmobiliaria') {
      this.renditionForm.value.sellerSharedWith == 'Mi oficina'
        ? this.renditionForm.removeControl('buyerOffice')
        : this.renditionForm.removeControl('sellerOffice');
    }

    if (
      !this.isReferidoACobrar &&
      this.sharedWithToggle.optionSelected == 1 &&
      this.renditionForm.value.sellerOffice !=
        this.renditionForm.value.sharedWithOffice &&
      this.renditionForm.value.buyerOffice !=
        this.renditionForm.value.sharedWithOffice
    ) {
      this.snackbarService.openSnackBar(
        'Las oficinas elegidas en las puntas y en el tipo de operación no coinciden',
        '',
      );
      return false;
    }

    if (!this.voucherTypeValid) {
      this.snackbarService.openSnackBar(
        'Existen facturas sin tipo de comprobante. Edítelas para poder continuar.',
        '',
      );
      return false;
    }

    if (this.hasInvalidTeamLeaderForRenditionDate()) {
      this.showTeamLeaderJoinDateSnackbar();
      return false;
    }

    return result;
  }

  logMonitor(data: RenditionModel) {
    let dataMonitor: QrMonitorModel = this.qrMonitorService.getInstance();
    dataMonitor.className = 'RENDITIONS_0_COMMISSION';
    dataMonitor.type = 'error';
    dataMonitor.functionName = 'CREATION';
    dataMonitor.url = 'renditions';
    // dataMonitor.errorCode = response.data.code;
    dataMonitor.message = 'Rendicion con comisiones en 0 para la oficina';
    dataMonitor.data = [data];

    this.utilService.auditMonitor(dataMonitor, environment.monitorKey);
  }

  private getRenditionType(): number {
    if (this.isCuota) return 6;
    if (this.isIngresoRelacionado) return 8;
    if (this.isReferidoACobrar) return 5;
    return 4;
  }

  hydrateStatisticsComputationMode(
    deductions?: TeamLeaderDeduction[] | null,
    cobrokerTeamLeaders?: CobrokerTeamLeader[] | null,
  ): void {
    if (this.NODE !== this.NODE_DO) {
      return;
    }

    const sellerDeduction = deductions?.find((e) => e.deductionType === 1);
    const buyerDeduction = deductions?.find((e) => e.deductionType === 2);
    // Si ninguna punta tiene Team Leader, el modo quedo guardado en el Team
    // Leader del co-broker, que se envia con el mismo flag
    const source =
      sellerDeduction ?? buyerDeduction ?? cobrokerTeamLeaders?.[0];
    if (!source) {
      return;
    }

    this.statisticsComputationToggle.optionSelected =
      source.checkTeamLeader === 0 ? 0 : 1;
    this.statisticsComputationToggle = { ...this.statisticsComputationToggle };
  }

  onChangeStatisticsComputation($event: number): void {
    this.statisticsComputationToggle.optionSelected = $event;
    this.statisticsComputationToggle = { ...this.statisticsComputationToggle };
    this.formatForCheckout();
  }

  submit(): void {
    if (this.isSubmitting) {
      return;
    }

    this.userTriedToSubmitForm = true;

    if (this.hasInvalidTeamLeaderForRenditionDate()) {
      this.showTeamLeaderJoinDateSnackbar();
      this.stopLoading.emit(true);
      return;
    }

    this.isSubmitting = true;
    const renditionBE = this.formatFormForRendition();

    const IS_GROSS_AGENCY_COMMISSION_WITHOUT_REFERRED_DEDUCTION_ZERO =
      renditionBE.grossAgencyComissionUSDWithoutReferredDeduction === 0 &&
      renditionBE.grossAgencyComissionARSWithoutReferredDeduction === 0;

    const IS_PUNTA_100 =
      (renditionBE.purchaseRelationshipPercentage === 100 &&
        renditionBE.saleRelationshipPercentage === 0) ||
      (renditionBE.purchaseRelationshipPercentage === 0 &&
        renditionBE.saleRelationshipPercentage === 100);

    if (
      IS_GROSS_AGENCY_COMMISSION_WITHOUT_REFERRED_DEDUCTION_ZERO &&
      IS_PUNTA_100
    ) {
      this.logMonitor(renditionBE);
    }

    if (renditionBE.quotaNumber) delete renditionBE.quotaNumber;
    // Borrar un borrador - reserva asociada a un borrador y genera uno nuevo
    if (this.needsToDeleteDraft) {
      const url = 'draft/delete';
      const dto = {
        id: this.needsToDeleteDraft,
        loggedUser: this.user?.username,
      };
      this.renditionsService
        .post(dto, url)
        .then((response: any) => {
          if (response?.body?.code == 200) {
            renditionBE.renditionType = 4;
            this.renditionsService
              .post(renditionBE, '')
              .then((response: any) => {
                this.removeUnloadListener();
                this.router.navigate([
                  'renditions/movements/' + response.body.data.renditionId,
                ]);
              })
              .catch((error: any) => this.handleSubmitError(error));
          } else {
            this.releaseSubmitLock();
          }
        })
        .catch((error: any) => this.handleSubmitError(error));
    } else {
      const isEdit = this.router.url.includes('edit');
      if (!isEdit) {
        renditionBE.renditionType = this.getRenditionType();
      }

      // Edicion de una rendicion
      const isRenditionNoDraft = [1, 2, 3, 7].some(
        (n) => n == renditionBE.renditionType,
      );
      if (isEdit && isRenditionNoDraft) {
        const renditionId = Number(this.activatedRoute.snapshot.params['id']);
        const dto = {
          oldRenditionId: renditionId,
          rendition: renditionBE,
        };
        this.renditionsService
          .put(dto, '')
          .then((response: any) => {
            if (response?.body?.data?.renditionId) {
              this.removeUnloadListener();
              this.router.navigate([
                'renditions/movements/' + response.body.data.renditionId,
              ]);
            } else {
              this.snackbarService.openSnackBar(
                'Se produjo un error, contacte a soporte.',
                '',
              );
              this.releaseSubmitLock();
            }
          })
          .catch((error: any) => this.handleSubmitError(error));
      } else if (isEdit) {
        const draftId = Number(this.activatedRoute.snapshot.params['id']);
        renditionBE.id = draftId;
        this.waitingService = true;
        this.msgLoading = 'Modificando borrador...';

        this.renditionsService
          .post(renditionBE, '')
          .then((response: any) => {
            this.waitingService = false;
            this.removeUnloadListener();
            if (response?.body.data?.renditionId) {
              if (this.isDraft) {
                this.releaseSubmitLock();
                this.dialogDraftCreated = {
                  ...this.dialogDraftCreated,
                  isVisible: true,
                  title: 'Borrador guardado',
                  value: 'Borrador editado correctamente',
                };
              } else {
                this.router.navigate([
                  'renditions/movements/' + response.body.data.renditionId,
                ]);
              }
            } else {
              this.releaseSubmitLock();
            }
          })
          .catch((error: any) => this.handleSubmitError(error));
      } else {
        //Creacion de un borrador o creacion de borrador + movimientos
        this.waitingService = true;
        this.msgLoading = this.isDraft
          ? 'Creando borrador...'
          : 'Generando movimientos...';

        this.renditionsService
          .post(renditionBE, '')
          .then((response: any) => {
            this.removeUnloadListener();
            this.waitingService = false;
            if (this.isDraft) {
              this.releaseSubmitLock();
              this.dialogDraftCreated = {
                ...this.dialogDraftCreated,
                isVisible: true,
                title: 'Borrador creado',
                value: 'Rendición guardada como borrador.',
              };
            } else {
              const PARAM_ORIGIN =
                this.NavigationOrigin === NavigationOriginTypes.GESTOR
                  ? { queryParams: { origin: this.NavigationOrigin } }
                  : undefined;

              this.router.navigate(
                ['renditions/movements/' + response.body.data.renditionId],
                PARAM_ORIGIN,
              );
            }
          })
          .catch((error: any) => this.handleSubmitError(error));
      }
    }
  }

  private handleSubmitError(error: any): void {
    let message = 'Se produjo un error, contacte a soporte.';
    if (error?.error?.errors?.[0]) {
      message = error.error.errors[0];
    }
    this.snackbarService.openSnackBar(message, '');
    this.releaseSubmitLock();
  }

  private releaseSubmitLock(): void {
    this.isSubmitting = false;
    this.waitingService = false;
    this.stopLoading.emit(true);
  }

  private resolveExclusivityType(value: unknown, fallback = 1): number {
    if (value === null || value === undefined || value === '') {
      return fallback;
    }

    const numericValue = Number(value);
    if (!Number.isNaN(numericValue)) {
      return numericValue;
    }

    const normalized = this.utilService.textNormalize(String(value));
    if (normalized === 'exclusiva' || normalized === 'exclusivo') {
      return 1;
    }
    if (normalized === 'no exclusiva' || normalized === 'no exclusivo') {
      return 2;
    }

    return fallback;
  }

  formatFormForRendition() {
    this.rendition ??= new RenditionModel();
    // Es una rendicion -> TYPE = 4 PARA BORRADOR
    this.rendition.renditionType = this.renditionFromBE?.renditionType ?? 0;
    // RenditionId = origen de la cuota
    // Si es add cuota se manda el id de la rendicion padre como renditionId. Si es un edit de cuota se deja el que estaba.
    let quotaOrigin = 0;
    if (this.isCuota) {
      if (this.router.url.includes('edit')) {
        quotaOrigin = this.renditionFromBE?.renditionId ?? 0;
      } else {
        quotaOrigin = Number(this.activatedRoute.snapshot.params['id']);
      }
      if (this.NODE === this.NODE_DO) {
        quotaOrigin =
          this.renditionFromBE?.id ??
          Number(this.activatedRoute.snapshot.params['renditionId']);
      }
    }

    this.rendition.renditionId = quotaOrigin;

    if (this.NODE !== this.NODE_DO) {
      delete this.rendition.royaltyAmount;
      delete this.rendition.royaltyPercentage;
    }

    // Reservation Id
    // Si viene de una reserva o es nueva
    if (this.renditionFromBE) {
      this.rendition.reservationId = this.renditionFromBE.reservationId
        ? this.renditionFromBE.reservationId
        : 0;
    } else {
      this.rendition.reservationId = this.reservation ? this.reservation.id : 0;
    }
    // Usuario logueado
    this.rendition.loggedUser = this.user ? this.user.username : '';
    // Agency id
    this.rendition.agencyId = this.user ? this.user.agency_id : 0;
    // Direccion
    this.rendition.propertyAddress = this.renditionForm.value.address;
    // Mlsid
    this.rendition.mlsId =
      this.NODE === this.NODE_GLOBAL || this.NODE === this.NODE_DO
        ? this.renditionForm.value.mlsidGlobal
        : this.renditionForm.value.mlsidFirst +
          '-' +
          this.renditionForm.value.mlsidLast;

    // Tipo de propiedad
    const PROP_TYPE = this.propertiesList.find(
      (e: { id: number; name: string }) =>
        this.utilService.textNormalize(e.name) ==
        this.utilService.textNormalize(this.renditionForm.value.propertyType),
    );
    this.rendition.propertyType = PROP_TYPE ? PROP_TYPE.id : null;
    // Fecha
    this.rendition.renditionDate =
      this.datePicker.date ?? this.renditionForm.value.date;
    // Tipo de operacion
    this.rendition.operationType =
      this.dataForForm[this.renditionForm.value.operationType];

    // Si no es venta, deberia existir periodos
    if (this.rendition.operationType != 2) {
      this.rendition.amountByRental = true;
      // 1 => DIAS / 2 => MESES
      this.rendition.contractTimeType = this.periodoToggle.optionSelected + 1;
      // Input periodo alquiler
      this.rendition.contractTime = this.renditionForm.value.rentInput;
    }
    // Credito
    this.rendition.credit = this.renditionForm.value.credit;
    // Bancos y garantias
    const FIND_BANK = this.banks.find(
      (e: Banks) => e.entidad == this.renditionForm.value.bank,
    );
    this.rendition.bank = FIND_BANK ? FIND_BANK.id : null;
    // Jurisdiccion
    const jurisdiction = this.jurisdictions.find(
      (e: { id: number; name: string }) =>
        e.name == this.renditionForm.value.jurisdiction,
    );
    this.rendition.jurisdictionId = jurisdiction ? jurisdiction.id : null;
    // Compartida con
    this.rendition.sharedBy = 3;
    if (this.renditionForm.value.sharedWith == 'Dos puntas') {
      this.rendition.sharedBy = 1;
      this.rendition.sharedAgencyName = null;
      this.rendition.agencyName = this.user?.agency_name ?? '';
    } else if (this.renditionForm.value.sharedWith == 'RE/MAX') {
      this.rendition.sharedBy = 2;
      if (this.renditionForm.value.sellerOffice == this.user?.agency_name) {
        this.rendition.sharedAgencyName = this.renditionForm.value.buyerOffice;
        const OFFICE = this.officesList.find(
          (e) => this.renditionForm.value.buyerOffice == e.name,
        );
        if (OFFICE) this.rendition.sharedAgencyId = OFFICE.id;
      } else if (
        this.renditionForm.value.buyerOffice == this.user?.agency_name
      ) {
        this.rendition.sharedAgencyName = this.renditionForm.value.sellerOffice;
        const OFFICE = this.officesList.find(
          (e) => this.renditionForm.value.sellerOffice == e.name,
        );
        if (OFFICE) this.rendition.sharedAgencyId = OFFICE.id;
      }
    } else if (this.renditionFromBE && this.isCuota) {
      this.rendition.otherRealEstate = this.renditionFromBE.otherRealEstate;
    } else {
      const OTHER_ESTATE = this.otherRealEstateList.find(
        (e) => e.name == this.renditionForm.value.sharedWithAnotherRealEstate,
      );
      if (OTHER_ESTATE) {
        const item = {
          id: OTHER_ESTATE.id,
          name: OTHER_ESTATE.name,
          visible: OTHER_ESTATE.visible,
        };
        this.rendition.otherRealEstate = OTHER_ESTATE.id != 0 ? item : null;
      }
    }

    // Tipo de cambio
    this.rendition.exchangeRate = this.renditionForm.value.exchangeRate;
    // Comision bruta dolares
    this.rendition.totalAmountOperationUSD =
      this.renditionForm.value.closePriceUSD;
    // Comision bruta local
    this.rendition.totalAmountOperationARS =
      this.renditionForm.value.closePriceLocal;

    // Relacion punta vendedora
    this.rendition.purchaseRelationshipPercentage = this.sellerRelation;

    // Exclusiva
    // 1 exclusiva, 2 no exclusiva, 3 no captado busqueda
    this.rendition.exclusivityType = this.resolveExclusivityType(
      this.renditionForm.value.exclusiveId,
    );

    ////////////////////////////////////////////////////////////////////
    //////////////////// REFERIDO A COBRAR /////////////////////////////
    ////////////////////////////////////////////////////////////////////

    if (this.isReferidoACobrar) {
      delete this.rendition.cobrokersCommissions;
      delete this.rendition.cobrokerTeamLeaders;

      this.sellerRelation = 100;
      this.rendition.purchaseRelationshipPercentage = 100;
      this.rendition.saleRelationshipPercentage = 0;

      const AGENT = this.fullAgentList.find(
        (e) => this.renditionForm.value.referredName == e.agentName,
      );

      this.rendition.organizationCommission.saleOrganizationName =
        this.originReferredToggle.optionSelected == 1
          ? (AGENT?.agentName ?? 'Referido a cobrar')
          : 'Referido a cobrar';
      this.rendition.organizationCommission.saleOrganizationId =
        this.originReferredToggle.optionSelected == 1 ? (AGENT?.id ?? 0) : null;
      this.rendition.organizationCommission.saleAmountARS =
        this.originReferredToggle.optionSelected == 1
          ? this.renditionForm.value.closePriceLocal
          : null;
      this.rendition.organizationCommission.saleAmountUSD =
        this.originReferredToggle.optionSelected == 1
          ? this.renditionForm.value.closePriceUSD
          : null;

      this.rendition.saleRelationshipPercentage =
        this.originReferredToggle.optionSelected == 1 ? 100 : 0;

      this.rendition.organizationCommission.purchaseOrganizationType =
        this.originReferredToggle.optionSelected == 1 ? 0 : 2;
      this.rendition.organizationCommission.saleOrganizationType =
        this.originReferredToggle.optionSelected == 1 ? 2 : 0;

      this.rendition.organizationCommission.purchaseOrganizationName =
        this.originReferredToggle.optionSelected == 0
          ? (AGENT?.agentName ?? 'Referido a cobrar')
          : 'Referido a cobrar';
      this.rendition.organizationCommission.purchaseOrganizationId =
        this.originReferredToggle.optionSelected == 0 ? (AGENT?.id ?? 0) : null;
      this.rendition.organizationCommission.purchaseAmountARS =
        this.originReferredToggle.optionSelected == 0
          ? this.renditionForm.value.closePriceLocal
          : null;
      this.rendition.organizationCommission.purchaseAmountUSD =
        this.originReferredToggle.optionSelected == 0
          ? this.renditionForm.value.closePriceUSD
          : null;

      this.rendition.purchaseRelationshipPercentage =
        this.originReferredToggle.optionSelected == 0 ? 100 : 0;

      const OFFICE = this.officesList.find(
        (e: { name: string; id: number }) =>
          e.name == this.renditionForm.value.sharedWithOffice,
      );

      this.rendition.organizationCommission.purchaseCommissionPercentage =
        this.originReferredToggle.optionSelected == 0 ? 100 : 0;
      this.rendition.organizationCommission.saleCommissionPercentage =
        this.originReferredToggle.optionSelected == 1 ? 100 : 0;

      this.rendition.sharedBy =
        this.sharedWithToggle.optionSelected == 1 ? 3 : 2;
      this.rendition.sharedAgencyName = OFFICE?.name ?? '';
      this.rendition.sharedAgencyId = OFFICE?.id ?? null;

      if (this.renditionForm.value.sharedWith == 'Otra inmobiliaria') {
        const OTHER_ESTATE = this.otherRealEstateList.find(
          (e) => e.name == this.renditionForm.value.sharedWithAnotherRealEstate,
        );
        if (OTHER_ESTATE) {
          const item = {
            id: OTHER_ESTATE.id,
            name: OTHER_ESTATE.name,
            visible: OTHER_ESTATE.visible,
          };
          this.rendition.otherRealEstate = OTHER_ESTATE.id != 0 ? item : null;
        } else {
          this.rendition.sharedAgencyName =
            this.renditionForm.value.sharedWithAnotherRealEstate;
        }
      }

      // Deducciones por jurisdiccion
      this.rendition.saleDeduction.deductionPercentage =
        this.renditionForm.value.buyerAgentDeductionPercentage ?? 0;

      this.rendition.saleDeduction.deductionAmountUSD =
        this.renditionForm.value.buyerAgentDeductionUSD ?? 0;
      this.rendition.saleDeduction.deductionAmountARS =
        this.renditionForm.value.buyerAgentDeductionLocal ?? 0;

      this.rendition.purchaseDeduction.deductionPercentage =
        this.renditionForm.value.sellerAgentDeductionPercentage ?? 0;
      this.rendition.purchaseDeduction.deductionAmountUSD =
        this.renditionForm.value.sellerAgentDeductionUSD ?? 0;
      this.rendition.purchaseDeduction.deductionAmountARS =
        this.renditionForm.value.sellerAgentDeductionLocal ?? 0;

      const referredClient = this.clientOirgin.find(
        (e: { id: number; label: string }) =>
          e.label == this.renditionForm.value.referredClient,
      );

      if (referredClient) {
        this.rendition.clientContact.purchaseCustomerOriginId =
          this.originReferredToggle.optionSelected == 0
            ? referredClient.id
            : null;
        this.rendition.clientContact.saleCustomerOriginId =
          this.originReferredToggle.optionSelected == 1
            ? referredClient.id
            : null;
      }

      // Campos varios para el objeto de BE
      this.rendition.grossAgencyComissionPercentage = 100;
      this.rendition.grossAgencyComissionPercentageWithoutReferredDeduction = 100;
      this.rendition.grossAgencyComissionUSDWithoutReferredDeduction =
        this.commissionCheckout.office.netCommission.usd;
      this.rendition.grossAgencyComissionARSWithoutReferredDeduction =
        this.commissionCheckout.office.netCommission.local;
      this.rendition.grossComissionPercentage = 100;
      this.rendition.grossComissionUSD =
        this.commissionCheckout.closedPrice.usd;
      this.rendition.grossComissionARS =
        this.commissionCheckout.closedPrice.local;

      this.rendition.purchaseOrganizationAmountCommissionUSD =
        this.originReferredToggle.optionSelected == 1
          ? 0
          : this.commissionCheckout.referred.netCommission.usd;
      this.rendition.purchaseOrganizationAmountCommissionARS =
        this.originReferredToggle.optionSelected == 1
          ? 0
          : this.commissionCheckout.referred.netCommission.local;

      this.rendition.saleOrganizationAmountCommissionUSD =
        this.originReferredToggle.optionSelected == 1
          ? this.commissionCheckout.referred.netCommission.usd
          : 0;
      this.rendition.saleOrganizationAmountCommissionARS =
        this.originReferredToggle.optionSelected == 1
          ? this.commissionCheckout.referred.netCommission.local
          : 0;
    } else {
      // Relacion punta compradora
      this.rendition.saleRelationshipPercentage =
        100 - this.rendition.purchaseRelationshipPercentage;

      // Es 50 y 50 ?? Dios que booleano al re pedo
      this.rendition.relationFiftyFifty =
        this.rendition.saleRelationshipPercentage ==
        this.rendition.purchaseRelationshipPercentage;

      ///////////////////////////////////////////////////////////////////////////////////
      ////////////////////////////// Punta vendedora ////////////////////////////////////
      ///////////////////////////////////////////////////////////////////////////////////

      // Porcentaje Punta vendedora
      this.rendition.organizationCommission.purchaseCommissionPercentage =
        this.renditionForm.value.sellerPercentage;
      // USD Punta vendedora
      this.rendition.organizationCommission.purchaseAmountUSD =
        this.renditionForm.value.sellerUSD;
      // Local Punta vendedora
      this.rendition.organizationCommission.purchaseAmountARS =
        this.renditionForm.value.sellerLocal;

      if (this.sellerSharedWith.optionSelected == 2) {
        this.rendition.sharedAgencyName =
          this.renditionForm.value.sharedWithAnotherRealEstate;
        this.rendition.clientContact.saleOrganizationName =
          this.renditionForm.value.sellerAgent;
      }

      // Id agente vendedor
      const purchaseAgent = this.fullAgentList.find(
        (e: Agent) => e.agentName == this.renditionForm.value.sellerAgent,
      );

      this.rendition.organizationCommission.purchaseOrganizationName =
        this.renditionForm.value.sellerAgent ?? null;

      if (
        this.renditionForm.value.sellerSharedWith == 'Mi oficina' ||
        this.renditionForm.value.sellerOffice == this.user?.agency_name
      ) {
        this.rendition.organizationCommission.purchaseOrganizationId =
          purchaseAgent ? purchaseAgent.id : null;
      } else if (
        this.renditionForm.value.sellerSharedWith == 'RE/MAX' &&
        this.renditionForm.value.sellerOffice != this.user?.agency_name
      ) {
        if (this.NODE === this.NODE_GLOBAL) {
          this.rendition.organizationCommission.purchaseOrganizationId = -2;
          this.rendition.organizationCommission.purchaseOrganizationName =
            this.renditionForm.value.sellerAgent;
        } else {
          this.rendition.organizationCommission.purchaseOrganizationIdOtherRemax =
            purchaseAgent?.id ?? null;
          this.rendition.organizationCommission.purchaseOrganizationNameOtherRemax =
            purchaseAgent?.agentName ?? null;
        }
      }

      // Nombre agente vendedor
      this.rendition.purchaseOrganizationName =
        this.renditionForm.value.sellerAgent;
      this.rendition.organizationCommission.purchaseOrganizationName =
        this.renditionForm.value.sellerAgent;
      // Repite el id del agente vendedor para el objeto de cliente
      this.rendition.clientContact.purchaseOrganizationId =
        this.rendition.organizationCommission.purchaseOrganizationId;
      // Id origen cliente vendedor
      const purchaseClient = this.clientOirgin.find(
        (e: { id: number; label: string }) =>
          e.label == this.renditionForm.value.sellerClient,
      );
      // Lamentablemente y por alguna razon estupida o por error, para el clientOrigin sale es vendedor y purchase comprador
      this.rendition.clientContact.saleCustomerOriginId = purchaseClient
        ? purchaseClient.id
        : null;
      this.rendition.clientContact.purchaseClientName = null;

      this.rendition.organizationCommission.purchaseOrganizationType =
        this.renditionForm.value.sellerSharedWith == 'Mi oficina' ||
        this.renditionForm.value.sellerOffice == this.user?.agency_name
          ? 2
          : 4;

      // Limpio referidos
      this.rendition.referredCommissions = [];
      this.rendition.referredDeductions = [];
      // Referido vendedor

      if (this.renditionForm.value.sellerReferredName) {
        const itemReferred = {} as ReferredRendition;
        // Agente

        const array = [...this.sellerReferredAgentList, ...this.fullAgentList];

        const purchaseReferred = array.find(
          (e: Agent) =>
            e.agentName == this.renditionForm.value.sellerReferredName,
        );

        if (
          this.NODE_GLOBAL === this.NODE &&
          this.renditionForm.value.sellerReferredName
        ) {
          itemReferred.organizationName =
            this.renditionForm.value.sellerReferredName;
        }

        itemReferred.organizationId = purchaseReferred
          ? purchaseReferred.id
          : 0;
        itemReferred.typePayment = 1;
        itemReferred.agencyId = 0;
        itemReferred.organizationName =
          this.renditionForm.value.sellerReferredName;
        // Oficina
        if (this.renditionForm.value.sellerReferredOffice) {
          const purchaseOfficeReferred = this.officesList.find(
            (e: { id: number; name: string }) =>
              e.name == this.renditionForm.value.sellerReferredOffice,
          );
          if (
            purchaseOfficeReferred &&
            this.renditionForm.value.sellerReferredSharedWith == 'RE/MAX'
          ) {
            itemReferred.organizationIdOtherRemax = purchaseReferred
              ? purchaseReferred.id
              : 0;
            itemReferred.agencyId = purchaseOfficeReferred.id;
            itemReferred.organizationId = 0;
          }
          if (this.renditionForm.value.sellerReferredSharedWith == 'Otro') {
            itemReferred.organizationNameOtherRemax = purchaseOfficeReferred
              ? purchaseOfficeReferred.name
              : '';
          }
        }

        switch (this.sellerReferredSharedWith.optionSelected) {
          case 1:
            itemReferred.organizationType = 5;
            break;
          case 2:
            itemReferred.organizationType = 4;
            break;
          default:
            itemReferred.organizationType = 2;
            break;
        }
        itemReferred.deductionPercentage =
          this.renditionForm.value.sellerReferredPercentage;
        itemReferred.deductionAmountUSD =
          this.renditionForm.value.sellerReferredUSD;
        itemReferred.deductionAmountARS =
          this.renditionForm.value.sellerReferredLocal;

        this.rendition.referredDeductions[0] = itemReferred;

        const referredCommision = {} as ReferredCommission;
        referredCommision.commissionUSD =
          this.commissionCheckout.seller.referred.netCommission.usd;
        referredCommision.commissionARS =
          this.commissionCheckout.seller.referred.netCommission.local;
        referredCommision.organizationId = itemReferred.organizationId ?? 0;
        referredCommision.type = 1;
        this.rendition.referredCommissions[0] = referredCommision;
      }

      this.rendition.cobrokersCommissions = [];
      this.rendition.cobrokerTeamLeaders = [];

      if (this.NODE === this.NODE_DO) {
        if (this.commissionCheckout.cobrokers.length > 0) {
          for (const coBroker of this.commissionCheckout.cobrokers) {
            const OBJECT_COBROKER = new CobrokerCommission();
            OBJECT_COBROKER.organizationType = 4;
            OBJECT_COBROKER.organizationName = coBroker.name ?? '';
            OBJECT_COBROKER.organizationId = 0;
            OBJECT_COBROKER.grossAmountUsd = coBroker.rawCommission.usd ?? 0;
            OBJECT_COBROKER.netAmountUsd = coBroker.netCommission.usd ?? 0;
            OBJECT_COBROKER.grossAmountArs = coBroker.rawCommission.local ?? 0;
            OBJECT_COBROKER.netAmountArs = coBroker.netCommission.local ?? 0;
            OBJECT_COBROKER.type = 2;

            if (
              coBroker.office &&
              coBroker.officeId &&
              coBroker.office !== this.user?.agency_name
            ) {
              OBJECT_COBROKER.organizationType = 5;
              OBJECT_COBROKER.organizationIdOtherRemax = Number(
                coBroker.id ?? 0,
              );
              OBJECT_COBROKER.organizationNameOtherRemax =
                coBroker.office ?? '';
              OBJECT_COBROKER.agencyId = Number(coBroker.officeId ?? 0);
            } else if (coBroker.office === this.user?.agency_name) {
              OBJECT_COBROKER.organizationType = 2;
              OBJECT_COBROKER.organizationId = coBroker.id;
              OBJECT_COBROKER.agentType = coBroker.type.name ?? '';
              OBJECT_COBROKER.agentLevelType =
                AgentTypesArray.agentTypesArray[coBroker.type.original] ?? '';
              OBJECT_COBROKER.agencyId = this.user?.agency_id ?? 0;
            }

            this.rendition.cobrokersCommissions?.push(OBJECT_COBROKER);

            if (coBroker.teamLeader.name) {
              const OBJECT_COBROKER_TEAM_LEADER = new CobrokerTeamLeader();
              OBJECT_COBROKER_TEAM_LEADER.renditionId =
                this.renditionFromBE?.renditionId ?? 0;

              const FIND_TEAM_LEADER = this.fullAgentList.find(
                (e: Agent) => e.agentName === coBroker.teamLeader.name,
              );

              OBJECT_COBROKER_TEAM_LEADER.checkTeamLeader =
                this.statisticsCheckTeamLeader;
              OBJECT_COBROKER_TEAM_LEADER.juniorOrganizationId =
                OBJECT_COBROKER.organizationId ?? 0;
              OBJECT_COBROKER_TEAM_LEADER.deductionType = 1;
              OBJECT_COBROKER_TEAM_LEADER.organizationName =
                coBroker.teamLeader.name;
              OBJECT_COBROKER_TEAM_LEADER.organizationId =
                FIND_TEAM_LEADER?.id ?? 0;
              OBJECT_COBROKER_TEAM_LEADER.teamId =
                FIND_TEAM_LEADER?.teamId ?? 0;
              OBJECT_COBROKER_TEAM_LEADER.grossDeductionAmountArs =
                coBroker.teamLeader.rawCommission.local ?? 0;
              OBJECT_COBROKER_TEAM_LEADER.grossDeductionAmountUsd =
                coBroker.teamLeader.rawCommission.usd ?? 0;
              OBJECT_COBROKER_TEAM_LEADER.netDeductionAmountArs =
                coBroker.teamLeader.netCommission.local ?? 0;
              OBJECT_COBROKER_TEAM_LEADER.netDeductionAmountUsd =
                coBroker.teamLeader.netCommission.usd ?? 0;

              this.rendition.cobrokerTeamLeaders?.push(
                OBJECT_COBROKER_TEAM_LEADER,
              );
            }
          }
        }
      } else {
        delete this.rendition.cobrokersCommissions;
        delete this.rendition.cobrokerTeamLeaders;
      }
      // Deduccion Agente Vendedor
      if (this.renditionForm.value.sellerOffice == this.user?.agency_name) {
        this.rendition.purchaseDeduction.deductionPercentage =
          this.renditionForm.value.sellerAgentDeductionPercentage ?? 0;
        this.rendition.purchaseDeduction.deductionAmountUSD =
          this.renditionForm.value.sellerAgentDeductionUSD ?? 0;
        this.rendition.purchaseDeduction.deductionAmountARS =
          this.renditionForm.value.sellerAgentDeductionLocal ?? 0;
      }

      // Team Leader Vendedor
      this.rendition.teamLeaderDeductions = [];
      this.rendition.teamLeaderCommissions = [];

      const FIND_TEAM_LEADER = this.fullAgentList.find(
        (e) => e.agentName === this.renditionForm.value.sellerTeamLeader,
      );

      const HAS_VALUE =
        this.renditionForm.value.sellerTeamLeaderUSD > 0 ||
        (this.renditionForm.value.sellerTeamLeaderLocal > 0 &&
          (this.renditionForm.value.sellerLocal > 0 ||
            this.renditionForm.value.sellerUSD > 0));

      if (
        FIND_TEAM_LEADER &&
        this.renditionForm.value.sellerTeamLeader !==
          this.renditionForm.value.sellerAgent &&
        HAS_VALUE
      ) {
        // Origen de la captacion -> 1 leader, 0 member
        const SELLER_TEAM_LEADER_DEDUCTION: TeamLeaderDeduction = {
          checkTeamLeader:
            this.NODE === this.NODE_DO
              ? this.statisticsCheckTeamLeader
              : this.renditionForm.value.sellerTeamLeaderOrigin ===
                  this.sellerTeamLeaderOrigin.viewValues[0]
                ? 1
                : 0,
          renditionId: this.renditionFromBE
            ? this.renditionFromBE.renditionId
            : 0,
          deductionType: 1, // Vendedor
          organizationName: FIND_TEAM_LEADER.agentName,
          organizationId: FIND_TEAM_LEADER.id,
          teamId: FIND_TEAM_LEADER.teamId ?? 0,
          deductionPercentage: 0,
          deductionAmountArs: this.renditionForm.value.sellerTeamLeaderLocal,
          deductionAmountUsd: this.renditionForm.value.sellerTeamLeaderUSD,
        };
        this.rendition.teamLeaderDeductions.push(SELLER_TEAM_LEADER_DEDUCTION);

        const SELLER_TEAM_LEADER_COMMISSION: TeamLeaderCommission = {
          type: 1, // Vendedor
          organizationId: FIND_TEAM_LEADER.id,
          organizationName: FIND_TEAM_LEADER.agentName,
          commissionARS:
            this.commissionCheckout.seller.teamLeader.netCommission.local,
          commissionUSD:
            this.commissionCheckout.seller.teamLeader.netCommission.usd,
        };

        this.rendition.teamLeaderCommissions.push(
          SELLER_TEAM_LEADER_COMMISSION,
        );
      }

      ///////////////////////////////////////////////////////////////////////////////////
      ////////////////////////////// Punta compradora ///////////////////////////////////
      ///////////////////////////////////////////////////////////////////////////////////

      // Porcentaje Punta compradora
      this.rendition.organizationCommission.saleCommissionPercentage =
        this.renditionForm.value.buyerPercentage;
      // USD Punta compradora
      this.rendition.organizationCommission.saleAmountUSD =
        this.renditionForm.value.buyerUSD;
      // Local Punta compradora
      this.rendition.organizationCommission.saleAmountARS =
        this.renditionForm.value.buyerLocal;

      if (this.buyerSharedWith.optionSelected == 2) {
        this.rendition.sharedAgencyName =
          this.renditionForm.value.sharedWithAnotherRealEstate;
        this.rendition.clientContact.saleOrganizationName =
          this.renditionForm.value.buyerAgent;
      }

      // Id agente comprador
      const saleAgent = this.fullAgentList.find(
        (e: Agent) => e.agentName == this.renditionForm.value.buyerAgent,
      );

      this.rendition.organizationCommission.saleOrganizationName =
        this.renditionForm.value.buyerAgent ?? null;

      if (
        this.renditionForm.value.buyerSharedWith == 'Mi oficina' ||
        this.renditionForm.value.buyerOffice == this.user?.agency_name
      ) {
        this.rendition.organizationCommission.saleOrganizationId = saleAgent
          ? saleAgent.id
          : null;
        this.rendition.organizationCommission.saleOrganizationName =
          this.renditionForm.value.buyerAgent;
        this.rendition.saleOrganizationName =
          this.renditionForm.value.buyerAgent;
      } else if (
        this.renditionForm.value.buyerSharedWith == 'RE/MAX' &&
        this.renditionForm.value.buyerOffice != this.user?.agency_name
      ) {
        if (this.NODE === this.NODE_GLOBAL) {
          this.rendition.organizationCommission.saleOrganizationId = -2;
          this.rendition.organizationCommission.saleOrganizationName =
            this.renditionForm.value.buyerAgent;
        } else {
          this.rendition.organizationCommission.saleOrganizationIdOtherRemax =
            saleAgent?.id ?? null;
          this.rendition.organizationCommission.saleOrganizationNameOtherRemax =
            saleAgent?.agentName ?? null;
        }
      }
      // Nombre agente comprador

      // Repite el id del agente comprador para el objeto de cliente
      this.rendition.clientContact.saleOrganizationId =
        this.rendition.organizationCommission.saleOrganizationId;
      // Id origen cliente comprador
      const saleClient = this.clientOirgin.find(
        (e: { id: number; label: string }) =>
          e.label == this.renditionForm.value.buyerClient,
      );
      // Lamentablemente y por alguna razon estupida o por error, para el clientOrigin sale es vendedor y purchase comprador

      this.rendition.clientContact.purchaseCustomerOriginId = saleClient
        ? saleClient.id
        : null;

      this.rendition.organizationCommission.saleOrganizationType =
        this.renditionForm.value.buyerSharedWith == 'Mi oficina' ||
        this.renditionForm.value.buyerOffice == this.user?.agency_name
          ? 2
          : 4;

      // Referido comprador
      if (this.renditionForm.value.buyerReferredName) {
        const itemReferred = {} as ReferredRendition;
        // Agente

        const array = [...this.buyerReferredAgentList, ...this.fullAgentList];

        const saleReferred = array.find(
          (e: Agent) =>
            e.agentName == this.renditionForm.value.buyerReferredName,
        );

        itemReferred.organizationId = saleReferred ? saleReferred.id : 0;
        itemReferred.typePayment = 2;
        itemReferred.agencyId = 0;
        itemReferred.organizationName =
          this.renditionForm.value.buyerReferredName;
        // Oficina
        if (this.renditionForm.value.buyerReferredOffice) {
          const saleOfficeReferred = this.officesList.find(
            (e: { id: number; name: string }) =>
              e.name == this.renditionForm.value.buyerReferredOffice,
          );
          if (
            saleOfficeReferred &&
            this.renditionForm.value.buyerReferredSharedWith == 'RE/MAX'
          ) {
            itemReferred.organizationIdOtherRemax = saleReferred
              ? saleReferred.id
              : 0;
            itemReferred.agencyId = saleOfficeReferred.id;
            itemReferred.organizationId = 0;
          }
          if (this.renditionForm.value.buyerReferredSharedWith == 'Otro') {
            itemReferred.organizationNameOtherRemax = saleOfficeReferred
              ? saleOfficeReferred.name
              : '';
          }
        }

        switch (this.buyerReferredSharedWith.optionSelected) {
          case 1:
            itemReferred.organizationType = 5;
            break;
          case 2:
            itemReferred.organizationType = 4;
            break;
          default:
            itemReferred.organizationType = 2;
            break;
        }

        const INDEX_REFERRED_COMMISSION =
          this.rendition.referredCommissions.length > 0 ? 1 : 0;
        const INDEX_REFERRED_DEDUCTION =
          this.rendition.referredDeductions.length > 0 ? 1 : 0;

        itemReferred.deductionPercentage =
          this.renditionForm.value.buyerReferredPercentage;
        itemReferred.deductionAmountUSD =
          this.renditionForm.value.buyerReferredUSD;
        itemReferred.deductionAmountARS =
          this.renditionForm.value.buyerReferredLocal;

        this.rendition.referredDeductions[INDEX_REFERRED_DEDUCTION] =
          itemReferred;

        const referredCommision = {} as ReferredCommission;
        referredCommision.commissionUSD =
          this.commissionCheckout.buyer.referred.netCommission.usd;
        referredCommision.commissionARS =
          this.commissionCheckout.buyer.referred.netCommission.local;
        referredCommision.organizationId = itemReferred.organizationId ?? 0;
        referredCommision.type = 2;
        this.rendition.referredCommissions[INDEX_REFERRED_COMMISSION] =
          referredCommision;
      }
    }

    this.rendition.otherDeductions = [];
    // Deduccion Manual Vendedor
    if (this.renditionForm.value.sellerManualDeductionName) {
      const item = {
        description: this.renditionForm.value.sellerManualDeductionName,
        type: 1,
        percentage: 0,
        amountUSD: this.renditionForm.value.sellerManualDeductionUSD ?? 0,
        amountARS: this.renditionForm.value.sellerManualDeductionLocal ?? 0,
      };
      this.rendition.otherDeductions?.push(item);
    }

    // Deduccion Manual Comprador
    if (this.renditionForm.value.buyerManualDeductionName) {
      const item = {
        description: this.renditionForm.value.buyerManualDeductionName,
        type: 2,
        percentage: 0,
        amountUSD: this.renditionForm.value.buyerManualDeductionUSD ?? 0,
        amountARS: this.renditionForm.value.buyerManualDeductionLocal ?? 0,
      };
      this.rendition.otherDeductions?.push(item);
    }

    // referredDeductions
    // referredCommissions

    // Deduccion Agente Comprador
    if (this.renditionForm.value.buyerOffice == this.user?.agency_name) {
      this.rendition.saleDeduction.deductionPercentage =
        this.renditionForm.value.buyerAgentDeductionPercentage ?? 0;
      this.rendition.saleDeduction.deductionAmountUSD =
        this.renditionForm.value.buyerAgentDeductionUSD ?? 0;
      this.rendition.saleDeduction.deductionAmountARS =
        this.renditionForm.value.buyerAgentDeductionLocal ?? 0;
    }

    const FIND_TEAM_LEADER = this.fullAgentList.find(
      (e) => e.agentName === this.renditionForm.value.buyerTeamLeader,
    );

    const HAS_VALUE =
      (this.renditionForm.value.buyerTeamLeaderUSD > 0 ||
        this.renditionForm.value.buyerTeamLeaderLocal > 0) &&
      (this.renditionForm.value.buyerLocal > 0 ||
        this.renditionForm.value.buyerUSD > 0);

    if (
      FIND_TEAM_LEADER &&
      this.renditionForm.value.buyerTeamLeader !==
        this.renditionForm.value.buyerAgent &&
      HAS_VALUE
    ) {
      // Origen de la captacion -> 1 leader, 0 member
      const BUYER_TEAM_LEADER_DEDUCTION: TeamLeaderDeduction = {
        checkTeamLeader:
          this.NODE === this.NODE_DO
            ? this.statisticsCheckTeamLeader
            : this.renditionForm.value.buyerTeamLeaderOrigin ===
                this.buyerTeamLeaderOrigin.viewValues[0]
              ? 1
              : 0,
        renditionId: this.renditionFromBE
          ? this.renditionFromBE.renditionId
          : 0,
        deductionType: 2, // Comprador
        organizationName: FIND_TEAM_LEADER.agentName,
        organizationId: FIND_TEAM_LEADER.id,
        teamId: FIND_TEAM_LEADER.teamId ?? 0,
        deductionPercentage: 0,
        deductionAmountArs: this.renditionForm.value.buyerTeamLeaderLocal,
        deductionAmountUsd: this.renditionForm.value.buyerTeamLeaderUSD,
      };
      this.rendition.teamLeaderDeductions.push(BUYER_TEAM_LEADER_DEDUCTION);

      const BUYER_TEAM_LEADER_COMMISSION: TeamLeaderCommission = {
        type: 2, // Comprador
        organizationId: FIND_TEAM_LEADER.id,
        organizationName: FIND_TEAM_LEADER.agentName,
        commissionARS:
          this.commissionCheckout.buyer.teamLeader.netCommission.local,
        commissionUSD:
          this.commissionCheckout.buyer.teamLeader.netCommission.usd,
      };

      this.rendition.teamLeaderCommissions.push(BUYER_TEAM_LEADER_COMMISSION);
    }

    // Notas
    this.rendition.reservationNotes =
      this.renditionForm.value.reservationNotes ?? null;
    this.rendition.notes = this.renditionForm.value.renditionNotes ?? null;

    // Facturas

    this.rendition.agentBillings = [];
    this.invoices.forEach((e: InvoiceRendition) => {
      const invoice = new InvoiceRendition(e);
      if (invoice.origin == this.AGENT_CLIENT) {
        const item = new InvoiceRenditionAgentBilling(invoice);
        const agent = this.fullAgentList.find(
          (e: Agent) => e.agentName == invoice.agent,
        );
        if (agent) item.organizationId = agent.id;
        this.rendition?.agentBillings.push(item);
      }
    });
    const invoicesTotal =
      this.rendition.agentBillings.length ||
      0 + this.rendition.agentPayments.length ||
      0 + this.rendition.billings.length ||
      0;
    if (this.invoices.length != invoicesTotal && this.isEdit) {
      this.resolveInvoices();
    }

    this.rendition.billingSubTotalARS = 0;
    this.rendition.billingSubTotalIVAARS = 0;
    this.rendition.billingSubTotalIVAUSD = 0;
    this.rendition.billingSubTotalUSD = 0;
    this.rendition.billingTotalARS = 0;
    this.rendition.billingTotalUSD = 0;

    this.rendition.billings.forEach((e: InvoiceRenditionBilling) => {
      if (this.rendition) {
        this.rendition.billingSubTotalARS += Number(e.subtotalARS);
        this.rendition.billingSubTotalIVAARS += Number(e.subtotalIVAARS);
        this.rendition.billingSubTotalIVAUSD += Number(e.subtotalIVAUSD);
        this.rendition.billingSubTotalUSD += Number(e.subtotalUSD);
        this.rendition.billingTotalARS += Number(e.totalARS);
        this.rendition.billingTotalUSD += Number(e.totalUSD);
      }
    });

    if (jurisdiction && this.cajaPrev.length > 0) {
      let resultUSD = 0;
      let resultLocal = 0;
      this.cajaPrev.forEach((e: InvoiceRenditionBilling) => {
        resultUSD = resultUSD + e.subtotalUSD + e.overbillingUSD;
        resultLocal = resultLocal + e.subtotalARS + e.overbillingLocal;
      });

      this.rendition.jurisdictionDeduction.deductionPercentage =
        jurisdiction.previsionalCash ?? 0;
      this.rendition.jurisdictionDeduction.deductionAmountUSD =
        resultUSD * (jurisdiction.previsionalCash / 100);
      this.rendition.jurisdictionDeduction.deductionAmountARS =
        resultLocal * (jurisdiction.previsionalCash / 100);
    }

    // Guardo los ABAO generados (si hay)
    if (
      this.commissionCheckout.seller.agent.abao.usd > 0 ||
      this.commissionCheckout.seller.agent.abao.local > 0
    ) {
      this.rendition.purchaseJurisdictionDeduction.deductionPercentage =
        jurisdiction?.previsionalCash ?? 0;
      this.rendition.purchaseJurisdictionDeduction.deductionAmountUSD =
        this.commissionCheckout.seller.agent.abao.usd ?? 0;
      this.rendition.purchaseJurisdictionDeduction.deductionAmountARS =
        this.commissionCheckout.seller.agent.abao.local ?? 0;
    }

    if (
      this.commissionCheckout.buyer.agent.abao.usd > 0 ||
      this.commissionCheckout.buyer.agent.abao.local > 0
    ) {
      this.rendition.salesJurisdictionDeduction.deductionPercentage =
        jurisdiction?.previsionalCash ?? 0;
      this.rendition.salesJurisdictionDeduction.deductionAmountUSD =
        this.commissionCheckout.buyer.agent.abao.usd ?? 0;
      this.rendition.salesJurisdictionDeduction.deductionAmountARS =
        this.commissionCheckout.buyer.agent.abao.local ?? 0;
    }

    // Campos varios

    if (!this.isReferidoACobrar) {
      let totalCobrokerOwnUSD = 0;
      let totalCobrokerOwnLocal = 0;
      let totalCobrokerExternalUSD = 0;
      let totalCobrokerExternalLocal = 0;

      if (this.NODE === this.NODE_DO) {
        const COBROKERS_OWN = this.sellerCobrokers.controls.filter(
          (c) =>
            !c.value.sellerCobrokerOfficeId && c.value.sellerCobrokerOffice,
        );
        const COBROKERS_EXTERNAL = this.sellerCobrokers.controls.filter(
          (c) =>
            (c.value.sellerCobrokerOfficeId && c.value.sellerCobrokerOffice) ||
            c.value.sellerCobrokerSharedWith === 'Otro',
        );

        totalCobrokerOwnUSD = COBROKERS_OWN.reduce((sum, cobrokerControl) => {
          const COBROKER = cobrokerControl.value;
          return sum + (COBROKER.sellerCobrokerUSD ?? 0);
        }, 0);

        totalCobrokerOwnLocal = COBROKERS_OWN.reduce((sum, cobrokerControl) => {
          const COBROKER = cobrokerControl.value;
          return sum + (COBROKER.sellerCobrokerLocal ?? 0);
        }, 0);

        totalCobrokerExternalUSD = COBROKERS_EXTERNAL.reduce(
          (sum, cobrokerControl) => {
            const COBROKER = cobrokerControl.value;
            return sum + (COBROKER.sellerCobrokerUSD ?? 0);
          },
          0,
        );

        totalCobrokerExternalLocal = COBROKERS_EXTERNAL.reduce(
          (sum, cobrokerControl) => {
            const COBROKER = cobrokerControl.value;
            return sum + (COBROKER.sellerCobrokerLocal ?? 0);
          },
          0,
        );
      }

      this.rendition.grossComissionPercentage =
        this.renditionForm.value.sellerPercentage +
        this.renditionForm.value.buyerPercentage;
      this.rendition.grossComissionUSD =
        this.renditionForm.value.sellerUSD + this.renditionForm.value.buyerUSD;
      this.rendition.grossComissionARS =
        this.renditionForm.value.sellerLocal +
        this.renditionForm.value.buyerLocal;

      // grossAgencyComissionPercentage
      const sellerPercentage =
        this.commissionCheckout.seller.officeId == null &&
        this.commissionCheckout.seller.otherRealEstateName == null
          ? this.commissionCheckout.seller.percentage
          : 0;
      const buyerPercentage =
        this.commissionCheckout.buyer.officeId == null &&
        this.commissionCheckout.buyer.otherRealEstateName == null
          ? this.commissionCheckout.buyer.percentage
          : 0;

      this.rendition.grossAgencyComissionPercentage =
        sellerPercentage + buyerPercentage;

      // grossAgencyComissionUSD
      const sellerUSD =
        this.commissionCheckout.seller.officeId == null &&
        this.commissionCheckout.seller.otherRealEstateName == null
          ? this.commissionCheckout.seller.usd +
            totalCobrokerOwnUSD +
            totalCobrokerExternalUSD
          : 0 + totalCobrokerOwnUSD;
      const buyerUSD =
        this.commissionCheckout.buyer.officeId == null &&
        this.commissionCheckout.buyer.otherRealEstateName == null
          ? this.commissionCheckout.buyer.usd
          : 0;

      this.rendition.grossAgencyComissionUSD = sellerUSD + buyerUSD;

      // grossAgencyComissionARS
      const sellerLocal =
        this.commissionCheckout.seller.officeId == null &&
        this.commissionCheckout.seller.otherRealEstateName == null
          ? this.commissionCheckout.seller.local +
            totalCobrokerOwnLocal +
            totalCobrokerExternalLocal
          : 0 + totalCobrokerOwnLocal;
      const buyerLocal =
        this.commissionCheckout.buyer.officeId == null &&
        this.commissionCheckout.buyer.otherRealEstateName == null
          ? this.commissionCheckout.buyer.local
          : 0;

      this.rendition.grossAgencyComissionARS =
        (sellerLocal ?? 0) + (buyerLocal ?? 0);
      if (this.NODE === this.NODE_DO) {
        this.rendition.grossAgencyComissionPercentage =
          ((this.rendition.grossAgencyComissionUSD +
            this.rendition.grossAgencyComissionARS /
              this.rendition.exchangeRate) /
            ((this.rendition.totalAmountOperationUSD ?? 0) +
              (this.rendition.totalAmountOperationARS ?? 0) /
                this.rendition.exchangeRate)) *
          100;
      }

      this.rendition.grossAgencyComissionPercentageWithoutReferredDeduction =
        this.commissionCheckout.office.subtotal.percentage;
      this.rendition.grossAgencyComissionUSDWithoutReferredDeduction =
        this.commissionCheckout.office.subtotal.usd;
      this.rendition.grossAgencyComissionARSWithoutReferredDeduction =
        this.commissionCheckout.office.subtotal.local;

      // Neta Punta Vendedora
      this.rendition.purchaseOrganizationAmountCommissionUSD =
        this.commissionCheckout.seller.agent.netCommission.usd;
      this.rendition.purchaseOrganizationAmountCommissionARS =
        this.commissionCheckout.seller.agent.netCommission.local;

      // Neta Punta Compradora
      this.rendition.saleOrganizationAmountCommissionUSD =
        this.commissionCheckout.buyer.agent.netCommission.usd;
      this.rendition.saleOrganizationAmountCommissionARS =
        this.commissionCheckout.buyer.agent.netCommission.local;

      // Neta oficina

      this.rendition.agencyAmountCommissionUSD =
        this.commissionCheckout.office.netCommission.usd;
      this.rendition.agencyAmountCommissionARS =
        this.commissionCheckout.office.netCommission.local;

      // Precios de cierre

      this.rendition.totalAmountOperationUSD =
        this.renditionForm.value.closePriceUSD;
      this.rendition.totalAmountOperationARS =
        this.renditionForm.value.closePriceLocal;
    } else {
      // Referido a cobrar toma todos estos valores BRUTOS. El resto toma los NETOS
      this.rendition.grossAgencyComissionPercentageWithoutReferredDeduction =
        this.commissionCheckout.office.rawCommission.percentage;
      this.rendition.grossAgencyComissionUSDWithoutReferredDeduction =
        this.commissionCheckout.office.rawCommission.usd;
      this.rendition.grossAgencyComissionARSWithoutReferredDeduction =
        this.commissionCheckout.office.rawCommission.local;

      // grossAgencyComissionUSD
      this.rendition.grossAgencyComissionARS =
        this.commissionCheckout.office.rawCommission.local ?? 0;
      this.rendition.grossAgencyComissionUSD =
        this.commissionCheckout.office.rawCommission.usd;

      this.rendition.agencyAmountCommissionUSD =
        this.commissionCheckout.office.netCommission.usd;
      this.rendition.agencyAmountCommissionARS =
        this.commissionCheckout.office.netCommission.local;
    }

    if (this.NODE === this.NODE_DO) {
      const IS_USD = this.renditionForm.value.regaliasUSD > 0;
      const IS_LOCAL = this.renditionForm.value.regaliasLocal > 0;

      let amount = 0;

      if (IS_USD && IS_LOCAL) {
        amount =
          this.renditionForm.value.regaliasLocal / this.rendition.exchangeRate +
          this.renditionForm.value.regaliasUSD;
      } else if (IS_USD && !IS_LOCAL) {
        amount = this.renditionForm.value.regaliasUSD;
      } else if (!IS_USD && IS_LOCAL) {
        amount = this.renditionForm.value.regaliasLocal;
      }

      this.rendition.royaltyAmount = amount;

      this.rendition.royaltyPercentage =
        this.rendition.grossAgencyComissionARS > 0
          ? (amount / this.rendition.grossAgencyComissionARS) * 100
          : (amount / this.rendition.grossAgencyComissionUSD) * 100;
    }

    //QRID y EMPRENDIMIENTO ID
    this.rendition.qrId = this.qrid;
    this.rendition.entrepreneurshipId = this.entrepreneurshipId;

    //ORIGIN: Definir origen de la rendición (desde donde se creó)
    this.rendition.origin = getNavigationOriginCode(this.NavigationOrigin);
    if (this.isEdit) {
      delete (this.rendition as Partial<RenditionModel>).origin;
    }

    if (this.NODE === this.NODE_DO) {
      this.rendition.pendingCommissions =
        this.renditionForm.value.pendingCommissions;
    } else {
      delete this.rendition.pendingCommissions;
    }

    return this.rendition;
  }

  performCalculation(type?: string) {
    if (type) {
      switch (type) {
        case 'percentage':
          this.sellerSideCommissionPercentage();
          this.buyerSideCommissionPercentage();
          break;
        case 'value':
        case 'tc':
          this.sellerSideCommissionValues();
          this.buyerSideCommissionValues();
          break;
      }
      if (type != 'tc' && type != 'referred') this.setRelation();
    }

    if (type != 'referred') {
      this.sellerReferredCalculations();
      this.buyerReferredCalculations();
    }

    // if (
    //   this.renditionForm.value.sellerTeamLeaderUSD > 0 ||
    //   this.renditionForm.value.sellerTeamLeaderLocal > 0
    // ) {
    //   this.sellerTeamLeaderCommissionValues();
    // }

    // if (
    //   this.renditionForm.value.buyerTeamLeaderUSD > 0 ||
    //   this.renditionForm.value.buyerTeamLeaderLocal > 0
    // ) {
    //   this.buyerTeamLeaderCommissionValues();
    // }

    this.formatForCheckout();
    this.calculationsJurisdiction();
  }

  buyerTeamLeaderCommissionValues() {
    const PERCENTAGE_SUGGESTED =
      this.buyerTeamLeaderOrigin.optionSelected === 0 ? 0.5625 : 0.4375;
    this.renditionForm.get('sellerTeamLeaderUSD')?.setValue(0);

    const USD =
      (this.renditionForm.value.sellerUSD + this.renditionForm.value.buyerUSD) *
        ((100 - this.sellerRelation) / 100) -
      this.renditionForm.value.buyerManualDeductionUSD -
      (this.renditionForm.value.buyerReferredUSD || 0);

    const TOTAL_USD = USD * PERCENTAGE_SUGGESTED;
    this.renditionForm.get('buyerTeamLeaderUSD')?.setValue(TOTAL_USD);

    this.renditionForm.get('buyerTeamLeaderLocal')?.setValue(0);

    const LOCAL =
      (this.renditionForm.value.sellerLocal +
        this.renditionForm.value.buyerLocal) *
        ((100 - this.sellerRelation) / 100) -
      this.renditionForm.value.buyerManualDeductionLocal -
      (this.renditionForm.value.buyerReferredLocal || 0);

    const TOTAL_LOCAL = LOCAL * PERCENTAGE_SUGGESTED;
    this.renditionForm.get('buyerTeamLeaderLocal')?.setValue(TOTAL_LOCAL);
  }

  sellerTeamLeaderCommissionValues() {
    const PERCENTAGE_SUGGESTED =
      this.sellerTeamLeaderOrigin.optionSelected === 0 ? 0.5625 : 0.4375;
    this.renditionForm.get('sellerTeamLeaderUSD')?.setValue(0);

    const USD =
      (this.renditionForm.value.sellerUSD + this.renditionForm.value.buyerUSD) *
        (this.sellerRelation / 100) -
      this.renditionForm.value.sellerManualDeductionUSD -
      (this.renditionForm.value.sellerReferredUSD || 0);

    const TOTAL_USD = USD * PERCENTAGE_SUGGESTED;
    this.renditionForm.get('sellerTeamLeaderUSD')?.setValue(TOTAL_USD);

    this.renditionForm.get('sellerTeamLeaderLocal')?.setValue(0);

    const LOCAL =
      (this.renditionForm.value.sellerLocal +
        this.renditionForm.value.buyerLocal) *
        (this.sellerRelation / 100) -
      this.renditionForm.value.sellerManualDeductionLocal -
      (this.renditionForm.value.sellerReferredLocal || 0);

    const TOTAL_LOCAL = LOCAL * PERCENTAGE_SUGGESTED;
    this.renditionForm.get('sellerTeamLeaderLocal')?.setValue(TOTAL_LOCAL);
  }

  // Punta vendedora VALORES
  sellerSideCommissionValues() {
    const localConverted =
      this.renditionForm.value.sellerLocal /
      this.renditionForm.value.exchangeRate;
    const closedPriceConverted =
      this.renditionForm.value.closePriceLocal /
      this.renditionForm.value.exchangeRate;

    const percentage =
      ((localConverted + this.renditionForm.value.sellerUSD) /
        (this.renditionForm.value.closePriceUSD + closedPriceConverted)) *
      100;

    if (
      Math.trunc(percentage * 100) / 100 !=
      this.renditionForm.value.sellerPercentage
    ) {
      const newpercentage = Math.trunc(percentage * 100) / 100;

      this.changeInputSellerPercentage(newpercentage, 'calc');
    }
  }

  sellerSideCommissionPercentage() {
    const usd = this.renditionForm.value.sellerUSD ?? 0;
    const local = this.renditionForm.value.sellerLocal ?? 0;

    const old_percentage_usd =
      (usd / (this.renditionForm.value.closePriceUSD ?? 0)) * 100 || 0;
    const old_percentage_local =
      (local / (this.renditionForm.value.closePriceLocal ?? 0)) * 100 || 0;

    if (
      Math.round(old_percentage_usd * 100) / 100 !=
        this.renditionForm.value.sellerPercentage ||
      Math.round(old_percentage_local * 100) / 100 !=
        this.renditionForm.value.sellerPercentage
    ) {
      const usdSeller =
        this.renditionForm.value.closePriceUSD *
        (this.renditionForm.value.sellerPercentage / 100);
      const localSeller =
        this.renditionForm.value.closePriceLocal *
        (this.renditionForm.value.sellerPercentage / 100);

      if (this.renditionForm.value.sellerUSD != usdSeller) {
        this.renditionForm.get('sellerUSD')?.setValue(usdSeller);
      }

      if (this.renditionForm.value.sellerLocal != localSeller) {
        this.renditionForm.get('sellerLocal')?.setValue(localSeller);
      }
    }
  }

  // Punta compradora VALORES
  buyerSideCommissionValues() {
    const localConverted =
      this.renditionForm.value.buyerLocal /
      this.renditionForm.value.exchangeRate;
    const closedPriceConverted =
      this.renditionForm.value.closePriceLocal /
      this.renditionForm.value.exchangeRate;

    const percentage =
      ((localConverted + this.renditionForm.value.buyerUSD) /
        (this.renditionForm.value.closePriceUSD + closedPriceConverted)) *
      100;

    if (
      Math.trunc(percentage * 100) / 100 !=
      this.renditionForm.value.buyerPercentage
    ) {
      const newpercentage = Math.trunc(percentage * 100) / 100;
      this.changeInputBuyerPercentage(newpercentage, 'calc');
    }
  }

  buyerSideCommissionPercentage() {
    const usd = this.renditionForm.value.buyerUSD ?? 0;
    const local = this.renditionForm.value.buyerLocal ?? 0;

    const old_percentage_usd =
      (usd / (this.renditionForm.value.closePriceUSD ?? 0)) * 100 || 0;
    const old_percentage_local =
      (local / (this.renditionForm.value.closePriceLocal ?? 0)) * 100 || 0;

    if (
      Math.round(old_percentage_usd * 100) / 100 !=
        this.renditionForm.value.buyerPercentage ||
      Math.round(old_percentage_local * 100) / 100 !=
        this.renditionForm.value.buyerPercentage
    ) {
      const usdBuyer =
        this.renditionForm.value.closePriceUSD *
        (this.renditionForm.value.buyerPercentage / 100);
      const localBuyer =
        this.renditionForm.value.closePriceLocal *
        (this.renditionForm.value.buyerPercentage / 100);

      if (this.renditionForm.value.buyerUSD != usdBuyer) {
        this.renditionForm.get('buyerUSD')?.setValue(usdBuyer);
      }

      if (this.renditionForm.value.buyerLocal != localBuyer) {
        this.renditionForm.get('buyerLocal')?.setValue(localBuyer);
      }
    }
  }

  setRelation() {
    // Establezco nuevas relaciones en base a los inputs del usuario

    if (!this.isRelationFiftyFifty) {
      const EXCHANGE = this.renditionForm.value.exchangeRate;
      const TOTAL_SELLER =
        this.renditionForm.value.sellerUSD +
        this.renditionForm.value.sellerLocal / EXCHANGE;

      const TOTAL_BUYER =
        this.renditionForm.value.buyerUSD +
        this.renditionForm.value.buyerLocal / EXCHANGE;

      const RELATION = (TOTAL_SELLER / (TOTAL_BUYER + TOTAL_SELLER)) * 100;

      if (RELATION != this.sellerRelation) {
        this.sellerRelation = RELATION;
        if (Number(RELATION)) {
          this.renditionForm.get('sellerRelation')?.setValue(RELATION);
          this.renditionForm.get('buyerRelation')?.setValue(100 - RELATION);
        } else if (TOTAL_SELLER == 0 && TOTAL_BUYER != 0) {
          this.renditionForm.get('sellerRelation')?.setValue(0);
          this.renditionForm.get('buyerRelation')?.setValue(100);
        }
      }
    }
  }

  sellerReferredCalculations() {
    if (this.renditionForm.value.sellerReferredPercentage > 0) {
      const USD =
        (this.renditionForm.value.sellerUSD +
          this.renditionForm.value.buyerUSD) *
        (this.sellerRelation / 100) *
        (this.renditionForm.value.sellerReferredPercentage / 100);
      this.renditionForm.get('sellerReferredUSD')?.setValue(USD);

      const LOCAL =
        (this.renditionForm.value.sellerLocal +
          this.renditionForm.value.buyerLocal) *
        (this.sellerRelation / 100) *
        (this.renditionForm.value.sellerReferredPercentage / 100);

      this.renditionForm.get('sellerReferredLocal')?.setValue(LOCAL);
    } else {
      this.renditionForm.get('sellerReferredUSD')?.setValue(0);
      this.renditionForm.get('sellerReferredLocal')?.setValue(0);
    }
  }

  buyerReferredCalculations() {
    if (this.renditionForm.value.buyerReferredPercentage > 0) {
      const RELATION = 100 - this.sellerRelation;
      const USD =
        (this.renditionForm.value.sellerUSD +
          this.renditionForm.value.buyerUSD) *
        (RELATION / 100) *
        (this.renditionForm.value.buyerReferredPercentage / 100);
      this.renditionForm.get('buyerReferredUSD')?.setValue(USD);

      const LOCAL =
        (this.renditionForm.value.sellerLocal +
          this.renditionForm.value.buyerLocal) *
        (RELATION / 100) *
        (this.renditionForm.value.buyerReferredPercentage / 100);

      this.renditionForm.get('buyerReferredLocal')?.setValue(LOCAL);
    } else {
      this.renditionForm.get('buyerReferredUSD')?.setValue(0);
      this.renditionForm.get('buyerReferredLocal')?.setValue(0);
    }
  }

  cleanInput(number: InputTypes): number {
    if (number === null) return 0;
    let input = number?.toString().trim() ?? '';

    if (this.NODE === this.NODE_DO) {
      const LAST_DOT = input.lastIndexOf(',');
      const LAST_COMMA = input.lastIndexOf('.');

      let lastSeparator = Math.max(LAST_DOT, LAST_COMMA);
      if (lastSeparator !== -1) {
        const DECIMAL_PART = input.slice(lastSeparator + 1);
        const IS_LIKELY_DECIMAL =
          DECIMAL_PART.length > 0 && DECIMAL_PART.length <= 2;

        if (IS_LIKELY_DECIMAL) {
          const CLEAN =
            input.slice(0, lastSeparator).replace(/[.,]/g, '') +
            '.' +
            DECIMAL_PART;
          input = CLEAN;
        } else {
          input = input.replace(/[.,]/g, '');
        }
      }

      // Number() solo acepta '.' como separador decimal (ECMAScript)
      const DATA = input.replaceAll(',', '') ?? '0';
      return Number(DATA);
    } else {
      const LAST_DOT = input.lastIndexOf('.');
      const LAST_COMMA = input.lastIndexOf(',');

      let lastSeparator = Math.max(LAST_DOT, LAST_COMMA);
      if (lastSeparator !== -1) {
        const DECIMAL_PART = input.slice(lastSeparator + 1);
        const IS_LIKELY_DECIMAL =
          DECIMAL_PART.length > 0 && DECIMAL_PART.length <= 2;

        if (IS_LIKELY_DECIMAL) {
          const CLEAN =
            input.slice(0, lastSeparator).replace(/[.,]/g, '') +
            ',' +
            DECIMAL_PART;
          input = CLEAN;
        } else {
          input = input.replace(/[.,]/g, '');
        }
      }

      const DATA = input.replaceAll('.', '').replaceAll(',', '.') ?? '0';
      return Number(DATA);
    }
  }

  cleanInputJurisdiction(number: InputTypes) {
    return number;
  }

  isValidDecimalNumber(e: KeyboardEvent): void {
    const INPUT_ELEMENT = e.target as HTMLInputElement;
    const VALUE = INPUT_ELEMENT.value;

    if (this.NODE === this.NODE_DO) {
      if (e.key === ',' && !VALUE.includes('.')) {
        e.preventDefault();

        // Insert "," at the cursor position
        const SELECTION_START = INPUT_ELEMENT.selectionStart ?? 0;
        const SELECTION_END = INPUT_ELEMENT.selectionEnd ?? 0;
        const NEW_VALUE =
          VALUE.slice(0, SELECTION_START) + '.' + VALUE.slice(SELECTION_END);

        INPUT_ELEMENT.value = NEW_VALUE;

        // Position the cursor after the ","
        INPUT_ELEMENT.setSelectionRange(
          SELECTION_START + 1,
          SELECTION_START + 1,
        );

        // Trigger the input event to register the change
        const EVENT = new Event('input', { bubbles: true });
        INPUT_ELEMENT.dispatchEvent(EVENT);
        return;
      }
    } else {
      if (e.key === '.' && !VALUE.includes(',')) {
        e.preventDefault();

        // Insert "," at the cursor position
        const SELECTION_START = INPUT_ELEMENT.selectionStart ?? 0;
        const SELECTION_END = INPUT_ELEMENT.selectionEnd ?? 0;
        const NEW_VALUE =
          VALUE.slice(0, SELECTION_START) + ',' + VALUE.slice(SELECTION_END);

        INPUT_ELEMENT.value = NEW_VALUE;

        // Position the cursor after the ","
        INPUT_ELEMENT.setSelectionRange(
          SELECTION_START + 1,
          SELECTION_START + 1,
        );

        // Trigger the input event to register the change
        const EVENT = new Event('input', { bubbles: true });
        INPUT_ELEMENT.dispatchEvent(EVENT);

        return;
      }
    }

    // Handle copy/paste/cut and allowed shortcuts
    const IS_CTRL_OR_CMD_SHORTCUT =
      (e.ctrlKey || e.metaKey) &&
      ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase());

    if (IS_CTRL_OR_CMD_SHORTCUT) {
      return; // Allow copy/paste (Ctrl+C, Ctrl+V, etc.)
    }

    const DECIMAL_SEP = this.NODE === this.NODE_DO ? '.' : ',';
    const DECIMAL_KEY_OK =
      this.NODE === this.NODE_DO
        ? e.key === '.' && !VALUE.includes('.')
        : e.key === ',' && !VALUE.includes(',');

    if (
      ['Tab', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(
        e.key,
      ) ||
      DECIMAL_KEY_OK
    ) {
      return;
    }

    if (!isNaN(Number(e.key)) && e.key !== ' ') {
      const DECIMAL_INDEX = VALUE.indexOf(DECIMAL_SEP);
      const HAS_SELECTION =
        (INPUT_ELEMENT.selectionStart ?? 0) !==
        (INPUT_ELEMENT.selectionEnd ?? 0);
      const CURSOR_POS = INPUT_ELEMENT.selectionStart ?? VALUE.length;
      const [, DECIMAL_PART] = VALUE.split(DECIMAL_SEP);

      const IS_TYPING_IN_DECIMALS =
        DECIMAL_INDEX !== -1 && CURSOR_POS > DECIMAL_INDEX && !HAS_SELECTION;

      if (IS_TYPING_IN_DECIMALS && DECIMAL_PART && DECIMAL_PART.length >= 2) {
        e.preventDefault();
      }
      return;
    }

    e.preventDefault();
  }

  onPasteDecimalNumber(e: ClipboardEvent): void {
    e.preventDefault();

    const INPUT_ELEMENT = e.target as HTMLInputElement;
    const PASTED = e.clipboardData?.getData('text') ?? '';
    const VALUE = INPUT_ELEMENT.value;
    const SELECTION_START = INPUT_ELEMENT.selectionStart ?? 0;
    const SELECTION_END = INPUT_ELEMENT.selectionEnd ?? 0;

    const MERGED =
      VALUE.slice(0, SELECTION_START) + PASTED + VALUE.slice(SELECTION_END);
    const SANITIZED = this.sanitizeDecimalPasteValue(MERGED);

    INPUT_ELEMENT.value = SANITIZED;
    INPUT_ELEMENT.setSelectionRange(SANITIZED.length, SANITIZED.length);

    INPUT_ELEMENT.dispatchEvent(new Event('input', { bubbles: true }));
  }

  private sanitizeDecimalPasteValue(input: string): string {
    const DECIMAL_SEP = this.NODE === this.NODE_DO ? '.' : ',';
    const OTHER_SEP = DECIMAL_SEP === ',' ? '.' : ',';
    const SANITIZED = input.replace(/[^\d.,]/g, '');

    const LAST_DECIMAL_SEP = SANITIZED.lastIndexOf(DECIMAL_SEP);
    const LAST_OTHER_SEP = SANITIZED.lastIndexOf(OTHER_SEP);
    const LAST_SEPARATOR = Math.max(LAST_DECIMAL_SEP, LAST_OTHER_SEP);

    if (LAST_SEPARATOR === -1) {
      return SANITIZED.replace(/[.,]/g, '');
    }

    const DECIMAL_PART = SANITIZED.slice(LAST_SEPARATOR + 1)
      .replace(/[.,]/g, '')
      .slice(0, 2);
    const INTEGER_PART = SANITIZED.slice(0, LAST_SEPARATOR).replace(
      /[.,]/g,
      '',
    );

    if (!DECIMAL_PART.length) {
      return `${INTEGER_PART}${DECIMAL_SEP}`;
    }

    return `${INTEGER_PART}${DECIMAL_SEP}${DECIMAL_PART}`;
  }

  formatForCheckout() {
    if (isNaN(this.sellerRelation)) {
      this.sellerRelation = 0;
    }

    const isNodeDO = this.NODE === this.NODE_DO;

    let commissionSummary: CommissionSummary = new CommissionSummary();

    // Precio de cierre USD
    commissionSummary.closedPrice.usd =
      this.renditionForm.value.closePriceUSD ?? 0;
    // Precio de cierre Local
    commissionSummary.closedPrice.local =
      this.renditionForm.value.closePriceLocal ?? 0;

    // Comision Bruta porcentaje
    commissionSummary.rawCommission.percentage =
      this.renditionForm.value.sellerPercentage +
      this.renditionForm.value.buyerPercentage;
    // Comision Bruta USD
    commissionSummary.rawCommission.usd =
      this.renditionForm.value.sellerUSD + this.renditionForm.value.buyerUSD;
    // Comision Bruta Local
    commissionSummary.rawCommission.local =
      this.renditionForm.value.sellerLocal +
      this.renditionForm.value.buyerLocal;

    const jurisdiction = this.jurisdictions.find(
      (e) => e.name == this.renditionForm.value.jurisdiction,
    );

    // Checkeo si es form comun o referido a cobrar
    if (this.isReferidoACobrar) {
      // Armo el objeto para referido a cobrar

      commissionSummary.referred.isSeller =
        this.originReferredToggle.optionSelected == 0;

      commissionSummary.referred.isReferred = true;
      // Nombre
      commissionSummary.referred.name = this.renditionForm.value.referredName;
      // Deduccion Manual Nombre
      commissionSummary.referred.manualDeduction.name =
        this.originReferredToggle.optionSelected == 0
          ? this.renditionForm.value.sellerManualDeductionName
          : this.renditionForm.value.buyerManualDeductionName;
      // Deduccion Manual USD
      commissionSummary.referred.manualDeduction.usd =
        this.originReferredToggle.optionSelected == 0
          ? this.renditionForm.value.sellerManualDeductionUSD
          : this.renditionForm.value.buyerManualDeductionUSD;
      // Deduccion Manual Local
      commissionSummary.referred.manualDeduction.local =
        this.originReferredToggle.optionSelected == 0
          ? this.renditionForm.value.sellerManualDeductionLocal
          : this.renditionForm.value.buyerManualDeductionLocal;

      commissionSummary.referidoACobrarCalculation();

      // Calculo primer subtotal
      commissionSummary.referred.firstSubtotal.usd =
        (commissionSummary.closedPrice.usd ?? 0) -
        commissionSummary.referred.manualDeduction.usd;
      commissionSummary.referred.firstSubtotal.local =
        (commissionSummary.closedPrice.local ?? 0) -
        commissionSummary.referred.manualDeduction.local;

      const referredAgent = this.fullAgentList.find(
        (e: Agent) => e.agentName == this.renditionForm.value.referredName,
      );

      if (referredAgent) {
        const dataArray = CommissionSummary.dataArray;
        const getReferidoTypeDeductionFactor = (typeName: string): number => {
          if (!typeName || dataArray[typeName] === undefined) {
            return 0;
          }
          return (100 - dataArray[typeName]) / 100;
        };

        if (isNodeDO) {
          commissionSummary.referred.type.original =
            AgentTypesArray.agentTypesArray[
              referredAgent.agentLevelType ?? ''
            ] ?? '';
          commissionSummary.referred.type.name = referredAgent.agentType;

          const typeDeductionFactor = getReferidoTypeDeductionFactor(
            commissionSummary.referred.type.name,
          );

          commissionSummary.referred.type.usd =
            (commissionSummary.referred.firstSubtotal.usd ?? 0) *
            typeDeductionFactor;
          commissionSummary.referred.type.local =
            (commissionSummary.referred.firstSubtotal.local ?? 0) *
            typeDeductionFactor;
        } else {
          // Pongo tipo de agente del referido
          commissionSummary.referred.type.original =
            AgentTypesArray.agentTypesArray[referredAgent.agentType];
          commissionSummary.referred.type.name = referredAgent.teamId
            ? 'TEAM_JUNIOR'
            : referredAgent.agentType;

          const typeDeductionFactor = getReferidoTypeDeductionFactor(
            commissionSummary.referred.type.name,
          );

          commissionSummary.referred.type.usd =
            (commissionSummary.referred.firstSubtotal.usd ?? 0) *
            typeDeductionFactor;
          commissionSummary.referred.type.local =
            (commissionSummary.referred.firstSubtotal.local ?? 0) *
            typeDeductionFactor;
        }
      }

      commissionSummary.referred.manualDeduction.name =
        this.originReferredToggle.optionSelected == 0
          ? this.renditionForm.value.sellerManualDeductionName
          : this.renditionForm.value.buyerManualDeductionName;

      // Jurisdiccion agente
      commissionSummary.referred.deduction.percentage =
        this.originReferredToggle.optionSelected == 0
          ? this.renditionForm.value.sellerAgentDeductionPercentage
          : this.renditionForm.value.buyerAgentDeductionPercentage;

      commissionSummary.referred.deduction.usd =
        this.originReferredToggle.optionSelected == 0
          ? this.renditionForm.value.sellerAgentDeductionUSD
          : this.renditionForm.value.buyerAgentDeductionUSD;
      commissionSummary.referred.deduction.local =
        this.originReferredToggle.optionSelected == 0
          ? this.renditionForm.value.sellerAgentDeductionLocal
          : this.renditionForm.value.buyerAgentDeductionLocal;

      commissionSummary.referidoACobrarCalculation();
    } else {
      /////////////////////////////////////////////
      ///////////// Punta Vendedora ///////////////
      /////////////////////////////////////////////

      // Checkeo si tiene oficina (es compartida con otro remax)
      switch (this.renditionForm.value.sellerSharedWith) {
        case 'Mi oficina':
          commissionSummary.seller.officeId = null;
          commissionSummary.seller.otherRealEstateName = null;
          commissionSummary.seller.agent.office =
            this.renditionForm.value.sellerOffice;
          break;
        case 'RE/MAX': {
          commissionSummary.seller.officeId =
            this.renditionForm.value.sellerOffice != this.user?.agency_name
              ? 1
              : null;
          commissionSummary.seller.agent.office =
            this.renditionForm.value.sellerOffice;
          commissionSummary.seller.otherRealEstateName = null;
          break;
        }
        case 'Otro': {
          commissionSummary.seller.otherRealEstateName =
            this.renditionForm.value.sharedWithAnotherRealEstate ?? '';
          commissionSummary.seller.agent.office = '';
          commissionSummary.seller.officeId = null;

          break;
        }
      }

      // Relacion

      commissionSummary.seller.relation = this.sellerRelation ?? 0;

      this.buyerRelation = 100 - this.sellerRelation;

      commissionSummary.buyer.relation =
        100 - commissionSummary.seller.relation;

      // USD
      commissionSummary.seller.usd =
        commissionSummary.rawCommission.usd *
        (commissionSummary.seller.relation / 100);
      this.sellerRawCommissionUSD = commissionSummary.seller.usd ?? 0;

      // Local
      commissionSummary.seller.local =
        commissionSummary.rawCommission.local *
        (commissionSummary.seller.relation / 100);
      this.sellerRawCommissionLocal = commissionSummary.seller.local ?? 0;

      if (this.NODE === this.NODE_DO) {
        const TOTAL_COBROKER_USD = this.sellerCobrokers.controls.reduce(
          (sum, cobrokerControl) => {
            const COBROKER = cobrokerControl.value;
            return (
              sum + COBROKER.sellerCobrokerUSD
              // (COBROKER.sellerCobrokerOffice === this.user?.agency_name
              //   ? COBROKER.sellerCobrokerUSD
              //   : 0)
            );
          },
          0,
        );

        commissionSummary.seller.usd =
          this.sellerRawCommissionUSD -
          (commissionSummary.seller.officeId !== null ||
          commissionSummary.seller.otherRealEstateName !== null
            ? 0
            : TOTAL_COBROKER_USD);

        this.sellerRawCommissionUSD = commissionSummary.seller.usd ?? 0;

        const TOTAL_COBROKER_LOCAL = this.sellerCobrokers.controls.reduce(
          (sum, cobrokerControl) => {
            const COBROKER = cobrokerControl.value;
            return (
              sum + COBROKER.sellerCobrokerLocal
              // (COBROKER.sellerCobrokerOffice === this.user?.agency_name
              //   ? COBROKER.sellerCobrokerLocal
              //   : 0)
            );
          },
          0,
        );

        commissionSummary.seller.local =
          this.sellerRawCommissionLocal -
          (commissionSummary.seller.officeId !== null ||
          commissionSummary.seller.otherRealEstateName !== null
            ? 0
            : TOTAL_COBROKER_LOCAL);
        this.sellerRawCommissionLocal = commissionSummary.seller.local ?? 0;
      }

      // Porcentaje
      commissionSummary.seller.percentage =
        commissionSummary.rawCommission.percentage *
        (commissionSummary.seller.relation / 100);

      // Comisiones brutas punta vendedora
      this.sellerRawCommissionUSD = commissionSummary.seller.usd ?? 0;
      this.sellerRawCommissionLocal = commissionSummary.seller.local ?? 0;

      // Deduccion Manual vendedor

      if (
        this.renditionForm.value.closePriceUSD > 0 ||
        (this.renditionForm.value.closePriceLocal > 0 &&
          this.buyerRelation != 100)
      ) {
        commissionSummary.seller.agent.manualDeduction.name =
          this.renditionForm.value.sellerManualDeductionName ?? null;
        commissionSummary.seller.agent.manualDeduction.usd =
          this.renditionForm.value.sellerManualDeductionUSD ?? null;
        commissionSummary.seller.agent.manualDeduction.local =
          this.renditionForm.value.sellerManualDeductionLocal ?? null;

        if (this.addSellerReferred) {
          const sellerReferredSummary = commissionSummary.seller.referred;
          const sellerForm = this.renditionForm.value;
          const dataArray = CommissionSummary.dataArray;
          const isSharedWithMyOffice =
            sellerForm.sellerReferredSharedWith === 'Mi oficina';

          const applyTypeDeduction = () => {
            const typeName = sellerReferredSummary.type.name;
            const rawUsd = sellerReferredSummary.rawCommission.usd ?? 0;
            const rawLocal = sellerReferredSummary.rawCommission.local ?? 0;
            const factor = (100 - dataArray[typeName]) / 100;

            sellerReferredSummary.type.usd = rawUsd * factor;
            sellerReferredSummary.type.local = rawLocal * factor;
          };

          const setAgentDeductionByType = () => {
            switch (sellerReferredSummary.type.name) {
              case 'ALTO':
                sellerReferredSummary.agentDeduction.percentage =
                  jurisdiction?.altoDeductionPercentage ?? 0;
                break;
              case 'PURO':
                sellerReferredSummary.agentDeduction.percentage =
                  jurisdiction?.puroDeductionPercentage ?? 0;
                break;
              case 'TEAM_JUNIOR':
                sellerReferredSummary.agentDeduction.percentage =
                  jurisdiction?.teamDeductionPercentage ?? 0;
                break;
              default:
                sellerReferredSummary.agentDeduction.percentage = 0;
                break;
            }

            sellerReferredSummary.agentDeduction.local =
              (sellerReferredSummary.rawCommission.local ?? 0) *
              (sellerReferredSummary.agentDeduction.percentage / 100);
            sellerReferredSummary.agentDeduction.usd =
              (sellerReferredSummary.rawCommission.usd ?? 0) *
              (sellerReferredSummary.agentDeduction.percentage / 100);
          };

          if (isSharedWithMyOffice) {
            const sellerBE = this.renditionFromBE?.referredCommissions.find(
              (e: ReferredCommission) => e.type === 1,
            );
            const sellerReferred = this.fullAgentList.find(
              (e: Agent) => e.agentName === sellerForm.sellerReferredName,
            );

            if (sellerReferred || sellerBE) {
              sellerReferredSummary.officeId = null;
              sellerReferredSummary.name =
                sellerBE?.organizationName ?? sellerReferred?.agentName ?? '';

              sellerReferredSummary.rawCommission.percentage =
                sellerForm.sellerReferredPercentage ?? 0;
              sellerReferredSummary.rawCommission.usd =
                sellerForm.sellerReferredUSD ?? 0;
              sellerReferredSummary.rawCommission.local =
                sellerForm.sellerReferredLocal ?? 0;

              sellerReferredSummary.type.name =
                sellerBE?.organizationAgentType ??
                sellerReferred?.agentType ??
                '';

              if (isNodeDO) {
                sellerReferredSummary.type.original =
                  AgentTypesArray.agentTypesArray[
                    sellerReferred?.agentLevelType ??
                      sellerBE?.organizationAgentLevelType ??
                      ''
                  ] ?? '';
              } else {
                sellerReferredSummary.type.original =
                  sellerBE?.organizationAgentType ??
                  sellerReferred?.agentType ??
                  '';

                if (sellerBE?.organizationTeamId || sellerReferred?.teamId) {
                  sellerReferredSummary.type.name = 'TEAM_JUNIOR';
                }
              }

              applyTypeDeduction();
            } else {
              // Sin sellerReferred ni sellerBE, tomar datos de BE
              const renditionCommission =
                this.renditionFromBE?.referredCommissions.find(
                  (e) => e.type === 1,
                );

              if (renditionCommission) {
                if (isNodeDO) {
                  sellerReferredSummary.type.original =
                    AgentTypesArray.agentTypesArray[
                      renditionCommission.organizationAgentLevelType ?? ''
                    ] ?? '';
                  sellerReferredSummary.type.name =
                    renditionCommission.organizationAgentType ?? '';
                } else {
                  sellerReferredSummary.type.original =
                    AgentTypesArray.agentTypesArray[
                      renditionCommission.organizationAgentType
                    ] ?? '';
                  sellerReferredSummary.type.name =
                    renditionCommission.organizationTeamId
                      ? 'TEAM_JUNIOR'
                      : (AgentTypesArray.agentTypesArray[
                          renditionCommission.organizationAgentType
                        ] ?? '');
                }

                sellerReferredSummary.officeId = null;
              }

              const referreDeduction =
                this.renditionFromBE?.referredDeductions.find(
                  (e) => e.typePayment === 1,
                );

              if (referreDeduction) {
                sellerReferredSummary.name = referreDeduction.organizationName;
                sellerReferredSummary.rawCommission.usd =
                  referreDeduction.deductionAmountUSD;
                sellerReferredSummary.rawCommission.local =
                  referreDeduction.deductionAmountARS;
                sellerReferredSummary.rawCommission.percentage =
                  referreDeduction.deductionPercentage;
              }

              applyTypeDeduction();
            }

            // Deducciones por tipo de agente
            setAgentDeductionByType();
          } else {
            // Compartido con otra oficina / externo
            sellerReferredSummary.officeId =
              this.sellerReferredSharedWith.optionSelected === 1
                ? sellerForm.sellerReferredOffice.toUpperCase()
                : sellerForm.sellerReferredName;

            sellerReferredSummary.name = sellerForm.sellerReferredName;
            sellerReferredSummary.rawCommission.percentage =
              sellerForm.sellerReferredPercentage ?? 0;
            sellerReferredSummary.rawCommission.usd =
              sellerForm.sellerReferredUSD ?? 0;
            sellerReferredSummary.rawCommission.local =
              sellerForm.sellerReferredLocal ?? 0;
          }
        }

        commissionSummary.sellerAgentCalculation();

        // COBROKERS DOMINICANA

        commissionSummary.cobrokers = [];
        if (isNodeDO && this.sellerCobrokers.length > 0) {
          let i = 1;
          for (const cobroker of this.sellerCobrokers.controls) {
            i++;
            const COBROKER = cobroker.value;

            // incorporar deducciones cuando haya

            const SPLIT_VALUE = Number(
              CommissionSummary.dataArray[COBROKER.sellerCobrokerSplit],
            );

            const FACTOR =
              isNaN(SPLIT_VALUE) ||
              COBROKER.sellerCobrokerOffice !== this.user?.agency_name
                ? 1
                : (100 - SPLIT_VALUE) / 100;

            const USD_SPLIT = FACTOR * COBROKER.sellerCobrokerUSD;
            const LOCAL_SPLIT = FACTOR * COBROKER.sellerCobrokerLocal;
            const COBROKER_OBJECT = {
              id: COBROKER.sellerCobrokerId ?? i++,
              name: COBROKER.sellerCobrokerName,
              office: COBROKER.sellerCobrokerOffice,
              officeId:
                COBROKER.sellerCobrokerSharedWith === 'Mi oficina'
                  ? null
                  : COBROKER.sellerCobrokerOfficeId,
              otherRealEstateName: !COBROKER.sellerCobrokerOffice
                ? COBROKER.sellerCobrokerName
                : null,
              rawCommission: {
                usd: COBROKER.sellerCobrokerUSD,
                local: COBROKER.sellerCobrokerLocal,
              },
              type: {
                name: COBROKER.sellerCobrokerSplit,
                usd: USD_SPLIT,
                local: LOCAL_SPLIT,
                original: COBROKER.sellerCobrokerType,
              },
              agentDeduction: { percentage: 0, usd: 0, local: 0 },
              netCommission: {
                usd:
                  COBROKER.sellerCobrokerUSD === USD_SPLIT
                    ? COBROKER.sellerCobrokerUSD
                    : COBROKER.sellerCobrokerUSD - USD_SPLIT,
                local:
                  COBROKER.sellerCobrokerLocal === LOCAL_SPLIT
                    ? COBROKER.sellerCobrokerLocal
                    : COBROKER.sellerCobrokerLocal - LOCAL_SPLIT,
              },
              teamLeader: {
                name: '',
                rawCommission: { usd: 0, local: 0 },
                type: { name: '', usd: 0, local: 0, original: '' },
                agentDeduction: { percentage: 0, usd: 0, local: 0 },
                netCommission: { usd: 0, local: 0 },
              },
            };

            // Si tiene teamleader
            if (COBROKER.sellerCobrokerOffice === this.user?.agency_name) {
              const FIND_COBROKER = this.fullAgentList.find(
                (e: Agent) => e.agentName === COBROKER.sellerCobrokerName,
              );
              if (
                FIND_COBROKER?.teamId &&
                FIND_COBROKER?.teamLeaderId !== FIND_COBROKER?.id
              ) {
                const FIND_TEAM_LEADER = this.fullAgentList.find(
                  (e: Agent) => e.id === FIND_COBROKER.teamLeaderId,
                );

                if (FIND_TEAM_LEADER) {
                  const FACTOR_TEAM_LEADER =
                    (100 -
                      CommissionSummary.dataArray[FIND_TEAM_LEADER.agentType]) /
                    100;

                  const USD_SPLIT_TEAM_LEADER =
                    FACTOR_TEAM_LEADER * COBROKER.sellerCobrokerUSD;
                  const LOCAL_SPLIT_TEAM_LEADER =
                    FACTOR_TEAM_LEADER * COBROKER.sellerCobrokerLocal;

                  COBROKER_OBJECT.teamLeader.name = FIND_TEAM_LEADER.agentName;
                  COBROKER_OBJECT.teamLeader.type.name =
                    FIND_TEAM_LEADER.agentType;
                  COBROKER_OBJECT.teamLeader.rawCommission.usd = USD_SPLIT;
                  COBROKER_OBJECT.teamLeader.rawCommission.local = LOCAL_SPLIT;
                  COBROKER_OBJECT.teamLeader.type.usd = USD_SPLIT_TEAM_LEADER;
                  COBROKER_OBJECT.teamLeader.type.local =
                    LOCAL_SPLIT_TEAM_LEADER;
                  COBROKER_OBJECT.teamLeader.netCommission.usd =
                    COBROKER_OBJECT.teamLeader.rawCommission.usd -
                    COBROKER_OBJECT.teamLeader.type.usd;
                  COBROKER_OBJECT.teamLeader.netCommission.local =
                    COBROKER_OBJECT.teamLeader.rawCommission.local -
                    COBROKER_OBJECT.teamLeader.type.local;
                }
              }
            }
            commissionSummary.cobrokers.push(COBROKER_OBJECT);
          }
        }

        // TEAM LEADER VENDEDOR

        if (this.renditionForm.value.sellerTeamLeader) {
          const sellerForm = this.renditionForm.value;
          const sellerSummary = commissionSummary.seller;
          const teamLeaderSummary = sellerSummary.teamLeader;
          const dataArray = CommissionSummary.dataArray;

          const applyTeamLeaderTypeDeduction = () => {
            const typeName = teamLeaderSummary.type.name;
            const rawUsd = teamLeaderSummary.rawCommission.usd ?? 0;
            const rawLocal = teamLeaderSummary.rawCommission.local ?? 0;
            const factor = (100 - dataArray[typeName]) / 100;

            teamLeaderSummary.type.usd = rawUsd * factor;
            teamLeaderSummary.type.local = rawLocal * factor;
          };

          const applyTeamLeaderJurisdictionDeduction = () => {
            teamLeaderSummary.agentDeduction.percentage =
              jurisdiction?.teamDeductionPercentage || 0;

            const percentageFactor =
              teamLeaderSummary.agentDeduction.percentage / 100;

            teamLeaderSummary.agentDeduction.local =
              (teamLeaderSummary.rawCommission.local ?? 0) * percentageFactor;
            teamLeaderSummary.agentDeduction.usd =
              (teamLeaderSummary.rawCommission.usd ?? 0) * percentageFactor;
          };

          if (isNodeDO) {
            // TEAM LEADER VENDEDOR DOMINICANA
            const sellerAgent = this.fullAgentList.find(
              (e: Agent) => e.agentName === sellerForm.sellerAgent,
            );

            sellerSummary.agent.type.name = sellerAgent?.agentType ?? '';
            sellerSummary.agent.type.original =
              AgentTypesArray.agentTypesArray[
                sellerAgent?.agentLevelType ?? ''
              ] ?? '';
            // Nombre TL
            teamLeaderSummary.name = sellerForm.sellerTeamLeader;

            const SELLER_TEAM_LEADER = this.fullAgentList.find(
              (e: Agent) => e.agentName === sellerForm.sellerTeamLeader,
            );

            if (SELLER_TEAM_LEADER) {
              teamLeaderSummary.type.original =
                AgentTypesArray.agentTypesArray[
                  SELLER_TEAM_LEADER.agentLevelType ?? ''
                ] ?? '';
              teamLeaderSummary.type.name = SELLER_TEAM_LEADER.agentType ?? '';

              const sellerAgentTypeName = sellerSummary.agent.type.name;
              const teamLeaderTypeName = teamLeaderSummary.type.name;

              const sellerAgentFactor =
                (100 - dataArray[sellerAgentTypeName]) / 100;
              const teamLeaderFactor =
                (100 - dataArray[teamLeaderTypeName]) / 100;

              if (sellerSummary.agent.firstSubtotal.usd > 0) {
                teamLeaderSummary.rawCommission.usd =
                  sellerSummary.agent.firstSubtotal.usd * sellerAgentFactor;

                teamLeaderSummary.type.usd =
                  sellerSummary.usd * teamLeaderFactor;
              }

              if (sellerSummary.agent.firstSubtotal.local > 0) {
                teamLeaderSummary.rawCommission.local =
                  sellerSummary.agent.firstSubtotal.local * sellerAgentFactor;

                teamLeaderSummary.type.local =
                  sellerSummary.local * teamLeaderFactor;
              }

              this.renditionForm
                .get('sellerTeamLeaderUSD')
                ?.setValue(teamLeaderSummary.rawCommission.usd);
              this.renditionForm
                .get('sellerTeamLeaderLocal')
                ?.setValue(teamLeaderSummary.rawCommission.local);
            }
          } else {
            // TEAM LEADER VENDEDOR ARGENTINA / RESTO

            // Nombre
            teamLeaderSummary.name = sellerForm.sellerTeamLeader;

            // Siempre es team leader así que liquida al 80%
            teamLeaderSummary.type.name = 'TEAM_JUNIOR';

            // Comisión bruta USD / LOCAL
            teamLeaderSummary.rawCommission.usd =
              sellerForm.sellerTeamLeaderUSD;
            teamLeaderSummary.rawCommission.local =
              sellerForm.sellerTeamLeaderLocal;

            // Descuento tipo de agente
            applyTeamLeaderTypeDeduction();

            // Descuento por jurisdicción
            applyTeamLeaderJurisdictionDeduction();
          }
        }

        if (
          this.renditionForm.value.sellerUSD > 0 ||
          this.renditionForm.value.sellerLocal > 0 ||
          this.buyerRelation !== 100
        ) {
          const sellerForm = this.renditionForm.value;
          const sellerSummary = commissionSummary.seller;
          const agentSummary = sellerSummary.agent;
          const dataArray = CommissionSummary.dataArray;
          const isSameAgency =
            sellerForm.sellerSharedWith === 'Mi oficina' &&
            sellerForm.sellerOffice === this.user?.agency_name &&
            !sellerSummary.otherRealEstateName;

          agentSummary.name = sellerForm.sellerAgent;

          const sellerAgent = this.fullAgentList.find(
            (e: Agent) => e.agentName === sellerForm.sellerAgent,
          );

          const getTypeDeductionFactor = (
            typeName: string | null | undefined,
          ): number => {
            if (!typeName || dataArray[typeName] === undefined) {
              return 0;
            }
            return (100 - dataArray[typeName]) / 100;
          };

          const applyAgentTypeDeductionFromFirstSubtotal = () => {
            const factor = getTypeDeductionFactor(agentSummary.type.name);

            agentSummary.type.usd =
              (agentSummary.firstSubtotal.usd ?? 0) * factor;
            agentSummary.type.local =
              (agentSummary.firstSubtotal.local ?? 0) * factor;
          };

          const applyAgentTypeDeductionFromSecondSubtotal = () => {
            const factor = getTypeDeductionFactor(agentSummary.type.name);

            agentSummary.type.usd =
              (agentSummary.secondSubtotal.usd ?? 0) * factor;
            agentSummary.type.local =
              (agentSummary.secondSubtotal.local ?? 0) * factor;
          };

          const applyAgentJurisdictionDeductionFromForm = () => {
            agentSummary.deduction.percentage =
              sellerForm.sellerAgentDeductionPercentage;
            agentSummary.deduction.usd =
              sellerForm.sellerAgentDeductionUSD ?? 0;
            agentSummary.deduction.local =
              sellerForm.sellerAgentDeductionLocal ?? 0;
          };

          if (sellerAgent && isSameAgency) {
            // Agente vendedor de mi oficina con datos actuales
            commissionSummary.sellerAgentCalculation(); // <- acá estaba el error

            if (isNodeDO) {
              agentSummary.type.original =
                AgentTypesArray.agentTypesArray[
                  sellerAgent.agentLevelType ?? ''
                ] ?? '';
            } else {
              agentSummary.type.original =
                AgentTypesArray.agentTypesArray[
                  sellerAgent.agentLevelType ?? ''
                ] ??
                this.renditionFromBE?.organizationCommission
                  .purchaseOrganizationAgentType ??
                '';
            }

            agentSummary.type.name =
              sellerAgent.agentType ??
              this.renditionFromBE?.organizationCommission
                .purchaseOrganizationAgentType ??
              '';

            if (
              (this.renditionFromBE?.organizationCommission
                .purchaseOrganizationTeamId ||
                sellerAgent.teamId) &&
              !isNodeDO
            ) {
              agentSummary.type.name = 'TEAM_JUNIOR';
            }

            if (
              isNodeDO &&
              (!sellerAgent.teamId ||
                sellerAgent.teamLeaderId === sellerAgent.id)
            ) {
              // Deducción vendedor por tipo de agente (DO, sin team o TL)
              applyAgentTypeDeductionFromFirstSubtotal();
            } else if (!isNodeDO) {
              // Deducción vendedor por tipo de agente (no DO, usa secondSubtotal)
              applyAgentTypeDeductionFromSecondSubtotal();
            }

            // Jurisdicción agente (siempre viene del form en este branch)
            applyAgentJurisdictionDeductionFromForm();
          } else if (this.renditionFromBE && isSameAgency) {
            // Tengo datos de BE y misma oficina, pero no sellerAgent válido
            if (isNodeDO) {
              agentSummary.type.original =
                AgentTypesArray.agentTypesArray[
                  sellerAgent?.agentLevelType ?? ''
                ] ?? '';
            } else {
              agentSummary.type.original =
                this.renditionFromBE.organizationCommission.purchaseOrganizationAgentType;
            }

            agentSummary.type.name =
              this.renditionFromBE.organizationCommission
                .purchaseOrganizationAgentType ?? '';

            if (
              this.renditionFromBE.organizationCommission
                .purchaseOrganizationTeamId
            ) {
              agentSummary.type.name = 'TEAM_JUNIOR';
            }

            // Deducción vendedor por tipo de agente (siempre con firstSubtotal acá)
            applyAgentTypeDeductionFromFirstSubtotal();
          } else if (
            sellerSummary.otherRealEstateName ||
            sellerForm.sellerSharedWith === 'Otro'
          ) {
            agentSummary.type.name = '';
            agentSummary.type.usd = 0;
            agentSummary.type.local = 0;
            agentSummary.type.original = '';
          }
        }
      }

      // Envio al componente
      commissionSummary.sellerAgentCalculation();
      commissionSummary.sellerReferredCalculation();
      commissionSummary.sellerTeamLeaderCalculation();

      /////////////////////////////////////////////
      ///////////// Punta Compradora //////////////
      /////////////////////////////////////////////

      // Checkeo si tiene oficina (es compartida con otro remax)

      switch (this.renditionForm.value.buyerSharedWith) {
        case 'Mi oficina':
          commissionSummary.buyer.officeId = null;
          commissionSummary.buyer.otherRealEstateName = null;
          commissionSummary.buyer.agent.office =
            this.renditionForm.value.buyerOffice;
          break;
        case 'RE/MAX': {
          commissionSummary.buyer.officeId =
            this.renditionForm.value.buyerOffice != this.user?.agency_name
              ? 1
              : null;
          commissionSummary.buyer.agent.office =
            this.renditionForm.value.buyerOffice;
          commissionSummary.buyer.otherRealEstateName = null;
          break;
        }
        case 'Otro': {
          commissionSummary.buyer.otherRealEstateName =
            this.renditionForm.value.sharedWithAnotherRealEstate ?? '';
          commissionSummary.buyer.agent.office = '';
          commissionSummary.buyer.officeId = null;

          break;
        }
      }

      // USD
      commissionSummary.buyer.usd =
        commissionSummary.rawCommission.usd *
        (commissionSummary.buyer.relation / 100);
      this.buyerRawCommissionUSD = commissionSummary.buyer.usd ?? 0;

      // Local
      commissionSummary.buyer.local =
        commissionSummary.rawCommission.local *
        (commissionSummary.buyer.relation / 100);
      this.buyerRawCommissionLocal = commissionSummary.buyer.local ?? 0;

      // Porcentaje
      commissionSummary.buyer.percentage =
        commissionSummary.rawCommission.percentage *
        (commissionSummary.buyer.relation / 100);

      // Comisiones brutas punta vendedora
      this.buyerRawCommissionUSD = commissionSummary.buyer.usd ?? 0;
      this.buyerRawCommissionLocal = commissionSummary.buyer.local ?? 0;

      // Deduccion Manual comprador
      if (
        (this.renditionForm.value.closePriceUSD > 0 ||
          this.renditionForm.value.closePriceLocal > 0) &&
        this.sellerRelation != 100
      ) {
        commissionSummary.buyer.agent.manualDeduction.name =
          this.renditionForm.value.buyerManualDeductionName ?? null;
        commissionSummary.buyer.agent.manualDeduction.usd =
          this.renditionForm.value.buyerManualDeductionUSD ?? null;
        commissionSummary.buyer.agent.manualDeduction.local =
          this.renditionForm.value.buyerManualDeductionLocal ?? null;

        // Referido comprador
        if (this.addBuyerReferred) {
          const buyerReferredSummary = commissionSummary.buyer.referred;
          const buyerForm = this.renditionForm.value;
          const dataArray = CommissionSummary.dataArray;
          const isSharedWithMyOffice =
            buyerForm.buyerReferredSharedWith === 'Mi oficina';

          const applyTypeDeduction = () => {
            const typeName = buyerReferredSummary.type.name;
            const rawUsd = buyerReferredSummary.rawCommission.usd ?? 0;
            const rawLocal = buyerReferredSummary.rawCommission.local ?? 0;
            const factor = (100 - dataArray[typeName]) / 100;

            buyerReferredSummary.type.usd = rawUsd * factor;
            buyerReferredSummary.type.local = rawLocal * factor;
          };

          const setAgentDeductionByType = () => {
            switch (buyerReferredSummary.type.name) {
              case 'ALTO':
                buyerReferredSummary.agentDeduction.percentage =
                  jurisdiction?.altoDeductionPercentage ?? 0;
                break;
              case 'PURO':
                buyerReferredSummary.agentDeduction.percentage =
                  jurisdiction?.puroDeductionPercentage ?? 0;
                break;
              case 'TEAM_JUNIOR':
                buyerReferredSummary.agentDeduction.percentage =
                  jurisdiction?.teamDeductionPercentage ?? 0;
                break;
              default:
                buyerReferredSummary.agentDeduction.percentage = 0;
                break;
            }

            buyerReferredSummary.agentDeduction.local =
              (buyerReferredSummary.rawCommission.local ?? 0) *
              (buyerReferredSummary.agentDeduction.percentage / 100);
            buyerReferredSummary.agentDeduction.usd =
              (buyerReferredSummary.rawCommission.usd ?? 0) *
              (buyerReferredSummary.agentDeduction.percentage / 100);
          };

          if (isSharedWithMyOffice) {
            const buyerBE = this.renditionFromBE?.referredCommissions.find(
              (e: ReferredCommission) => e.type === 2,
            );
            const buyerReferred = this.fullAgentList.find(
              (e: Agent) => e.agentName === buyerForm.buyerReferredName,
            );

            if (buyerReferred || buyerBE) {
              buyerReferredSummary.officeId = null;
              buyerReferredSummary.name =
                buyerBE?.organizationName ?? buyerReferred?.agentName ?? '';

              buyerReferredSummary.rawCommission.percentage =
                buyerForm.buyerReferredPercentage ?? 0;
              buyerReferredSummary.rawCommission.usd =
                buyerForm.buyerReferredUSD ?? 0;
              buyerReferredSummary.rawCommission.local =
                buyerForm.buyerReferredLocal ?? 0;

              buyerReferredSummary.type.name =
                buyerBE?.organizationAgentType ??
                buyerReferred?.agentType ??
                '';

              if (isNodeDO) {
                buyerReferredSummary.type.original =
                  AgentTypesArray.agentTypesArray[
                    buyerReferred?.agentLevelType ??
                      buyerBE?.organizationAgentLevelType ??
                      ''
                  ] ?? '';
              } else {
                buyerReferredSummary.type.original =
                  buyerBE?.organizationAgentType ??
                  buyerReferred?.agentType ??
                  '';

                if (buyerBE?.organizationTeamId || buyerReferred?.teamId) {
                  buyerReferredSummary.type.name = 'TEAM_JUNIOR';
                }
              }

              applyTypeDeduction();
            } else {
              // Sin sbuyerReferred ni sbuyerBE, tomar datos de BE
              const renditionCommission =
                this.renditionFromBE?.referredCommissions.find(
                  (e) => e.type === 2,
                );

              if (renditionCommission) {
                if (isNodeDO) {
                  buyerReferredSummary.type.original =
                    AgentTypesArray.agentTypesArray[
                      renditionCommission.organizationAgentLevelType ?? ''
                    ] ?? '';
                  buyerReferredSummary.type.name =
                    renditionCommission.organizationAgentType ?? '';
                } else {
                  buyerReferredSummary.type.original =
                    AgentTypesArray.agentTypesArray[
                      renditionCommission.organizationAgentType
                    ] ?? '';
                  buyerReferredSummary.type.name =
                    renditionCommission.organizationTeamId
                      ? 'TEAM_JUNIOR'
                      : renditionCommission.organizationAgentType;
                }

                buyerReferredSummary.officeId = null;
              }

              const referreDeduction =
                this.renditionFromBE?.referredDeductions.find(
                  (e) => e.typePayment === 2,
                );

              if (referreDeduction) {
                buyerReferredSummary.name = referreDeduction.organizationName;
                buyerReferredSummary.rawCommission.usd =
                  referreDeduction.deductionAmountUSD;
                buyerReferredSummary.rawCommission.local =
                  referreDeduction.deductionAmountARS;
                buyerReferredSummary.rawCommission.percentage =
                  referreDeduction.deductionPercentage;
              }

              applyTypeDeduction();
            }

            // Deducciones por tipo de agente
            setAgentDeductionByType();
          } else {
            // Compartido con otra oficina / externo
            buyerReferredSummary.officeId =
              this.buyerReferredSharedWith.optionSelected === 1
                ? buyerForm.buyerReferredOffice.toUpperCase()
                : buyerForm.buyerReferredName;

            buyerReferredSummary.name = buyerForm.buyerReferredName;
            buyerReferredSummary.rawCommission.percentage =
              buyerForm.buyerReferredPercentage ?? 0;
            buyerReferredSummary.rawCommission.usd =
              buyerForm.buyerReferredUSD ?? 0;
            buyerReferredSummary.rawCommission.local =
              buyerForm.buyerReferredLocal ?? 0;
          }
        }

        commissionSummary.buyerAgentCalculation();

        // TEAM LEADER COMPRADOR
        if (this.renditionForm.value.buyerTeamLeader) {
          const buyerForm = this.renditionForm.value;
          const buyerSummary = commissionSummary.buyer;
          const teamLeaderSummary = buyerSummary.teamLeader;
          const dataArray = CommissionSummary.dataArray;

          const buyerAgent = this.fullAgentList.find(
            (e: Agent) => e.agentName === buyerForm.buyerAgent,
          );

          buyerSummary.agent.type.name = buyerAgent?.agentType ?? '';
          buyerSummary.agent.type.original =
            AgentTypesArray.agentTypesArray[buyerAgent?.agentLevelType ?? ''] ??
            '';

          const applyTeamLeaderTypeDeduction = () => {
            const typeName = teamLeaderSummary.type.name;
            const rawUsd = teamLeaderSummary.rawCommission.usd ?? 0;
            const rawLocal = teamLeaderSummary.rawCommission.local ?? 0;
            const factor = (100 - dataArray[typeName]) / 100;

            teamLeaderSummary.type.usd = rawUsd * factor;
            teamLeaderSummary.type.local = rawLocal * factor;
          };

          const applyTeamLeaderJurisdictionDeduction = () => {
            teamLeaderSummary.agentDeduction.percentage =
              jurisdiction?.teamDeductionPercentage || 0;

            const percentageFactor =
              teamLeaderSummary.agentDeduction.percentage / 100;

            teamLeaderSummary.agentDeduction.local =
              (teamLeaderSummary.rawCommission.local ?? 0) * percentageFactor;
            teamLeaderSummary.agentDeduction.usd =
              (teamLeaderSummary.rawCommission.usd ?? 0) * percentageFactor;
          };

          if (
            isNodeDO &&
            (buyerSummary.agent.firstSubtotal.usd > 0 ||
              buyerSummary.agent.firstSubtotal.local > 0)
          ) {
            // TEAM LEADER COMPRADOR DOMINICANA

            // Nombre TL
            teamLeaderSummary.name = buyerForm.buyerTeamLeader;

            const BUYER_TEAM_LEADER = this.fullAgentList.find(
              (e: Agent) => e.agentName === buyerForm.buyerTeamLeader,
            );

            if (BUYER_TEAM_LEADER) {
              teamLeaderSummary.type.original =
                AgentTypesArray.agentTypesArray[
                  BUYER_TEAM_LEADER.agentLevelType ?? ''
                ] ?? '';
              teamLeaderSummary.type.name = BUYER_TEAM_LEADER.agentType ?? '';

              const buyerAgentTypeName = buyerSummary.agent.type.name;
              const teamLeaderTypeName = teamLeaderSummary.type.name;

              let buyerAgentFactor =
                (100 - dataArray[buyerAgentTypeName]) / 100;
              buyerAgentFactor = isNaN(buyerAgentFactor) ? 0 : buyerAgentFactor;

              let teamLeaderFactor =
                (100 - dataArray[teamLeaderTypeName]) / 100;
              teamLeaderFactor = isNaN(teamLeaderFactor) ? 0 : teamLeaderFactor;

              if (buyerSummary.agent.firstSubtotal.usd > 0) {
                teamLeaderSummary.rawCommission.usd =
                  buyerSummary.agent.firstSubtotal.usd * buyerAgentFactor;

                teamLeaderSummary.type.usd =
                  buyerSummary.usd * teamLeaderFactor;
              }

              if (buyerSummary.agent.firstSubtotal.local > 0) {
                teamLeaderSummary.rawCommission.local =
                  buyerSummary.agent.firstSubtotal.local * buyerAgentFactor;

                teamLeaderSummary.type.local =
                  buyerSummary.local * teamLeaderFactor;
              }

              this.renditionForm
                .get('buyerTeamLeaderUSD')
                ?.setValue(teamLeaderSummary.rawCommission.usd);
              this.renditionForm
                .get('buyerTeamLeaderLocal')
                ?.setValue(teamLeaderSummary.rawCommission.local);
            }
          } else {
            // TEAM LEADER VENDEDOR ARGENTINA / RESTO

            // Nombre
            teamLeaderSummary.name = buyerForm.buyerTeamLeader;

            // Siempre es team leader así que liquida al 80%
            teamLeaderSummary.type.name = 'TEAM_JUNIOR';

            // Comisión bruta USD / LOCAL
            teamLeaderSummary.rawCommission.usd = buyerForm.buyerTeamLeaderUSD;
            teamLeaderSummary.rawCommission.local =
              buyerForm.buyerTeamLeaderLocal;

            // Descuento tipo de agente
            applyTeamLeaderTypeDeduction();

            // Descuento por jurisdicción
            applyTeamLeaderJurisdictionDeduction();
          }
        }

        if (
          this.renditionForm.value.buyerUSD > 0 ||
          this.renditionForm.value.buyerLocal > 0 ||
          this.sellerRelation !== 100
        ) {
          const buyerForm = this.renditionForm.value;
          const buyerSummary = commissionSummary.buyer;
          const agentSummary = buyerSummary.agent;
          const dataArray = CommissionSummary.dataArray;
          const isSameAgency =
            buyerForm.buyerSharedWith === 'Mi oficina' &&
            buyerForm.buyerOffice === this.user?.agency_name &&
            !buyerSummary.otherRealEstateName;

          agentSummary.name = buyerForm.buyerAgent;

          const buyerAgent = this.fullAgentList.find(
            (e: Agent) => e.agentName === buyerForm.buyerAgent,
          );

          const getTypeDeductionFactor = (
            typeName: string | null | undefined,
          ): number => {
            if (!typeName || dataArray[typeName] === undefined) {
              return 0;
            }
            return (100 - dataArray[typeName]) / 100;
          };

          const applyAgentTypeDeductionFromFirstSubtotal = () => {
            const factor = getTypeDeductionFactor(agentSummary.type.name);

            agentSummary.type.usd =
              (agentSummary.firstSubtotal.usd ?? 0) * factor;
            agentSummary.type.local =
              (agentSummary.firstSubtotal.local ?? 0) * factor;
          };

          const applyAgentTypeDeductionFromSecondSubtotal = () => {
            const factor = getTypeDeductionFactor(agentSummary.type.name);

            agentSummary.type.usd =
              (agentSummary.secondSubtotal.usd ?? 0) * factor;
            agentSummary.type.local =
              (agentSummary.secondSubtotal.local ?? 0) * factor;
          };

          const applyAgentJurisdictionDeductionFromForm = () => {
            agentSummary.deduction.percentage =
              buyerForm.buyerAgentDeductionPercentage;
            agentSummary.deduction.usd = buyerForm.buyerAgentDeductionUSD ?? 0;
            agentSummary.deduction.local =
              buyerForm.buyerAgentDeductionLocal ?? 0;
          };

          if (buyerAgent && isSameAgency) {
            // Agente comprador de mi oficina con datos actuales
            commissionSummary.buyerAgentCalculation();

            if (isNodeDO) {
              agentSummary.type.original =
                AgentTypesArray.agentTypesArray[
                  buyerAgent?.agentLevelType ?? ''
                ] ?? '';
            } else {
              agentSummary.type.original =
                this.renditionFromBE?.organizationCommission
                  .saleOrganizationAgentType ?? buyerAgent.agentType;
            }

            agentSummary.type.name =
              buyerAgent.agentType ??
              this.renditionFromBE?.organizationCommission
                .saleOrganizationAgentType ??
              '';

            if (
              (this.renditionFromBE?.organizationCommission
                .saleOrganizationTeamId ||
                buyerAgent.teamId) &&
              !isNodeDO
            ) {
              agentSummary.type.name = 'TEAM_JUNIOR';
            }

            if (
              isNodeDO &&
              (!buyerAgent.teamId || buyerAgent.teamLeaderId === buyerAgent.id)
            ) {
              // Deducción comprador por tipo de agente (DO, sin team o TL)
              applyAgentTypeDeductionFromFirstSubtotal();
            } else if (!isNodeDO) {
              // Deducción comprador por tipo de agente (no DO, usa secondSubtotal)
              applyAgentTypeDeductionFromSecondSubtotal();
            }

            // Jurisdicción agente (siempre viene del form en este branch)
            applyAgentJurisdictionDeductionFromForm();
          } else if (this.renditionFromBE && isSameAgency) {
            // Tengo datos de BE y misma oficina, pero no buyerAgent válido
            if (isNodeDO) {
              agentSummary.type.original =
                AgentTypesArray.agentTypesArray[
                  buyerAgent?.agentLevelType ?? ''
                ] ?? '';
            } else {
              agentSummary.type.original =
                this.renditionFromBE.organizationCommission.saleOrganizationAgentType;
            }

            agentSummary.type.name =
              this.renditionFromBE.organizationCommission
                .saleOrganizationAgentType ?? '';

            if (
              this.renditionFromBE.organizationCommission.saleOrganizationTeamId
            ) {
              agentSummary.type.name = 'TEAM_JUNIOR';
            }

            // Deducción comprador por tipo de agente (siempre con firstSubtotal acá)
            applyAgentTypeDeductionFromFirstSubtotal();
          } else if (
            buyerSummary.otherRealEstateName ||
            buyerForm.buyerSharedWith === 'Otro'
          ) {
            agentSummary.type.name = '';
            agentSummary.type.usd = 0;
            agentSummary.type.local = 0;
            agentSummary.type.original = '';
          }
        }
      }

      // Envio al componente
      commissionSummary.buyerAgentCalculation();
      commissionSummary.buyerReferredCalculation();
      commissionSummary.officeCalculation();

      this.sellerAgentFirstSubtotalUSD =
        commissionSummary.seller.agent.firstSubtotal.usd;
      this.sellerAgentFirstSubtotalLocal =
        commissionSummary.seller.agent.firstSubtotal.local;
      this.sellerAgentSecondSubtotalUSD =
        commissionSummary.seller.agent.secondSubtotal.usd;
      this.sellerAgentSecondSubtotalLocal =
        commissionSummary.seller.agent.secondSubtotal.local;

      this.buyerAgentFirstSubtotalUSD =
        commissionSummary.buyer.agent.firstSubtotal.usd;
      this.buyerAgentFirstSubtotalLocal =
        commissionSummary.buyer.agent.firstSubtotal.local;
      this.buyerAgentSecondSubtotalUSD =
        commissionSummary.buyer.agent.secondSubtotal.usd;
      this.buyerAgentSecondSubtotalLocal =
        commissionSummary.buyer.agent.secondSubtotal.local;
    }

    ///////////////////////////////////////////////////////
    //////////////////// ABAO /////////////////////////////
    ///////////////////////////////////////////////////////

    if (jurisdiction && this.invoices.length > 0) {
      const MATCHES_BUYER_CLIENT = (client: string) =>
        invoiceMatchesBuyerClient(client, this.NODE === this.NODE_DO);

      const sellerTeamLeaderBillable = isTeamLeaderBillable(
        commissionSummary.seller.teamLeader,
      );
      const buyerTeamLeaderBillable = isTeamLeaderBillable(
        commissionSummary.buyer.teamLeader,
      );

      const officeClientSellerTeamLeader = this.invoices.filter(
        (e: InvoiceRendition) =>
          e.origin == this.AGENT_OFFICE &&
          e.agent == this.renditionForm.value.sellerTeamLeader &&
          invoiceMatchesSellerClient(e.client),
      );
      const officeClientBuyerTeamLeader = this.invoices.filter(
        (e: InvoiceRendition) =>
          e.origin == this.AGENT_OFFICE &&
          e.agent == this.renditionForm.value.buyerTeamLeader &&
          MATCHES_BUYER_CLIENT(e.client),
      );
      const officeClientSellerAgent = this.invoices.filter(
        (e: InvoiceRendition) =>
          e.origin == this.AGENT_OFFICE &&
          e.agent == this.renditionForm.value.sellerAgent &&
          invoiceMatchesSellerClient(e.client),
      );
      const officeClientBuyerAgent = this.invoices.filter(
        (e: InvoiceRendition) =>
          e.origin == this.AGENT_OFFICE &&
          e.agent == this.renditionForm.value.buyerAgent &&
          MATCHES_BUYER_CLIENT(e.client),
      );

      const POOL_SELLER_ABAO =
        sellerTeamLeaderBillable &&
        !this.isReferidoACobrar &&
        commissionSummary.seller.agent.type.original != 'RAPP';
      const POOL_BUYER_ABAO =
        buyerTeamLeaderBillable &&
        commissionSummary.buyer.agent.type.original != 'RAPP';

      if (POOL_SELLER_ABAO) {
        const POOLED_ABAO = this.resolveABAO(
          this.mergeAgentOfficeInvoices(
            officeClientSellerAgent,
            officeClientSellerTeamLeader,
          ),
          (commissionSummary.seller.agent.netCommission.local ?? 0) +
            (commissionSummary.seller.teamLeader.netCommission.local ?? 0),
          jurisdiction.previsionalCash,
        );
        const SPLIT = this.splitPooledAbao(
          POOLED_ABAO,
          commissionSummary.seller.agent.netCommission,
          commissionSummary.seller.teamLeader.netCommission,
        );
        commissionSummary.seller.agent.abao.usd = SPLIT.agent.usd;
        commissionSummary.seller.agent.abao.local = SPLIT.agent.local;
        commissionSummary.seller.teamLeader.abao.usd = SPLIT.teamLeader.usd;
        commissionSummary.seller.teamLeader.abao.local = SPLIT.teamLeader.local;
      } else {
        const sellerTeamLeaderAbao = this.resolveABAO(
          officeClientSellerTeamLeader,
          commissionSummary.seller.teamLeader.netCommission.local,
          jurisdiction.previsionalCash,
        );

        commissionSummary.seller.teamLeader.abao.usd =
          sellerTeamLeaderAbao.usd ?? 0;
        commissionSummary.seller.teamLeader.abao.local =
          sellerTeamLeaderAbao.local ?? 0;
      }

      if (POOL_BUYER_ABAO) {
        const POOLED_ABAO = this.resolveABAO(
          this.mergeAgentOfficeInvoices(
            officeClientBuyerAgent,
            officeClientBuyerTeamLeader,
          ),
          (commissionSummary.buyer.agent.netCommission.local ?? 0) +
            (commissionSummary.buyer.teamLeader.netCommission.local ?? 0),
          jurisdiction.previsionalCash,
        );
        const SPLIT = this.splitPooledAbao(
          POOLED_ABAO,
          commissionSummary.buyer.agent.netCommission,
          commissionSummary.buyer.teamLeader.netCommission,
        );
        commissionSummary.buyer.agent.abao.usd = SPLIT.agent.usd;
        commissionSummary.buyer.agent.abao.local = SPLIT.agent.local;
        commissionSummary.buyer.teamLeader.abao.usd = SPLIT.teamLeader.usd;
        commissionSummary.buyer.teamLeader.abao.local = SPLIT.teamLeader.local;
      } else {
        const buyerTeamLeaderAbao = this.resolveABAO(
          officeClientBuyerTeamLeader,
          commissionSummary.buyer.teamLeader.netCommission.local,
          jurisdiction.previsionalCash,
        );

        commissionSummary.buyer.teamLeader.abao.usd =
          buyerTeamLeaderAbao.usd ?? 0;
        commissionSummary.buyer.teamLeader.abao.local =
          buyerTeamLeaderAbao.local ?? 0;
      }

      // Referido vendedor
      const officeClientSellerReferred = this.invoices.filter(
        (e: InvoiceRendition) =>
          e.origin == this.AGENT_OFFICE &&
          e.agent == this.renditionForm.value.sellerReferredName &&
          invoiceMatchesSellerClient(e.client),
      );

      if (commissionSummary.seller.referred.type.original != 'RAPP') {
        const sellerReferredAbao = this.resolveABAO(
          officeClientSellerReferred,
          commissionSummary.seller.referred.netCommission.local,
          jurisdiction.previsionalCash,
        );
        commissionSummary.seller.referred.abao.usd =
          sellerReferredAbao.usd ?? 0;
        commissionSummary.seller.referred.abao.local =
          sellerReferredAbao.local ?? 0;
      }

      // Referido comprador

      if (commissionSummary.buyer.referred.type.original != 'RAPP') {
        const officeClientBuyerReferred = this.invoices.filter(
          (e: InvoiceRendition) =>
            e.origin == this.AGENT_OFFICE &&
            e.agent == this.renditionForm.value.buyerReferredName &&
            MATCHES_BUYER_CLIENT(e.client),
        );

        const buyerReferredAbao = this.resolveABAO(
          officeClientBuyerReferred,
          commissionSummary.buyer.referred.netCommission.local,
          jurisdiction.previsionalCash,
        );
        commissionSummary.buyer.referred.abao.usd = buyerReferredAbao.usd ?? 0;
        commissionSummary.buyer.referred.abao.local =
          buyerReferredAbao.local ?? 0;
      }

      // Agente vendedor abao
      if (
        !POOL_SELLER_ABAO &&
        commissionSummary.seller.agent.type.original != 'RAPP'
      ) {
        if (this.isReferidoACobrar) {
          const sellerAgentAbao = this.resolveABAO(
            officeClientSellerAgent,
            commissionSummary.referred.netCommission.local,
            jurisdiction.previsionalCash,
          );

          commissionSummary.referred.abao.usd = sellerAgentAbao.usd ?? 0;
          commissionSummary.referred.abao.local = sellerAgentAbao.local ?? 0;
        } else {
          const sellerAgentAbao = this.resolveABAO(
            officeClientSellerAgent,
            commissionSummary.seller.agent.netCommission.local,
            jurisdiction.previsionalCash,
          );
          commissionSummary.seller.agent.abao.usd = sellerAgentAbao.usd ?? 0;
          commissionSummary.seller.agent.abao.local =
            sellerAgentAbao.local ?? 0;
        }
      }

      if (
        !POOL_BUYER_ABAO &&
        commissionSummary.buyer.agent.type.original != 'RAPP'
      ) {
        const buyerAgentAbao = this.resolveABAO(
          officeClientBuyerAgent,
          commissionSummary.buyer.agent.netCommission.local,
          jurisdiction.previsionalCash,
        );
        commissionSummary.buyer.agent.abao.usd = buyerAgentAbao.usd ?? 0;
        commissionSummary.buyer.agent.abao.local = buyerAgentAbao.local ?? 0;
      }
    }
    ///////////////////////////////////////////////////////
    //////////////////// FINAL ////////////////////////////
    ///////////////////////////////////////////////////////

    // Comision Neta
    commissionSummary.referred.netCommission.usd =
      commissionSummary.referred.firstSubtotal.usd -
      commissionSummary.referred.deduction.usd -
      commissionSummary.referred.type.usd -
      commissionSummary.referred.abao.usd;
    commissionSummary.referred.netCommission.local =
      commissionSummary.referred.firstSubtotal.local -
      commissionSummary.referred.deduction.local -
      commissionSummary.referred.type.local -
      commissionSummary.referred.abao.local;

    commissionSummary.sellerAgentCalculation();
    commissionSummary.sellerReferredCalculation();
    commissionSummary.sellerTeamLeaderCalculation();

    commissionSummary.buyerAgentCalculation();
    commissionSummary.buyerReferredCalculation();
    commissionSummary.buyerTeamLeaderCalculation();

    commissionSummary.officeCalculation();

    const rawOffice =
      commissionSummary.office.rawCommission.usd +
      commissionSummary.office.rawCommission.local /
        this.renditionForm.value.exchangeRate;
    const rawOperation =
      commissionSummary.closedPrice.usd ||
      0 +
        (commissionSummary.closedPrice.local ?? 0) /
          this.renditionForm.value.exchangeRate;

    commissionSummary.office.rawCommission.percentage =
      (rawOffice / rawOperation) * 100;

    const subtotalOffice =
      commissionSummary.office.subtotal.usd +
      commissionSummary.office.subtotal.local /
        this.renditionForm.value.exchangeRate;

    commissionSummary.office.subtotal.percentage =
      (subtotalOffice / rawOperation) * 100;

    commissionSummary.iva = this.commissionCheckout.iva;

    const agentBillingsLength = this.renditionFromBE?.agentBillings.length ?? 0;
    const billingsLength = this.renditionFromBE?.billings.length ?? 0;
    const agentPaymentsLength = this.renditionFromBE?.agentPayments.length ?? 0;

    this.commissionCheckout = { ...commissionSummary } as CommissionSummary;

    if (
      (this.renditionForm.value.closePriceUSD > 0 ||
        this.renditionForm.value.closePriceLocal > 0) &&
      this.invoices.length >=
        agentBillingsLength + billingsLength + agentPaymentsLength &&
      this.invoices.length > 0
    ) {
      this.validateCapsInvoices();
    }

    if (
      this.invoicesCapsAreValid &&
      (this.renditionForm.value.closePriceUSD > 0 ||
        this.renditionForm.value.closePriceLocal > 0)
    )
      this.validateNetCommissions();

    if (this.invoices?.length > 0) this.validateVoucherType();

    if (this.isReferidoACobrar) {
      commissionSummary.office.rawCommission.usd =
        commissionSummary.closedPrice.usd;
      commissionSummary.office.netCommission.usd =
        commissionSummary.office.rawCommission.usd -
        commissionSummary.referred.netCommission.usd;

      commissionSummary.office.rawCommission.percentage = 100;

      commissionSummary.office.rawCommission.local =
        commissionSummary.closedPrice.local;
      commissionSummary.office.netCommission.local =
        commissionSummary.office.rawCommission.local -
        commissionSummary.referred.netCommission.local;

      commissionSummary.office.subtotal.local =
        commissionSummary.office.netCommission.local;
      commissionSummary.office.subtotal.usd =
        commissionSummary.office.netCommission.usd;
    }

    // Computo de estadisticas: no aplica a Referido a cobrar ni a Ingreso relacionado
    if (isNodeDO && !this.isReferidoACobrar && !this.isIngresoRelacionado) {
      commissionSummary.statistics = buildStatisticsSummary(
        commissionSummary,
        this.statisticsCheckTeamLeader,
        this.renditionForm.value.exchangeRate ?? 0,
      );
    }

    this.changeCommissionSummary.emit(commissionSummary);
    this.commissionCheckout = { ...commissionSummary } as CommissionSummary;
    this.checkValidityRenditionForm();
  }

  roundTwoDecimals(num: number) {
    return Math.round(num * 100) / 100;
    // return num;
  }

  validateVoucherType() {
    this.voucherTypeValid = true;
    this.invoices.forEach((e: InvoiceRendition) => {
      this.voucherTypeValid =
        this.voucherTypeValid &&
        e.invoiceType !== 'Ninguno' &&
        e.invoiceType !== '';
    });
    // ABRIR DIALOGO
    if (!this.voucherTypeValid) {
      this.dialogWarningForInvalidCapsInvoices = {
        ...this.dialogWarningForInvalidCapsInvoices,
        value: { type: 'VOUCHER' },
        isVisible: true,
      };
    }
  }

  validateNetCommissionsReferidoACobrar(): boolean {
    return (
      (this.isReferidoACobrar &&
        this.renditionForm.value.closePriceUSD > 0 &&
        this.commissionCheckout.referred.netCommission.usd >= 0) ||
      (this.renditionForm.value.closePriceLocal > 0 &&
        this.commissionCheckout.referred.netCommission.local >= 0)
    );
  }

  validateNetCommissionsSellerAgent(): boolean {
    return (
      (this.renditionForm.value.closePriceUSD > 0 &&
        this.commissionCheckout.seller.agent.netCommission.usd >= 0) ||
      (this.renditionForm.value.closePriceLocal > 0 &&
        this.commissionCheckout.seller.agent.netCommission.local >= 0)
    );
  }

  validateNetCommissionsSellerReferred(): boolean {
    return (
      (this.renditionForm.value.closePriceUSD > 0 &&
        this.commissionCheckout.seller.referred.netCommission.usd >= 0) ||
      (this.renditionForm.value.closePriceLocal > 0 &&
        this.commissionCheckout.seller.referred.netCommission.local >= 0)
    );
  }

  validateNetCommissionsBuyerAgent(): boolean {
    return (
      (this.renditionForm.value.closePriceUSD > 0 &&
        this.commissionCheckout.buyer.agent.netCommission.usd >= 0) ||
      (this.renditionForm.value.closePriceLocal > 0 &&
        this.commissionCheckout.buyer.agent.netCommission.local >= 0)
    );
  }

  validateNetCommissionsBuyerReferred(): boolean {
    return (
      (this.renditionForm.value.closePriceUSD > 0 &&
        this.commissionCheckout.buyer.referred.netCommission.usd >= 0) ||
      (this.renditionForm.value.closePriceLocal > 0 &&
        this.commissionCheckout.buyer.referred.netCommission.local >= 0)
    );
  }

  validateNetCommissions() {
    let referidoACobrar = !this.isReferidoACobrar;
    let sellerAgent = true;
    let buyerAgent = true;
    let buyerReferred = true;
    let sellerReferred = true;

    if (this.isReferidoACobrar) {
      referidoACobrar = this.validateNetCommissionsReferidoACobrar();
    } else {
      // Comision Neta VENDEDOR AGENTE
      sellerAgent = this.validateNetCommissionsSellerAgent();
      // Comision Neta VENDEDOR REFERIDO
      sellerReferred = this.validateNetCommissionsSellerReferred();
      // Comision Neta COMPRADOR AGENTE
      buyerAgent = this.validateNetCommissionsBuyerAgent();
      // Comision Neta COMPRADOR REFERIDO
      buyerReferred = this.validateNetCommissionsBuyerReferred();
    }

    const isValid =
      sellerAgent &&
      sellerReferred &&
      buyerAgent &&
      buyerReferred &&
      referidoACobrar;

    if (isValid != this.netCommissionsAreValid) {
      this.netCommissionsAreValid = isValid;
      if (!this.netCommissionsAreValid) {
        const dto = {
          seller: !sellerAgent,
          buyer: !buyerAgent,
          sellerReferred: !sellerReferred,
          buyerReferred: !buyerReferred,
          referidoACobrar: !referidoACobrar,
        };

        // ABRIR DIALOGO
        if (!isValid) {
          this.dialogWarningForInvalidCapsInvoices = {
            ...this.dialogWarningForInvalidCapsInvoices,
            value: { dto: dto, type: 'netcommissions' },
            isVisible: true,
          };
        }
      }
    }

    if (isValid && this.netCommissionsAreValid) {
      this.dialogWarningForInvalidCapsInvoices = {
        ...this.dialogWarningForInvalidCapsInvoices,
        isVisible: false,
      };
    }
  }

  onAddInvoices($event: any) {
    this.invoices = [];
    if ($event) {
      this.invoices = [...$event.invoices];
      this.resolveInvoices();
      this.cajaPrev = $event.cajaPrev;
    }
    this.resolveIVA(this.invoices);
    this.formatForCheckout();
  }

  validateCapsInvoices() {
    let validAgentReferidoACobrar = true;
    let validAgentOfficeSeller = true;
    let validAgentOfficeSellerReferred = true;
    let validAgentOfficeBuyer = true;
    let validAgentOfficeBuyerReferred = true;

    const EXCHANGE_RATE = this.renditionForm.value.exchangeRate;
    const PREVISIONAL = this.getInvoiceCapPrevisional();
    const AGENT_OFFICE_INVOICES = this.invoices.filter(
      (e: InvoiceRendition) => e.origin == this.AGENT_OFFICE,
    );

    if (this.isReferidoACobrar) {
      if (
        (AGENT_OFFICE_INVOICES.length > 0 &&
          this.commissionCheckout.referred.netCommission.usd > 0) ||
        this.commissionCheckout.referred.netCommission.local > 0
      ) {
        validAgentReferidoACobrar = invoicesWithinCap(
          AGENT_OFFICE_INVOICES,
          this.getReferidoACobrarCapUsd(PREVISIONAL),
          EXCHANGE_RATE,
        );
      }
    }

    if (!this.isReferidoACobrar) {
      let sellerAgentUSD =
        (this.renditionFromBE?.purchaseOrganizationAmountCommissionUSD ?? 0) >
          this.commissionCheckout.seller.agent.netCommission.usd &&
        (this.renditionFromBE?.totalAmountOperationUSD ?? 0) ==
          this.commissionCheckout.closedPrice.usd &&
        this.sellerRelation ==
          this.renditionFromBE?.purchaseRelationshipPercentage
          ? (this.renditionFromBE?.purchaseOrganizationAmountCommissionUSD ?? 0)
          : (this.commissionCheckout.seller.agent.netCommission.usd ?? 0);

      // if (sellerAgentUSD > 0)
      //   sellerAgentUSD = Math.round(sellerAgentUSD * 100) / 100;

      let sellerAgentLocal =
        (this.renditionFromBE?.purchaseOrganizationAmountCommissionARS ?? 0) >
          this.commissionCheckout.seller.agent.netCommission.local &&
        (this.renditionFromBE?.totalAmountOperationARS ?? 0) ==
          this.commissionCheckout.closedPrice.local &&
        this.sellerRelation ==
          this.renditionFromBE?.purchaseRelationshipPercentage
          ? (this.renditionFromBE?.purchaseOrganizationAmountCommissionARS ?? 0)
          : (this.commissionCheckout.seller.agent.netCommission.local ?? 0);

      // if (sellerAgentLocal > 0)
      //   sellerAgentLocal = Math.round(sellerAgentLocal * 100) / 100;

      const sellerPoolContext = getAgentOfficePoolCapContext({
        checkout: this.commissionCheckout,
        side: 'seller',
        agentFormName: this.renditionForm.value.sellerAgent,
        teamLeaderFormName: this.renditionForm.value.sellerTeamLeader,
        exchangeRate: EXCHANGE_RATE,
        previsional: PREVISIONAL,
        agentNetCommissionUsd: sellerAgentUSD,
        agentNetCommissionLocal: sellerAgentLocal,
      });

      const agentOfficeSeller = filterAgentOfficeInvoicesForPool(
        AGENT_OFFICE_INVOICES,
        sellerPoolContext.poolAgentNames,
        invoiceMatchesSellerClient,
      );

      if (
        agentOfficeSeller.length > 0 &&
        (this.commissionCheckout.seller.agent.netCommission.usd > 0 ||
          this.commissionCheckout.seller.agent.netCommission.local > 0 ||
          this.commissionCheckout.seller.teamLeader.netCommission.usd > 0 ||
          this.commissionCheckout.seller.teamLeader.netCommission.local > 0)
      ) {
        let sellerCapUSD =
          this.renditionForm.value.sellerOffice == this.user?.agency_name
            ? sellerPoolContext.expensesCap
            : 0;

        // if (sellerCapUSD > 0)
        //   sellerCapUSD = Math.round(sellerCapUSD * 100) / 100;

        validAgentOfficeSeller = invoicesWithinCap(
          agentOfficeSeller,
          sellerCapUSD,
          EXCHANGE_RATE,
        );
      }

      const agentOfficeSellerReferred = AGENT_OFFICE_INVOICES.filter(
        (e: InvoiceRendition) =>
          e.agent == this.renditionForm.value.sellerReferredName &&
          invoiceMatchesSellerClient(e.client),
      );

      if (
        agentOfficeSellerReferred.length > 0 &&
        (this.commissionCheckout.seller.referred.netCommission.usd > 0 ||
          this.commissionCheckout.seller.referred.netCommission.local > 0)
      ) {
        let sellerReferredCapUSD =
          this.sellerReferredSharedWith.optionSelected == 0
            ? calculateAgentExpensesCap(
                this.commissionCheckout.seller.referred.netCommission.usd +
                  (this.commissionCheckout.seller.referred.abao.usd > 0
                    ? this.commissionCheckout.seller.referred.abao.usd
                    : 0),
                this.commissionCheckout.seller.referred.netCommission.local +
                  (this.commissionCheckout.seller.referred.abao.local > 0
                    ? this.commissionCheckout.seller.referred.abao.local
                    : 0),
                this.commissionCheckout.seller.referred.type.original,
                EXCHANGE_RATE,
                PREVISIONAL,
              )
            : 0;

        // if (sellerReferredCapUSD > 0)
        //   sellerReferredCapUSD = Math.round(sellerReferredCapUSD * 100) / 100;

        validAgentOfficeSellerReferred = invoicesWithinCap(
          agentOfficeSellerReferred,
          sellerReferredCapUSD,
          EXCHANGE_RATE,
        );
      }

      let buyerAgentUSD =
        (this.renditionFromBE?.saleOrganizationAmountCommissionUSD ?? 0) >
          this.commissionCheckout.buyer.agent.netCommission.usd &&
        (this.renditionFromBE?.totalAmountOperationUSD ?? 0) ==
          this.commissionCheckout.closedPrice.usd &&
        this.sellerRelation ==
          this.renditionFromBE?.purchaseRelationshipPercentage
          ? (this.renditionFromBE?.saleOrganizationAmountCommissionUSD ?? 0)
          : (this.commissionCheckout.buyer.agent.netCommission.usd ?? 0);

      // if (buyerAgentUSD > 0)
      //   buyerAgentUSD = Math.round(buyerAgentUSD * 100) / 100;

      let buyerAgentLocal =
        (this.renditionFromBE?.saleOrganizationAmountCommissionARS ?? 0) >
          this.commissionCheckout.buyer.agent.netCommission.local &&
        (this.renditionFromBE?.totalAmountOperationARS ?? 0) ==
          this.commissionCheckout.closedPrice.local &&
        this.sellerRelation ==
          this.renditionFromBE?.purchaseRelationshipPercentage
          ? (this.renditionFromBE?.saleOrganizationAmountCommissionARS ?? 0)
          : (this.commissionCheckout.buyer.agent.netCommission.local ?? 0);

      // if (buyerAgentLocal > 0)
      //   buyerAgentLocal = Math.round(buyerAgentLocal * 100) / 100;

      const buyerPoolContext = getAgentOfficePoolCapContext({
        checkout: this.commissionCheckout,
        side: 'buyer',
        agentFormName: this.renditionForm.value.buyerAgent,
        teamLeaderFormName: this.renditionForm.value.buyerTeamLeader,
        exchangeRate: EXCHANGE_RATE,
        previsional: PREVISIONAL,
        agentNetCommissionUsd: buyerAgentUSD,
        agentNetCommissionLocal: buyerAgentLocal,
      });
      const agentOfficeBuyer = filterAgentOfficeInvoicesForPool(
        AGENT_OFFICE_INVOICES,
        buyerPoolContext.poolAgentNames,
        (client) =>
          invoiceMatchesBuyerClient(client, this.NODE === this.NODE_DO),
      );

      if (
        agentOfficeBuyer.length > 0 &&
        (this.commissionCheckout.buyer.agent.netCommission.usd > 0 ||
          this.commissionCheckout.buyer.agent.netCommission.local > 0 ||
          this.commissionCheckout.buyer.teamLeader.netCommission.usd > 0 ||
          this.commissionCheckout.buyer.teamLeader.netCommission.local > 0)
      ) {
        let buyerCapUSD =
          this.renditionForm.value.buyerOffice == this.user?.agency_name
            ? buyerPoolContext.expensesCap
            : 0;

        // if (buyerCapUSD > 0) buyerCapUSD = Math.round(buyerCapUSD * 100) / 100;

        validAgentOfficeBuyer = invoicesWithinCap(
          agentOfficeBuyer,
          buyerCapUSD,
          EXCHANGE_RATE,
        );
      }

      const agentOfficeBuyerReferred = AGENT_OFFICE_INVOICES.filter(
        (e: InvoiceRendition) =>
          e.agent == this.renditionForm.value.buyerReferredName &&
          invoiceMatchesBuyerClient(e.client, this.NODE === this.NODE_DO),
      );

      if (
        agentOfficeBuyerReferred.length > 0 &&
        (this.commissionCheckout.buyer.referred.netCommission.usd > 0 ||
          this.commissionCheckout.buyer.referred.netCommission.local > 0)
      ) {
        let buyerReferredCapUSD =
          this.buyerReferredSharedWith.optionSelected == 0
            ? calculateAgentExpensesCap(
                this.commissionCheckout.buyer.referred.netCommission.usd +
                  (this.commissionCheckout.buyer.referred.abao.usd > 0
                    ? this.commissionCheckout.buyer.referred.abao.usd
                    : 0),
                this.commissionCheckout.buyer.referred.netCommission.local +
                  (this.commissionCheckout.buyer.referred.abao.local > 0
                    ? this.commissionCheckout.buyer.referred.abao.local
                    : 0),
                this.commissionCheckout.buyer.referred.type.original,
                EXCHANGE_RATE,
                PREVISIONAL,
              )
            : 0;

        // if (buyerReferredCapUSD > 0)
        //   buyerReferredCapUSD = Math.round(buyerReferredCapUSD * 100) / 100;

        validAgentOfficeBuyerReferred = invoicesWithinCap(
          agentOfficeBuyerReferred,
          buyerReferredCapUSD,
          EXCHANGE_RATE,
        );
      }
    }

    const isValid =
      validAgentReferidoACobrar &&
      validAgentOfficeSeller &&
      validAgentOfficeSellerReferred &&
      validAgentOfficeBuyer &&
      validAgentOfficeBuyerReferred;

    if (isValid != this.invoicesCapsAreValid) {
      this.invoicesCapsAreValid = isValid;
      if (!this.invoicesCapsAreValid) {
        const dto = {
          seller: !validAgentOfficeSeller,
          buyer: !validAgentOfficeBuyer,
          sellerReferred: !validAgentOfficeSellerReferred,
          buyerReferred: !validAgentOfficeBuyerReferred,
          referidoACobrar: !validAgentReferidoACobrar,
        };

        if (!isValid) {
          this.dialogWarningForInvalidCapsInvoices = {
            ...this.dialogWarningForInvalidCapsInvoices,
            value: { dto: dto, type: 'invoices' },
            isVisible: true,
          };
        }
      } else {
        this.dialogWarningForInvalidCapsInvoices = {
          ...this.dialogWarningForInvalidCapsInvoices,
          isVisible: false,
        };
      }
    }
  }

  private getInvoiceCapPrevisional(): number {
    const jurisdiction = this.jurisdictions?.find(
      (e) => e.name == this.renditionForm.value.jurisdiction,
    );
    return jurisdiction?.previsionalCash ?? 0;
  }

  private getReferidoACobrarCapUsd(previsional: number): number {
    const referred = this.commissionCheckout.referred;
    return calculateAgentExpensesCap(
      referred.netCommission.usd +
        (referred.abao.usd > 0 ? referred.abao.usd : 0),
      referred.netCommission.local +
        (referred.abao.local > 0 ? referred.abao.local : 0),
      referred.type.original,
      this.renditionForm.value.exchangeRate,
      previsional,
    );
  }

  resolveIVA(invoices: InvoiceRendition[]) {
    this.commissionCheckout.iva.office.usd = 0;
    this.commissionCheckout.iva.office.local = 0;
    this.commissionCheckout.iva.agent.usd = 0;
    this.commissionCheckout.iva.agent.local = 0;
    invoices.forEach((e: InvoiceRendition) => {
      if (e.origin == this.OFFICE_CLIENT) {
        const invoiceBE = new InvoiceRenditionBilling(e);
        this.commissionCheckout.iva.office.usd += Number(
          invoiceBE.subtotalIVAUSD,
        );
        this.commissionCheckout.iva.office.local += Number(
          invoiceBE.subtotalIVAARS,
        );
      } else if (e.origin == this.AGENT_OFFICE) {
        const invoiceBE = new InvoiceRenditionAgentPayment(e);
        this.commissionCheckout.iva.agent.usd += Number(
          invoiceBE.subtotalIVAUSD,
        );
        this.commissionCheckout.iva.agent.local += Number(
          invoiceBE.subtotalIVAARS,
        );
      }
    });
  }

  resolveInvoices() {
    this.rendition ??= new RenditionModel();
    this.rendition.agentPayments = [];
    this.rendition.billings = [];
    const filteredInvoices = this.invoices.filter(
      (e: InvoiceRendition) => e.origin != this.AGENT_CLIENT,
    );
    // Caso donde hay solo moneda LOCAL
    if (
      (this.renditionForm.value.sellerUSD == 0 &&
        this.renditionForm.value.closePriceUSD == 0 &&
        this.renditionForm.value.buyerUSD == 0 &&
        this.renditionForm.value.closePriceLocal > 0) ||
      // Caso donde hay solo moneda USD

      (this.renditionForm.value.sellerLocal == 0 &&
        this.renditionForm.value.closePriceLocal == 0 &&
        this.renditionForm.value.buyerLocal == 0 &&
        this.renditionForm.value.closePriceUSD > 0)
    ) {
      filteredInvoices.forEach((e: InvoiceRendition) => {
        let newAmount = e.amount;
        if (e.overbilled > 0) newAmount = e.amount - e.overbilled;
        let invoiceBE: InvoiceRenditionBilling | InvoiceRenditionAgentPayment =
          e.origin == this.OFFICE_CLIENT
            ? new InvoiceRenditionBilling(e)
            : new InvoiceRenditionAgentPayment(e);
        if (e.amountCurrency != 'U$S' && e.amountCurrency != 'USD') {
          invoiceBE.subtotalARS = newAmount;
          invoiceBE.totalARS =
            Number(invoiceBE.subtotalIVAARS) + Number(invoiceBE.subtotalARS);
        } else {
          invoiceBE.subtotalUSD = newAmount;
          invoiceBE.totalUSD =
            Number(invoiceBE.subtotalUSD) + Number(invoiceBE.subtotalIVAUSD);
        }
        // Es OFICINA AL CLIENTE
        if (e.origin == this.OFFICE_CLIENT) {
          this.rendition?.billings.push(invoiceBE as InvoiceRenditionBilling);
        } else {
          const agentItem = this.fullAgentList.find(
            (agent: Agent) => agent.agentName == e.agent,
          );
          invoiceBE = invoiceBE as InvoiceRenditionAgentPayment;
          if (agentItem) invoiceBE.organizationId = agentItem.id;
          // Es AGENTE A LA OFICINA
          this.rendition?.agentPayments.push(invoiceBE);
        }
      });
    } else {
      // Caso donde hay ambas monedas
      const officeClientSellerTeamLeader = this.invoices.filter(
        (e: InvoiceRendition) =>
          e.origin == this.AGENT_OFFICE &&
          e.agent == this.renditionForm.value.sellerTeamLeader &&
          e.client == 'Vendedor',
      );
      if (officeClientSellerTeamLeader?.length > 0)
        this.rendition.agentPayments = [
          ...this.rendition.agentPayments,
          ...this.resolveCaps(
            officeClientSellerTeamLeader,
            this.commissionCheckout.seller.teamLeader.netCommission.usd,
            this.commissionCheckout.seller.teamLeader.netCommission.local,
          ),
        ];

      const officeClientBuyerTeamLeader = this.invoices.filter(
        (e: InvoiceRendition) =>
          e.origin == this.AGENT_OFFICE &&
          e.agent == this.renditionForm.value.buyerTeamLeader &&
          e.client == 'Comprador',
      );
      if (officeClientBuyerTeamLeader?.length > 0)
        this.rendition.agentPayments = [
          ...this.rendition.agentPayments,
          ...this.resolveCaps(
            officeClientBuyerTeamLeader,
            this.commissionCheckout.buyer.teamLeader.netCommission.usd,
            this.commissionCheckout.buyer.teamLeader.netCommission.local,
          ),
        ];

      const officeClientSellerReferred = this.invoices.filter(
        (e: InvoiceRendition) =>
          e.origin == this.AGENT_OFFICE &&
          e.agent == this.renditionForm.value.sellerReferredName &&
          e.client == 'Vendedor',
      );
      if (officeClientSellerReferred?.length > 0)
        this.rendition.agentPayments = [
          ...this.rendition.agentPayments,
          ...this.resolveCaps(
            officeClientSellerReferred,
            this.commissionCheckout.seller.referred.netCommission.usd,
            this.commissionCheckout.seller.referred.netCommission.local,
          ),
        ];

      const officeClientBuyerReferred = this.invoices.filter(
        (e: InvoiceRendition) =>
          e.origin == this.AGENT_OFFICE &&
          e.agent == this.renditionForm.value.buyerReferredName &&
          e.client == 'Comprador',
      );

      if (officeClientBuyerReferred?.length > 0)
        this.rendition.agentPayments = [
          ...this.rendition.agentPayments,
          ...this.resolveCaps(
            officeClientBuyerReferred,
            this.commissionCheckout.buyer.referred.netCommission.usd,
            this.commissionCheckout.buyer.referred.netCommission.local,
          ),
        ];

      const officeClientSellerAgent = this.invoices.filter(
        (e: InvoiceRendition) =>
          e.origin == this.AGENT_OFFICE &&
          e.agent == this.renditionForm.value.sellerAgent &&
          e.client == 'Vendedor',
      );

      if (officeClientSellerAgent?.length > 0)
        this.rendition.agentPayments = [
          ...this.rendition.agentPayments,
          ...this.resolveCaps(
            officeClientSellerAgent,
            this.commissionCheckout.seller.agent.netCommission.usd,
            this.commissionCheckout.seller.agent.netCommission.local,
          ),
        ];

      const officeClientBuyerAgent = this.invoices.filter(
        (e: InvoiceRendition) =>
          e.origin == this.AGENT_OFFICE &&
          e.agent == this.renditionForm.value.buyerAgent &&
          e.client == 'Comprador',
      );

      if (officeClientBuyerAgent?.length > 0)
        this.rendition.agentPayments = [
          ...this.rendition.agentPayments,
          ...this.resolveCaps(
            officeClientBuyerAgent,
            this.commissionCheckout.buyer.agent.netCommission.usd,
            this.commissionCheckout.buyer.agent.netCommission.local,
          ),
        ];

      const officeClient = this.invoices.filter(
        (e: InvoiceRendition) => e.origin == this.OFFICE_CLIENT,
      );

      if (officeClient?.length > 0)
        this.rendition.billings = [
          ...this.rendition.billings,
          ...this.resolveCaps(
            officeClient,
            this.commissionCheckout.office.subtotal.usd,
            this.commissionCheckout.office.subtotal.local,
          ),
        ];
    }
  }

  resolveCaps(
    invoices: InvoiceRendition[],
    capUSD: number,
    capLocal: number,
  ): any[] {
    const array: any[] = [];
    invoices.forEach((e: InvoiceRendition) => {
      let newAmount = e.amount;
      if (e.overbilled > 0) newAmount = e.amount - e.overbilled;
      let invoiceBE: InvoiceRenditionBilling | InvoiceRenditionAgentPayment =
        e.origin == this.OFFICE_CLIENT
          ? new InvoiceRenditionBilling(e)
          : new InvoiceRenditionAgentPayment(e);
      if (e.amountCurrency != 'U$S' && e.amountCurrency != 'USD') {
        invoiceBE.subtotalARS = newAmount;
        invoiceBE.totalARS =
          Number(invoiceBE.subtotalIVAARS) + Number(invoiceBE.subtotalARS);
      } else {
        invoiceBE.subtotalUSD = newAmount;
        invoiceBE.totalUSD =
          Number(invoiceBE.subtotalUSD) + Number(invoiceBE.subtotalIVAUSD);
      }

      if (e.origin == this.AGENT_OFFICE) {
        invoiceBE = invoiceBE as InvoiceRenditionAgentPayment;
        const agent = this.fullAgentList.find(
          (item: Agent) => item.agentName == e.agent,
        );
        if (agent) invoiceBE.organizationId = agent.id;
      }

      array.push(invoiceBE);
    });
    return array;
  }

  // resolveCaps2(
  //   invoices: InvoiceRendition[],
  //   capUSD: number,
  //   capLocal: number
  // ): any[] {
  //   const array: any[] = [];

  //   invoices.forEach((e: InvoiceRendition) => {
  //     debugger;
  //     let newAmount = e.amount;
  //     if (e.overbilled > 0) newAmount = e.amount - e.overbilled;
  //     let invoiceBE: InvoiceRenditionBilling | InvoiceRenditionAgentPayment =
  //       e.origin == this.OFFICE_CLIENT
  //         ? new InvoiceRenditionBilling(e)
  //         : new InvoiceRenditionAgentPayment(e);

  //     e.amountCurrency != 'U$S'
  //       ? (newAmount = newAmount / this.renditionForm.value.exchangeRate)
  //       : (newAmount = newAmount);
  //     capUSD = capUSD - newAmount;
  //     if (capUSD < 0) {
  //       invoiceBE.subtotalUSD = newAmount - Math.abs(capUSD);
  //       invoiceBE.subtotalARS =
  //         Math.abs(capUSD) * this.renditionForm.value.exchangeRate;
  //     } else {
  //       invoiceBE.subtotalUSD = newAmount;
  //       invoiceBE.subtotalARS = 0;
  //     }

  //     invoiceBE.totalUSD =
  //       Number(invoiceBE.subtotalUSD) + Number(invoiceBE.subtotalIVAUSD);
  //     invoiceBE.totalARS = Number(
  //       invoiceBE.subtotalIVAARS + Number(invoiceBE.subtotalARS)
  //     );
  //     array.push(invoiceBE);
  //   });
  //   return array;
  // }

  private mergeAgentOfficeInvoices(
    agentInvoices: InvoiceRendition[],
    teamLeaderInvoices: InvoiceRendition[],
  ): InvoiceRendition[] {
    const MERGED = [...agentInvoices];
    teamLeaderInvoices.forEach((invoice) => {
      if (!MERGED.includes(invoice)) {
        MERGED.push(invoice);
      }
    });
    return MERGED;
  }

  private splitPooledAbao(
    pooled: { usd: number; local: number },
    agentNet: { usd: number; local: number },
    teamLeaderNet: { usd: number; local: number },
  ): {
    agent: { usd: number; local: number };
    teamLeader: { usd: number; local: number };
  } {
    const splitAmount = (
      total: number,
      agentShare: number,
      teamLeaderShare: number,
    ): { agent: number; teamLeader: number } => {
      const POOLED_NET = agentShare + teamLeaderShare;
      if (total <= 0 || POOLED_NET <= 0) {
        return { agent: 0, teamLeader: 0 };
      }

      const AGENT_PART = Math.min(
        total * (agentShare / POOLED_NET),
        agentShare,
      );
      const TEAM_LEADER_PART = Math.min(total - AGENT_PART, teamLeaderShare);
      return { agent: AGENT_PART, teamLeader: TEAM_LEADER_PART };
    };

    const LOCAL = splitAmount(
      pooled.local ?? 0,
      agentNet.local ?? 0,
      teamLeaderNet.local ?? 0,
    );
    const USD = splitAmount(
      pooled.usd ?? 0,
      agentNet.usd ?? 0,
      teamLeaderNet.usd ?? 0,
    );

    return {
      agent: { usd: USD.agent, local: LOCAL.agent },
      teamLeader: { usd: USD.teamLeader, local: LOCAL.teamLeader },
    };
  }

  resolveABAO(
    invoices: InvoiceRendition[],
    capLocal: number,
    percentage: number,
  ): { usd: number; local: number } {
    let restUSD = 0;
    let restLocal = 0;
    let total = 0;

    invoices.forEach((e: InvoiceRendition) => {
      total =
        total +
        (e.amountCurrency == 'U$S' || e.amountCurrency == 'USD'
          ? e.amount *
            (percentage / 100) *
            this.renditionForm.value.exchangeRate
          : e.amount * (percentage / 100));
    });

    restLocal = capLocal - total;
    if (restLocal < 0) {
      restUSD = Math.abs(restLocal) / this.renditionForm.value.exchangeRate;
    }

    return {
      usd: restUSD,
      local: restUSD > 0 ? capLocal : total,
    };
  }

  async formatRenditionFromBeToForm(data: RenditionModelBE) {
    let isSellerMyOffice = false;
    let isBuyerMyOffice = false;
    ///////////////////////////////////////////////////////////////////
    //////////////////////////// PROPIEDAD ////////////////////////////
    ///////////////////////////////////////////////////////////////////

    // Origen
    this.renditionForm
      .get('originToggle')
      ?.setValue(data.reservationId ? 'Reserva' : 'Nueva');
    this.originToggle.optionSelected = data.reservationId ? 0 : 1;
    // Dirección
    this.renditionForm.get('address')?.setValue(data.propertyAddress);
    // Mls Id
    if (data.mlsId) {
      if (
        this.NODE === Constants.TENANT_ID_GLOBAL ||
        this.NODE === this.NODE_DO
      ) {
        this.renditionForm.get('mlsidGlobal')?.setValue(data.mlsId);
      } else {
        const MLSID_SPLIT = data.mlsId.split('-');
        const PARSED_VALUE_1 = Number(MLSID_SPLIT[0]);
        const PARSED_VALUE_2 = Number(MLSID_SPLIT[1]);

        this.renditionForm
          .get('mlsidFirst')
          ?.setValue(isNaN(PARSED_VALUE_1) ? null : PARSED_VALUE_1);

        this.renditionForm
          .get('mlsidLast')
          ?.setValue(isNaN(PARSED_VALUE_2) ? null : PARSED_VALUE_2);
      }
    }
    // Tipo de propiedad
    if (data.propertyTypeTxt) {
      this.renditionForm.get('propertyType')?.setValue(data.propertyTypeTxt);
    } else {
      const property = this.propertiesList.find(
        (e: { id: number; name: string }) => data.propertyType == e.id,
      );
      this.renditionForm.get('propertyType')?.setValue(property?.id ?? null);
    }

    ///////////////////////////////////////////////////////////////////
    ////////////////////// DATOS DE LA OPERACION //////////////////////
    ///////////////////////////////////////////////////////////////////

    // Fecha
    if (!this.isCuota || (this.isCuota && this.isEdit)) {
      this.renditionForm.get('date')?.setValue(data.renditionDate ?? null);
    }
    // Tipo de operación
    if (data.operationTypeTxt) {
      this.renditionForm
        .get('operationType')
        ?.setValue(data.operationTypeTxt ?? null);
    }
    switch (data.operationType) {
      case 2:
        this.renditionForm.get('operationType')?.setValue('Venta');
        this.operationToggle.optionSelected = 0;
        break;
      case 1:
        this.renditionForm.get('operationType')?.setValue('Alquiler');
        this.operationToggle.optionSelected = 1;
        break;
      default:
        this.renditionForm.get('operationType')?.setValue('Alquiler temp.');
        this.operationToggle.optionSelected = 2;
        break;
    }

    // Inputs de periodos y cantidad ALQUILERES
    switch (data.contractTimeType) {
      case 1:
        this.renditionForm.get('rentPeriod')?.setValue(0);
        this.renditionForm.get('rentInput')?.setValue(data.contractTime);

        break;
      case 2:
        this.renditionForm.get('rentPeriod')?.setValue(1);
        this.renditionForm.get('rentInput')?.setValue(data.contractTime);

        break;

      default:
        this.renditionForm.get('rentPeriod')?.setValue(null);
        this.renditionForm.get('rentInput')?.setValue(null);
        break;
    }

    // Credito
    this.renditionForm.get('credit')?.setValue(data.credit);

    // Jurisdiccion
    if (data.jurisdictionTxt) {
      this.renditionForm.get('jurisdiction')?.setValue(data.jurisdictionTxt);
    } else {
      const jurisdiction = this.jurisdictions.find(
        (e: Jurisdiction) => e.id == data.jurisdictionId,
      );
      this.renditionForm
        .get('jurisdiction')
        ?.setValue(jurisdiction?.name ?? null);
    }

    // Compartida con
    if (!this.isReferidoACobrar) {
      if (
        (data.sharedBy == 1 &&
          (data.sharedAgencyId == 0 || !data.sharedAgencyId)) ||
        (data.sharedBy == 2 &&
          data.organizationCommission.purchaseOrganizationId ==
            data.organizationCommission.saleOrganizationId)
      ) {
        this.renditionForm.get('sharedWith')?.setValue('Dos puntas');
        this.sharedWithToggle.optionSelected = 0;
        isSellerMyOffice = true;
        isBuyerMyOffice = true;
      } else if (data.sharedBy == 2) {
        this.renditionForm.get('sharedWith')?.setValue('RE/MAX');
        this.sharedWithToggle.optionSelected = 1;
        this.renditionForm
          .get('sharedWithOffice')
          ?.setValue(data.sharedAgencyName);
        isSellerMyOffice =
          data.organizationCommission.purchaseOrganizationId != 0;
        isBuyerMyOffice = data.organizationCommission.saleOrganizationId != 0;
      } else {
        this.renditionForm.get('sharedWith')?.setValue('Otra inmobiliaria');
        this.sharedWithToggle.optionSelected = 2;
        this.renditionForm
          .get('sharedWithAnotherRealEstate')
          ?.setValue(data.otherRealEstate?.name ?? data.sharedAgencyName);
        isSellerMyOffice =
          data.organizationCommission.purchaseOrganizationId != 0;
        isBuyerMyOffice = data.organizationCommission.saleOrganizationId != 0;
      }
    }

    this.updateSharedWithOfficeValidator();

    // Tipo de cambio
    this.renditionForm.get('exchangeRate')?.setValue(data.exchangeRate);
    this.renditionForm.get('exclusiveId')?.setValue(data.exclusivityType);

    // Punta vendedora
    // Precio de cierre USD
    if (!this.isCuota || (this.isCuota && this.router.url.includes('edit'))) {
      this.renditionForm
        .get('closePriceUSD')
        ?.setValue(data.totalAmountOperationUSD);

      // Precio de cierre Local
      this.renditionForm
        .get('closePriceLocal')
        ?.setValue(data.totalAmountOperationARS);
      // Relacion
      this.renditionForm
        .get('sellerRelation')
        ?.setValue(data.purchaseRelationshipPercentage);

      this.sellerRelation = data.purchaseRelationshipPercentage;

      // USD
      this.renditionForm
        .get('sellerUSD')
        ?.setValue(data.organizationCommission.purchaseAmountUSD);

      // Local
      this.renditionForm
        .get('sellerLocal')
        ?.setValue(data.organizationCommission.purchaseAmountARS);

      // Porcentaje
      this.renditionForm
        .get('sellerPercentage')
        ?.setValue(data.organizationCommission.purchaseCommissionPercentage);

      // Exclusiva

      // Punta compradora

      // Relacion
      this.renditionForm
        .get('buyerRelation')
        ?.setValue(data.saleRelationshipPercentage);

      if (data.saleRelationshipPercentage == 50) this.onRelationFiftyFifty();

      // USD
      this.renditionForm
        .get('buyerUSD')
        ?.setValue(data.organizationCommission.saleAmountUSD);

      // Local
      this.renditionForm
        .get('buyerLocal')
        ?.setValue(data.organizationCommission.saleAmountARS);

      // Porcentaje
      this.renditionForm
        .get('buyerPercentage')
        ?.setValue(data.organizationCommission.saleCommissionPercentage);
    }

    /////////////////////////////////////////////////////////////////
    /////////////////////// AGENTE VENDEDOR /////////////////////////
    /////////////////////////////////////////////////////////////////

    if (isSellerMyOffice) {
      // Origen
      this.renditionForm.get('sellerSharedWith')?.setValue('Mi oficina');
      this.sellerSharedWith.optionSelected = 0;

      // Oficina
      this.renditionForm.get('sellerOffice')?.setValue(this.user?.agency_name);
    } else if (
      data.sharedBy == 2 &&
      data.sharedAgencyName != this.user?.agency_name
    ) {
      // Origen
      this.renditionForm.get('sellerSharedWith')?.setValue('RE/MAX');
      this.sellerSharedWith.optionSelected = 1;
      // Oficina
      this.renditionForm.get('sellerOffice')?.setValue(data.sharedAgencyName);
    } else {
      // Origen
      this.renditionForm.get('sellerSharedWith')?.setValue('Otro');
      this.sellerSharedWith.optionSelected = 2;
    }

    // Agente
    this.renditionForm
      .get('sellerAgent')
      ?.setValue(data.organizationCommission.purchaseOrganizationName);

    // Origen de cliente
    this.renditionForm
      .get('sellerClient')
      ?.setValue(data.clientContact.saleCustomerOrigin);

    /////////////////////////////////////////////////////////////////
    ////////////////////// REFERIDO VENDEDOR ////////////////////////
    /////////////////////////////////////////////////////////////////

    if (!this.isCuota || (this.isCuota && this.router.url.includes('edit'))) {
      const sellerReferredDeduction = data.referredDeductions.find(
        (e: ReferredDeduction) => e.typePayment == 1,
      );
      if (sellerReferredDeduction) {
        this.addSellerReferred = true;
        // Es referido propia oficina
        if (sellerReferredDeduction.organizationId) {
          // Origen
          this.renditionForm
            .get('sellerReferredSharedWith')
            ?.setValue('Mi oficina');
          this.sellerReferredSharedWith.optionSelected = 0;

          // Oficina
          this.renditionForm
            .get('sellerReferredOffice')
            ?.setValue(this.user?.agency_name);

          // Agente
          this.renditionForm
            .get('sellerReferredName')
            ?.setValue(sellerReferredDeduction.organizationName);
        } else if (
          sellerReferredDeduction.organizationType == 1 ||
          sellerReferredDeduction.organizationType == 5
        ) {
          const office = this.officesList.find(
            (e: { id: number; name: string }) =>
              e.id == sellerReferredDeduction.agencyId,
          );
          // Es referido otra oficina remax
          // Origen
          this.renditionForm
            .get('sellerReferredSharedWith')
            ?.setValue('RE/MAX');
          this.sellerReferredSharedWith.optionSelected = 1;
          // Oficina
          if (office) {
            this.renditionForm
              .get('sellerReferredOffice')
              ?.setValue(office.name);
            this.sellerReferredOfficeAutocompleteChange(office.name);
          }

          // Agente
          this.renditionForm
            .get('sellerReferredName')
            ?.setValue(sellerReferredDeduction.organizationName);
        } else {
          // Es referido otra inmobiliaria
          // Origen
          this.renditionForm.get('sellerReferredSharedWith')?.setValue('Otro');
          this.sellerReferredSharedWith.optionSelected = 2;
          this.renditionForm
            .get('sellerReferredName')
            ?.setValue(sellerReferredDeduction.organizationName);
        }

        this.renditionForm
          .get('sellerReferredPercentage')
          ?.setValue(sellerReferredDeduction.deductionPercentage);
        this.renditionForm
          .get('sellerReferredUSD')
          ?.setValue(sellerReferredDeduction.deductionAmountUSD);
        this.renditionForm
          .get('sellerReferredLocal')
          ?.setValue(sellerReferredDeduction.deductionAmountARS);
      }
    }

    /////////////////////////////////////////////////////////////////
    ////////////////////// COBROKERS VENDEDOR ///////////////////////
    /////////////////////////////////////////////////////////////////
    if (data.cobrokersCommissions && data.cobrokersCommissions.length > 0) {
      this.coBrokers = [];
      for (const cobroker of data.cobrokersCommissions) {
        const NEW_ID_COBROKER = this.getNextCoBrokerId();
        let index = 0;

        this.sellerCobrokers.insert(index, this.createSellerCobrokerForm());
        this.coBrokers.unshift({
          id: NEW_ID_COBROKER,
        });
        this.generateNewCoBrokerInputs(NEW_ID_COBROKER);

        // CASO MI OFICINA

        if (cobroker.organizationType === 2) {
          this.onChangeSellerCobrokerSharedWith(
            0,
            { id: NEW_ID_COBROKER },
            index,
          );
          this.sellerCobrokerAgentAutocompleteChange(
            cobroker.organizationName,
            index,
          );

          // CASO OTRO REMAX
        } else if (cobroker.organizationType === 5) {
          this.onChangeSellerCobrokerSharedWith(
            1,
            { id: NEW_ID_COBROKER },
            index,
          );
          const OFFICE = this.officesList.find(
            (e) => e.id === cobroker.agencyId,
          );
          if (OFFICE) {
            await this.sellerCobrokerOfficeAutocompleteChange(
              OFFICE.name,
              { id: NEW_ID_COBROKER },
              index,
            );
            this.sellerCobrokerAgentAutocompleteChange(
              cobroker.organizationName,
              index,
            );
          }
        }

        // CASO OTRA INMOBILIARIA
        else if (cobroker.organizationType === 4) {
          this.onChangeSellerCobrokerSharedWith(
            2,
            { id: NEW_ID_COBROKER },
            index,
          );
          this.changeSellerCobrokerOther(cobroker.organizationName, index);
        }

        this.changeInputSellerCobrokerUSD(cobroker.grossAmountUsd, index);
        this.changeInputSellerCobrokerLocal(cobroker.grossAmountArs, index);

        index++;
      }
    }

    /////////////////////////////////////////////////////////////////
    ////////////////////// TEAM LEADER VENDEDOR /////////////////////
    /////////////////////////////////////////////////////////////////

    if (data.teamLeaderDeductions && data.teamLeaderDeductions.length > 0) {
      const SELLER_TEAMLEADER_DEDUCTION = data.teamLeaderDeductions.find(
        (e) => e.deductionType === 1,
      );
      if (
        SELLER_TEAMLEADER_DEDUCTION &&
        data.organizationCommission.purchaseOrganizationTeamId
      ) {
        this.renditionForm
          .get('sellerTeamLeader')
          ?.setValue(SELLER_TEAMLEADER_DEDUCTION.organizationName);
        this.renditionForm
          .get('sellerTeamLeaderLocal')
          ?.setValue(SELLER_TEAMLEADER_DEDUCTION.deductionAmountArs);
        this.renditionForm
          .get('sellerTeamLeaderUSD')
          ?.setValue(SELLER_TEAMLEADER_DEDUCTION.deductionAmountUsd);
        this.renditionForm
          .get('sellerTeamLeaderOrigin')
          ?.setValue(
            SELLER_TEAMLEADER_DEDUCTION.checkTeamLeader === 1
              ? this.sellerTeamLeaderOrigin.viewValues[0]
              : this.sellerTeamLeaderOrigin.viewValues[1],
          );
        // Supongamos que en su momento pertenencio a un team y ahora ya no, deberiamos borrar el elemento
      } else if (!data.organizationCommission.purchaseOrganizationTeamId) {
        const INDEX = data.teamLeaderDeductions.findIndex(
          (e) => e.deductionType === 1,
        );

        if (INDEX !== -1) {
          data.teamLeaderDeductions.splice(INDEX, 1);
        }
      }
    }

    if (data.teamLeaderCommissions && data.teamLeaderCommissions.length > 0) {
      const SELLER_TEAMLEADER_COMMISSION = data.teamLeaderCommissions.find(
        (e) => e.type === 1,
      );
      if (
        SELLER_TEAMLEADER_COMMISSION &&
        !data.organizationCommission.purchaseOrganizationTeamId
      ) {
        const INDEX = data.teamLeaderCommissions.findIndex((e) => e.type === 1);

        if (INDEX !== -1) {
          data.teamLeaderCommissions.splice(INDEX, 1);
        }
      }
    }

    /////////////////////////////////////////////////////////////////
    /////////////////////// AGENTE COMPRADOR /////////////////////////
    /////////////////////////////////////////////////////////////////

    if (isBuyerMyOffice) {
      // Origen
      this.renditionForm.get('buyerSharedWith')?.setValue('Mi oficina');
      this.buyerSharedWith.optionSelected = 0;

      // Oficina
      this.renditionForm.get('buyerOffice')?.setValue(this.user?.agency_name);
    } else if (
      data.sharedBy == 2 &&
      data.sharedAgencyName != this.user?.agency_name
    ) {
      // Origen
      this.renditionForm.get('buyerSharedWith')?.setValue('RE/MAX');
      this.buyerSharedWith.optionSelected = 1;
      // Oficina
      this.renditionForm.get('buyerOffice')?.setValue(data.sharedAgencyName);
    } else {
      // Origen
      this.renditionForm.get('buyerSharedWith')?.setValue('Otro');
      this.buyerSharedWith.optionSelected = 2;
    }

    // Agente
    this.renditionForm
      .get('buyerAgent')
      ?.setValue(data.organizationCommission.saleOrganizationName);

    // Origen de cliente
    this.renditionForm
      .get('buyerClient')
      ?.setValue(data.clientContact.purchaseCustomerOrigin);

    /////////////////////////////////////////////////////////////////
    ////////////////////// REFERIDO COMPRADOR ////////////////////////
    /////////////////////////////////////////////////////////////////
    if (!this.isCuota || (this.isCuota && this.router.url.includes('edit'))) {
      const buyerReferredDeduction = data.referredDeductions.find(
        (e: ReferredDeduction) => e.typePayment == 2,
      );
      if (buyerReferredDeduction) {
        this.addBuyerReferred = true;
        // Es referido propia oficina
        if (buyerReferredDeduction.organizationId) {
          // Origen
          this.renditionForm
            .get('buyerReferredSharedWith')
            ?.setValue('Mi oficina');
          this.buyerReferredSharedWith.optionSelected = 0;

          // Oficina
          this.renditionForm
            .get('buyerReferredOffice')
            ?.setValue(this.user?.agency_name);

          // Agente
          this.renditionForm
            .get('buyerReferredName')
            ?.setValue(buyerReferredDeduction.organizationName);
        } else if (
          buyerReferredDeduction.organizationType == 5 ||
          buyerReferredDeduction.organizationType == 1
        ) {
          // Es referido otra oficina remax
          const office = this.officesList.find(
            (e: { id: number; name: string }) =>
              e.id == buyerReferredDeduction.agencyId,
          );

          // Origen
          this.renditionForm.get('buyerReferredSharedWith')?.setValue('RE/MAX');
          this.buyerReferredSharedWith.optionSelected = 1;

          // Oficina
          if (office) {
            this.renditionForm
              .get('buyerReferredOffice')
              ?.setValue(office.name);
            this.buyerReferredOfficeAutocompleteChange(office.name);
          }

          // Agente
          this.renditionForm
            .get('buyerReferredName')
            ?.setValue(buyerReferredDeduction.organizationName);
        } else {
          // Es referido otra inmobiliaria
          // Origen
          this.renditionForm.get('buyerReferredSharedWith')?.setValue('Otro');
          this.buyerReferredSharedWith.optionSelected = 2;
          // Agente
          this.renditionForm
            .get('buyerReferredName')
            ?.setValue(buyerReferredDeduction.organizationName);
        }

        this.renditionForm
          .get('buyerReferredPercentage')
          ?.setValue(buyerReferredDeduction.deductionPercentage);
        this.renditionForm
          .get('buyerReferredUSD')
          ?.setValue(buyerReferredDeduction.deductionAmountUSD);
        this.renditionForm
          .get('buyerReferredLocal')
          ?.setValue(buyerReferredDeduction.deductionAmountARS);
      }

      /////////////////////////////////////////////////////////////////
      ////////////////////// TEAM LEADER COMPRADOR /////////////////////
      /////////////////////////////////////////////////////////////////

      if (data.teamLeaderDeductions && data.teamLeaderDeductions.length > 0) {
        const BUYER_TEAMLEADER_DEDUCTION = data.teamLeaderDeductions.find(
          (e) => e.deductionType === 2,
        );
        if (
          BUYER_TEAMLEADER_DEDUCTION &&
          data.organizationCommission.saleOrganizationTeamId
        ) {
          this.renditionForm
            .get('buyerTeamLeader')
            ?.setValue(BUYER_TEAMLEADER_DEDUCTION.organizationName);
          this.renditionForm
            .get('buyerTeamLeaderLocal')
            ?.setValue(BUYER_TEAMLEADER_DEDUCTION.deductionAmountArs);
          this.renditionForm
            .get('buyerTeamLeaderUSD')
            ?.setValue(BUYER_TEAMLEADER_DEDUCTION.deductionAmountUsd);
          this.renditionForm
            .get('buyerTeamLeaderOrigin')
            ?.setValue(
              BUYER_TEAMLEADER_DEDUCTION.checkTeamLeader === 1
                ? this.buyerTeamLeaderOrigin.viewValues[0]
                : this.buyerTeamLeaderOrigin.viewValues[1],
            );
          // Supongamos que en su momento pertenencio a un team y ahora ya no, deberiamos borrar el elemento
        } else if (!data.organizationCommission.saleOrganizationTeamId) {
          const INDEX = data.teamLeaderDeductions.findIndex(
            (e) => e.deductionType === 2,
          );

          if (INDEX !== -1) {
            data.teamLeaderDeductions.splice(INDEX, 1);
          }
        }
      }

      if (data.teamLeaderCommissions && data.teamLeaderCommissions.length > 0) {
        const BUYER_TEAMLEADER_COMMISSION = data.teamLeaderCommissions.find(
          (e) => e.type === 2,
        );
        if (
          BUYER_TEAMLEADER_COMMISSION &&
          !data.organizationCommission.saleOrganizationTeamId
        ) {
          const INDEX = data.teamLeaderCommissions.findIndex(
            (e) => e.type === 2,
          );

          if (INDEX !== -1) {
            data.teamLeaderCommissions.splice(INDEX, 1);
          }
        }
      }

      // DEDUCCIONES AGENTE VENDEDOR

      if (isSellerMyOffice) {
        // Porcentaje
        this.renditionForm
          .get('sellerAgentDeductionPercentage')
          ?.setValue(data.purchaseDeduction.deductionPercentage);
        // USD
        this.renditionForm
          .get('sellerAgentDeductionUSD')
          ?.setValue(data.purchaseDeduction.deductionAmountUSD);
        // Local
        this.renditionForm
          .get('sellerAgentDeductionLocal')
          ?.setValue(data.purchaseDeduction.deductionAmountARS);

        // Deduccion Manual vendedor
        if (
          !this.isCuota ||
          (this.isCuota && this.router.url.includes('edit'))
        ) {
          const sellerManualDeduction = data.otherDeductions.find(
            (e: OtherDeduction) => e.type == 1,
          );
          if (sellerManualDeduction) {
            this.showSellerManualDeduction = true;
            this.renditionForm
              .get('sellerManualDeductionName')
              ?.setValue(sellerManualDeduction.description);
            this.renditionForm
              .get('sellerManualDeductionUSD')
              ?.setValue(sellerManualDeduction.amountUSD);
            this.renditionForm
              .get('sellerManualDeductionLocal')
              ?.setValue(sellerManualDeduction.amountARS);
          }
        }
      }

      // DEDUCCIONES AGENTE COMPRADOR
      if (isBuyerMyOffice) {
        // Porcentaje

        this.renditionForm
          .get('buyerAgentDeductionPercentage')
          ?.setValue(data.saleDeduction.deductionPercentage);
        // USD
        this.renditionForm
          .get('buyerAgentDeductionUSD')
          ?.setValue(data.saleDeduction.deductionAmountUSD);
        // Local
        this.renditionForm
          .get('buyerAgentDeductionLocal')
          ?.setValue(data.saleDeduction.deductionAmountARS);

        // Deduccion Manual vendedor
        const buyerManualDeduction = data.otherDeductions.find(
          (e: OtherDeduction) => e.type == 2,
        );
        if (buyerManualDeduction) {
          this.showBuyerManualDeduction = true;
          this.renditionForm
            .get('buyerManualDeductionName')
            ?.setValue(buyerManualDeduction.description);
          this.renditionForm
            .get('buyerManualDeductionUSD')
            ?.setValue(buyerManualDeduction.amountUSD);
          this.renditionForm
            .get('buyerManualDeductionLocal')
            ?.setValue(buyerManualDeduction.amountARS);
        }
      }
    }

    if (this.isReferidoACobrar) {
      if (data.organizationCommission.saleOrganizationId) {
        this.renditionForm
          .get('referredName')
          ?.setValue(data.organizationCommission.saleOrganizationName);
      } else if (data.organizationCommission.purchaseOrganizationId) {
        this.renditionForm
          .get('referredName')
          ?.setValue(data.organizationCommission.purchaseOrganizationName);
      }
      this.renditionForm
        .get('originReferredTogle')
        ?.setValue(
          data.organizationCommission.saleCommissionPercentage == 100
            ? 'Comprador'
            : 'Vendedor',
        );
      this.originReferredToggle.optionSelected =
        data.organizationCommission.saleCommissionPercentage == 100 ? 1 : 0;

      const referredClient = this.clientOirgin.find(
        (e: { id: number; label: string }) =>
          e.id == data.clientContact.purchaseCustomerOriginId ||
          e.id == data.clientContact.saleCustomerOriginId,
      );

      if (referredClient)
        this.renditionForm
          .get('referredClient')
          ?.setValue(referredClient.label);
    }

    // FACTURAS
    this.invoices = [];

    if (!this.isCuota || (this.isCuota && this.router.url.includes('edit'))) {
      // Agente a la oficina
      data.agentPayments.forEach((e: AgentPayment) => {
        const invoice = this.formatBEtoFEAgentPayment(e);
        this.invoices.push(invoice);
      });

      // Oficina al cliente
      data.billings.forEach((e: Billing) => {
        const invoice = this.formatBEtoFEBilling(e);
        this.invoices.push(invoice);
      });

      // Agente al cliente
      data.agentBillings.forEach((e: AgentBilling) => {
        const invoice = this.formatBEtoFEAgentBilling(e);
        this.invoices.push(invoice);
      });

      let i = 0;
      this.invoices.forEach((e: InvoiceRendition) => {
        i = i + 1;
        e.id = i;
      });

      this.resolveIVA(this.invoices);
    }

    if (
      this.NODE === this.NODE_DO &&
      this.rendition?.royaltyAmount &&
      this.rendition?.royaltyPercentage
    ) {
      const ONLY_LOCAL =
        this.renditionForm.value.sellerLocal > 0 ||
        (this.renditionForm.value.buyerLocal > 0 &&
          this.renditionForm.value.sellerUSD === 0) ||
        this.renditionForm.value.buyerUSD === 0;
      const FORM_INPUT = ONLY_LOCAL ? 'regaliasLocal' : 'regaliasUSD';

      this.renditionForm
        .get(FORM_INPUT)
        ?.setValue(this.rendition?.royaltyAmount);
    }

    // Nota reserva
    this.renditionForm.get('reservationNotes')?.setValue(data.reservationNotes);
    // Nota rendicion
    this.renditionForm.get('renditionNotes')?.setValue(data.notes);
    this.formatForCheckout();
  }

  formatBEtoFEAgentPayment(data: AgentPayment): InvoiceRendition {
    return {
      agent: data.organizationName,
      id: 0,
      client: data.typePayment == 1 ? 'Vendedor' : 'Comprador',
      number: data.billNumber,
      invoiceType: data.voucherTypeTxt, // Agregar vouchertype
      name: '',
      description: '',
      amountCurrency: data.subtotalUSD > 0 ? 'U$S' : 'Local',
      amount: data.subtotalUSD > 0 ? data.subtotalUSD : data.subtotalARS,
      ivaCurrency: data.subtotalIVAUSD > 0 ? 'U$S' : 'Local',
      iva: data.subtotalIVAUSD > 0 ? data.subtotalIVAUSD : data.subtotalIVAARS,
      overbilled: 0,
      origin: 'Agente a la oficina',
      voucher: data.voucherType,
    } as InvoiceRendition;
  }

  formatBEtoFEBilling(data: Billing): InvoiceRendition {
    return {
      id: 0,
      agent: '',
      client: data.typePayment == 1 ? 'Vendedor' : 'Comprador',
      number: data.billNumber,
      invoiceType: data.voucherTypeTxt, // Agregar vouchertype
      name: data.companyName,
      description: data.concept,
      amountCurrency: data.currency == 'USD' ? 'U$S' : 'Local',
      amount:
        data.currency == 'USD'
          ? data.subtotalUSD + data.overbillingUSD
          : data.subtotalARS + data.overbillingLocal,
      ivaCurrency: data.ivaCurrency == 'USD' ? 'U$S' : 'Local',
      iva:
        data.ivaCurrency == 'USD' ? data.subtotalIVAUSD : data.subtotalIVAARS,
      overbilled:
        data.currency == 'USD' ? data.overbillingUSD : data.overbillingLocal,
      origin: 'Oficina al cliente',
      voucher: data.voucherType,
    } as InvoiceRendition;
  }

  formatBEtoFEAgentBilling(data: AgentBilling): InvoiceRendition {
    return {
      id: 0,
      client: data.typePayment == 1 ? 'Vendedor' : 'Comprador',
      agent: data.organizationName,
      number: data.billNumber,
      invoiceType: data.voucherTypeTxt, // Agregar vouchertype
      name: data.companyName,
      description: data.concept,
      amountCurrency: data.subtotalUSD > 0 ? 'U$S' : 'Local',
      amount: data.subtotalUSD > 0 ? data.subtotalUSD : data.subtotalARS,
      ivaCurrency: data.subtotalIVAUSD > 0 ? 'U$S' : 'Local',
      iva: data.subtotalIVAUSD > 0 ? data.subtotalIVAUSD : data.subtotalIVAARS,
      overbilled: 0,
      origin: 'Agente al cliente',
      voucher: data.voucherType,
    } as InvoiceRendition;
  }

  setFormFieldsForForm(type: string) {
    switch (type) {
      case 'ingreso-relacionado':
        this.renditionForm = new FormGroup({
          originToggle: new FormControl(''),
          address: new FormControl('', Validators.required),
          mlsidFirst: new FormControl(null),
          mlsidLast: new FormControl(null),
          mlsidGlobal: new FormControl(''),
          propertyType: new FormControl(''),
          date: new FormControl(this.datePicker.date, Validators.required),
          operationType: new FormControl('Venta', Validators.required),
          rentPeriod: new FormControl(1),
          rentInput: new FormControl(0),
          credit: new FormControl(false),
          bank: new FormControl('', Validators.required),
          jurisdiction: new FormControl('', Validators.required),
          sharedWith: new FormControl('Dos puntas', Validators.required),
          sharedWithOffice: new FormControl(''),
          sharedWithAnotherRealEstate: new FormControl(''),
          exchangeRate: new FormControl('', [
            Validators.required,
            this.exchangeRateValidator(
              this.exchangeRateMin,
              this.exchangeRateMax,
            ),
          ]),
          closePriceUSD: new FormControl(0),
          closePriceLocal: new FormControl(0),
          sellerPercentage: new FormControl(0, Validators.required),
          sellerUSD: new FormControl(0),
          sellerLocal: new FormControl(0),
          buyerPercentage: new FormControl(0, Validators.required),
          buyerUSD: new FormControl(0),
          buyerLocal: new FormControl(0),
          sellerRelation: new FormControl(50),
          buyerRelation: new FormControl(50),
          exclusiveId: new FormControl(1),
          sellerSharedWith: new FormControl('Mi oficina'),
          buyerSharedWith: new FormControl('Mi oficina'),
          sellerOffice: new FormControl(''),
          sellerAgent: new FormControl('', Validators.required),
          buyerOffice: new FormControl(''),
          buyerAgent: new FormControl('', Validators.required),
          sellerClient: new FormControl(''),
          buyerClient: new FormControl(''),
          sellerReferredSharedWith: new FormControl('Mi oficina'),
          sellerReferredOffice: new FormControl(''),
          sellerReferredName: new FormControl(''),
          sellerReferredPercentage: new FormControl(0),
          sellerReferredUSD: new FormControl(0),
          sellerReferredLocal: new FormControl(0),
          sellerReferredDeductionPercentage: new FormControl(0),
          sellerReferredDeductionUSD: new FormControl(0),
          sellerReferredDeductionLocal: new FormControl(0),
          sellerTeamLeader: new FormControl(''),
          sellerTeamLeaderUSD: new FormControl(0),
          sellerTeamLeaderLocal: new FormControl(0),
          invoices: new FormControl([]),
          sellerAgentDeductionPercentage: new FormControl(0),
          sellerAgentDeductionUSD: new FormControl(0),
          sellerAgentDeductionLocal: new FormControl(0),
          sellerManualDeductionName: new FormControl(''),
          sellerManualDeductionUSD: new FormControl(0),
          sellerManualDeductionLocal: new FormControl(0),
          buyerReferredSharedWith: new FormControl('Mi oficina'),
          buyerReferredOffice: new FormControl(''),
          buyerReferredName: new FormControl(''),
          buyerReferredPercentage: new FormControl(0),
          buyerReferredUSD: new FormControl(0),
          buyerReferredLocal: new FormControl(0),
          buyerReferredDeductionPercentage: new FormControl(0),
          buyerReferredDeductionUSD: new FormControl(0),
          buyerReferredDeductionLocal: new FormControl(0),
          buyerTeamLeader: new FormControl(''),
          buyerTeamLeaderUSD: new FormControl(0),
          buyerTeamLeaderLocal: new FormControl(0),
          buyerAgentDeductionPercentage: new FormControl(0),
          buyerAgentDeductionUSD: new FormControl(0),
          buyerAgentDeductionLocal: new FormControl(0),
          buyerManualDeductionName: new FormControl(''),
          buyerManualDeductionUSD: new FormControl(0),
          buyerManualDeductionLocal: new FormControl(0),
          reservationNotes: new FormControl(''),
          renditionNotes: new FormControl(''),
        });
        this.sharedWithToggle.viewValues = [
          'Dos puntas',
          'RE/MAX',
          'Otra inmobiliaria',
        ];

        if (
          this.NODE === this.NODE_DO &&
          !this.renditionForm.contains('sellerCobrokers')
        ) {
          this.renditionForm.addControl('sellerCobrokers', this.fb.array([]));
        }

        if (this.NODE === this.NODE_DO && this.isRegaliasChecked) {
          this.renditionForm.addControl(
            'regaliasLocal',
            new FormControl(0, Validators.required),
          );
          this.renditionForm.addControl(
            'regaliasUSD',
            new FormControl(0, Validators.required),
          );
        }

        break;

      case 'cuota':
        this.renditionForm = new FormGroup({
          originToggle: new FormControl('Reserva', Validators.required),
          address: new FormControl('', Validators.required),
          propertyType: new FormControl('', Validators.required),
          date: new FormControl(this.datePicker.date, Validators.required),
          operationType: new FormControl('Venta', Validators.required),
          rentPeriod: new FormControl(1),
          rentInput: new FormControl(0),
          credit: new FormControl(false, Validators.required),
          bank: new FormControl('', Validators.required),
          jurisdiction: new FormControl('', Validators.required),
          sharedWith: new FormControl('Dos puntas', Validators.required),
          sharedWithOffice: new FormControl(''),
          sharedWithAnotherRealEstate: new FormControl(''),
          exchangeRate: new FormControl('', [
            Validators.required,
            this.exchangeRateValidator(
              this.exchangeRateMin,
              this.exchangeRateMax,
            ),
          ]),
          closePriceUSD: new FormControl(0),
          closePriceLocal: new FormControl(0),
          sellerPercentage: new FormControl(0, Validators.required),
          sellerUSD: new FormControl(0),
          sellerLocal: new FormControl(0),
          buyerPercentage: new FormControl(0, Validators.required),
          buyerUSD: new FormControl(0),
          buyerLocal: new FormControl(0),
          sellerRelation: new FormControl(50, Validators.required),
          buyerRelation: new FormControl(50, Validators.required),
          exclusiveId: new FormControl(1, Validators.required),
          sellerSharedWith: new FormControl('Mi oficina', Validators.required),
          buyerSharedWith: new FormControl('Mi oficina', Validators.required),
          sellerOffice: new FormControl('', Validators.required),
          sellerAgent: new FormControl('', Validators.required),
          buyerOffice: new FormControl('', Validators.required),
          buyerAgent: new FormControl('', Validators.required),
          // sellerClient: new FormControl('', Validators.required),
          // buyerClient: new FormControl('', Validators.required),
          sellerClient: new FormControl(
            '',
            this.NODE === this.NODE_DO ? [] : [Validators.required],
          ),
          buyerClient: new FormControl(
            '',
            this.NODE === this.NODE_DO ? [] : [Validators.required],
          ),
          sellerReferredSharedWith: new FormControl('Mi oficina'),
          sellerReferredOffice: new FormControl(''),
          sellerReferredName: new FormControl(''),
          sellerReferredPercentage: new FormControl(0),
          sellerReferredUSD: new FormControl(0),
          sellerReferredLocal: new FormControl(0),
          sellerReferredDeductionPercentage: new FormControl(0),
          sellerReferredDeductionUSD: new FormControl(0),
          sellerReferredDeductionLocal: new FormControl(0),
          sellerTeamLeader: new FormControl(''),
          sellerTeamLeaderUSD: new FormControl(0),
          sellerTeamLeaderLocal: new FormControl(0),
          invoices: new FormControl([]),
          sellerAgentDeductionPercentage: new FormControl(0),
          sellerAgentDeductionUSD: new FormControl(0),
          sellerAgentDeductionLocal: new FormControl(0),
          sellerManualDeductionName: new FormControl(''),
          sellerManualDeductionUSD: new FormControl(0),
          sellerManualDeductionLocal: new FormControl(0),
          buyerReferredSharedWith: new FormControl('Mi oficina'),
          buyerReferredOffice: new FormControl(''),
          buyerReferredName: new FormControl(''),
          buyerReferredPercentage: new FormControl(0),
          buyerReferredUSD: new FormControl(0),
          buyerReferredLocal: new FormControl(0),
          buyerReferredDeductionPercentage: new FormControl(0),
          buyerReferredDeductionUSD: new FormControl(0),
          buyerReferredDeductionLocal: new FormControl(0),
          buyerTeamLeader: new FormControl(''),
          buyerTeamLeaderUSD: new FormControl(0),
          buyerTeamLeaderLocal: new FormControl(0),
          buyerAgentDeductionPercentage: new FormControl(0),
          buyerAgentDeductionUSD: new FormControl(0),
          buyerAgentDeductionLocal: new FormControl(0),
          buyerManualDeductionName: new FormControl(''),
          buyerManualDeductionUSD: new FormControl(0),
          buyerManualDeductionLocal: new FormControl(0),
          reservationNotes: new FormControl(''),
          renditionNotes: new FormControl(''),
        });

        if (
          this.NODE === Constants.TENANT_ID_GLOBAL ||
          this.NODE === this.NODE_DO
        ) {
          this.renditionForm.addControl(
            'mlsidGlobal',
            new FormControl('', Validators.required),
          );
        } else {
          this.renditionForm.addControl(
            'mlsidFirst',
            new FormControl('', Validators.required),
          );
          this.renditionForm.addControl(
            'mlsidLast',
            new FormControl('', Validators.required),
          );
        }

        if (
          this.NODE === this.NODE_DO &&
          !this.renditionForm.contains('sellerCobrokers')
        ) {
          this.renditionForm.addControl('sellerCobrokers', this.fb.array([]));
        }

        if (this.NODE === this.NODE_DO && this.isRegaliasChecked) {
          this.renditionForm.addControl(
            'regaliasLocal',
            new FormControl(0, Validators.required),
          );
          this.renditionForm.addControl(
            'regaliasUSD',
            new FormControl(0, Validators.required),
          );
        }

        break;
      case 'referido-a-cobrar':
        this.renditionForm = new FormGroup({
          referredName: new FormControl('', Validators.required),
          originReferredToggle: new FormControl(
            'Vendedor',
            Validators.required,
          ),
          referredClient: new FormControl('', Validators.required),
          originToggle: new FormControl(''),
          address: new FormControl('', Validators.required),
          mlsidFirst: new FormControl(null),
          mlsidLast: new FormControl(null),
          mlsidGlobal: new FormControl(''),
          propertyType: new FormControl('', Validators.required),
          date: new FormControl(this.datePicker.date, Validators.required),
          operationType: new FormControl('Venta', Validators.required),
          rentPeriod: new FormControl(1),
          rentInput: new FormControl(0),
          bank: new FormControl('', Validators.required),
          credit: new FormControl(false),
          jurisdiction: new FormControl('', Validators.required),
          sharedWith: new FormControl('RE/MAX', Validators.required),
          sharedWithOffice: new FormControl(''),
          sharedWithAnotherRealEstate: new FormControl(''),
          exchangeRate: new FormControl('', [
            Validators.required,
            this.exchangeRateValidator(
              this.exchangeRateMin,
              this.exchangeRateMax,
            ),
          ]),
          closePriceUSD: new FormControl(0),
          closePriceLocal: new FormControl(0),
          sellerPercentage: new FormControl(0, Validators.required),
          sellerUSD: new FormControl(0),
          sellerLocal: new FormControl(0),
          buyerPercentage: new FormControl(0),
          buyerUSD: new FormControl(0),
          buyerLocal: new FormControl(0),
          sellerRelation: new FormControl(50),
          buyerRelation: new FormControl(50),
          exclusiveId: new FormControl(1),
          sellerSharedWith: new FormControl(''),
          buyerSharedWith: new FormControl(''),
          sellerOffice: new FormControl(''),
          sellerAgent: new FormControl(''),
          buyerOffice: new FormControl(''),
          buyerAgent: new FormControl(''),
          sellerClient: new FormControl(''),
          buyerClient: new FormControl(''),
          sellerReferredSharedWith: new FormControl('Mi oficina'),
          sellerReferredOffice: new FormControl(''),
          sellerReferredName: new FormControl(''),
          sellerReferredPercentage: new FormControl(0),
          sellerReferredUSD: new FormControl(0),
          sellerReferredLocal: new FormControl(0),
          sellerReferredDeductionPercentage: new FormControl(0),
          sellerReferredDeductionUSD: new FormControl(0),
          sellerReferredDeductionLocal: new FormControl(0),
          sellerTeamLeader: new FormControl(''),
          sellerTeamLeaderUSD: new FormControl(0),
          sellerTeamLeaderLocal: new FormControl(0),
          invoices: new FormControl([]),
          sellerAgentDeductionPercentage: new FormControl(0),
          sellerAgentDeductionUSD: new FormControl(0),
          sellerAgentDeductionLocal: new FormControl(0),
          sellerManualDeductionName: new FormControl(''),
          sellerManualDeductionUSD: new FormControl(0),
          sellerManualDeductionLocal: new FormControl(0),
          buyerReferredSharedWith: new FormControl('Mi oficina'),
          buyerReferredOffice: new FormControl(''),
          buyerReferredName: new FormControl(''),
          buyerReferredPercentage: new FormControl(0),
          buyerReferredUSD: new FormControl(0),
          buyerReferredLocal: new FormControl(0),
          buyerReferredDeductionPercentage: new FormControl(0),
          buyerReferredDeductionUSD: new FormControl(0),
          buyerReferredDeductionLocal: new FormControl(0),
          buyerTeamLeader: new FormControl(''),
          buyerTeamLeaderUSD: new FormControl(0),
          buyerTeamLeaderLocal: new FormControl(0),
          buyerAgentDeductionPercentage: new FormControl(0),
          buyerAgentDeductionUSD: new FormControl(0),
          buyerAgentDeductionLocal: new FormControl(0),
          buyerManualDeductionName: new FormControl(''),
          buyerManualDeductionUSD: new FormControl(0),
          buyerManualDeductionLocal: new FormControl(0),
          reservationNotes: new FormControl(''),
          renditionNotes: new FormControl(''),
        });
        this.sharedWithToggle.viewValues = ['RE/MAX', 'Otra inmobiliaria'];
        if (
          this.NODE === this.NODE_DO &&
          !this.renditionForm.contains('sellerCobrokers')
        ) {
          this.renditionForm.addControl('sellerCobrokers', this.fb.array([]));
        }

        if (this.NODE === this.NODE_DO && this.isRegaliasChecked) {
          this.renditionForm.addControl(
            'regaliasLocal',
            new FormControl(0, Validators.required),
          );
          this.renditionForm.addControl(
            'regaliasUSD',
            new FormControl(0, Validators.required),
          );
        }

        break;
      default:
        this.renditionForm = new FormGroup({
          originToggle: new FormControl('Reserva', Validators.required),
          address: new FormControl('', Validators.required),
          propertyType: new FormControl('', Validators.required),
          date: new FormControl(this.datePicker.date, Validators.required),
          operationType: new FormControl('Venta', Validators.required),
          rentPeriod: new FormControl(1),
          rentInput: new FormControl(0),
          credit: new FormControl(false, Validators.required),
          bank: new FormControl('', Validators.required),
          jurisdiction: new FormControl('', Validators.required),
          sharedWith: new FormControl('Dos puntas', Validators.required),
          sharedWithOffice: new FormControl(''),
          sharedWithAnotherRealEstate: new FormControl(''),
          exchangeRate: new FormControl('', [
            Validators.required,
            this.exchangeRateValidator(
              this.exchangeRateMin,
              this.exchangeRateMax,
            ),
          ]),
          closePriceUSD: new FormControl(0),
          closePriceLocal: new FormControl(0),
          sellerPercentage: new FormControl(0, Validators.required),
          sellerUSD: new FormControl(0),
          sellerLocal: new FormControl(0),
          buyerPercentage: new FormControl(0, Validators.required),
          buyerUSD: new FormControl(0),
          buyerLocal: new FormControl(0),
          sellerRelation: new FormControl(50, Validators.required),
          buyerRelation: new FormControl(50, Validators.required),
          exclusiveId: new FormControl(1, Validators.required),
          sellerSharedWith: new FormControl('Mi oficina', Validators.required),
          buyerSharedWith: new FormControl('Mi oficina', Validators.required),
          sellerOffice: new FormControl('', Validators.required),
          sellerAgent: new FormControl('', Validators.required),
          buyerOffice: new FormControl('', Validators.required),
          buyerAgent: new FormControl('', Validators.required),
          // sellerClient: new FormControl('', Validators.required),
          // buyerClient: new FormControl('', Validators.required),
          sellerClient: new FormControl(
            '',
            this.NODE === this.NODE_DO ? [] : [Validators.required],
          ),
          buyerClient: new FormControl(
            '',
            this.NODE === this.NODE_DO ? [] : [Validators.required],
          ),
          sellerReferredSharedWith: new FormControl('Mi oficina'),
          sellerReferredOffice: new FormControl(''),
          sellerReferredName: new FormControl(''),
          sellerReferredPercentage: new FormControl(0),
          sellerReferredUSD: new FormControl(0),
          sellerReferredLocal: new FormControl(0),
          sellerReferredDeductionPercentage: new FormControl(0),
          sellerReferredDeductionUSD: new FormControl(0),
          sellerReferredDeductionLocal: new FormControl(0),
          sellerTeamLeader: new FormControl(''),
          sellerTeamLeaderOrigin: new FormControl(''),
          sellerTeamLeaderUSD: new FormControl(0),
          sellerTeamLeaderLocal: new FormControl(0),
          invoices: new FormControl([]),
          sellerAgentDeductionPercentage: new FormControl(0),
          sellerAgentDeductionUSD: new FormControl(0),
          sellerAgentDeductionLocal: new FormControl(0),
          sellerManualDeductionName: new FormControl(''),
          sellerManualDeductionUSD: new FormControl(0),
          sellerManualDeductionLocal: new FormControl(
            0,
            Validators.max(this.renditionForm.value.sellerLocal),
          ),
          buyerReferredSharedWith: new FormControl('Mi oficina'),
          buyerReferredOffice: new FormControl(''),
          buyerReferredName: new FormControl(''),
          buyerReferredPercentage: new FormControl(0),
          buyerReferredUSD: new FormControl(0),
          buyerReferredLocal: new FormControl(0),
          buyerReferredDeductionPercentage: new FormControl(0),
          buyerReferredDeductionUSD: new FormControl(0),
          buyerReferredDeductionLocal: new FormControl(0),
          buyerTeamLeader: new FormControl(''),
          buyerTeamLeaderOrigin: new FormControl(''),
          buyerTeamLeaderUSD: new FormControl(0),
          buyerTeamLeaderLocal: new FormControl(0),
          buyerAgentDeductionPercentage: new FormControl(0),
          buyerAgentDeductionUSD: new FormControl(0),
          buyerAgentDeductionLocal: new FormControl(0),
          buyerManualDeductionName: new FormControl(''),
          buyerManualDeductionUSD: new FormControl(0),
          buyerManualDeductionLocal: new FormControl(0),
          reservationNotes: new FormControl(''),
          renditionNotes: new FormControl(''),
        });

        if (this.NODE === this.NODE_DO) {
          this.renditionForm.addControl(
            'pendingCommissions',
            new FormControl(false),
          );
        }

        if (
          this.NODE === this.NODE_DO &&
          !this.renditionForm.contains('sellerCobrokers')
        ) {
          this.renditionForm.addControl('sellerCobrokers', this.fb.array([]));
        }

        if (this.NODE === this.NODE_DO && this.isRegaliasChecked) {
          this.renditionForm.addControl(
            'regaliasLocal',
            new FormControl(0, Validators.required),
          );
          this.renditionForm.addControl(
            'regaliasUSD',
            new FormControl(0, Validators.required),
          );
        }

        if (this.NODE === this.NODE_GLOBAL || this.NODE === this.NODE_DO) {
          this.renditionForm.addControl(
            'mlsidGlobal',
            new FormControl('', Validators.required),
          );
        } else {
          this.renditionForm.addControl(
            'mlsidFirst',
            new FormControl('', Validators.required),
          );
          this.renditionForm.addControl(
            'mlsidLast',
            new FormControl('', Validators.required),
          );
        }
        break;
    }
  }

  preventDefault($event: Event) {
    $event.preventDefault();
  }

  onRelationFiftyFifty() {
    if (!this.isRelationFiftyFifty) {
      this.previousSellerRelation = this.sellerRelation;
    }
    this.isRelationFiftyFifty = !this.isRelationFiftyFifty;

    if (
      this.renditionForm.value.sellerRelation != 0 &&
      this.isRelationFiftyFifty
    ) {
      this.renditionForm.get('sellerRelation')?.setValue(50);
      this.renditionForm.get('buyerRelation')?.setValue(50);
      this.sellerRelation = 50;
      this.buyerRelation = 50;
    } else {
      const EXCHANGE = this.renditionForm.value.exchangeRate;
      const TOTAL_SELER =
        this.renditionForm.value.sellerUSD +
        this.renditionForm.value.sellerLocal / EXCHANGE;

      const TOTAL_BUYER =
        this.renditionForm.value.buyerUSD +
        this.renditionForm.value.buyerLocal / EXCHANGE;

      const RELATION_1 =
        Math.round((TOTAL_SELER / (TOTAL_BUYER + TOTAL_SELER)) * 100 * 100) /
        100;

      this.sellerRelation = RELATION_1;

      this.buyerRelation = 100 - this.sellerRelation;
      this.renditionForm.get('sellerRelation')?.setValue(this.sellerRelation);
      this.renditionForm.get('buyerRelation')?.setValue(this.buyerRelation);
    }
    this.calculationsJurisdiction();
  }

  openDialogClearForm(): void {
    this.dialogClearForm = {
      ...this.dialogClearForm,
      isVisible: true,
    };
  }

  dialogChangeClearForm($event: any): void {
    //mandarlo al primer form
    if ($event) {
      const currentUrl = this.router.url;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([currentUrl]);
      });
    }
  }

  //Acciones tras guardar borrador
  dialogChangeDraftCreated(value: string) {
    value == 'borradores'
      ? this.router.navigate(['/renditions/drafts'])
      : this.router.navigate(['/renditions/']);
  }

  isValidNumberMlsId(e: KeyboardEvent): void {
    const NAVIGATION_KEYS = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'Home',
      'End',
      'ArrowLeft',
      'ArrowRight',
      'Clear',
      'Copy',
      'Paste',
    ];

    if (this.NODE === Constants.TENANT_ID_GLOBAL) return;

    if (NAVIGATION_KEYS.includes(e.key)) {
      return;
    }

    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  }

  checkValidityRenditionForm() {
    if (this.userTriedToSubmitForm) {
      const formValidity = {
        draft: this.renditionForm.valid,
        form:
          this.renditionForm.valid &&
          this.renditionForm.value.date <= this.today,
      };
      this.formValidation.emit(formValidity);
    }
  }

  validateCapsOverbilling(isDraft?: boolean) {
    const BILLING_FILTER = this.invoices.filter(
      (e) => e.origin == this.OFFICE_CLIENT,
    );
    if (BILLING_FILTER) {
      BILLING_FILTER.forEach((e) => (e.hasError = false));
    }
    this.isDraft = isDraft ?? false;
    let RESULT = true;
    const INVOICES = this.invoices.filter(
      (e: InvoiceRendition) => e.origin == this.OFFICE_CLIENT,
    );
    if (INVOICES?.length > 0) {
      const TOTAL_OFFICE =
        this.commissionCheckout.office.subtotal.usd +
        this.commissionCheckout.office.subtotal.local /
          this.renditionForm.value.exchangeRate;

      let TOTAL_INVOICES = 0;
      let OVERBILLED = 0;
      INVOICES.forEach((e: InvoiceRendition) => {
        const AMOUNT_OVERBILLED = e.overbilled > 0 ? e.overbilled : 0;
        if (e.amountCurrency == 'USD' || e.amountCurrency == 'U$S') {
          TOTAL_INVOICES =
            TOTAL_INVOICES + Number(e.amount) - AMOUNT_OVERBILLED;
          OVERBILLED = OVERBILLED + AMOUNT_OVERBILLED;
        } else {
          TOTAL_INVOICES =
            TOTAL_INVOICES +
            Number(e.amount / this.renditionForm.value.exchangeRate) -
            AMOUNT_OVERBILLED / this.renditionForm.value.exchangeRate;
          OVERBILLED =
            OVERBILLED +
            AMOUNT_OVERBILLED / this.renditionForm.value.exchangeRate;
        }
      });

      if (TOTAL_INVOICES > TOTAL_OFFICE) {
        // Solo boton invoices
        this.errorInOfficeCaps = false;
        this.openOverlay = true;
        if (BILLING_FILTER) {
          BILLING_FILTER[BILLING_FILTER.length - 1].hasError = true;
        }
        RESULT = false;
      } else if (
        (TOTAL_INVOICES + OVERBILLED < TOTAL_OFFICE && OVERBILLED > 0) ||
        (TOTAL_INVOICES < TOTAL_OFFICE && OVERBILLED > 0)
      ) {
        // boton continuar o editar facturas
        this.errorInOfficeCaps = true;
        if (BILLING_FILTER) {
          BILLING_FILTER[BILLING_FILTER.length - 1].hasError = true;
        }
        this.openOverlay = true;
        RESULT = false;
      }
      this.invoices = [...this.invoices];
    }
    return RESULT;
  }

  onChangeDialogWarningInvoices($event: any) {
    this.openOverlay = false;
    if ($event == 'invoices') this.openInvoices();
  }

  exchangeRateValidator(min: number, max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = parseFloat(control.value);

      // Check if the value is a number and within the range
      if (!isNaN(value) && value >= min && value <= max) {
        return null; // Valid
      }

      // Invalid: return an error object
      return { outOfRange: { value, min, max } };
    };
  }

  getBanks(type: number | undefined) {
    // operationtype = 1 -> garantias (caso alquiler/alquiler temporario)
    // operationtype = 2 -> bancos (caso venta)
    const TYPE = type == 2 ? 2 : 1;
    const FILTER = this.banks.filter(
      (bank: Banks) => bank.operationType == TYPE,
    );
    FILTER.forEach((e: Banks) => {
      this.dropdownBanks.options.push(e.entidad);
    });
  }

  onChangePendingCommissions($event: number) {
    this.renditionForm
      .get('pendingCommissions')
      ?.setValue($event === 1 ? false : true);
  }
}
